/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/help/chat/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 85);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(93);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var GlobalStoreService=function(){function GlobalStoreService(){var _scenarioList,_categoriesFetched;_classCallCheck(this,GlobalStoreService);this._store={currentNumber:null,currentNumberType:null,primaryNumber:null,primaryNumberType:null,isUserLoggedIn:false,userProfileType:null,platformType:__WEBPACK_IMPORTED_MODULE_0__enums_PlatformType__["a" /* default */].WEB,currentBotType:__WEBPACK_IMPORTED_MODULE_1__enums_BotType__["a" /* default */].POSTPAID,// default scenario list
scenarioList:(_scenarioList={},_defineProperty(_scenarioList,__WEBPACK_IMPORTED_MODULE_1__enums_BotType__["a" /* default */].POSTPAID,[]),_defineProperty(_scenarioList,__WEBPACK_IMPORTED_MODULE_1__enums_BotType__["a" /* default */].PREPAID,[]),_defineProperty(_scenarioList,__WEBPACK_IMPORTED_MODULE_1__enums_BotType__["a" /* default */].PAYMENTS_BANK,[]),_scenarioList),// for logged out users
basicToken:null,// for logged in users
loggedInToken:null,// component state
components_handler:{//bottom bar comp can be --- 'chat-bar-comp' || 'user-accounts-menu-comp' || 'login-comp' || 'cancel-comp'||'switch-bar-comp'
bottom_bar_comp:__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR},//maintained for alternate no intent found 1 and no intent found 2
no_intent_found_1:false,//options from category fetch
categoriesFetched:(_categoriesFetched={},_defineProperty(_categoriesFetched,__WEBPACK_IMPORTED_MODULE_1__enums_BotType__["a" /* default */].POSTPAID,undefined),_defineProperty(_categoriesFetched,__WEBPACK_IMPORTED_MODULE_1__enums_BotType__["a" /* default */].PREPAID,undefined),_categoriesFetched),// Handling for previuos step
chatHistoryForCurrentScenario:[],// Maintain context for login via otp 
loginViaOtp:false,// Tracking data for analytics
trackingData:{circle:"",enteredTextMode:"click",startTime:new Date(),user_response:"",queryCount:0,current_scenario:{},isIdleChat:true,isIdleChatCallled:false},chatBotHistory:{dbWriteStatus:true}};}_createClass(GlobalStoreService,[{key:'get',value:function get(key){return this._store[key];}},{key:'set',value:function set(key,value){this._store[key]=value;}}]);return GlobalStoreService;}();/* harmony default export */ __webpack_exports__["a"] = (new GlobalStoreService());

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {
	    /*
	     * Local polyfil of Object.create
	     */
	    var create = Object.create || (function () {
	        function F() {};

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            var r = (function (m_w) {
	                var m_w = m_w;
	                var m_z = 0x3ade68b1;
	                var mask = 0xffffffff;

	                return function () {
	                    m_z = (0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10)) & mask;
	                    m_w = (0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10)) & mask;
	                    var result = ((m_z << 0x10) + m_w) & mask;
	                    result /= 0x100000000;
	                    result += 0.5;
	                    return result * (Math.random() > .5 ? 1 : -1);
	                }
	            });

	            for (var i = 0, rcache; i < nBytes; i += 4) {
	                var _r = r((rcache || Math.random()) * 0x100000000);

	                rcache = _r() * 0x3ade67b7;
	                words.push((_r() * 0x100000000) | 0);
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                var processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_static_links__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_config__ = __webpack_require__(12);
var _this=this;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UtilService=function(){function UtilService(){_classCallCheck(this,UtilService);}_createClass(UtilService,null,[{key:"getCurrentTime",value:function getCurrentTime(){var date=new Date();var hours=date.getHours();var minutes=date.getMinutes();var timestamp=date.getTime();var ampm=hours>=12?"pm":"am";hours%=12;if(!hours){hours=12;}minutes=minutes<10?"0"+minutes:minutes;var strTime=hours+":"+minutes+" "+ampm;return{time_in_format:strTime,timestamp:timestamp};}},{key:"getOS",value:function getOS(){var userAgent=window.navigator.userAgent;var platform=window.navigator.platform;var macosPlatforms=["Macintosh","MacIntel","MacPPC","Mac68K"];var windowsPlatforms=["Win32","Win64","Windows","WinCE"];var iosPlatforms=["iPhone","iPad","iPod"];var os=null;if(macosPlatforms.indexOf(platform)!==-1){os="Mac OS";}else if(iosPlatforms.indexOf(platform)!==-1){os="iOS";}else if(windowsPlatforms.indexOf(platform)!==-1){os="Windows";}else if(/Android/.test(userAgent)){os="Android";}else if(!os&&/Linux/.test(platform)){os="Linux";}return os;}},{key:"getPlatformTypeForTracking",value:function getPlatformTypeForTracking(){var os=this.getOS();if(window.MyAirtelAppReact||window.MyAirtelChatAppReact){//app context
switch(os){case"iOS":return __WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__["a" /* default */].IOS_WEBVIEW;case"Android":return __WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__["a" /* default */].ANDROID_WEBVIEW;}}else{//web cases
switch(os){case"iOS":return __WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__["a" /* default */].IOS_MSITE;case"Android":return __WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__["a" /* default */].ANDROID_MSITE;default:return __WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__["a" /* default */].WEB;}}}},{key:"getPlatformType",value:function getPlatformType(){switch(this.getOS()){case"iOS":return __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].IOS;case"Android":return __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].ANDROID;default:return __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].WEB;}return __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].WEB;}},{key:"escapeRegExp",value:function escapeRegExp(string){return string.replace(/[.*+?^${}()|[\]\\]/g,"\\$&");}},{key:"replaceAll",value:function replaceAll(str,term,replacement){return str.replace(new RegExp(this.escapeRegExp(term),"g"),replacement);}},{key:"handleDtLink",value:function handleDtLink(handleDtLinkClick){if(document.querySelectorAll("a[href^='executeDT']")&&document.querySelectorAll("a[href^='executeDT']")[0]){var _loop=function _loop(_i){document.querySelectorAll("a[href^='executeDT']")[_i].addEventListener("click",function(event){__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();if(!event.target.disabled){var paramsCount=event.target.href.split("/").length;// eslint-disable-next-line
event.target["disabled"]=true;event.preventDefault();if(__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("isUserLoggedIn")){// ALREADY LOGGED IN AND CONFIRMED HIS NUMBER ----  INITIATE SCENARIO
var scenarioId=event.target.href.split("/")[paramsCount-1];handleDtLinkClick({actionType:"INITIATE",scenarioResponse:{scenarioId:event.target.href.split("/")[paramsCount-1],scenarioName:""}});// TRACKING EXECUTE DT
var user_response=document.querySelectorAll("a[href^='executeDT']")[_i].title?document.querySelectorAll("a[href^='executeDT']")[_i].title:"";__WEBPACK_IMPORTED_MODULE_6__tracking_middleware_service__["a" /* default */].setTrackingData({enteredTextMode:'click',scenarioStrategy:"DTScenario",scenarioName:scenarioId});__WEBPACK_IMPORTED_MODULE_6__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].LINK_CLICKS);}else{handleDtLinkClick({actionType:"ASK_FOR_LOGIN",scenarioResponse:{scenarioId:event.target.href.split("/")[paramsCount-1],scenarioName:""}});}}else{event.preventDefault();}});};for(var _i=0;_i<document.querySelectorAll("a[href^='executeDT']").length;_i+=1){_loop(_i);}}// TRACK NORMAL LINKS
var normalLinksList=document.querySelectorAll("a:not([href^='executeDT'])");if(normalLinksList&&normalLinksList[0]){var _loop2=function _loop2(_i2){normalLinksList[_i2].addEventListener("click",function(event){if(normalLinksList[_i2].href&&normalLinksList[_i2].href!=='javascript:void(0)'){try{__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();var user_response=normalLinksList[_i2].title?normalLinksList[_i2].title:"";__WEBPACK_IMPORTED_MODULE_6__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].LINK_CLICKS);}catch(e){console.log(e);}}});};for(var _i2=0;_i2<normalLinksList.length;_i2+=1){_loop2(_i2);}}}},{key:"isCountryTemplate",value:function isCountryTemplate(templateList){return templateList.includes(__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].Scenario_Template_List.IR_Pack_Countries)?true:false;}},{key:"IS_IR_RECO_DYN_PARAM",value:function IS_IR_RECO_DYN_PARAM(templateList){return templateList.includes(__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].Scenario_Template_List.IR_RECO_DYN_PARAM)?true:false;}},{key:"IS_IR_PACKS_RECO",value:function IS_IR_PACKS_RECO(templateList){return templateList.includes(__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].Scenario_Template_List.IR_PACKS_RECO)?true:false;}},{key:"IS_IR_PACKS_ALL",value:function IS_IR_PACKS_ALL(templateList){return templateList.includes(__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].Scenario_Template_List.IR_PACKS_ALL)?true:false;}},{key:"createDynamicData",value:function createDynamicData(templateList,userInput){switch(true){case this.isCountryTemplate(templateList):return{"INPUT_PARAM-IR_BOOSTER_COUNTRY_NAME":userInput};case this.IS_IR_RECO_DYN_PARAM(templateList):return{"INPUT_PARAM-IR_BOOSTER_VALIDITY":userInput};case this.IS_IR_PACKS_RECO(templateList):return{"INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST":userInput};case this.IS_IR_PACKS_ALL(templateList):return{"INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST":userInput};case templateList.includes('IR_ACTIVATED_PACKS_DEACTIVATION'):return{"DEACTIVATION_IR_PACK_ID":userInput};default:return{};}}},{key:"htmlEncode",value:function htmlEncode(inputString){if(inputString===null||inputString.length===0){/* eslint-disable */inputString="";}var finalString="";var inputStringLength=inputString.length;// Allow: a-z A-Z 0-9
// Allow (dec): 97-122 65-90 48-57
for(var _i3=0;_i3<inputStringLength;_i3+=1){var currentCharacter=inputString.charCodeAt(_i3);if(currentCharacter>=97&&currentCharacter<=122||currentCharacter>=65&&currentCharacter<=90||currentCharacter>=48&&currentCharacter<=57){// eslint-disable-next-line
finalString+=inputString.charAt(_i3);}else{// eslint-disable-next-line
finalString+='&#'+currentCharacter+';';}}return finalString;}},{key:"getPlatformWiseLinkForPlanDeatils",value:function getPlatformWiseLinkForPlanDeatils(){var platformType=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("platformType");switch(platformType){case __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].WEB:return __WEBPACK_IMPORTED_MODULE_3__constants_static_links__["a" /* static_links */].plan_rental.WEB;return __WEBPACK_IMPORTED_MODULE_3__constants_static_links__["a" /* static_links */].plan_rental.ANDROID.replace("{mobile}",__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentNumber"));case __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].ANDROID:return __WEBPACK_IMPORTED_MODULE_3__constants_static_links__["a" /* static_links */].plan_rental.ANDROID.replace("{mobile}",__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentNumber"));case __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].IOS:return __WEBPACK_IMPORTED_MODULE_3__constants_static_links__["a" /* static_links */].plan_rental.IOS.replace("{mobile}",__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentNumber"));}}},{key:"userProfileHasValidProducts",value:function userProfileHasValidProducts(userProfile){if(UtilService.isSingleAccount(userProfile)||UtilService.isMultipleAccount(userProfile)){return true;}return false;}},{key:"isMultipleAccount",value:function isMultipleAccount(userProfile){var noOfAccounts=0;if(userProfile&&userProfile.products){for(i=0;i<__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list.length;i++){if(userProfile&&userProfile.products&&userProfile.products.hasOwnProperty(__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list[i])){noOfAccounts+=userProfile.products[__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list[i]].length;}}}if(noOfAccounts>1)return true;return false;}},{key:"isSingleAccount",value:function isSingleAccount(userProfile){var noOfAccounts=0;if(userProfile&&userProfile.products){for(i=0;i<__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list.length;i++){if(userProfile&&userProfile.products&&userProfile.products.hasOwnProperty(__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list[i])){noOfAccounts+=userProfile.products[__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list[i]].length;}}}if(noOfAccounts===1)return true;return false;}},{key:"isPrepaidEnabled",value:function isPrepaidEnabled(){if(__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list.includes('PREPAID')){return true;}else return false;}},{key:"insertAccountTypeInfo",value:function insertAccountTypeInfo(accounts,type){accounts.forEach(function(element){if(type===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].POSTPAID&&element.isSiebel&&element.isSiebel==="true"){element["type"]=__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].SIEBEL;}else{element["type"]=type;}});}},{key:"getUserProfileNumbersWithAccountType",value:function getUserProfileNumbersWithAccountType(profile){var userProfile=profile||__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('userProfile');var numbers=[];if(userProfile&&userProfile.products){for(var _i4=0;_i4<__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list.length;_i4++){if(userProfile&&userProfile.products&&userProfile.products.hasOwnProperty(__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list[_i4])){var product_numbers=userProfile.products[__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list[_i4]];UtilService.insertAccountTypeInfo(product_numbers,__WEBPACK_IMPORTED_MODULE_9__config_config__["a" /* default */].lob_list[_i4]);numbers=[].concat(_toConsumableArray(numbers),_toConsumableArray(product_numbers));}}}return numbers;}},{key:"allowUserLogin",value:function allowUserLogin(loginResult,mobNo){var primaryNumber=loginResult&&loginResult.userProfile&&loginResult.userProfile.userAuthToken&&loginResult.userProfile.userAuthToken.primaryMsisdn?loginResult.userProfile.userAuthToken.primaryMsisdn:mobNo?mobNo:undefined;if(primaryNumber&&loginResult.userProfile&&loginResult.userProfile.products){switch(UtilService.getAccountNumberType(primaryNumber,loginResult.userProfile)){case'POSTPAID':{//ALLOW FOR POASTPAID primary number
return true;}case'PREPAID':{// allow for prepaid primary number
return false;}case'SIEBEL':{// allow for postpaid siebel primary number
return true;}default:{return false;// dont allow for null value
}}}return false;}},{key:"getBotType",value:function getBotType(mobNo,userProfile){userProfile=userProfile?userProfile:__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("userProfile");var numberType=UtilService.getAccountNumberType(mobNo,userProfile);if(numberType===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].POSTPAID){return __WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].POSTPAID;}else if(numberType===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].PREPAID){return __WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].PREPAID;}else if(numberType===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].SIEBEL){return __WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].SIEBEL;}else{return __WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].POSTPAID;}}},{key:"getAccountNumberType",value:function getAccountNumberType(mobNo,userProfile){userProfile=userProfile?userProfile:__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("userProfile");if(mobNo&&userProfile&&userProfile.products&&Object.keys(userProfile.products).length>0){for(var _i5=0;_i5<Object.keys(userProfile.products).length;_i5++){var productKey=Object.keys(userProfile.products)[_i5];for(var j=0;j<userProfile.products[productKey].length;j++){if(userProfile.products[productKey][j].siNumber===mobNo){// console.log('account type number', productKey)
if(productKey.toUpperCase()===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].POSTPAID&&userProfile.products[productKey][j].isSiebel&&userProfile.products[productKey][j].isSiebel==="true"){return __WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].SIEBEL;}else{return productKey.toUpperCase();}}}}}return null;}},{key:"getTotalSessionTimeInSeconds",value:function getTotalSessionTimeInSeconds(){return(new Date().getTime()-__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("trackingData").startTime.getTime())/1000;}},{key:"generateUniqueSessionId",value:function generateUniqueSessionId(){var date=new Date();var components=[date.getYear(),date.getMonth(),date.getDate(),date.getHours(),date.getMinutes(),date.getSeconds(),date.getMilliseconds()];return(components.join("")+Math.random()+Math.random()).replace(".","").replace(".","");}},{key:"refreshLoginToken",value:function refreshLoginToken(){var method="GET";var uri="https://api.myairtelapp.bsbportal.in/myairtelapp/v2/home/mainAccCard?density=XXHDPI";var payload="";var app_reference=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("APP_CONTEXT");var appHeaders=app_reference.getHeaders(method,uri,payload);appHeaders=String(appHeaders).replace(/\n/g,"");appHeaders=JSON.parse(appHeaders);var headers={"x-bsy-dt":String(appHeaders["x-bsy-dt"]).replace(/\n/g,""),"x-bsy-utkn1":String(appHeaders["x-bsy-utkn"]).replace(/\n/g,""),"x-bsy-did":String(appHeaders["x-bsy-did"]).replace(/\n/g,"")};var newappHeaders=app_reference.getHeaders(method,"https://www.airtel.in/app/wl-service/airtel-digital-profile/rest/customer/profile/v2/rtn/fetch","");newappHeaders=String(newappHeaders).replace(/\n/g,"");newappHeaders=JSON.parse(newappHeaders);headers["x-bsy-utkn2"]=String(newappHeaders["x-bsy-utkn"]).replace(/\n/g,"");ChatBotApiService.getChatTokenForApp(headers).then(function(result){if(result&&result.access_token){__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("loggedInToken","Bearer"+result.access_token);}},function(err){console.log(err);});}},{key:"isResponseEmpty",value:function isResponseEmpty(response){var final=response.replace(/<(\/?)([a-z]*)([A-Z]*)>/g,'');// console.log(final)
if(final.trim()===""){return true;}else return false;}},{key:"getSpeechResponse",value:function getSpeechResponse(response){var final=response.replace(/<(\/?)([a-z]*)([A-Z]*)>/g,'');return final;}},{key:"getCategoryFaqPlatformResponse",value:function getCategoryFaqPlatformResponse(category_object){var platformType=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("platformType");var finalResult=void 0;if(platformType===__WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].ANDROID){if(__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&category_object.android){var replaceString="{mobile}";finalResult=this.replaceAll(category_object.android,replaceString,__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}else if(!__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&category_object.web){var _replaceString="{mobile}";finalResult=this.replaceAll(category_object.web,_replaceString,__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}}else if(platformType===__WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].IOS){if(__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&category_object.ios){var _replaceString2="{mobile}";finalResult=this.replaceAll(category_object.ios,_replaceString2,__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}else if(!__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&category_object.web){var _replaceString3="{mobile}";finalResult=this.replaceAll(category_object.web,_replaceString3,__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}}return category_object.web;}},{key:"hasTemplateDisableInput",value:function hasTemplateDisableInput(templateList){if(templateList.includes('DISABLE_INPUT')){return true;}else return false;}},{key:"checkIfRedirectCase",value:function checkIfRedirectCase(){var params=new URLSearchParams(window.location.search);if(params.get("changePlanStatus")){return"changePlanRedirectCase";}else if(params.get("transactionStatus")){return"paymentTransactionRedirectCase";}else return undefined;}},{key:"getParamValue",value:function getParamValue(key){var params=new URLSearchParams(window.location.search);var value=params.get(key);return value?value:null;}},{key:"removeSourceAndUriParamsFromLink",value:function removeSourceAndUriParamsFromLink(link){var startLink=link.split('?')[0];var queryString=link.split('?')[1];// console.log(startLink,queryString)
var params=queryString.split('&');params=params.filter(function(param){return!(param.indexOf('source=')!==-1||param.indexOf('uri=')!==-1);});var newQueryString='?'+params.join('&');var newLink=startLink+newQueryString;return newLink;}},{key:"checkIfInitializationParamsMissing",value:function checkIfInitializationParamsMissing(){var scenarioList=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('scenarioList');if(!__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('basicToken')){return true;}if(!scenarioList||scenarioList&&(!scenarioList[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('currentBotType')]||scenarioList[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('currentBotType')]&&scenarioList[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('currentBotType')].length===0)){return true;}if(__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){if(!__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('loggedInToken')){return true;}}else{return false;}}},{key:"returnSwipeGesture",value:function returnSwipeGesture(position){if(Math.abs(position.x)>Math.abs(position.y)){// horizontal swipe
return'HORIZONTAL_SWIPE';}else{// vertical swipe
return'VERTICAL_SWIPE';}}},{key:"checkForCarouselWebScrollArrows",value:function checkForCarouselWebScrollArrows(){var carousels=document.getElementsByClassName('monthly-plan');var carousel_arrows_div=void 0;if(carousels&&carousels.length>0){for(var _i6=0;_i6<carousels.length;_i6++){carousel_arrows_div=null;if(carousels[_i6].childNodes&&carousels[_i6].childNodes.length>0){for(var j=0;j<carousels[_i6].childNodes.length;j++){if(carousels[_i6].childNodes[j]&&carousels[_i6].childNodes[j].classList.length>0){for(var k=0;k<carousels[_i6].childNodes[j].classList.length;k++){if(carousels[_i6].childNodes[j].classList[k]==="carousel_web_arrows"){carousel_arrows_div=carousels[_i6].childNodes[j];}if(carousels[_i6].childNodes[j].classList[k]==="carousel_list"){var list=carousels[_i6].childNodes[j];if(!(list.scrollWidth>list.offsetWidth)){if(carousel_arrows_div){// set display property fro carousel arrows to none
carousel_arrows_div.remove();return;}}}}}}}}}}}]);return UtilService;}();UtilService.getAccountsForBotType=function(userProfile,BotType){var botTypeAccounts=[];BotType=BotType.toUpperCase();if(userProfile&&userProfile.products&&userProfile.products[BotType]){botTypeAccounts=userProfile.products[BotType];}return botTypeAccounts;};UtilService.startScrollingRight=function(id){var count=0;var count_limit=13;var myInterval=setInterval(function(){count++;if(document.getElementById(id).scrollLeft===0){count_limit=19;}document.getElementById(id).scrollLeft=document.getElementById(id).scrollLeft+10;if(count>count_limit){clearInterval(myInterval);}},10);_this.myInterval=myInterval;};UtilService.startScrollingLeft=function(id){var count=0;var myInterval=setInterval(function(){count++;document.getElementById(id).scrollLeft=document.getElementById(id).scrollLeft-10;if(count>13){clearInterval(myInterval);}},10);_this.myInterval=myInterval;};UtilService.getIosSpecificClass=function(){var platformType=UtilService.getPlatformTypeForTracking();if(platformType===__WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__["a" /* default */].IOS_MSITE||platformType===__WEBPACK_IMPORTED_MODULE_8__enums_TrackingPlatform__["a" /* default */].IOS_WEBVIEW)return"ios-scroll-fix";else return"";};UtilService.isBadFeedbackScenario=function(current_scenario){if(current_scenario&&current_scenario.scenario&&current_scenario.scenario.scenarioId===__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentBotType")]['BAD_FEEDBACK'].scenarioId){return true;}else return false;};UtilService.isGridClickScenario=function(current_scenario){var isGridClickScenario=false;if(current_scenario&&current_scenario.scenario&&current_scenario.scenario.scenarioId){switch(current_scenario.scenario.scenarioId){case __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentBotType")]["WELCOME"].scenarioId:case __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentBotType")]["FAILURE"].scenarioId:case __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_1"].scenarioId:case __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_2"].scenarioId:{isGridClickScenario=true;break;}}}return isGridClickScenario;};UtilService.createUserMessageObject=function(message,is_feedback){return{component_type:'USER_RESPONSE',message:message,messageTime:UtilService.getCurrentTime(),is_feedback:is_feedback};};UtilService.createChatBotMessageObject=function(message){return{component_type:'DEFAULT',message:message,messageTime:UtilService.getCurrentTime()};};UtilService.disableActivateIrCardLink=function(){var ir_card_links=document.getElementsByClassName('ir-card-links');for(var _i7=0;_i7<ir_card_links.length;_i7++){ir_card_links[_i7].disabled=true;ir_card_links[_i7].style.opacity=0.5;}};UtilService.disableDeactivateIrCardLink=function(){var ir_card_links=document.getElementsByClassName('dir-card-links');for(var _i8=0;_i8<ir_card_links.length;_i8++){ir_card_links[_i8].disabled=true;ir_card_links[_i8].style.opacity=0.5;}};UtilService.disableSwitchMessageButtonClick=function(){var btns=document.getElementsByClassName('switch_msg_btn');for(var _i9=0;_i9<btns.length;_i9++){btns[_i9].disabled=true;btns[_i9].style.opacity=0.5;}};/* harmony default export */ __webpack_exports__["a"] = (UtilService);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return globalConstants; });
var globalConstants={feedbackScenarioIds:{POSITIVE:'5b7147f098a4ed07f726a5ee',NEGATIVE:'5b7148ef98a4ed07f726a5ef'},botTypeBaseUrl:{POSTPAID:"chatMediator",PREPAID:"chatMediatorPrePaid",PAYMENTSBANK:"chatMediatorBank"},script:{welcomeScenarioWithoutMsisdnText:"Hello there! Hope you’re having a good day!",dffShowText:"Please provide us some of your details so that I can register a complaint on your behalf."},error:{limitReached:"You’ve tried the maximum number of times for today. Please come back after 24 hours and try again.",inCorrectOtp:"Oops! The OTP you've entered is incorrect. Please retry.",validateError:"Oops! Your OTP could not be validated. Please retry.",otpSendError:"Oops! Your OTP could not be sent. Please retry.",noPostpaidAccountMessage:"Oops! The mobile number you have entered is not a valid postpaid number. Kindly enter a Postpaid number.",loggedOutMessage:"It Seems you have logged out. Kindly relogin for smoother experience.",dffSubmitErrorMsg:"Oops! Something went wrong.",genericSRError:"Oops! An unexpected error has occurred, please try after sometime."},login_message:'For a seamless experience, please login with your Airtel number.',login_again_message:'Oops! Your session has expired. Please re-login.',login_successful_message:'Great! You have successfully logged-in',default_error_message:'Ooops.. something went wrong!',number_chosen_message:'',cancel_chatbot_response:' Got it. Please share a new query or choose your query from the bottom left menu.',number_selected_acknowledgement_msg:' Great! Let’s get started.',successful_switch_message:'Great! You have successfully switched account to ',on_skip_message:'Please type in your new query.',Scenario_Template_List:{"IR_Pack_Countries":"IR_Pack_Countries","IR_PACKS_RECO":"IR_PACKS_RECO","IR_RECO_DYN_PARAM":"IR_RECO_DYN_PARAM","IR_PACKS_ALL":"IR_PACKS_ALL"},CONFIRMATION_FOR_SINGLE_ACCOUNT_WEB:{scenarioType:"ASK_NUMBER_CONFIRMATION_WEB",responseFirst:"Hello there! Hope you’re having a good day!",response:"Hey! Seems you're already logged-in to your account. Do you wish to continue chat for moblieNumbetPlaceholder ?",options:[{choiceId:"1",choiceText:"YES",displayText:"YES",nextStep:"2"},{choiceId:"2",choiceText:"NO",displayText:"NO",nextStep:"3"}]},CONFIRMATION_FOR_MULTIPLE_CHATHISTORYREAD_APP:{scenarioType:"ASK_NUMBER_CONFIRMATION_FOR_MULTIPLE_CHATHISTORYREAD_APP",responseFirst:"Hello there! Hope you’re having a good day!",response:"Hey! You were chatting with number %mobilenumberplaceholder% . You wish to continue or switch account?",options:[{choiceId:"1",choiceText:"YES",displayText:"YES",nextStep:"2"},{choiceId:"2",choiceText:"NO",displayText:"NO",nextStep:"3"}]},SESSION_EXPIRED_STATUS:{status:"UNAUTHORIZED",message:"Ooops.. something went wrong! Please type in query again."},TRACKING_EVENTS_CONSTANTS:{pageName:"leadIframe",source:window.MyAirtelAppReact||window.MyAirtelChatAppReact?"APP":"WEB",loginType:{"OTP":"OTP","ALREADY_LOGGEDIN":"ALREADY_LOGGEDIN"}},USER_ACTION_TYPES:{'CHAT':'SMART_SEARCH_CLICK','PLACE':'COUNTRY_SELECT','DEFAULT':'CHAT_TEXT_ENTER','CATEGORY':'CATEGORY_OPTION_CLICK'},INPUT_FIELD_TYPES:{'CHAT':'CHAT','PLACE':'PLACE'},BOTTOM_BAR_COMPONENTS:{CHAT_INPUT_BAR:'CHAT_BAR_COMPONENT',LOGIN_COMPONENT:'LOGIN_COMPONENT',USER_ACCOUNTS_MENU:'USER_ACCOUNTS_MENU',CANCEL_COMPONENT:'CANCEL_COMPONENT',DFF_FORM_COMPONENT:'DFF_FORM_COMPONENT'},CANCEL_CASES:{"IR_PACK":{title:"Cancel IR pack request?",message:"This will end your current session of IR pack request. Do you want to proceed?",cancel_user_response:'I want to cancel my IR pack activation request'},"Eligible_Bill_Plans":{title:"Cancel plan change request?",message:"This will end your current session of plan change request. Do you want to proceed?",cancel_user_response:'I want to cancel my plan change request'},"New_Bill_Plan":{title:"Cancel new plan request?",message:"This will end your current session of new plan request. Do you want to proceed?",cancel_user_response:'I want to cancel my new plan request'},"IR_ACTIVATED_PACKS_DEACTIVATION":{title:"Cancel IR deactivation request?",message:"This will end your current session of IR pack deactivation request. Do you want to proceed?",cancel_user_response:'I want to cancel my IR pack deactivation request'}}};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PlatformType={"WEB":"WEB","ANDROID":"ANDROID","IOS":"IOS"};/* harmony default export */ __webpack_exports__["a"] = (PlatformType);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(16));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./evpkdf"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher core components.
	 */
	CryptoJS.lib.Cipher || (function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var Base64 = C_enc.Base64;
	    var C_algo = C.algo;
	    var EvpKDF = C_algo.EvpKDF;

	    /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */
	    var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */
	        cfg: Base.extend(),

	        /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createEncryptor: function (key, cfg) {
	            return this.create(this._ENC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */
	        createDecryptor: function (key, cfg) {
	            return this.create(this._DEC_XFORM_MODE, key, cfg);
	        },

	        /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */
	        init: function (xformMode, key, cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Store transform mode and key
	            this._xformMode = xformMode;
	            this._key = key;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-cipher logic
	            this._doReset();
	        },

	        /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */
	        process: function (dataUpdate) {
	            // Append
	            this._append(dataUpdate);

	            // Process available blocks
	            return this._process();
	        },

	        /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */
	        finalize: function (dataUpdate) {
	            // Final data update
	            if (dataUpdate) {
	                this._append(dataUpdate);
	            }

	            // Perform concrete-cipher logic
	            var finalProcessedData = this._doFinalize();

	            return finalProcessedData;
	        },

	        keySize: 128/32,

	        ivSize: 128/32,

	        _ENC_XFORM_MODE: 1,

	        _DEC_XFORM_MODE: 2,

	        /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */
	        _createHelper: (function () {
	            function selectCipherStrategy(key) {
	                if (typeof key == 'string') {
	                    return PasswordBasedCipher;
	                } else {
	                    return SerializableCipher;
	                }
	            }

	            return function (cipher) {
	                return {
	                    encrypt: function (message, key, cfg) {
	                        return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
	                    },

	                    decrypt: function (ciphertext, key, cfg) {
	                        return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
	                    }
	                };
	            };
	        }())
	    });

	    /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */
	    var StreamCipher = C_lib.StreamCipher = Cipher.extend({
	        _doFinalize: function () {
	            // Process partial blocks
	            var finalProcessedBlocks = this._process(!!'flush');

	            return finalProcessedBlocks;
	        },

	        blockSize: 1
	    });

	    /**
	     * Mode namespace.
	     */
	    var C_mode = C.mode = {};

	    /**
	     * Abstract base block cipher mode template.
	     */
	    var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
	        /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */
	        createEncryptor: function (cipher, iv) {
	            return this.Encryptor.create(cipher, iv);
	        },

	        /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */
	        createDecryptor: function (cipher, iv) {
	            return this.Decryptor.create(cipher, iv);
	        },

	        /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */
	        init: function (cipher, iv) {
	            this._cipher = cipher;
	            this._iv = iv;
	        }
	    });

	    /**
	     * Cipher Block Chaining mode.
	     */
	    var CBC = C_mode.CBC = (function () {
	        /**
	         * Abstract base CBC mode.
	         */
	        var CBC = BlockCipherMode.extend();

	        /**
	         * CBC encryptor.
	         */
	        CBC.Encryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // XOR and encrypt
	                xorBlock.call(this, words, offset, blockSize);
	                cipher.encryptBlock(words, offset);

	                // Remember this block to use with next block
	                this._prevBlock = words.slice(offset, offset + blockSize);
	            }
	        });

	        /**
	         * CBC decryptor.
	         */
	        CBC.Decryptor = CBC.extend({
	            /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */
	            processBlock: function (words, offset) {
	                // Shortcuts
	                var cipher = this._cipher;
	                var blockSize = cipher.blockSize;

	                // Remember this block to use with next block
	                var thisBlock = words.slice(offset, offset + blockSize);

	                // Decrypt and XOR
	                cipher.decryptBlock(words, offset);
	                xorBlock.call(this, words, offset, blockSize);

	                // This block becomes the previous block
	                this._prevBlock = thisBlock;
	            }
	        });

	        function xorBlock(words, offset, blockSize) {
	            // Shortcut
	            var iv = this._iv;

	            // Choose mixing block
	            if (iv) {
	                var block = iv;

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            } else {
	                var block = this._prevBlock;
	            }

	            // XOR blocks
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= block[i];
	            }
	        }

	        return CBC;
	    }());

	    /**
	     * Padding namespace.
	     */
	    var C_pad = C.pad = {};

	    /**
	     * PKCS #5/7 padding strategy.
	     */
	    var Pkcs7 = C_pad.Pkcs7 = {
	        /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */
	        pad: function (data, blockSize) {
	            // Shortcut
	            var blockSizeBytes = blockSize * 4;

	            // Count padding bytes
	            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	            // Create padding word
	            var paddingWord = (nPaddingBytes << 24) | (nPaddingBytes << 16) | (nPaddingBytes << 8) | nPaddingBytes;

	            // Create padding
	            var paddingWords = [];
	            for (var i = 0; i < nPaddingBytes; i += 4) {
	                paddingWords.push(paddingWord);
	            }
	            var padding = WordArray.create(paddingWords, nPaddingBytes);

	            // Add padding
	            data.concat(padding);
	        },

	        /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */
	        unpad: function (data) {
	            // Get number of padding bytes from last byte
	            var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	            // Remove padding
	            data.sigBytes -= nPaddingBytes;
	        }
	    };

	    /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */
	    var BlockCipher = C_lib.BlockCipher = Cipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */
	        cfg: Cipher.cfg.extend({
	            mode: CBC,
	            padding: Pkcs7
	        }),

	        reset: function () {
	            // Reset cipher
	            Cipher.reset.call(this);

	            // Shortcuts
	            var cfg = this.cfg;
	            var iv = cfg.iv;
	            var mode = cfg.mode;

	            // Reset block mode
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                var modeCreator = mode.createEncryptor;
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                var modeCreator = mode.createDecryptor;
	                // Keep at least one block in the buffer for unpadding
	                this._minBufferSize = 1;
	            }

	            if (this._mode && this._mode.__creator == modeCreator) {
	                this._mode.init(this, iv && iv.words);
	            } else {
	                this._mode = modeCreator.call(mode, this, iv && iv.words);
	                this._mode.__creator = modeCreator;
	            }
	        },

	        _doProcessBlock: function (words, offset) {
	            this._mode.processBlock(words, offset);
	        },

	        _doFinalize: function () {
	            // Shortcut
	            var padding = this.cfg.padding;

	            // Finalize
	            if (this._xformMode == this._ENC_XFORM_MODE) {
	                // Pad data
	                padding.pad(this._data, this.blockSize);

	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');
	            } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
	                // Process final blocks
	                var finalProcessedBlocks = this._process(!!'flush');

	                // Unpad data
	                padding.unpad(finalProcessedBlocks);
	            }

	            return finalProcessedBlocks;
	        },

	        blockSize: 128/32
	    });

	    /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */
	    var CipherParams = C_lib.CipherParams = Base.extend({
	        /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */
	        init: function (cipherParams) {
	            this.mixIn(cipherParams);
	        },

	        /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */
	        toString: function (formatter) {
	            return (formatter || this.formatter).stringify(this);
	        }
	    });

	    /**
	     * Format namespace.
	     */
	    var C_format = C.format = {};

	    /**
	     * OpenSSL formatting strategy.
	     */
	    var OpenSSLFormatter = C_format.OpenSSL = {
	        /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            // Shortcuts
	            var ciphertext = cipherParams.ciphertext;
	            var salt = cipherParams.salt;

	            // Format
	            if (salt) {
	                var wordArray = WordArray.create([0x53616c74, 0x65645f5f]).concat(salt).concat(ciphertext);
	            } else {
	                var wordArray = ciphertext;
	            }

	            return wordArray.toString(Base64);
	        },

	        /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */
	        parse: function (openSSLStr) {
	            // Parse base64
	            var ciphertext = Base64.parse(openSSLStr);

	            // Shortcut
	            var ciphertextWords = ciphertext.words;

	            // Test for salt
	            if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
	                // Extract salt
	                var salt = WordArray.create(ciphertextWords.slice(2, 4));

	                // Remove salt from ciphertext
	                ciphertextWords.splice(0, 4);
	                ciphertext.sigBytes -= 16;
	            }

	            return CipherParams.create({ ciphertext: ciphertext, salt: salt });
	        }
	    };

	    /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */
	    var SerializableCipher = C_lib.SerializableCipher = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */
	        cfg: Base.extend({
	            format: OpenSSLFormatter
	        }),

	        /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Encrypt
	            var encryptor = cipher.createEncryptor(key, cfg);
	            var ciphertext = encryptor.finalize(message);

	            // Shortcut
	            var cipherCfg = encryptor.cfg;

	            // Create and return serializable cipher params
	            return CipherParams.create({
	                ciphertext: ciphertext,
	                key: key,
	                iv: cipherCfg.iv,
	                algorithm: cipher,
	                mode: cipherCfg.mode,
	                padding: cipherCfg.padding,
	                blockSize: cipher.blockSize,
	                formatter: cfg.format
	            });
	        },

	        /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, key, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Decrypt
	            var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);

	            return plaintext;
	        },

	        /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */
	        _parse: function (ciphertext, format) {
	            if (typeof ciphertext == 'string') {
	                return format.parse(ciphertext, this);
	            } else {
	                return ciphertext;
	            }
	        }
	    });

	    /**
	     * Key derivation function namespace.
	     */
	    var C_kdf = C.kdf = {};

	    /**
	     * OpenSSL key derivation function.
	     */
	    var OpenSSLKdf = C_kdf.OpenSSL = {
	        /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */
	        execute: function (password, keySize, ivSize, salt) {
	            // Generate random salt
	            if (!salt) {
	                salt = WordArray.random(64/8);
	            }

	            // Derive key and IV
	            var key = EvpKDF.create({ keySize: keySize + ivSize }).compute(password, salt);

	            // Separate key and IV
	            var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
	            key.sigBytes = keySize * 4;

	            // Return params
	            return CipherParams.create({ key: key, iv: iv, salt: salt });
	        }
	    };

	    /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */
	    var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */
	        cfg: SerializableCipher.cfg.extend({
	            kdf: OpenSSLKdf
	        }),

	        /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        encrypt: function (cipher, message, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Encrypt
	            var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);

	            // Mix in derived params
	            ciphertext.mixIn(derivedParams);

	            return ciphertext;
	        },

	        /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */
	        decrypt: function (cipher, ciphertext, password, cfg) {
	            // Apply config defaults
	            cfg = this.cfg.extend(cfg);

	            // Convert string to CipherParams
	            ciphertext = this._parse(ciphertext, cfg.format);

	            // Derive key and other params
	            var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);

	            // Add IV to config
	            cfg.iv = derivedParams.iv;

	            // Decrypt
	            var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);

	            return plaintext;
	        }
	    });
	}());


}));

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BotType={PREPAID:"PREPAID",POSTPAID:"POSTPAID",PAYMENTS_BANK:"PAYMENTSBANK",SIEBEL:"SIEBEL",getNumberTypeToShow:function getNumberTypeToShow(type){if(type){switch(type){case BotType.SIEBEL:return'POSTPAID';default:return type;}}else{return'';}}};/* harmony default export */ __webpack_exports__["a"] = (BotType);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCRIPTS; });
var SCRIPTS={WELCOME:'Hey! Great to have you here.<br/>  What can I help you with today?',WELCOME_BACK:'Hey! Great to have you back :)<br/>  What can I help you with today?',SELECT_ACCOUNT:'Just choose a connection for which you want to talk about.',LOGIN_SUCCESS:'Great! You have successfully logged-in',SKIP_MESSAGE:'Please type in your new query.',DEFAULT_ERROR:'Ooops.. something went wrong!',PLAN_CHANGE_SUCCESS:'You request for plan change is under process and will take 2 hours to complete. Don’t worry, an SMS confirmation will be sent once the plan change request is completed.',PLAN_CHANGE_FAIL:'Uh-oh ! Your request for plan change could not be completed successfully. Please retry.',PAYMENT_SUCCESS:'Yay ! Your transaction was successful. Here are your payment details:<br>\n                                Mobile Number: {mobile}\n                                Amount Paid: Rs {amount}\n                                Transaction Id: {transactionId}\n                                Transaction Date: {transactionDate}',PAYMENT_FAIL:'Uh-oh ! Your payment could not be completed successfully. Please retry.',PAYMENT_PENDING:'Your payment is under process. Don’t worry, an SMS confirmation will be sent once the payment is done.',EXCEPTION_REPLACED_MESSAGE:'Oops, I am not able to process your request at this moment. You can connect to our Airtel friends at 121.',NO_SYSTEM_INFO_MESSAGE:' Oops, I am not able to find this information at this moment. You can connect with our Airtel friends at 121.',NO_BILLS:'This is to inform you that there are  no previous bills on your account.',NO_RECEIPTS:'This is to inform you that there are no previous receipts on your account.',SR_RAISED_SUCCESSFULLY:'I have registered your complaint via service request no. ',LOB_SPECIFIC_NO_RESOLUTION_VOC:"I'm sorry! I'm unable to provide resolution to your queries for {LOB} connection at the moment.",LOGIN_FAILED_PLEASE_RELOGIN:"Hey! while I’m learning about other businesses I can currently answer Postpaid related queries. Please login with a Postpaid number."};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(60);
var isBuffer = __webpack_require__(113);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TrackingKey={START_CHAT_SUCCESS:"start_chat_success",START_CHAT_FAIL:"start_chat_fail",LOGIN_SUCCESS:"login_success",LOGIN_FAIL:"login_fail",FAQ_QUERY:"faq_query",SCENARIO_QUERY:"scenario_query",FEEDBACK_SKIPPED:"feedback_skipped",CLOSE_CHAT_YES:"close_chat_yes",CLOSE_CHAT_NO:"close_chat_no",SSO_PROFILE_SINGLE:'sso_profile_single',SSO_PROFILE_MULTIPLE:'sso_profile_multiple',SSO_PROFILE_NO_ACCOUNT:'sso_profile_no_account',INTENT_READING_SUCCESS:"intent_reading_success",INTENT_READING_FAIL:"intent_reading_fail",ERROR_FRONTEND:"error_frontend",ERROR_BACKEND:"error_backend",IDLE_CHAT:"idle_chat",RETRY_OPTION:"retry_option",FEEDBACK_HAPPY:"feedback_happy",FEEDBACK_SAD:"feedback_sad",IMPROVE_FEEDBACK:"improve_feedback",IMPROVE_FEEDBACK_SKIPPED:"improve_feedback_skipped",GRID_CLICKS:'grid_clicks',LINK_CLICKS:'link_clicks',SWITCH_CLICK_PRE_TO_POST:'switch_click_pre_to_post',SWITCH_CLICK_POST_TO_PRE:'switch_click_post_to_pre'};/* harmony default export */ __webpack_exports__["a"] = (TrackingKey);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom_http_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums_BotType__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ChatBotApiService=function(){function ChatBotApiService(){_classCallCheck(this,ChatBotApiService);}_createClass(ChatBotApiService,null,[{key:'getBaseApiUrl',value:function getBaseApiUrl(botType){var user_logged_in=false;if(!__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('primaryNumber')&&__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('currentNumber')&&__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('isUserLoggedIn')&&__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('loggedInToken')){user_logged_in=true;}if(!botType){botType=__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("currentBotType");}return''+(user_logged_in?__WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* default */].baseUrlWithAuth:__WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* default */].baseUrlWithoutAuth)+__WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* default */].botTypeBaseUrl[botType]+'/';}},{key:'initiate',value:function initiate(mobileNo,scenarioObject,initiateretry,botType){// const url = `${ChatBotApiService.getBaseApiUrl()}initiateScenario`;
var url='initiateScenario';var data=void 0;if(initiateretry){data={scenario:scenarioObject,msisdn:mobileNo,scenarioActive:true,initiateRetry:initiateretry};}else{data={scenario:scenarioObject,msisdn:mobileNo,scenarioActive:true};}return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'chatInScenario',value:function chatInScenario(mobileNo,authtoken,Response,transactionid,ScenarioObject,enteredtext,initiateretry,botType,acceptParameters,dynamicParameters){var enteredTextLowerCase=enteredtext.toLowerCase();// const url = `${ChatBotApiService.getBaseApiUrl()}chatInScenario`;
var url='chatInScenario';var data=void 0;if(initiateretry){data={msisdn:mobileNo,authToken:authtoken,transactionId:transactionid,scenarioActive:true,enteredText:enteredTextLowerCase,scenario:ScenarioObject,initiateRetry:initiateretry,response:Response};}else if(!initiateretry){data={msisdn:mobileNo,authToken:authtoken,transactionId:transactionid,scenarioActive:true,enteredText:enteredTextLowerCase,scenario:ScenarioObject,response:Response,acceptParameters:acceptParameters,dynamicParameters:dynamicParameters};}return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'chatOutScenario',value:function chatOutScenario(enteredtext){var enteredTextLowerCase=enteredtext.toLowerCase();// const url = `${ChatBotApiService.getBaseApiUrl()}chatOutScenario`;
var url='chatOutScenario';var data={enteredText:enteredTextLowerCase};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'submitFeedback',value:function submitFeedback(){// const url = `${ChatBotApiService.getBaseApiUrl()}saveFeedback`;
var url='saveFeedback';var data={customerNumber:"",timestamp:""};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,null,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getSmartSearches',value:function getSmartSearches(searchText){var url=ChatBotApiService.getBaseApiUrl()+'autoSuggest?text='+searchText;return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getCountrySmartSearches',value:function getCountrySmartSearches(searchText){var url=ChatBotApiService.getBaseApiUrl()+'countrySuggest?text='+searchText;return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getUserMsisdn',value:function getUserMsisdn(reqData){// const url = `${ChatBotApiService.getBaseApiUrl()}authenticateUser`;
var url='authenticateUser';var data={"x-bsy-did":reqData["x-bsy-did"],"x-bsy-utkn":reqData["x-bsy-utkn"],"x-bsy-dt":reqData["x-bsy-dt"]};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,null,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'submitDffCall',value:function submitDffCall(reqData){// const url = `${ChatBotApiService.getBaseApiUrl()}createServiceRequest`;
var url='createServiceRequest';var data={tagging:reqData.crmCode,notes:reqData.notes,scenarioName:reqData.scenarioName,lob:"postpaid",source:"DTPSTCBOT",transactionId:reqData.transactionId,dffNameValuePairs:reqData.dffNameValuePairs,channel:"chatbot",locationSMS:false,smsTemplate:"",authToken:reqData.authToken};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getSSOProfileInApp',value:function getSSOProfileInApp(reqData){// const url = `${ChatBotApiService.getBaseApiUrl()}userProfile`;
var url='userProfile';var data={"x-bsy-did":reqData["x-bsy-did"],"x-bsy-utkn":reqData["x-bsy-utkn"],"x-bsy-dt":reqData["x-bsy-dt"]};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,null,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getPostPaidBill',value:function getPostPaidBill(reqData){// const url = `${ChatBotApiService.getBaseApiUrl()}userProfile`;
var url='fetchPostPaidBill ';var data=reqData;return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getDefaultPostpaidScenarios',value:function getDefaultPostpaidScenarios(){var url=ChatBotApiService.getBaseApiUrl(__WEBPACK_IMPORTED_MODULE_6__enums_BotType__["a" /* default */].POSTPAID)+'welcomeConfiguration';return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getDefaultPrepaidScenarios',value:function getDefaultPrepaidScenarios(){var url=ChatBotApiService.getBaseApiUrl(__WEBPACK_IMPORTED_MODULE_6__enums_BotType__["a" /* default */].PREPAID)+'welcomeConfiguration';return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getBotTypeDefaultScenarios',value:function getBotTypeDefaultScenarios(botType){var url=ChatBotApiService.getBaseApiUrl(botType)+'welcomeConfiguration';return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getOptionsCategories',value:function getOptionsCategories(){var url=ChatBotApiService.getBaseApiUrl()+'categoryFetch';return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,{},__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].CHATBOT);}},{key:'getChatToken',value:function getChatToken(){var botType=__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("currentBotType");var url=''+__WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* default */].baseUrlWithoutAuth+__WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* default */].botTypeBaseUrl[botType]+'/chatToken';var data={"grant_type":"password","authSource":"BASIC"};var config={headers:{"Authorization":"Basic Y2hhdGJvdF91aV9jbGllbnQ6Y2hhdGJvdF91aV9jbGllbnQ=","Content-Type":"application/x-www-form-urlencoded"}};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED);}},{key:'getChatTokenForWeb',value:function getChatTokenForWeb(reqData){// const url = `https://www.airtel.in/ds2/chatbotstage/chatMediator/chatToken`;
var url=__WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* default */].baseUrlWithAuth+'chatMediator/chatToken';var data={"grant_type":"password","authSource":"AIRTEL_WEB","client_id":'chatbot_ui_client',"client_secret":'chatbot_ui_client'};var config={headers:{// "Authorization": "Basic Y2hhdGJvdF91aV9jbGllbnQ6Y2hhdGJvdF91aV9jbGllbnQ=",
"Content-Type":"application/x-www-form-urlencoded"}};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED);}},{key:'getChatTokenForApp',value:function getChatTokenForApp(reqData){var url=__WEBPACK_IMPORTED_MODULE_3__config_config__["a" /* default */].baseUrlWithoutAuth+'chatMediator/chatToken';var data={"grant_type":"password","authSource":"AIRTEL_APP","x-bsy-dt":reqData["x-bsy-dt"],"x-bsy-did":reqData["x-bsy-did"],"x-bsy-utkn1":reqData["x-bsy-utkn1"],"x-bsy-utkn2":reqData["x-bsy-utkn2"]};var config={headers:{"Authorization":"Basic Y2hhdGJvdF91aV9jbGllbnQ6Y2hhdGJvdF91aV9jbGllbnQ=","Content-Type":"application/x-www-form-urlencoded"}};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED);}}]);return ChatBotApiService;}();/* harmony default export */ __webpack_exports__["a"] = (ChatBotApiService);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_local__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_staging__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_prod__ = __webpack_require__(109);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Config=function(){function Config(){_classCallCheck(this,Config);}_createClass(Config,null,[{key:'getConfig',value:function getConfig(){switch("prod"){case'staging':return __WEBPACK_IMPORTED_MODULE_1__config_staging__["a" /* default */];case'prod':return __WEBPACK_IMPORTED_MODULE_2__config_prod__["a" /* default */];case'local':return __WEBPACK_IMPORTED_MODULE_0__config_local__["a" /* default */];default:return __WEBPACK_IMPORTED_MODULE_0__config_local__["a" /* default */];}}}]);return Config;}();Config.GLOBAL_CONFIG=Config.getConfig();/* harmony default export */ __webpack_exports__["a"] = (Config.GLOBAL_CONFIG);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_trackingKey__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var IdleTimeoutService=function(){function IdleTimeoutService(){_classCallCheck(this,IdleTimeoutService);}_createClass(IdleTimeoutService,null,[{key:"trackIdleChat",value:function trackIdleChat(){// TRACK IDLE TIMEOUT
var trackIdleEvent=setInterval(function(){if(!__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("trackingData").isIdleChatCallled&&__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("trackingData").isIdleChat){__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_3__enums_trackingKey__["a" /* default */].IDLE_CHAT);var _trackingData=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("trackingData");_trackingData.isIdleChatCallled=true;__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("trackingData",_trackingData);clearInterval(trackIdleEvent);}var trackingData=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("trackingData");trackingData.isIdleChat=true;__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("trackingData",trackingData);},1000*60*4);}},{key:"updateIdleState",value:function updateIdleState(){var trackingData=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("trackingData");trackingData.isIdleChat=false;__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("trackingData",trackingData);}}]);return IdleTimeoutService;}();/* harmony default export */ __webpack_exports__["a"] = (IdleTimeoutService);

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bot_analytics_service__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TrackingMiddlewareService=function(){function TrackingMiddlewareService(){_classCallCheck(this,TrackingMiddlewareService);this.pageName="leadIframe";this.platform=window.MyAirtelAppReact||window.MyAirtelChatAppReact?"APP":"WEB";this.platformType=null;this.sessionId=null;this.circle="";this.startTime=new Date();this.user_response="";this.enteredTextMode="";this.scenarioName="";this.scenarioStrategy="";this.user_suggestion="";this.intentScore="";this.setTrackingForSSOMultiple=function(userProfile){var str='';if(userProfile&&userProfile.products){var lob_arr=Object.keys(userProfile.products);for(var i=0;i<lob_arr.length;i++){if(userProfile.products[lob_arr[i]].length>0){for(var j=0;j<userProfile.products[lob_arr[i]].length;j++){str=str+("m="+userProfile.products[lob_arr[i]][j]['siNumber']+",l="+lob_arr[i]+"|");}}}// console.log('multiple tracking str', str)
window.ssoProfile=str;}};}_createClass(TrackingMiddlewareService,[{key:"setTrackingData",value:function setTrackingData(_ref){var circle=_ref.circle,enteredTextMode=_ref.enteredTextMode,user_response=_ref.user_response,current_scenario=_ref.current_scenario,user_suggestion=_ref.user_suggestion,scenarioName=_ref.scenarioName,scenarioStrategy=_ref.scenarioStrategy,intentScore=_ref.intentScore;// console.log({circle,enteredTextMode,user_response,current_scenario,user_suggestion,scenarioName,scenarioStrategy})
if(current_scenario){if(current_scenario.scenario&&current_scenario.scenario.scenarioName&&current_scenario.scenario.scenarioName!=="BAD_FEEDBACK"&&current_scenario.scenario.scenarioName!=="GOOD_FEEDBACK"){this.scenarioName=current_scenario.scenario&&current_scenario.scenario.scenarioName?current_scenario.scenario.scenarioName:"";this.scenarioStrategy=current_scenario.scenario&&current_scenario.scenario.scenarioStrategy?current_scenario.scenario.scenarioStrategy:"";}}if(circle){this.circle=circle;}if(enteredTextMode){this.enteredTextMode=enteredTextMode;}if(user_response||user_response===""){this.user_response=user_response;}if(user_suggestion){this.user_suggestion=user_suggestion;}if(scenarioName!==undefined){this.scenarioName=scenarioName;}if(scenarioStrategy!==undefined){this.scenarioStrategy=scenarioStrategy;}this.intentScore=intentScore;}},{key:"trackEvent",value:function trackEvent(trackingEnumKey){if(!this.sessionId){var sessionID=__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].generateUniqueSessionId();this.sessionId=sessionID;window.sessionID=sessionID;// console.log('set sessionID',window.sessionID)
}if(!this.platformType){var platformType=__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].getPlatformTypeForTracking();this.platformType=platformType;window.platformType=platformType;// console.log('set platformType',window.platformType)
}//set the tracking key
window.my_data=trackingEnumKey;window.circle=this.circle;window.mobileNumber=__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get("currentNumber")||__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get("primaryNumber")||null;window.numberType=__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get("currentBotType");window.loginType=__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get("loginType");//set the tracking variables in window variables
window.optionSelected=this.user_response||"N/A";window.intentType=this.scenarioStrategy||"N/A";window.selectedBy=this.enteredTextMode||"N/A";window.feedbackSuggestion=this.user_suggestion||"N/A";window.scenario=this.scenarioName||"N/A";window.intentScore=this.intentScore||"N/A";// console.log('platformType',window.platformType)
switch(trackingEnumKey){case __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].CLOSE_CHAT_NO:case __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].INTENT_READING_FAIL:case __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].ERROR_FRONTEND:case __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].CLOSE_CHAT_YES:window.sessionTime=privateMethods.getTotalSessionTimeInSeconds();break;case __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].IMPROVE_FEEDBACK_SKIPPED:this.user_suggestion="sad_skipped";window.feedbackSuggestion="sad_skipped";window.my_data=__WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].FEEDBACK_SKIPPED;break;case __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].ERROR_BACKEND:window.errorType="API_ERROR";break;case __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].INTENT_READING_SUCCESS:window.intentScore=this.intentScore;break;default:{}}if(trackingEnumKey===__WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].SWITCH_CLICK_POST_TO_PRE||trackingEnumKey===__WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].SWITCH_CLICK_PRE_TO_POST){window._satellite.track("generic-click");}else{var window_obj={optionSelected:window.optionSelected,intentType:window.intentType,selectedBy:window.selectedBy,feedbackSuggestion:window.feedbackSuggestion,scenario:window.scenario,intentScore:window.intentScore// console.log(trackingEnumKey)
// console.log(window.my_data)
// console.log(window_obj)
};window._satellite.track("chatbot");this.user_suggestion="N/A";}}}]);return TrackingMiddlewareService;}();var trackingMiddlewareService=new TrackingMiddlewareService();/* harmony default export */ __webpack_exports__["a"] = (trackingMiddlewareService);var privateMethods={getTotalSessionTimeInSeconds:function getTotalSessionTimeInSeconds(){return(new Date().getTime()-trackingMiddlewareService.startTime.getTime())/1000;}};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var UserActionType={CHOICE_CLICKED:"CHOICE_CLICKED",CHAT_TEXT_ENTER:"CHAT_TEXT_ENTER",COUNTRY_SELECT:"COUNTRY_SELECT",SNS_CLICKED:"SMART_SEARCH_CLICK",CATEGORY_OPTION_CLICKED:"CATEGORY_OPTION_CLICK",FEEDBACK_CLICK:'FEEDBACK_CLICK',RETRY_CLICK:'RETRY_CLICK',CREATE_SR:'CREATE_SR',DT_LINK_CLICK:'DT_LINK_CLICK'};/* harmony default export */ __webpack_exports__["a"] = (UserActionType);

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(36), __webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var MD5 = C_algo.MD5;

	    /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */
	    var EvpKDF = C_algo.EvpKDF = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: MD5,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init hasher
	            var hasher = cfg.hasher.create();

	            // Initial values
	            var derivedKey = WordArray.create();

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                if (block) {
	                    hasher.update(block);
	                }
	                var block = hasher.update(password).finalize(salt);
	                hasher.reset();

	                // Iterations
	                for (var i = 1; i < iterations; i++) {
	                    block = hasher.finalize(block);
	                    hasher.reset();
	                }

	                derivedKey.concat(block);
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.EvpKDF = function (password, salt, cfg) {
	        return EvpKDF.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.EvpKDF;

}));

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ChatActionType={"CHAT_IN":"CHAT_IN","CHAT_OUT":"CHAT_OUT","INITIATE_RETRY":"INITIATE_RETRY","INITIATE":"INITIATE","SHOW_DFF_FORM":"SHOW_DFF_FORM","SHOW_DFF_RESPONSE":"SHOW_DFF_RESPONSE","SHOW_DFF_CRM_ERROR":"SHOW_DFF_CRM_ERROR","ASK_FOR_LOGIN":"ASK_FOR_LOGIN","NO_INTENT_FOUND":"NO_INTENT_FOUND","SHOW_RESPONSE":"SHOW_RESPONSE","USER_RESPONSE":"USER_RESPONSE","FEEDBACK_ACTION":"FEEDBACK_ACTION","BOOKMARK":"BOOKMARK","CHOICE_OPTION_LINK":"CHOICE_OPTION_LINK","SHOW_WELCOME_COMP":"SHOW_WELCOME_COMP","CREATE_SR":"CREATE_SR","COUNTRY_SELECT":"COUNTRY_SELECT","NO_ACTION_CHOSEN":"NO_ACTION_CHOSEN"};/* harmony default export */ __webpack_exports__["a"] = (ChatActionType);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              words[nBytes >>> 2] |= (bits1 | bits2) << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var T = [];

	    // Compute constants
	    (function () {
	        for (var i = 0; i < 64; i++) {
	            T[i] = (Math.abs(Math.sin(i + 1)) * 0x100000000) | 0;
	        }
	    }());

	    /**
	     * MD5 hash algorithm.
	     */
	    var MD5 = C_algo.MD5 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }

	            // Shortcuts
	            var H = this._hash.words;

	            var M_offset_0  = M[offset + 0];
	            var M_offset_1  = M[offset + 1];
	            var M_offset_2  = M[offset + 2];
	            var M_offset_3  = M[offset + 3];
	            var M_offset_4  = M[offset + 4];
	            var M_offset_5  = M[offset + 5];
	            var M_offset_6  = M[offset + 6];
	            var M_offset_7  = M[offset + 7];
	            var M_offset_8  = M[offset + 8];
	            var M_offset_9  = M[offset + 9];
	            var M_offset_10 = M[offset + 10];
	            var M_offset_11 = M[offset + 11];
	            var M_offset_12 = M[offset + 12];
	            var M_offset_13 = M[offset + 13];
	            var M_offset_14 = M[offset + 14];
	            var M_offset_15 = M[offset + 15];

	            // Working varialbes
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];

	            // Computation
	            a = FF(a, b, c, d, M_offset_0,  7,  T[0]);
	            d = FF(d, a, b, c, M_offset_1,  12, T[1]);
	            c = FF(c, d, a, b, M_offset_2,  17, T[2]);
	            b = FF(b, c, d, a, M_offset_3,  22, T[3]);
	            a = FF(a, b, c, d, M_offset_4,  7,  T[4]);
	            d = FF(d, a, b, c, M_offset_5,  12, T[5]);
	            c = FF(c, d, a, b, M_offset_6,  17, T[6]);
	            b = FF(b, c, d, a, M_offset_7,  22, T[7]);
	            a = FF(a, b, c, d, M_offset_8,  7,  T[8]);
	            d = FF(d, a, b, c, M_offset_9,  12, T[9]);
	            c = FF(c, d, a, b, M_offset_10, 17, T[10]);
	            b = FF(b, c, d, a, M_offset_11, 22, T[11]);
	            a = FF(a, b, c, d, M_offset_12, 7,  T[12]);
	            d = FF(d, a, b, c, M_offset_13, 12, T[13]);
	            c = FF(c, d, a, b, M_offset_14, 17, T[14]);
	            b = FF(b, c, d, a, M_offset_15, 22, T[15]);

	            a = GG(a, b, c, d, M_offset_1,  5,  T[16]);
	            d = GG(d, a, b, c, M_offset_6,  9,  T[17]);
	            c = GG(c, d, a, b, M_offset_11, 14, T[18]);
	            b = GG(b, c, d, a, M_offset_0,  20, T[19]);
	            a = GG(a, b, c, d, M_offset_5,  5,  T[20]);
	            d = GG(d, a, b, c, M_offset_10, 9,  T[21]);
	            c = GG(c, d, a, b, M_offset_15, 14, T[22]);
	            b = GG(b, c, d, a, M_offset_4,  20, T[23]);
	            a = GG(a, b, c, d, M_offset_9,  5,  T[24]);
	            d = GG(d, a, b, c, M_offset_14, 9,  T[25]);
	            c = GG(c, d, a, b, M_offset_3,  14, T[26]);
	            b = GG(b, c, d, a, M_offset_8,  20, T[27]);
	            a = GG(a, b, c, d, M_offset_13, 5,  T[28]);
	            d = GG(d, a, b, c, M_offset_2,  9,  T[29]);
	            c = GG(c, d, a, b, M_offset_7,  14, T[30]);
	            b = GG(b, c, d, a, M_offset_12, 20, T[31]);

	            a = HH(a, b, c, d, M_offset_5,  4,  T[32]);
	            d = HH(d, a, b, c, M_offset_8,  11, T[33]);
	            c = HH(c, d, a, b, M_offset_11, 16, T[34]);
	            b = HH(b, c, d, a, M_offset_14, 23, T[35]);
	            a = HH(a, b, c, d, M_offset_1,  4,  T[36]);
	            d = HH(d, a, b, c, M_offset_4,  11, T[37]);
	            c = HH(c, d, a, b, M_offset_7,  16, T[38]);
	            b = HH(b, c, d, a, M_offset_10, 23, T[39]);
	            a = HH(a, b, c, d, M_offset_13, 4,  T[40]);
	            d = HH(d, a, b, c, M_offset_0,  11, T[41]);
	            c = HH(c, d, a, b, M_offset_3,  16, T[42]);
	            b = HH(b, c, d, a, M_offset_6,  23, T[43]);
	            a = HH(a, b, c, d, M_offset_9,  4,  T[44]);
	            d = HH(d, a, b, c, M_offset_12, 11, T[45]);
	            c = HH(c, d, a, b, M_offset_15, 16, T[46]);
	            b = HH(b, c, d, a, M_offset_2,  23, T[47]);

	            a = II(a, b, c, d, M_offset_0,  6,  T[48]);
	            d = II(d, a, b, c, M_offset_7,  10, T[49]);
	            c = II(c, d, a, b, M_offset_14, 15, T[50]);
	            b = II(b, c, d, a, M_offset_5,  21, T[51]);
	            a = II(a, b, c, d, M_offset_12, 6,  T[52]);
	            d = II(d, a, b, c, M_offset_3,  10, T[53]);
	            c = II(c, d, a, b, M_offset_10, 15, T[54]);
	            b = II(b, c, d, a, M_offset_1,  21, T[55]);
	            a = II(a, b, c, d, M_offset_8,  6,  T[56]);
	            d = II(d, a, b, c, M_offset_15, 10, T[57]);
	            c = II(c, d, a, b, M_offset_6,  15, T[58]);
	            b = II(b, c, d, a, M_offset_13, 21, T[59]);
	            a = II(a, b, c, d, M_offset_4,  6,  T[60]);
	            d = II(d, a, b, c, M_offset_11, 10, T[61]);
	            c = II(c, d, a, b, M_offset_2,  15, T[62]);
	            b = II(b, c, d, a, M_offset_9,  21, T[63]);

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);

	            var nBitsTotalH = Math.floor(nBitsTotal / 0x100000000);
	            var nBitsTotalL = nBitsTotal;
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = (
	                (((nBitsTotalH << 8)  | (nBitsTotalH >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalH << 24) | (nBitsTotalH >>> 8))  & 0xff00ff00)
	            );
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotalL << 8)  | (nBitsTotalL >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotalL << 24) | (nBitsTotalL >>> 8))  & 0xff00ff00)
	            );

	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                // Shortcut
	                var H_i = H[i];

	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    function FF(a, b, c, d, x, s, t) {
	        var n = a + ((b & c) | (~b & d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function GG(a, b, c, d, x, s, t) {
	        var n = a + ((b & d) | (c & ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function HH(a, b, c, d, x, s, t) {
	        var n = a + (b ^ c ^ d) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    function II(a, b, c, d, x, s, t) {
	        var n = a + (c ^ (b | ~d)) + x + t;
	        return ((n << s) | (n >>> (32 - s))) + b;
	    }

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */
	    C.MD5 = Hasher._createHelper(MD5);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */
	    C.HmacMD5 = Hasher._createHmacHelper(MD5);
	}(Math));


	return CryptoJS.MD5;

}));

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_idle_timeout_service__ = __webpack_require__(13);
var ConfirmationBox=function ConfirmationBox(data){//confirmation box
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,data&&data.title&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"fs-16"},data.title),data.messages&&data.messages.map(function(message,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{key:index,className:"fs-14 fs-light pb-10 pt-10 pull-left color-6-grey"},message);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"text-right"},data.buttons&&data.buttons.map(function(button,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{key:index,href:"javascript:void(0)",className:"pt-10 fs-14 mr-10 pl-20 uppercase \n                       "+(button.highlight?'color-link  ':'color-dark-grey'),onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__services_idle_timeout_service__["a" /* default */].updateIdleState();button.onClick();}},button.label);})));};/* harmony default export */ __webpack_exports__["a"] = (ConfirmationBox);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UserActionClass=function UserActionClass(actionType,inputQuery,snsObject,categoryObject,shownQuery,additionalData,dtLinkScenario){_classCallCheck(this,UserActionClass);this.actionType=actionType;this.inputQuery=inputQuery;this.shownQuery=shownQuery||inputQuery;this.snsObject=snsObject?{longKey:snsObject.longKey,shortKey:snsObject.shortKey,scenarioResponse:snsObject.scenarioResponse,botType:snsObject.botType,scenarioObject:snsObject.scenario,scenarioStrategy:snsObject.scenarioStrategy}:snsObject;this.categoryObject=categoryObject?{scenarioTitle:categoryObject.scenarioTitle,scenarioResponse:categoryObject.scenarioResponse,scenarioStrategy:categoryObject.scenarioStrategy,scenario:categoryObject.scenario}:categoryObject;//done temporarily to handle create sr action on dff form
this.additionalData=additionalData;this.dtLinkScenario=dtLinkScenario;};/* harmony default export */ __webpack_exports__["a"] = (UserActionClass);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(49);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix__ = __webpack_require__(195);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix__["a"]; });





/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(78);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return static_links; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_config__ = __webpack_require__(12);
var static_links={monthly_plans:{'WEB':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].monthlyPlan.WEB,'ANDROID':{'OLD_APP_CONTEXT':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].monthlyPlan.ANDROID,'NEW_APP_CONTEXT':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].monthlyPlanNewAppContext.ANDROID},'IOS':{'OLD_APP_CONTEXT':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].monthlyPlan.IOS,'NEW_APP_CONTEXT':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].monthlyPlanNewAppContext.IOS}},plan_rental:{'WEB':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].planRental.WEB,'ANDROID':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].planRental.ANDROID,'IOS':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].planRental.IOS},duplicate_bills:{'ANDROID':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].duplicateBills.ANDROID,'IOS':__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].duplicateBills.IOS},ir_pack_tnc:__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].irPackTnc,ir_pack_standard_charges:__WEBPACK_IMPORTED_MODULE_0__config_config__["a" /* default */].irPackStandardCharges};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ScenarioType={DTScenario:'DTScenario',FAQScenario:'FAQScenario',SwitchScenario:'SwitchScenario'};/* harmony default export */ __webpack_exports__["a"] = (ScenarioType);

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(169)();
}


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TrackingPlatform={IOS_WEBVIEW:"IOS_WEBVIEW",ANDROID_WEBVIEW:"ANDROID_WEBVIEW",IOS_MSITE:"IOS_MSITE",ANDROID_MSITE:"ANDROID_MSITE",WEB:"WEB",OTHER_MSITE:"OTHER_MSITE"};/* harmony default export */ __webpack_exports__["a"] = (TrackingPlatform);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var X32WordArray = C_lib.WordArray;

	    /**
	     * x64 namespace.
	     */
	    var C_x64 = C.x64 = {};

	    /**
	     * A 64-bit word.
	     */
	    var X64Word = C_x64.Word = Base.extend({
	        /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */
	        init: function (high, low) {
	            this.high = high;
	            this.low = low;
	        }

	        /**
	         * Bitwise NOTs this word.
	         *
	         * @return {X64Word} A new x64-Word object after negating.
	         *
	         * @example
	         *
	         *     var negated = x64Word.not();
	         */
	        // not: function () {
	            // var high = ~this.high;
	            // var low = ~this.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ANDs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to AND with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ANDing.
	         *
	         * @example
	         *
	         *     var anded = x64Word.and(anotherX64Word);
	         */
	        // and: function (word) {
	            // var high = this.high & word.high;
	            // var low = this.low & word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise ORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to OR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after ORing.
	         *
	         * @example
	         *
	         *     var ored = x64Word.or(anotherX64Word);
	         */
	        // or: function (word) {
	            // var high = this.high | word.high;
	            // var low = this.low | word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Bitwise XORs this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to XOR with this word.
	         *
	         * @return {X64Word} A new x64-Word object after XORing.
	         *
	         * @example
	         *
	         *     var xored = x64Word.xor(anotherX64Word);
	         */
	        // xor: function (word) {
	            // var high = this.high ^ word.high;
	            // var low = this.low ^ word.low;

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the left.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftL(25);
	         */
	        // shiftL: function (n) {
	            // if (n < 32) {
	                // var high = (this.high << n) | (this.low >>> (32 - n));
	                // var low = this.low << n;
	            // } else {
	                // var high = this.low << (n - 32);
	                // var low = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Shifts this word n bits to the right.
	         *
	         * @param {number} n The number of bits to shift.
	         *
	         * @return {X64Word} A new x64-Word object after shifting.
	         *
	         * @example
	         *
	         *     var shifted = x64Word.shiftR(7);
	         */
	        // shiftR: function (n) {
	            // if (n < 32) {
	                // var low = (this.low >>> n) | (this.high << (32 - n));
	                // var high = this.high >>> n;
	            // } else {
	                // var low = this.high >>> (n - 32);
	                // var high = 0;
	            // }

	            // return X64Word.create(high, low);
	        // },

	        /**
	         * Rotates this word n bits to the left.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotL(25);
	         */
	        // rotL: function (n) {
	            // return this.shiftL(n).or(this.shiftR(64 - n));
	        // },

	        /**
	         * Rotates this word n bits to the right.
	         *
	         * @param {number} n The number of bits to rotate.
	         *
	         * @return {X64Word} A new x64-Word object after rotating.
	         *
	         * @example
	         *
	         *     var rotated = x64Word.rotR(7);
	         */
	        // rotR: function (n) {
	            // return this.shiftR(n).or(this.shiftL(64 - n));
	        // },

	        /**
	         * Adds this word with the passed word.
	         *
	         * @param {X64Word} word The x64-Word to add with this word.
	         *
	         * @return {X64Word} A new x64-Word object after adding.
	         *
	         * @example
	         *
	         *     var added = x64Word.add(anotherX64Word);
	         */
	        // add: function (word) {
	            // var low = (this.low + word.low) | 0;
	            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
	            // var high = (this.high + word.high + carry) | 0;

	            // return X64Word.create(high, low);
	        // }
	    });

	    /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var X64WordArray = C_x64.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 8;
	            }
	        },

	        /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */
	        toX32: function () {
	            // Shortcuts
	            var x64Words = this.words;
	            var x64WordsLength = x64Words.length;

	            // Convert
	            var x32Words = [];
	            for (var i = 0; i < x64WordsLength; i++) {
	                var x64Word = x64Words[i];
	                x32Words.push(x64Word.high);
	                x32Words.push(x64Word.low);
	            }

	            return X32WordArray.create(x32Words, this.sigBytes);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);

	            // Clone "words" array
	            var words = clone.words = this.words.slice(0);

	            // Clone each X64Word object
	            var wordsLength = words.length;
	            for (var i = 0; i < wordsLength; i++) {
	                words[i] = words[i].clone();
	            }

	            return clone;
	        }
	    });
	}());


	return CryptoJS;

}));

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var EncodeDecodeType={DEFAULT:"DEFAULT",CHATBOT:"CHATBOT",ONLINE:"ONLINE",URL_FORM_ENCODED:"URL_FORM_ENCODED"};/* harmony default export */ __webpack_exports__["a"] = (EncodeDecodeType);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ComponentTypes={DEFAULT:'DEFAULT',USER_RESPONSE:'USER_RESPONSE',CURRENT_BILL_PLAN:'CURRENT_BILL_PLAN',DATA_BALANCE:'DATA_BALANCE',OUTSTANDING:'OUTSTANDING',MONTHLY_PLAN:'MONTHLY_PLAN',IR_PACK:'IR_PACK',LOGIN_COMPONENT:'LOGIN_COMPONENT',HISTORY_DATE_COMPONENT:'HISTORY_DATE_COMPONENT',WELCOME_COMPONENT_MULTIPLE:'WELCOME_COMPONENT_MULTIPLE',PREV_DUPLICATE_BILLS:'PREV_DUPLICATE_BILLS',PREV_PAYMENT_RECEIPTS:'PREV_PAYMENT_RECEIPTS',IR_PACK_DEACTIVATION:'IR_PACK_DEACTIVATION',SWITCH_ACCOUNT_MESSAGE:'SWITCH_ACCOUNT_MESSAGE'};/* harmony default export */ __webpack_exports__["a"] = (ComponentTypes);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chatbot_encdec_service__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__online_encdec_service__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__refresh_token_service__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_path__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_path__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CustomHTTPService=function(){function CustomHTTPService(){_classCallCheck(this,CustomHTTPService);}_createClass(CustomHTTPService,null,[{key:'post',value:function post(url,data,config,encodeDecodeType,retry_count){switch(encodeDecodeType){case __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT:_addDefaultChatBotConfig(config);_addChatBotTokenHeaders(config);return _chatBotPost(url,data,config,retry_count);case __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].ONLINE:_addDefaultOnlineConfig(config);return _onlinePost(url,data,config);case __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].DEFAULT:_addDefaultConfig(config);return _defaultPost(url,data,config);case __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED:_addDefaultConfig(config);return _getUrlFormEncodedPost(url,data,config,retry_count);}}},{key:'get',value:function get(url,config,encodeDecodeType,retry_count){switch(encodeDecodeType){case __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT:_addDefaultChatBotConfig(config);_addChatBotTokenHeaders(config);return _chatBotGet(url,config,retry_count);case __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].ONLINE:_addDefaultOnlineConfig(config);return _onlineGet(url,config);case __WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].DEFAULT:_addDefaultConfig(config);return _defaultGet(url,config);}}}]);return CustomHTTPService;}();/* harmony default export */ __webpack_exports__["a"] = (CustomHTTPService);var _addChatBotTokenHeaders=function _addChatBotTokenHeaders(config){if(!config){config={};}if(!config["headers"]){config["headers"]={};}config["headers"]["Airtel-Auth-Domain"]=__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("loggedInToken")?__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("loggedInToken"):__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("basicToken");if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("isUserLoggedIn")&&__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("primaryNumber")!==__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentNumber")){config["headers"]["sso-number"]=__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentNumber");}if(__WEBPACK_IMPORTED_MODULE_6__config_config__["a" /* default */].env==="local"){// config["headers"]["iv-user"] = "";
config["headers"]["iv-user"]="";// config["headers"]["iv-user"] = "";
}};var _addDefaultConfig=function _addDefaultConfig(config){if(!config){config={};}if(!config["timeout"]){config["timeout"]=30000;}if(!config["headers"]){config["headers"]={};}if(!config["headers"]["Content-Type"]){config["headers"]["Content-Type"]="application/json";}};var _defaultGet=function _defaultGet(url,config){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url,config);};var _defaultPost=function _defaultPost(url,data,config){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url,data,config);};var _addDefaultChatBotConfig=function _addDefaultChatBotConfig(config){if(!config){config={};}if(!config["timeout"]){config["timeout"]=30000;}if(!config["headers"]){config["headers"]={};}if(!config["headers"]["Content-Type"]){config["headers"]["Content-Type"]="application/json";}};var _chatBotGet=function _chatBotGet(url,config,retry_count){return new Promise(function(resolveChatBotGet,rejectChatBotGet){if(!retry_count){retry_count=0;}__WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url,config).then(function(response){if(!_checkWebsealAuthLogin(response)){if(retry_count<1){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")){//app case
__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshLoginToken().then(function(){retry_count=retry_count+1;resolveChatBotGet(CustomHTTPService.get(url,{},__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){rejectChatBotGet();});}else{//web case
if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("isUserLoggedIn")){__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loginSessionExpired",true);}__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshBasicToken().then(function(result){retry_count=retry_count+1;resolveChatBotGet(CustomHTTPService.get(url,{},__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){rejectChatBotGet();});}}else{rejectChatBotGet();}}else{resolveChatBotGet(__WEBPACK_IMPORTED_MODULE_1__chatbot_encdec_service__["a" /* default */].decode(response.data));}},function(error){if(retry_count<1){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")&&(checkIfErrorUnauthorized(error)||!_checkWebsealAuthLogin(error.response))){//app case
__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshLoginToken().then(function(){retry_count=retry_count+1;resolveChatBotGet(CustomHTTPService.get(url,{},__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){rejectChatBotGet();});}else if(!__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")&&(checkIfErrorUnauthorized(error)||!_checkWebsealAuthLogin(error.response))){//web case
if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("isUserLoggedIn")){__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loginSessionExpired",true);}__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshBasicToken().then(function(result){retry_count=retry_count+1;resolveChatBotGet(CustomHTTPService.get(url,{},__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){rejectChatBotGet();});}else{rejectChatBotGet();}}else{rejectChatBotGet();}});});};var _getUrlFormEncodedPost=function _getUrlFormEncodedPost(url,data,config,retry_count){return new Promise(function(resolveUrlEncodedPost,rejectUrlEncodedPost){if(!retry_count){retry_count=0;}__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url,__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(data),config).then(function(response){if(!_checkWebsealAuthLogin(response)){if(retry_count<1){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")){//app case
__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshLoginToken().then(function(result){retry_count=retry_count+1;resolveUrlEncodedPost(CustomHTTPService.post(url,data,config,__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED,retry_count));}).catch(function(err){retry_count=retry_count+1;rejectUrlEncodedPost();});;}else{//web case
if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("isUserLoggedIn")){__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loginSessionExpired",true);}__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshBasicToken().then(function(result){retry_count=retry_count+1;resolveUrlEncodedPost(CustomHTTPService.post(url,data,config,__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED,retry_count));}).catch(function(err){retry_count=retry_count+1;rejectUrlEncodedPost();});}}else{rejectUrlEncodedPost();}}else{resolveUrlEncodedPost(__WEBPACK_IMPORTED_MODULE_1__chatbot_encdec_service__["a" /* default */].decode(response.data));}},function(error){if(retry_count<1){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")&&(checkIfErrorUnauthorized(error)||!_checkWebsealAuthLogin(error.response))){//app case
__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshLoginToken().then(function(result){retry_count=retry_count+1;resolveUrlEncodedPost(CustomHTTPService.post(url,data,config,__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED,retry_count));}).catch(function(err){retry_count=retry_count+1;rejectUrlEncodedPost();});;}else if(!__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")&&(checkIfErrorUnauthorized(error)||!_checkWebsealAuthLogin(error.response))){//web case
if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("isUserLoggedIn")){__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loginSessionExpired",true);}__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshBasicToken().then(function(result){retry_count=retry_count+1;resolveUrlEncodedPost(CustomHTTPService.post(url,data,config,__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].URL_FORM_ENCODED,retry_count));}).catch(function(err){retry_count=retry_count+1;rejectUrlEncodedPost();});}else{rejectUrlEncodedPost();}}else{rejectUrlEncodedPost();}});});};var _checkWebsealAuthLogin=function _checkWebsealAuthLogin(response){if(response&&response.headers&&response.headers["content-type"]==="text/html"){return false;}return true;};var _chatBotPost=function _chatBotPost(url,data,config,retry_count){var final_url=''+__WEBPACK_IMPORTED_MODULE_10__chatbot_api_service__["a" /* default */].getBaseApiUrl()+url;return new Promise(function(resolveChatBoTPostRequest,rejectChatBotPostRequest){if(!retry_count){retry_count=0;}__WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(final_url,{message:__WEBPACK_IMPORTED_MODULE_1__chatbot_encdec_service__["a" /* default */].encode(data)},config).then(function(response){if(!_checkWebsealAuthLogin(response)){if(retry_count<1){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")){//app case
__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshLoginToken().then(function(result){retry_count=retry_count+1;resolveChatBoTPostRequest(CustomHTTPService.post(url,data,config,__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){retry_count=retry_count+1;rejectChatBotPostRequest();});;}else{//web case
if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("isUserLoggedIn")){__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loginSessionExpired",true);}__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshBasicToken().then(function(result){retry_count=retry_count+1;resolveChatBoTPostRequest(CustomHTTPService.post(url,data,{},__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){retry_count=retry_count+1;rejectChatBotPostRequest();});}}else{rejectChatBotPostRequest();}}else{if(response.headers['content-type']==="application/pdf"){// console.log(response)
resolveChatBoTPostRequest(response.data);}else resolveChatBoTPostRequest(__WEBPACK_IMPORTED_MODULE_1__chatbot_encdec_service__["a" /* default */].decode(response.data));}},function(error){if(retry_count<1){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")&&(checkIfErrorUnauthorized(error)||!_checkWebsealAuthLogin(error.response))){__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshLoginToken().then(function(result){retry_count=retry_count+1;resolveChatBoTPostRequest(CustomHTTPService.post(url,data,config,__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){rejectChatBotPostRequest();});;}else if(!__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("APP_CONTEXT")&&(checkIfErrorUnauthorized(error)||!_checkWebsealAuthLogin(error.response))){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("isUserLoggedIn")){__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loginSessionExpired",true);}__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_9__refresh_token_service__["a" /* RefreshTokenService */].refreshBasicToken().then(function(result){retry_count=retry_count+1;resolveChatBoTPostRequest(CustomHTTPService.post(url,data,{},__WEBPACK_IMPORTED_MODULE_2__enums_EncodeDecodeType__["a" /* default */].CHATBOT,retry_count));}).catch(function(err){retry_count=retry_count+1;rejectChatBotPostRequest();});}else{rejectChatBotPostRequest();}}else{rejectChatBotPostRequest();}});});};var _onlineGet=function _onlineGet(url,config){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url,config).then(function(response){return response;});};var _onlinePost=function _onlinePost(url,data,config){return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url,data,config).then(function(response){return response;});};var _addDefaultOnlineConfig=function _addDefaultOnlineConfig(config){if(!config){config={};}if(!config["timeout"]){config["timeout"]=30000;}if(!config["headers"]){config["headers"]={};}config["headers"]["Content-Type"]="application/json";if(!config["headers"]["adsHeader"]){var key=__WEBPACK_IMPORTED_MODULE_5__online_encdec_service__["a" /* default */]._generateEncryptionKeyForOTP();config["headers"]["adsHeader"]=key;}};var checkIfErrorUnauthorized=function checkIfErrorUnauthorized(error){if(error&&error.response&&error.response.status&&error.response.status.toString().startsWith("4")&&error.response.status.toString()!=="404"&&error.response.status.toString()!=="400"){return true;}else{return false;}};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(9);
var normalizeHeaderName = __webpack_require__(115);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(62);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(62);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-1 hash algorithm.
	     */
	    var SHA1 = C_algo.SHA1 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0x67452301, 0xefcdab89,
	                0x98badcfe, 0x10325476,
	                0xc3d2e1f0
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];

	            // Computation
	            for (var i = 0; i < 80; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
	                    W[i] = (n << 1) | (n >>> 31);
	                }

	                var t = ((a << 5) | (a >>> 27)) + e + W[i];
	                if (i < 20) {
	                    t += ((b & c) | (~b & d)) + 0x5a827999;
	                } else if (i < 40) {
	                    t += (b ^ c ^ d) + 0x6ed9eba1;
	                } else if (i < 60) {
	                    t += ((b & c) | (b & d) | (c & d)) - 0x70e44324;
	                } else /* if (i < 80) */ {
	                    t += (b ^ c ^ d) - 0x359d3e2a;
	                }

	                e = d;
	                d = c;
	                c = (b << 30) | (b >>> 2);
	                b = a;
	                a = t;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */
	    C.SHA1 = Hasher._createHelper(SHA1);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */
	    C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
	}());


	return CryptoJS.SHA1;

}));

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChatResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dompurify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_BotType__ = __webpack_require__(7);
function ChatResponse(_ref){var message=_ref.message,messageTime=_ref.messageTime,hide_logo=_ref.hide_logo;__WEBPACK_IMPORTED_MODULE_1_dompurify___default.a.addHook('afterSanitizeAttributes',function(node){// set all elements owning target to target=_blank
if(node.hasAttribute('href')){node.setAttribute('target','_blank');}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get("currentBotType")===__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */].PAYMENTS_BANK?"arya new paymentsbank":"arya new",style:{visibility:hide_logo?'hidden':'visible'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles relate'},message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_1_dompurify___default.a.sanitize(message,{ALLOW_UNKNOWN_PROTOCOLS:true})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'time'},messageTime&&messageTime.time_in_format)))));}

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.DOMPurify = factory());
}(this, (function () { 'use strict';

var html = ['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr'];

// SVG
var svg = ['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'audio', 'canvas', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'video', 'view', 'vkern'];

var svgFilters = ['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence'];

var mathMl = ['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmuliscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mpspace', 'msqrt', 'mystyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover'];

var text = ['#text'];

var html$1 = ['accept', 'action', 'align', 'alt', 'autocomplete', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'coords', 'crossorigin', 'datetime', 'default', 'dir', 'disabled', 'download', 'enctype', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'integrity', 'ismap', 'label', 'lang', 'list', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'multiple', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns'];

var svg$1 = ['accent-height', 'accumulate', 'additivive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan'];

var mathMl$1 = ['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns'];

var xml = ['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink'];

/* Add properties to a lookup table */
function addToSet(set, array) {
  var l = array.length;
  while (l--) {
    if (typeof array[l] === 'string') {
      array[l] = array[l].toLowerCase();
    }
    set[array[l]] = true;
  }
  return set;
}

/* Shallow clone an object */
function clone(object) {
  var newObject = {};
  var property = void 0;
  for (property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      newObject[property] = object[property];
    }
  }
  return newObject;
}

var MUSTACHE_EXPR = /\{\{[\s\S]*|[\s\S]*\}\}/gm; // Specify template detection regex for SAFE_FOR_TEMPLATES mode
var ERB_EXPR = /<%[\s\S]*|[\s\S]*%>/gm;
var DATA_ATTR = /^data-[\-\w.\u00B7-\uFFFF]/; // eslint-disable-line no-useless-escape
var ARIA_ATTR = /^aria-[\-\w]+$/; // eslint-disable-line no-useless-escape
var IS_ALLOWED_URI = /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i; // eslint-disable-line no-useless-escape
var IS_SCRIPT_OR_DATA = /^(?:\w+script|data):/i;
var ATTR_WHITESPACE = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g; // eslint-disable-line no-control-regex

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getGlobal = function getGlobal() {
  return typeof window === 'undefined' ? null : window;
};

function createDOMPurify() {
  var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

  var DOMPurify = function DOMPurify(root) {
    return createDOMPurify(root);
  };

  /**
   * Version label, exposed for easier checks
   * if DOMPurify is up to date or not
   */
  DOMPurify.version = '1.0.7';

  /**
   * Array of elements that DOMPurify removed during sanitation.
   * Empty if nothing was removed.
   */
  DOMPurify.removed = [];

  if (!window || !window.document || window.document.nodeType !== 9) {
    // Not running in a browser, provide a factory function
    // so that you can pass your own Window
    DOMPurify.isSupported = false;

    return DOMPurify;
  }

  var originalDocument = window.document;
  var useDOMParser = false; // See comment below
  var removeTitle = false; // See comment below

  var document = window.document;
  var DocumentFragment = window.DocumentFragment,
      HTMLTemplateElement = window.HTMLTemplateElement,
      Node = window.Node,
      NodeFilter = window.NodeFilter,
      _window$NamedNodeMap = window.NamedNodeMap,
      NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
      Text = window.Text,
      Comment = window.Comment,
      DOMParser = window.DOMParser;

  // As per issue #47, the web-components registry is inherited by a
  // new document created via createHTMLDocument. As per the spec
  // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
  // a new empty registry is used when creating a template contents owner
  // document, so we use that as our parent document to ensure nothing
  // is inherited.

  if (typeof HTMLTemplateElement === 'function') {
    var template = document.createElement('template');
    if (template.content && template.content.ownerDocument) {
      document = template.content.ownerDocument;
    }
  }

  var _document = document,
      implementation = _document.implementation,
      createNodeIterator = _document.createNodeIterator,
      getElementsByTagName = _document.getElementsByTagName,
      createDocumentFragment = _document.createDocumentFragment;
  var importNode = originalDocument.importNode;


  var hooks = {};

  /**
   * Expose whether this browser supports running the full DOMPurify.
   */
  DOMPurify.isSupported = implementation && typeof implementation.createHTMLDocument !== 'undefined' && document.documentMode !== 9;

  var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
      ERB_EXPR$$1 = ERB_EXPR,
      DATA_ATTR$$1 = DATA_ATTR,
      ARIA_ATTR$$1 = ARIA_ATTR,
      IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
      ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
  var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;
  /**
   * We consider the elements and attributes below to be safe. Ideally
   * don't add any new ones but feel free to remove unwanted ones.
   */

  /* allowed element names */

  var ALLOWED_TAGS = null;
  var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(svgFilters), _toConsumableArray(mathMl), _toConsumableArray(text)));

  /* Allowed attribute names */
  var ALLOWED_ATTR = null;
  var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(mathMl$1), _toConsumableArray(xml)));

  /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
  var FORBID_TAGS = null;

  /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
  var FORBID_ATTR = null;

  /* Decide if ARIA attributes are okay */
  var ALLOW_ARIA_ATTR = true;

  /* Decide if custom data attributes are okay */
  var ALLOW_DATA_ATTR = true;

  /* Decide if unknown protocols are okay */
  var ALLOW_UNKNOWN_PROTOCOLS = false;

  /* Output should be safe for jQuery's $() factory? */
  var SAFE_FOR_JQUERY = false;

  /* Output should be safe for common template engines.
   * This means, DOMPurify removes data attributes, mustaches and ERB
   */
  var SAFE_FOR_TEMPLATES = false;

  /* Decide if document with <html>... should be returned */
  var WHOLE_DOCUMENT = false;

  /* Track whether config is already set on this instance of DOMPurify. */
  var SET_CONFIG = false;

  /* Decide if all elements (e.g. style, script) must be children of
   * document.body. By default, browsers might move them to document.head */
  var FORCE_BODY = false;

  /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html string.
   * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
   */
  var RETURN_DOM = false;

  /* Decide if a DOM `DocumentFragment` should be returned, instead of a html string */
  var RETURN_DOM_FRAGMENT = false;

  /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
   * `Node` is imported into the current `Document`. If this flag is not enabled the
   * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
   * DOMPurify. */
  var RETURN_DOM_IMPORT = false;

  /* Output should be free from DOM clobbering attacks? */
  var SANITIZE_DOM = true;

  /* Keep element content when removing element? */
  var KEEP_CONTENT = true;

  /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
   * of importing it into a new Document and returning a sanitized copy */
  var IN_PLACE = false;

  /* Allow usage of profiles like html, svg and mathMl */
  var USE_PROFILES = {};

  /* Tags to ignore content of when KEEP_CONTENT is true */
  var FORBID_CONTENTS = addToSet({}, ['audio', 'head', 'math', 'script', 'style', 'template', 'svg', 'video']);

  /* Tags that are safe for data: URIs */
  var DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image']);

  /* Attributes safe for values like "javascript:" */
  var URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'summary', 'title', 'value', 'style', 'xmlns']);

  /* Keep a reference to config to pass to hooks */
  var CONFIG = null;

  /* Ideally, do not touch anything below this line */
  /* ______________________________________________ */

  var formElement = document.createElement('form');

  /**
   * _parseConfig
   *
   * @param  {Object} cfg optional config literal
   */
  // eslint-disable-next-line complexity
  var _parseConfig = function _parseConfig(cfg) {
    /* Shield configuration object from tampering */
    if ((typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
      cfg = {};
    }
    /* Set configuration parameters */
    ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
    ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
    FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
    FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
    USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
    ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
    ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
    ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
    SAFE_FOR_JQUERY = cfg.SAFE_FOR_JQUERY || false; // Default false
    SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
    WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
    RETURN_DOM = cfg.RETURN_DOM || false; // Default false
    RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
    RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT || false; // Default false
    FORCE_BODY = cfg.FORCE_BODY || false; // Default false
    SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
    KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
    IN_PLACE = cfg.IN_PLACE || false; // Default false

    IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;

    if (SAFE_FOR_TEMPLATES) {
      ALLOW_DATA_ATTR = false;
    }

    if (RETURN_DOM_FRAGMENT) {
      RETURN_DOM = true;
    }

    /* Parse profile info */
    if (USE_PROFILES) {
      ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(text)));
      ALLOWED_ATTR = [];
      if (USE_PROFILES.html === true) {
        addToSet(ALLOWED_TAGS, html);
        addToSet(ALLOWED_ATTR, html$1);
      }
      if (USE_PROFILES.svg === true) {
        addToSet(ALLOWED_TAGS, svg);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.svgFilters === true) {
        addToSet(ALLOWED_TAGS, svgFilters);
        addToSet(ALLOWED_ATTR, svg$1);
        addToSet(ALLOWED_ATTR, xml);
      }
      if (USE_PROFILES.mathMl === true) {
        addToSet(ALLOWED_TAGS, mathMl);
        addToSet(ALLOWED_ATTR, mathMl$1);
        addToSet(ALLOWED_ATTR, xml);
      }
    }

    /* Merge configuration parameters */
    if (cfg.ADD_TAGS) {
      if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
        ALLOWED_TAGS = clone(ALLOWED_TAGS);
      }
      addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
    }
    if (cfg.ADD_ATTR) {
      if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
        ALLOWED_ATTR = clone(ALLOWED_ATTR);
      }
      addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
    }
    if (cfg.ADD_URI_SAFE_ATTR) {
      addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
    }

    /* Add #text in case KEEP_CONTENT is set to true */
    if (KEEP_CONTENT) {
      ALLOWED_TAGS['#text'] = true;
    }

    /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
    if (WHOLE_DOCUMENT) {
      addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
    }

    /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286 */
    if (ALLOWED_TAGS.table) {
      addToSet(ALLOWED_TAGS, ['tbody']);
    }

    // Prevent further manipulation of configuration.
    // Not available in IE8, Safari 5, etc.
    if (Object && 'freeze' in Object) {
      Object.freeze(cfg);
    }

    CONFIG = cfg;
  };

  /**
   * _forceRemove
   *
   * @param  {Node} node a DOM node
   */
  var _forceRemove = function _forceRemove(node) {
    DOMPurify.removed.push({ element: node });
    try {
      node.parentNode.removeChild(node);
    } catch (err) {
      node.outerHTML = '';
    }
  };

  /**
   * _removeAttribute
   *
   * @param  {String} name an Attribute name
   * @param  {Node} node a DOM node
   */
  var _removeAttribute = function _removeAttribute(name, node) {
    try {
      DOMPurify.removed.push({
        attribute: node.getAttributeNode(name),
        from: node
      });
    } catch (err) {
      DOMPurify.removed.push({
        attribute: null,
        from: node
      });
    }
    node.removeAttribute(name);
  };

  /**
   * _initDocument
   *
   * @param  {String} dirty a string of dirty markup
   * @return {Document} a DOM, filled with the dirty markup
   */
  var _initDocument = function _initDocument(dirty) {
    /* Create a HTML document */
    var doc = void 0;

    if (FORCE_BODY) {
      dirty = '<remove></remove>' + dirty;
    }

    /* Use DOMParser to workaround Firefox bug (see comment below) */
    if (useDOMParser) {
      try {
        doc = new DOMParser().parseFromString(dirty, 'text/html');
      } catch (err) {}
    }

    /* Remove title to fix an mXSS bug in older MS Edge */
    if (removeTitle) {
      addToSet(FORBID_TAGS, ['title']);
    }

    /* Otherwise use createHTMLDocument, because DOMParser is unsafe in
    Safari (see comment below) */
    if (!doc || !doc.documentElement) {
      doc = implementation.createHTMLDocument('');
      var _doc = doc,
          body = _doc.body;

      body.parentNode.removeChild(body.parentNode.firstElementChild);
      body.outerHTML = dirty;
    }

    /* Work on whole document or just its body */
    return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
  };

  // Firefox uses a different parser for innerHTML rather than
  // DOMParser (see https://bugzilla.mozilla.org/show_bug.cgi?id=1205631)
  // which means that you *must* use DOMParser, otherwise the output may
  // not be safe if used in a document.write context later.
  //
  // So we feature detect the Firefox bug and use the DOMParser if necessary.
  //
  // MS Edge, in older versions, is affected by an mXSS behavior. The second
  // check tests for the behavior and fixes it if necessary.
  if (DOMPurify.isSupported) {
    (function () {
      try {
        var doc = _initDocument('<svg><p><style><img src="</style><img src=x onerror=alert(1)//">');
        if (doc.querySelector('svg img')) {
          useDOMParser = true;
        }
      } catch (err) {}
    })();
    (function () {
      try {
        var doc = _initDocument('<x/><title>&lt;/title&gt;&lt;img&gt;');
        if (doc.querySelector('title').textContent.match(/<\/title/)) {
          removeTitle = true;
        }
      } catch (err) {}
    })();
  }

  /**
   * _createIterator
   *
   * @param  {Document} root document/fragment to create iterator for
   * @return {Iterator} iterator instance
   */
  var _createIterator = function _createIterator(root) {
    return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, function () {
      return NodeFilter.FILTER_ACCEPT;
    }, false);
  };

  /**
   * _isClobbered
   *
   * @param  {Node} elm element to check for clobbering attacks
   * @return {Boolean} true if clobbered, false if safe
   */
  var _isClobbered = function _isClobbered(elm) {
    if (elm instanceof Text || elm instanceof Comment) {
      return false;
    }
    if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function') {
      return true;
    }
    return false;
  };

  /**
   * _isNode
   *
   * @param  {Node} obj object to check whether it's a DOM node
   * @return {Boolean} true is object is a DOM node
   */
  var _isNode = function _isNode(obj) {
    return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? obj instanceof Node : obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string';
  };

  /**
   * _executeHook
   * Execute user configurable hooks
   *
   * @param  {String} entryPoint  Name of the hook's entry point
   * @param  {Node} currentNode node to work on with the hook
   * @param  {Object} data additional hook parameters
   */
  var _executeHook = function _executeHook(entryPoint, currentNode, data) {
    if (!hooks[entryPoint]) {
      return;
    }

    hooks[entryPoint].forEach(function (hook) {
      hook.call(DOMPurify, currentNode, data, CONFIG);
    });
  };

  /**
   * _sanitizeElements
   *
   * @protect nodeName
   * @protect textContent
   * @protect removeChild
   *
   * @param   {Node} currentNode to check for permission to exist
   * @return  {Boolean} true if node was killed, false if left alive
   */
  var _sanitizeElements = function _sanitizeElements(currentNode) {
    var content = void 0;

    /* Execute a hook if present */
    _executeHook('beforeSanitizeElements', currentNode, null);

    /* Check if element is clobbered or can clobber */
    if (_isClobbered(currentNode)) {
      _forceRemove(currentNode);
      return true;
    }

    /* Now let's check the element's type and name */
    var tagName = currentNode.nodeName.toLowerCase();

    /* Execute a hook if present */
    _executeHook('uponSanitizeElement', currentNode, {
      tagName: tagName,
      allowedTags: ALLOWED_TAGS
    });

    /* Remove element if anything forbids its presence */
    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
      /* Keep content except for black-listed elements */
      if (KEEP_CONTENT && !FORBID_CONTENTS[tagName] && typeof currentNode.insertAdjacentHTML === 'function') {
        try {
          currentNode.insertAdjacentHTML('AfterEnd', currentNode.innerHTML);
        } catch (err) {}
      }
      _forceRemove(currentNode);
      return true;
    }

    /* Convert markup to cover jQuery behavior */
    if (SAFE_FOR_JQUERY && !currentNode.firstElementChild && (!currentNode.content || !currentNode.content.firstElementChild) && /</g.test(currentNode.textContent)) {
      DOMPurify.removed.push({ element: currentNode.cloneNode() });
      if (currentNode.innerHTML) {
        currentNode.innerHTML = currentNode.innerHTML.replace(/</g, '&lt;');
      } else {
        currentNode.innerHTML = currentNode.textContent.replace(/</g, '&lt;');
      }
    }

    /* Sanitize element content to be template-safe */
    if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
      /* Get the element's text content */
      content = currentNode.textContent;
      content = content.replace(MUSTACHE_EXPR$$1, ' ');
      content = content.replace(ERB_EXPR$$1, ' ');
      if (currentNode.textContent !== content) {
        DOMPurify.removed.push({ element: currentNode.cloneNode() });
        currentNode.textContent = content;
      }
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeElements', currentNode, null);

    return false;
  };

  /**
   * _isValidAttribute
   *
   * @param  {string} lcTag Lowercase tag name of containing element.
   * @param  {string} lcName Lowercase attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid, otherwise false.
   */
  var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
    /* Make sure attribute cannot clobber */
    if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
      return false;
    }

    /* Sanitize attribute content to be template-safe */
    if (SAFE_FOR_TEMPLATES) {
      value = value.replace(MUSTACHE_EXPR$$1, ' ');
      value = value.replace(ERB_EXPR$$1, ' ');
    }

    /* Allow valid data-* attributes: At least one character after "-"
        (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
        XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
        We don't need to check the value; it's always URI safe. */
    if (ALLOW_DATA_ATTR && DATA_ATTR$$1.test(lcName)) {
      // This attribute is safe
    } else if (ALLOW_ARIA_ATTR && ARIA_ATTR$$1.test(lcName)) {
      // This attribute is safe
      /* Otherwise, check the name is permitted */
    } else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
      return false;

      /* Check value is safe. First, is attr inert? If so, is safe */
    } else if (URI_SAFE_ATTRIBUTES[lcName]) {
      // This attribute is safe
      /* Check no script, data or unknown possibly unsafe URI
        unless we know URI values are safe for that attribute */
    } else if (IS_ALLOWED_URI$$1.test(value.replace(ATTR_WHITESPACE$$1, ''))) {
      // This attribute is safe
      /* Keep image data URIs alive if src/xlink:href is allowed */
    } else if ((lcName === 'src' || lcName === 'xlink:href') && value.indexOf('data:') === 0 && DATA_URI_TAGS[lcTag]) {
      // This attribute is safe
      /* Allow unknown protocols: This provides support for links that
        are handled by protocol handlers which may be unknown ahead of
        time, e.g. fb:, spotify: */
    } else if (ALLOW_UNKNOWN_PROTOCOLS && !IS_SCRIPT_OR_DATA$$1.test(value.replace(ATTR_WHITESPACE$$1, ''))) {
      // This attribute is safe
      /* Check for binary attributes */
      // eslint-disable-next-line no-negated-condition
    } else if (!value) {
      // Binary attributes are safe at this point
      /* Anything else, presume unsafe, do not add it back */
    } else {
      return false;
    }
    return true;
  };

  /**
   * _sanitizeAttributes
   *
   * @protect attributes
   * @protect nodeName
   * @protect removeAttribute
   * @protect setAttribute
   *
   * @param  {Node} node to sanitize
   */
  // eslint-disable-next-line complexity
  var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
    var attr = void 0;
    var value = void 0;
    var lcName = void 0;
    var idAttr = void 0;
    var l = void 0;
    /* Execute a hook if present */
    _executeHook('beforeSanitizeAttributes', currentNode, null);

    var attributes = currentNode.attributes;

    /* Check if we have attributes; if not we might have a text node */

    if (!attributes) {
      return;
    }

    var hookEvent = {
      attrName: '',
      attrValue: '',
      keepAttr: true,
      allowedAttributes: ALLOWED_ATTR
    };
    l = attributes.length;

    /* Go backwards over all attributes; safely remove bad ones */
    while (l--) {
      attr = attributes[l];
      var _attr = attr,
          name = _attr.name;

      value = attr.value.trim();
      lcName = name.toLowerCase();

      /* Execute a hook if present */
      hookEvent.attrName = lcName;
      hookEvent.attrValue = value;
      hookEvent.keepAttr = true;
      _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
      value = hookEvent.attrValue;

      /* Remove attribute */
      // Safari (iOS + Mac), last tested v8.0.5, crashes if you try to
      // remove a "name" attribute from an <img> tag that has an "id"
      // attribute at the time.
      if (lcName === 'name' && currentNode.nodeName === 'IMG' && attributes.id) {
        idAttr = attributes.id;
        attributes = Array.prototype.slice.apply(attributes);
        _removeAttribute('id', currentNode);
        _removeAttribute(name, currentNode);
        if (attributes.indexOf(idAttr) > l) {
          currentNode.setAttribute('id', idAttr.value);
        }
      } else if (
      // This works around a bug in Safari, where input[type=file]
      // cannot be dynamically set after type has been removed
      currentNode.nodeName === 'INPUT' && lcName === 'type' && value === 'file' && (ALLOWED_ATTR[lcName] || !FORBID_ATTR[lcName])) {
        continue;
      } else {
        // This avoids a crash in Safari v9.0 with double-ids.
        // The trick is to first set the id to be empty and then to
        // remove the attribute
        if (name === 'id') {
          currentNode.setAttribute(name, '');
        }
        _removeAttribute(name, currentNode);
      }

      /* Did the hooks approve of the attribute? */
      if (!hookEvent.keepAttr) {
        continue;
      }

      /* Is `value` valid for this attribute? */
      var lcTag = currentNode.nodeName.toLowerCase();
      if (!_isValidAttribute(lcTag, lcName, value)) {
        continue;
      }

      /* Handle invalid data-* attribute set by try-catching it */
      try {
        currentNode.setAttribute(name, value);
        DOMPurify.removed.pop();
      } catch (err) {}
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeAttributes', currentNode, null);
  };

  /**
   * _sanitizeShadowDOM
   *
   * @param  {DocumentFragment} fragment to iterate over recursively
   */
  var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
    var shadowNode = void 0;
    var shadowIterator = _createIterator(fragment);

    /* Execute a hook if present */
    _executeHook('beforeSanitizeShadowDOM', fragment, null);

    while (shadowNode = shadowIterator.nextNode()) {
      /* Execute a hook if present */
      _executeHook('uponSanitizeShadowNode', shadowNode, null);

      /* Sanitize tags and elements */
      if (_sanitizeElements(shadowNode)) {
        continue;
      }

      /* Deep shadow DOM detected */
      if (shadowNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(shadowNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(shadowNode);
    }

    /* Execute a hook if present */
    _executeHook('afterSanitizeShadowDOM', fragment, null);
  };

  /**
   * Sanitize
   * Public method providing core sanitation functionality
   *
   * @param {String|Node} dirty string or DOM node
   * @param {Object} configuration object
   */
  // eslint-disable-next-line complexity
  DOMPurify.sanitize = function (dirty, cfg) {
    var body = void 0;
    var importedNode = void 0;
    var currentNode = void 0;
    var oldNode = void 0;
    var returnNode = void 0;
    /* Make sure we have a string to sanitize.
      DO NOT return early, as this will return the wrong type if
      the user has requested a DOM object rather than a string */
    if (!dirty) {
      dirty = '<!-->';
    }

    /* Stringify, in case dirty is an object */
    if (typeof dirty !== 'string' && !_isNode(dirty)) {
      // eslint-disable-next-line no-negated-condition
      if (typeof dirty.toString !== 'function') {
        throw new TypeError('toString is not a function');
      } else {
        dirty = dirty.toString();
        if (typeof dirty !== 'string') {
          throw new TypeError('dirty is not a string, aborting');
        }
      }
    }

    /* Check we can run. Otherwise fall back or ignore */
    if (!DOMPurify.isSupported) {
      if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
        if (typeof dirty === 'string') {
          return window.toStaticHTML(dirty);
        }
        if (_isNode(dirty)) {
          return window.toStaticHTML(dirty.outerHTML);
        }
      }
      return dirty;
    }

    /* Assign config vars */
    if (!SET_CONFIG) {
      _parseConfig(cfg);
    }

    /* Clean up removed elements */
    DOMPurify.removed = [];

    if (IN_PLACE) {
      /* No special handling necessary for in-place sanitization */
    } else if (dirty instanceof Node) {
      /* If dirty is a DOM element, append to an empty document to avoid
         elements being stripped by the parser */
      body = _initDocument('<!-->');
      importedNode = body.ownerDocument.importNode(dirty, true);
      if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
        /* Node is already a body, use as is */
        body = importedNode;
      } else {
        body.appendChild(importedNode);
      }
    } else {
      /* Exit directly if we have nothing to do */
      if (!RETURN_DOM && !WHOLE_DOCUMENT && dirty.indexOf('<') === -1) {
        return dirty;
      }

      /* Initialize the document to work on */
      body = _initDocument(dirty);

      /* Check we have a DOM node from the data */
      if (!body) {
        return RETURN_DOM ? null : '';
      }
    }

    /* Remove first element node (ours) if FORCE_BODY is set */
    if (body && FORCE_BODY) {
      _forceRemove(body.firstChild);
    }

    /* Get node iterator */
    var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

    /* Now start iterating over the created document */
    while (currentNode = nodeIterator.nextNode()) {
      /* Fix IE's strange behavior with manipulated textNodes #89 */
      if (currentNode.nodeType === 3 && currentNode === oldNode) {
        continue;
      }

      /* Sanitize tags and elements */
      if (_sanitizeElements(currentNode)) {
        continue;
      }

      /* Shadow DOM detected, sanitize it */
      if (currentNode.content instanceof DocumentFragment) {
        _sanitizeShadowDOM(currentNode.content);
      }

      /* Check attributes, sanitize if necessary */
      _sanitizeAttributes(currentNode);

      oldNode = currentNode;
    }

    /* If we sanitized `dirty` in-place, return it. */
    if (IN_PLACE) {
      return dirty;
    }

    /* Return sanitized string or DOM */
    if (RETURN_DOM) {
      if (RETURN_DOM_FRAGMENT) {
        returnNode = createDocumentFragment.call(body.ownerDocument);

        while (body.firstChild) {
          returnNode.appendChild(body.firstChild);
        }
      } else {
        returnNode = body;
      }

      if (RETURN_DOM_IMPORT) {
        /* AdoptNode() is not used because internal state is not reset
               (e.g. the past names map of a HTMLFormElement), this is safe
               in theory but we would rather not risk another attack vector.
               The state that is cloned by importNode() is explicitly defined
               by the specs. */
        returnNode = importNode.call(originalDocument, returnNode, true);
      }

      return returnNode;
    }

    return WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
  };

  /**
   * Public method to set the configuration once
   * setConfig
   *
   * @param {Object} cfg configuration object
   */
  DOMPurify.setConfig = function (cfg) {
    _parseConfig(cfg);
    SET_CONFIG = true;
  };

  /**
   * Public method to remove the configuration
   * clearConfig
   *
   */
  DOMPurify.clearConfig = function () {
    CONFIG = null;
    SET_CONFIG = false;
  };

  /**
   * Public method to check if an attribute value is valid.
   * Uses last set config, if any. Otherwise, uses config defaults.
   * isValidAttribute
   *
   * @param  {string} tag Tag name of containing element.
   * @param  {string} attr Attribute name.
   * @param  {string} value Attribute value.
   * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
   */
  DOMPurify.isValidAttribute = function (tag, attr, value) {
    /* Initialize shared config vars if necessary. */
    if (!CONFIG) {
      _parseConfig({});
    }
    var lcTag = tag.toLowerCase();
    var lcName = attr.toLowerCase();
    return _isValidAttribute(lcTag, lcName, value);
  };

  /**
   * AddHook
   * Public method to add DOMPurify hooks
   *
   * @param {String} entryPoint entry point for the hook to add
   * @param {Function} hookFunction function to execute
   */
  DOMPurify.addHook = function (entryPoint, hookFunction) {
    if (typeof hookFunction !== 'function') {
      return;
    }
    hooks[entryPoint] = hooks[entryPoint] || [];
    hooks[entryPoint].push(hookFunction);
  };

  /**
   * RemoveHook
   * Public method to remove a DOMPurify hook at a given entryPoint
   * (pops it from the stack of hooks if more are present)
   *
   * @param {String} entryPoint entry point for the hook to remove
   */
  DOMPurify.removeHook = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint].pop();
    }
  };

  /**
   * RemoveHooks
   * Public method to remove all DOMPurify hooks at a given entryPoint
   *
   * @param  {String} entryPoint entry point for the hooks to remove
   */
  DOMPurify.removeHooks = function (entryPoint) {
    if (hooks[entryPoint]) {
      hooks[entryPoint] = [];
    }
  };

  /**
   * RemoveAllHooks
   * Public method to remove all DOMPurify hooks
   *
   */
  DOMPurify.removeAllHooks = function () {
    hooks = {};
  };

  return DOMPurify;
}

var purify = createDOMPurify();

return purify;

})));
//# sourceMappingURL=purify.js.map


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_message_components_chat_response_component__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_scenario_type__ = __webpack_require__(25);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ActionsCommonService=function ActionsCommonService(){_classCallCheck(this,ActionsCommonService);};ActionsCommonService.handleCreateSr=function(params){var data=params.data,resolve=params.resolve,reject=params.reject;var result=data;if(result.dffStepResponse){delete result.dffStepResponse;}var chatItem={response:data&&data.response?data.response:"",options:data&&data.scenario&&data.scenario.scenarioStep&&data.scenario.scenarioStep.options?data.scenario.scenarioStep.options:[],scenarioActive:data.scenarioActive,type:"chatbot",sentTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime(),scenarioResponse:data?data:""};__WEBPACK_IMPORTED_MODULE_2__services_chatbot_api_service__["a" /* default */].submitDffCall(data.aditionalData.reqData).then(function(response){try{var apiResponse=response;var messageList={};var message_objects=[];messageList.leapText=data&&data.aditionalData&&data.aditionalData.leapText?data.aditionalData.leapText:"";if(response&&response.status&&response.status==="UNAUTHORIZED"){//HANDLING SESSION EXPIRATION
chatItem.response=__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].SESSION_EXPIRED_STATUS.message;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});}else if(apiResponse&&apiResponse.result&&apiResponse.result.message){messageList.response=data&&data.response?data.response:"";messageList.statusMessage=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&apiResponse.result.message.indexOf("Click")!==-1?''+apiResponse.result.message.substring(0,apiResponse.result.message.indexOf("Click")-1):''+apiResponse.result.message;if(messageList&&messageList.leapText){var splittedChatItem=JSON.parse(JSON.stringify(chatItem));splittedChatItem.response=messageList.leapText;// console.log('leap text message',messageList.leapText)
message_objects.push({component_type:'DEFAULT',message:splittedChatItem.response,messageTime:splittedChatItem.sentTime});}// if(messageList && messageList.response){
//     const splittedChatItem = JSON.parse(JSON.stringify(chatItem));
//     splittedChatItem.response = messageList.response;
// }
if(messageList&&messageList.statusMessage){// console.log('status message',messageList.statusMessage)
var _splittedChatItem=JSON.parse(JSON.stringify(chatItem));_splittedChatItem.response=messageList.statusMessage;message_objects.push({component_type:'DEFAULT',message:_splittedChatItem.response,messageTime:_splittedChatItem.sentTime});}resolve({message_objects:message_objects,scenarioResponse:result});}else if(apiResponse.statusCode==="CRM_CONSUME_SR_API_ERROR"){messageList.statusMessage=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&apiResponse.result.message.indexOf("Click")!==-1?''+apiResponse.result.message.substring(0,apiResponse.result.message.indexOf("Click")-1):''+apiResponse.result.message;if(messageList&&messageList.leapText){var _splittedChatItem2=JSON.parse(JSON.stringify(chatItem));_splittedChatItem2.response=messageList.leapText;//TO DO VERIFY
message_objects.push({component_type:'DEFAULT',message:_splittedChatItem2.response,messageTime:_splittedChatItem2.sentTime});}if(messageList&&messageList.statusMessage){var _splittedChatItem3=JSON.parse(JSON.stringify(chatItem));_splittedChatItem3.response=messageList.statusMessage;message_objects.push({component_type:'DEFAULT',message:_splittedChatItem3.response,messageTime:_splittedChatItem3.sentTime});}resolve({message_objects:message_objects,scenarioResponse:result});}else if(apiResponse.statusCode==="PROCESSING_EXCEPTION"){// HANDLE ERROR CONDITION  ( SR NOT RAISED)
// chatItem.response = `${apiResponse.statusMessage}`;
chatItem.response=__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.genericSRError;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});}else if(apiResponse&&apiResponse.result&&apiResponse.result.tagId&&!apiResponse.result.message){message_objects.push({component_type:'DEFAULT',message:__WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__["a" /* SCRIPTS */].SR_RAISED_SUCCESSFULLY+apiResponse.result.tagId+'.',messageTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime()});resolve({message_objects:message_objects,scenarioResponse:result});}else{chatItem.response=''+messageList.leapText;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});}}catch(exception){// HANDLE EXCEPTION
reject({status:exception});}},function(error){// HANDLE ERROR
// REMOVE
// reject({status: error});
var message_objects=[];chatItem["response"]=__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].dffSubmitErrorMsg;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});});};ActionsCommonService.getWebOrAppSpecificResponse=function(response){var data="";if(response.indexOf("mobilecontentstart")!==-1){var platformType=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("platformType");if(platformType===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].IOS||platformType===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].ANDROID){if(response.split("<div><b>mobilecontentstart</b></div>")[1]){data=response.split("<div><b>mobilecontentstart</b></div>")[1].split("<div><b>mobilecontentend</b></div>")[0];}else{data=response.substring(0,response.indexOf("mobilecontentstart")-8);}}else{data=response.substring(0,response.indexOf("mobilecontentstart")-8);}}else{data=response;}return data;};ActionsCommonService.getPlatformSpeciifcDescription=function(result,strategy){var platformType=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("platformType");var finalResult=result;if(strategy==="DTScenario"||!strategy){var list=new DOMParser().parseFromString(result,"text/html");var allAnchorTags=list.body.querySelectorAll("a");for(var i=0;i<allAnchorTags.length;i+=1){var originalHref=allAnchorTags[i].href.replace(/%7C/g,"|");var splittedAllHrefValues=originalHref.split("|");if(splittedAllHrefValues.length>1){if(platformType===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].IOS){finalResult=finalResult.replace(originalHref,splittedAllHrefValues[1]);}else if(platformType===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].ANDROID){if(__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){finalResult=finalResult.replace(originalHref,splittedAllHrefValues[2]);}else{finalResult=finalResult.replace(originalHref,splittedAllHrefValues[0]);}}else{finalResult=finalResult.replace(originalHref,splittedAllHrefValues[0]);}}}var replaceString="{mobile}";finalResult=__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].replaceAll(finalResult,replaceString,__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentNumber")?__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentNumber"):"");return finalResult;}else if(strategy===__WEBPACK_IMPORTED_MODULE_8__enums_scenario_type__["a" /* default */].FAQScenario&&result.searchReply){//
return ActionsCommonService.getPlatformSpecificSearchReply(result);}else{return __WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR;}};ActionsCommonService.getPlatformSpecificSearchReply=function(result){var platformType=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("platformType");var finalResult=result;if(platformType===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].ANDROID){if(__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&result.searchReply.android){var replaceString="{mobile}";finalResult=__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].replaceAll(result.searchReply.android,replaceString,__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}else if(!__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&result.searchReply.web){var _replaceString="{mobile}";finalResult=__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].replaceAll(result.searchReply.web,_replaceString,__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}else{return __WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR;}}else if(platformType===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].IOS){if(__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&result.searchReply.ios){var _replaceString2="{mobile}";finalResult=__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].replaceAll(result.searchReply.ios,_replaceString2,__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}else if(!__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&result.searchReply.web){var _replaceString3="{mobile}";finalResult=__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].replaceAll(result.searchReply.web,_replaceString3,__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentNumber"));return finalResult;}else{return __WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR;}}return result.searchReply.web;};ActionsCommonService.getLinkDataForChoice=function(enteredText,result){var ScenarioObject=result.scenario;if(ScenarioObject&&ScenarioObject["scenarioStep"]&&ScenarioObject["scenarioStep"]["options"]&&ScenarioObject["scenarioStep"]["options"].length){for(var i=0;i<ScenarioObject["scenarioStep"]["options"].length;i++){if(ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase()===enteredText.toUpperCase()&&ScenarioObject["scenarioStep"]["options"][i]["stepLink"]){return ScenarioObject["scenarioStep"]["options"][i]["stepLink"];}}}return null;};ActionsCommonService.getBookmarkedScenarioIdForChoice=function(enteredText,result){var ScenarioObject=result.scenario;if(ScenarioObject&&ScenarioObject["scenarioStep"]&&ScenarioObject["scenarioStep"]["options"]&&ScenarioObject["scenarioStep"]["options"].length){for(var i=0;i<ScenarioObject["scenarioStep"]["options"].length;i++){if(ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase()===enteredText.toUpperCase()&&ScenarioObject["scenarioStep"]["options"][i]["bookMark"]&&ScenarioObject["scenarioStep"]["options"][i]["bookMark"]["scenarioId"]){return ScenarioObject["scenarioStep"]["options"][i]["bookMark"];}}}return null;};ActionsCommonService.handleCrmConsumeSrApiError=function(result,resolve,reject){// console.log('handleCrmConsumeSrApiError')
var chatItem={response:result&&result.response?result.response:"",options:result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options?result.scenario.scenarioStep.options:[],scenarioActive:result.scenarioActive,type:"chatbot",sentTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime(),scenarioResponse:result?result:""};var response={};var message_objects=[];response.leapText=result.additionalInfo&&result.additionalInfo.leap_informCustomerScript?result.additionalInfo.leap_informCustomerScript:"";response.status=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&result.dffStepResponse.statusMessage.indexOf("Click")!==-1?''+result.dffStepResponse.statusMessage.substring(0,result.dffStepResponse.statusMessage.indexOf("Click")-1):result.dffStepResponse.statusMessage;chatItem.response=response.leapText+' '+response.status;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});};ActionsCommonService.handleDffForm=function(result,resolve,reject){var DFFFields=result.dffStepResponse.result;// console.log('handle dff')
// PREPARING FIELD LIST
var DFFFieldToBeDisplayed=[];for(var i=0;i<DFFFields.length;i+=1){// if (
//     DFFFields[i].name !== "Customer Lat/Long" &&
//     DFFFields[i].name !==
//     "Problem Address & Landmark (M)" &&
//     DFFFields[i].name !== "Problem Address(M)"
// ) {
//     DFFFieldToBeDisplayed.push(DFFFields[i]);
// }
if(DFFFields[i].name==="Alternate number"||DFFFields[i].name==="Alt contact number"||DFFFields[i].name==="Alt contact number(M)"||DFFFields[i].name==="Alternate Contact Number(M)"||DFFFields[i].name==="Alternate Contact Number"||DFFFields[i].name==="Alternate Landline Number"||DFFFields[i].name==="Alternate Number(M)"||DFFFields[i].name==="Enter Alternate Number"){DFFFieldToBeDisplayed.push(DFFFields[i]);}}// REMOVE 
// DFFFieldToBeDisplayed.push({
//     order: "1",
//     value: "NA",
//     name: "ALternate Numbers"
// });
// SETTING LEAP INFO
var additionalInfo={};additionalInfo.leapText=result.additionalInfo&&result.additionalInfo.leap_informCustomerScript?result.additionalInfo.leap_informCustomerScript:"";// SETTING LEAP ADDRESS 
additionalInfo.leap_address=result.additionalInfo&&result.additionalInfo.leap_address?result.additionalInfo.leap_address:"";// SETTING LAT LONG
additionalInfo.lat_long=result.additionalInfo&&result.additionalInfo.leap_latitude&&result.additionalInfo.leap_longitude?result.additionalInfo.leap_latitude+','+result.additionalInfo.leap_longitude:"";// SETTING CRM CODE
additionalInfo.crmCode=result.crmCode;var chatItem={response:result&&result.response?result.response:"",options:result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options?result.scenario.scenarioStep.options:[],scenarioActive:result.scenarioActive,type:"chatbot",sentTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime(),scenarioResponse:result?result:""};// let component_arr = [];
var message_objects=[];// TO DO ------ component added showing dff response 
if(result.response&&!__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].isResponseEmpty(result.response)){var dffResChatItem=chatItem;message_objects.push({component_type:'DEFAULT',message:result.response,messageTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime()});}chatItem.response=__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].script.dffShowText;if(chatItem.response&&DFFFieldToBeDisplayed&&DFFFieldToBeDisplayed.length>0){message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime,notToBeWrittenToDB:true});}var bottom_comp=void 0;if(DFFFieldToBeDisplayed&&DFFFieldToBeDisplayed.length>0){bottom_comp={type:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.DFF_FORM_COMPONENT,dff_form_obj:{chatItem:chatItem,DFFFieldToBeDisplayed:DFFFieldToBeDisplayed,additionalInfo:additionalInfo}};}resolve({message_objects:message_objects,scenarioResponse:result,bottom_comp:bottom_comp});};ActionsCommonService.showDffResponse=function(result,resolve,reject){// console.log('show dff res')
var chatItem={response:result&&result.response?result.response:"",options:result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options?result.scenario.scenarioStep.options:[],scenarioActive:result.scenarioActive,type:"chatbot",sentTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime(),scenarioResponse:result?result:""};var message_objects=[];chatItem.response=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")&&result.dffStepResponse.result.message.indexOf("Click")!==-1?''+result.dffStepResponse.result.message.substring(0,result.dffStepResponse.result.message.indexOf("Click")-1):result.dffStepResponse.result.message;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});};/* harmony default export */ __webpack_exports__["a"] = (ActionsCommonService);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__ = __webpack_require__(1);
var addItem=function addItem(component){var chatHistoryForCurrentScenario=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("chatHistoryForCurrentScenario");chatHistoryForCurrentScenario.push(component);updateChatHistory(chatHistoryForCurrentScenario);};var addGoToPreviousOption=function addGoToPreviousOption(result,oldScenario){if(result&&result.scenarioActive&&result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options&&result.scenario.scenarioId&&result.notes!==""&&oldScenario&&oldScenario.scenario&&oldScenario.scenario.scenarioId===result.scenario.scenarioId&&!result.scenarioSwitchExecuted){if(result.scenario.scenarioIntent&&result.scenario.scenarioIntent.toLowerCase()==="I want to activate International Roaming".toLowerCase()){return result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options?result.scenario.scenarioStep.options:[];}var result_after_add=result;var option={choiceId:"1",choiceText:"Previous Step",displayText:"Previous Step",nextStep:"2"};result_after_add.scenario.scenarioStep.options.push(option);return result_after_add.scenario.scenarioStep.options;}return result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options?result.scenario.scenarioStep.options:[];};var updateChatHistory=function updateChatHistory(updatedValue){__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("chatHistoryForCurrentScenario",updatedValue);};var resetChatHistory=function resetChatHistory(){__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("chatHistoryForCurrentScenario",[]);};var goToPrevious=function goToPrevious(message_comp){var chatHistoryForCurrentScenario=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("chatHistoryForCurrentScenario");if(chatHistoryForCurrentScenario.length>0){chatHistoryForCurrentScenario.pop();var chatHistoryItem=chatHistoryForCurrentScenario[chatHistoryForCurrentScenario.length-1];message_comp.addNewMessages({new_messages:chatHistoryItem.message_objects});// message_comp.addComponent([chatHistoryItem.component]);
updateChatHistory(chatHistoryForCurrentScenario);message_comp.setState({current_scenario:chatHistoryItem.scenarioResponse,showFeedbackOptions:false,response_options:chatHistoryItem.chatItem});}return null;};/* harmony default export */ __webpack_exports__["a"] = ({addItem:addItem,updateChatHistory:updateChatHistory,resetChatHistory:resetChatHistory,goToPrevious:goToPrevious,addGoToPreviousOption:addGoToPreviousOption});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TemplateName={Data_Balance_Details:'Data_Balance_Details',Outstanding_Amount:'Outstanding_Amount',CURRENT_BILL_PLAN:'CURRENT_BILL_PLAN',Eligible_Bill_Plans:'Eligible_Bill_Plans',New_Bill_Plan:'New_Bill_Plan',PAY_MY_BILL:'PAY_MY_BILL',PREV_DUPLICATE_BILLS:'PREV_DUPLICATE_BILLS',PREV_PAYMENT_RECEIPTS:'PREV_PAYMENT_RECEIPTS',IR_ACTIVATED_PACKS_DEACTIVATION:'IR_ACTIVATED_PACKS_DEACTIVATION',IR_MULTIPLE_ZONE_PACKS:'IR_MULTIPLE_ZONE_PACKS',IR_SINGLE_ZONE_PACKS:'IR_SINGLE_ZONE_PACKS',IR_Pack_Countries:"IR_Pack_Countries",IR_PACKS_RECO:"IR_PACKS_RECO",IR_RECO_DYN_PARAM:"IR_RECO_DYN_PARAM",IR_PACKS_ALL:"IR_PACKS_ALL",IR_SERVICE_DEACTIVATION:"IR_SERVICE_DEACTIVATION"};/* harmony default export */ __webpack_exports__["a"] = (TemplateName);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_templateName__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_common_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_chatHistory_service__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enums_trackingKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_bot_switch_service__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__ = __webpack_require__(25);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ActionHandlerService2=function ActionHandlerService2(){_classCallCheck(this,ActionHandlerService2);};ActionHandlerService2.executeChatIn=function(data,resolve,reject,retry_count,chatBotQuery){var enteredText=chatBotQuery||data.user_response?data.user_response:data.scenarioResponse.user_res;__WEBPACK_IMPORTED_MODULE_4__services_chatbot_api_service__["a" /* default */].chatInScenario("",data.scenarioResponse.authToken,data.scenarioResponse.response,data.scenarioResponse.transactionId,data.scenarioResponse.scenario,enteredText,data&&data.initiateRetry?data.initiateRetry:"",__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType"),ActionHandlerService2.acceptDynamicParameters(data.scenarioResponse),ActionHandlerService2.createDynamicParameters(data.scenarioResponse,enteredText)).then(function(response){var result=response.executionContext;if(result){if(result.response&&ActionHandlerService2.hasDynamicDescription(result)){result['response']=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getDynamicDescriptionString(result);}var chatItem={response:result&&result.response?result.response:"",options:__WEBPACK_IMPORTED_MODULE_7__services_chatHistory_service__["a" /* default */].addGoToPreviousOption(result,data.scenarioResponse),scenarioActive:result&&result.scenarioActive?result.scenarioActive:false,type:"chatbot",sentTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime(),scenarioResponse:result?result:""};result.scenarioActive=result.scenarioActive||false;//replace the exception message with script
if(__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].checkIfNeedToReplaceExceptionMessage(result,data.scenarioResponse.templateNameList)){result.response=__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].EXCEPTION_REPLACED_MESSAGE;}//check if new intent in chatin to track intent reading success
if(ActionHandlerService2.checkIfNewIntentInChatIn(data,result)){__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].handleTrackingAfterResponse({enteredText:enteredText,result:result,response:response});}var message_objects=[];switch(true){case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isResponseUnauthorized(response):{ActionHandlerService2.handleUnauthorizedResponse(result,resolve);break;}case ActionHandlerService2.isSwitchBotCase(result):{ActionHandlerService2.handleBotSwitch(result,chatItem,resolve,reject,enteredText,retry_count);break;}case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isProcessingExceptionCase(result):{chatItem.response=__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].error.genericSRError;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result,chatItem:chatItem});break;}case result&&result.initiateRetry:{ActionHandlerService2.handleInitiateRetryInReponse(result,retry_count,resolve,reject);break;}case ActionHandlerService2.isFaqScenario(result):{ActionHandlerService2.handleFaqScenarioResponse(result,resolve,chatItem);break;}case result.askForLogin:{__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].showLoginForm(result,resolve);break;}case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isIntentReadingFailResponse(result):{ActionHandlerService2.handleIntentReadingFailedResponse(resolve,reject);break;}case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isShowDffFormCase(result):{__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].handleDffForm(result,resolve,reject);break;}case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isDffResponseSuccess(result):{__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].showDffResponse(result,resolve,reject);break;}case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isCrmConsumeSrApiError(result):{__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].handleCrmConsumeSrApiError(result,resolve,reject);break;}case ActionHandlerService2.isCountryTemplate(result):{ActionHandlerService2.handleCountryTemplate(result,resolve);break;}case ActionHandlerService2.isIrPackTemplate(result):{ActionHandlerService2.handleIrPackTemplate(result,chatItem,resolve);break;}case ActionHandlerService2.hasTemplate(result):{ActionHandlerService2.handleTemplateResponse(result,chatItem,resolve);break;}case ActionHandlerService2.isShowAdditionalInfoCase(result):{// console.log('show additional info')
ActionHandlerService2.showAdditionalInfo(result,chatItem,resolve);break;}case ActionHandlerService2.hasResponseString(result):{ActionHandlerService2.handleSimpleResponseCase(result,chatItem,resolve);break;}default:{ActionHandlerService2.handleDefaultErrorMessageCase(reject);break;}}}else{// no execution context in response
//handle default error case
ActionHandlerService2.handleDefaultErrorMessageCase(reject);}}).catch(function(error){ActionHandlerService2.handleDefaultErrorMessageCase(reject);});};ActionHandlerService2.initiateScenario=function(scenarioObject,resolve,reject,retry_count){__WEBPACK_IMPORTED_MODULE_4__services_chatbot_api_service__["a" /* default */].initiate("",scenarioObject,false,__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")).then(function(response){var result=response.executionContext;if(result){if(result.response&&ActionHandlerService2.hasDynamicDescription(result)){result['response']=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getDynamicDescriptionString(result);}var chatItem={response:result&&result.response?result.response:"",options:result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options?result.scenario.scenarioStep.options:[],scenarioActive:result&&result.scenarioActive?result.scenarioActive:false,type:"chatbot",sentTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime(),scenarioResponse:result?result:""};result.scenarioActive=result.scenarioActive||false;var message_objects=[];switch(true){case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isResponseUnauthorized(response):{ActionHandlerService2.handleUnauthorizedResponse(result,resolve);break;}case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isProcessingExceptionCase(result):{chatItem.response=__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].error.genericSRError;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result,chatItem:chatItem});break;}case result&&result.initiateRetry:{ActionHandlerService2.handleInitiateRetryInReponse(result,retry_count,resolve,reject);break;}case result.askForLogin:{__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].showLoginForm(result,resolve);break;}// case (ActionHandlerService.isIntentReadingFailResponse(result)):{
//     ActionHandlerService2.handleIntentReadingFailedResponse(resolve,reject)
//     break;
// }
case ActionHandlerService2.isCountryTemplate(result):{ActionHandlerService2.handleCountryTemplate(result,resolve);break;}case ActionHandlerService2.isIrPackTemplate(result):{ActionHandlerService2.handleIrPackTemplate(result,chatItem,resolve);break;}case ActionHandlerService2.hasTemplate(result):{ActionHandlerService2.handleTemplateResponse(result,chatItem,resolve);break;}case ActionHandlerService2.isShowAdditionalInfoCase(result):{// console.log('show additional info')
ActionHandlerService2.showAdditionalInfo(result,chatItem,resolve);break;}// case ActionHandlerService2.hasDynamicDescription(result): {
//     let dynDesc = ActionHandlerService.getDynamicDescriptionString(result)
//     console.log('dynamic desc', dynDesc)
//     break;
// }
case ActionHandlerService2.hasResponseString(result):{ActionHandlerService2.handleSimpleResponseCase(result,chatItem,resolve);break;}default:{ActionHandlerService2.handleDefaultErrorMessageCase(reject);break;}}}else{// no execution context in response
//handle default error case
ActionHandlerService2.handleDefaultErrorMessageCase(reject);}}).catch(function(error){ActionHandlerService2.handleDefaultErrorMessageCase(reject);});};ActionHandlerService2.executeChatOut=function(enteredText,resolve,reject,retry_count,chatBotQuery){var query=chatBotQuery||enteredText;var trackingData=__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("trackingData");trackingData.queryCount+=1;__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].set("trackingData",trackingData);__WEBPACK_IMPORTED_MODULE_4__services_chatbot_api_service__["a" /* default */].chatOutScenario(query).then(function(response){var result=response.executionContext;if(result){__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].handleTrackingAfterResponse({enteredText:enteredText,result:result,response:response});// if (result.response && ActionHandlerService2.hasDynamicDescription(result)) {
//     result['response'] = ActionHandlerService.getDynamicDescriptionString(result)
// }
var chatItem={response:result&&result.response?result.response:"",options:result&&result.scenario&&result.scenario.scenarioStep&&result.scenario.scenarioStep.options?result.scenario.scenarioStep.options:[],scenarioActive:result&&result.scenarioActive?result.scenarioActive:false,type:"chatbot",sentTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime(),scenarioObject:result&&result.scenario?result.scenario:""};result.scenarioActive=result.scenarioActive||false;switch(true){case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isResponseUnauthorized(response):{ActionHandlerService2.handleUnauthorizedResponse(result,resolve);break;}case ActionHandlerService2.isSwitchBotCase(result):{ActionHandlerService2.handleBotSwitch(result,chatItem,resolve,reject,query,retry_count);break;}case result&&result.initiateRetry:{ActionHandlerService2.handleInitiateRetryInReponse(result,retry_count,resolve,reject);break;}case __WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isIntentReadingFailResponse(result):{ActionHandlerService2.handleIntentReadingFailedResponse(resolve,reject);break;}case ActionHandlerService2.isFaqScenario(result):{ActionHandlerService2.handleFaqScenarioResponse(result,resolve,chatItem);break;}case ActionHandlerService2.isDTScenario(result):{ActionHandlerService2.handleDtScenario(result,resolve,reject,retry_count);break;}default:{ActionHandlerService2.handleDefaultErrorMessageCase(reject);break;}}}else{// no execution context in response
//handle default error case
ActionHandlerService2.handleDefaultErrorMessageCase(reject);}}).catch(function(error){ActionHandlerService2.handleDefaultErrorMessageCase(reject);});};ActionHandlerService2.isDTScenario=function(result){if(result&&result.scenario&&result.scenario.scenarioStrategy==="DTScenario"){return true;}return false;};ActionHandlerService2.isSwitchBotCase=function(result){if(result&&result.scenario&&result.scenario.scenarioLob&&result.scenario.scenarioLob.toUpperCase()!==__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")&&result.scenario.scenarioStrategy&&result.scenario.scenarioStrategy==="SwitchScenario"){// console.log('is switch bot case')
return true;}return false;};ActionHandlerService2.handleBotSwitch=function(result,chatItem,resolve,reject,query,retry_count){__WEBPACK_IMPORTED_MODULE_11__services_bot_switch_service__["a" /* default */].handleBotSwitch(result,chatItem,resolve,reject,query,retry_count);};ActionHandlerService2.handleDtScenario=function(result,resolve,reject,retry_count){if(__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].isLoginRequired(result)){if(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("isUserLoggedIn")){ActionHandlerService2.initiateScenario(result.scenario,resolve,reject,retry_count);}else{// console.log('handle dt scenario, show login')
__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].showLoginForm(result,resolve);}}else{ActionHandlerService2.initiateScenario(result.scenario,resolve,reject,retry_count);}};ActionHandlerService2.hasTemplate=function(result){if(result.templateNameList&&result.templateNameList.length>0){return true;}return false;};ActionHandlerService2.hasResponseString=function(result){if(result.response!==undefined){return true;}return false;};ActionHandlerService2.handleSimpleResponseCase=function(result,chatItem,resolve){var message_objects=[];var formattedresponse=__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getWebOrAppSpecificResponse(__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getPlatformSpeciifcDescription(result.response,result.scenario.scenarioStrategy));chatItem.response=formattedresponse;var splittedResponse=formattedresponse.split("<div>&gt;&gt;&gt;&gt;</div>");for(var i=0;i<splittedResponse.length;i++){var splittedChatItem=JSON.parse(JSON.stringify(chatItem));splittedChatItem.response=splittedResponse[i];message_objects.push({component_type:'DEFAULT',message:splittedChatItem.response,messageTime:splittedChatItem.sentTime});}if(result&&result.dffStepResponse&&result.dffStepResponse.result&&result.dffStepResponse.result.message){var _splittedChatItem=JSON.parse(JSON.stringify(chatItem));_splittedChatItem.response=result.dffStepResponse.result.message;message_objects.push({component_type:'DEFAULT',message:_splittedChatItem.response,messageTime:_splittedChatItem.sentTime});}// Update Chat History
__WEBPACK_IMPORTED_MODULE_7__services_chatHistory_service__["a" /* default */].addItem({message_objects:message_objects,scenarioResponse:result,chatItem:chatItem});resolve({message_objects:message_objects,scenarioResponse:result,chatItem:chatItem});};ActionHandlerService2.handleTemplateResponse=function(result,chatItem,resolve){var template_res=result.response;var message_objects=[];if(result.systemInfo){template_res=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getTemplateResponseFromSystemInfo(result.systemInfo,result.templateNameList,result);// console.log('template res',template_res)
if(result.response.indexOf('[json]')!==-1){var res_obj=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getTemplateResponseObject(result.response);chatItem.response=res_obj.chat_res_string;}message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});}else if(result.response.indexOf('[json]')!==-1){var _res_obj=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getTemplateResponseObject(result.response);chatItem.response=_res_obj.chat_res_string;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});template_res=_res_obj.template_res_string;}// let template_obj = ActionHandlerService2.getTemplateMessageObject(template_res,result.templateNameList,chatItem)
var template_obj=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].chooseTemplateToShow(result.templateNameList,template_res,chatItem);var showCancelButton=ActionHandlerService2.showCancelButton(result.templateNameList,chatItem);if(template_obj&&template_obj.message_obj){message_objects.push(template_obj.message_obj);}resolve({message_objects:message_objects,scenarioResponse:result,chatItem:template_obj&&!template_obj.options_hidden||!template_obj?chatItem:undefined,show_cancel_comp:template_obj?template_obj.show_cancel_comp:false,bottom_comp:template_obj&&template_obj.show_cancel_comp?{type:__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CANCEL_COMPONENT,cancel_obj:Object.assign({},template_obj.cancel_obj,{chatItem:chatItem})}:undefined,cancel_obj:template_obj?Object.assign({},template_obj.cancel_obj,{chatItem:chatItem}):undefined});};ActionHandlerService2.showCancelButton=function(templateNameList,chatItem){// console.log('cancel func')
if(chatItem&&chatItem.options&&chatItem.options.length>0){if(chatItem.options.includes(function(option){option.displayText==='CANCEL';}))// console.log('show cancel')
return true;}// console.log('no cancel')
return false;};ActionHandlerService2.getTemplateMessageObject=function(template_res_string,templateNameList,chatItem){// console.log('get template object')
var template_data=void 0;try{template_data=JSON.parse(template_res_string);}catch(e){template_data=undefined;}var template_obj=void 0;if(template_data){template_obj=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].chooseTemplateToShow(templateNameList,template_res_string,chatItem);}else{//template data not received or not parsable
if(!templateNameList.includes(__WEBPACK_IMPORTED_MODULE_0__enums_templateName__["a" /* default */].IR_RECO_DYN_PARAM)){template_obj={message_obj:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].createChatBotMessageObject('no template data')};}}return template_obj;};ActionHandlerService2.createChatBotMessageObject=function(message){return{component_type:'DEFAULT',message:message,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()};};ActionHandlerService2.isIrPackTemplate=function(result){if(result.templateNameList&&result.templateNameList.length>0&&(__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].IS_IR_PACKS_RECO(result.templateNameList)||__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].IS_IR_PACKS_ALL(result.templateNameList))){return true;}return false;};ActionHandlerService2.handleIrPackTemplate=function(result,chatItem,resolve){chatItem.sentTime=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime();var message_objects=[];var formattedresponse=__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getWebOrAppSpecificResponse(__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getPlatformSpeciifcDescription(result.response,result.scenario.scenarioStrategy));chatItem.response=formattedresponse;var template_res=result.response;if(result.systemInfo){template_res=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getTemplateResponseFromSystemInfo(result.systemInfo,result.templateNameList,result);if(result.response.indexOf('[json]')!==-1){var res_obj=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getTemplateResponseObject(result.response);chatItem.response=res_obj.chat_res_string;}message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});}else if(result.response.indexOf('[json]')!==-1){var _res_obj2=__WEBPACK_IMPORTED_MODULE_1__services_actions_handler_service__["a" /* default */].getTemplateResponseObject(result.response);chatItem.response=_res_obj2.chat_res_string;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});template_res=_res_obj2.template_res_string;}if(template_res){message_objects.push({component_type:'IR_PACK',messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime(),packDetails:template_res,chatItem:chatItem,templateName:result.templateNameList[0]});}else{message_objects.push({component_type:'DEFAULT',message:__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE,messageTime:chatItem.sentTime});}resolve({message_objects:message_objects,scenarioResponse:result,show_cancel_comp:true,bottom_comp:{type:__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CANCEL_COMPONENT,cancel_obj:{type:'IR_PACK',chatItem:chatItem}},cancel_obj:{type:'IR_PACK',chatItem:chatItem}});};ActionHandlerService2.handleCountryTemplate=function(result,resolve){var message_objects=[];var chatItem={};var formattedresponse=__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getWebOrAppSpecificResponse(__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getPlatformSpeciifcDescription(result.response,result.scenario.scenarioStrategy));chatItem.response=formattedresponse;chatItem.sentTime=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime();message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});};ActionHandlerService2.handleUnauthorizedResponse=function(result,resolve){var chatItem={};var message_objects=[];chatItem.response=__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].SESSION_EXPIRED_STATUS.message;chatItem.sentTime=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime();message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});};ActionHandlerService2.isCountryTemplate=function(result){if(result.templateNameList&&result.templateNameList.length>0&&__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].isCountryTemplate(result.templateNameList)){return true;}return false;};ActionHandlerService2.handleDefaultErrorMessageCase=function(reject){var chatItem={};chatItem['response']=__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].default_error_message;var message_objects=[];message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()});reject({message_objects:message_objects});};ActionHandlerService2.handleIntentReadingFailedResponse=function(resolve,reject){if(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get('no_intent_found_1')){__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].set('no_intent_found_1',false);ActionHandlerService2.initiateScenario(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_1"],resolve,reject);}else{__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].set('no_intent_found_1',true);ActionHandlerService2.initiateScenario(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_2"],resolve,reject);}};ActionHandlerService2.isFaqScenario=function(result){if(result&&result.scenario&&result.scenario.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__["a" /* default */].FAQScenario){return true;}return false;};ActionHandlerService2.handleFaqScenarioResponse=function(result,resolve,chatItem){chatItem={};var message_objects=[];var formattedresponse=__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getWebOrAppSpecificResponse(__WEBPACK_IMPORTED_MODULE_6__actions_common_service__["a" /* default */].getPlatformSpeciifcDescription(result,result.scenario.scenarioStrategy));chatItem.response=formattedresponse;message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result});};ActionHandlerService2.handleInitiateRetryInReponse=function(result,retry_count,resolve,reject){// console.log(retry_count)
var scenarioName=result&&result.scenario&&result.scenario.scenarioName||"";var scenarioStrategy=result&&result.scenario&&result.scenario.scenarioStrategy||"";if(!retry_count||retry_count<3){resolve({scenarioResponse:result,initiateRetry:result.initiateRetry,retry_count:retry_count?retry_count:0});//tracking for retry case
__WEBPACK_IMPORTED_MODULE_8__tracking_middleware_service__["a" /* default */].setTrackingData({scenarioName:scenarioName,scenarioStrategy:scenarioStrategy});__WEBPACK_IMPORTED_MODULE_8__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_9__enums_trackingKey__["a" /* default */].RETRY_OPTION);}else if(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]&&__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]["FAILURE"]){ActionHandlerService2.initiateScenario(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]["FAILURE"],resolve,reject,retry_count+1);}else{var chatItem={};chatItem['response']=__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].default_error_message;var message_objects=[];message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()});resolve({message_objects:message_objects});}};ActionHandlerService2.checkIfNewIntentInChatIn=function(data,result){if(data&&data.scenarioResponse&&data.scenarioResponse.scenario&&data.scenarioResponse.scenario.scenarioId&&result&&result.scenario&&result.scenario.scenarioId&&data.scenarioResponse.scenario.scenarioId!==result.scenario.scenarioId){return true;}return false;};ActionHandlerService2.acceptDynamicParameters=function(scenarioResponse){if(scenarioResponse&&scenarioResponse.templateNameList&&scenarioResponse.templateNameList.length>0){var templatesWithDynamicParam=[__WEBPACK_IMPORTED_MODULE_0__enums_templateName__["a" /* default */].IR_PACKS_ALL,__WEBPACK_IMPORTED_MODULE_0__enums_templateName__["a" /* default */].IR_PACKS_RECO,__WEBPACK_IMPORTED_MODULE_0__enums_templateName__["a" /* default */].IR_Pack_Countries,__WEBPACK_IMPORTED_MODULE_0__enums_templateName__["a" /* default */].IR_RECO_DYN_PARAM,__WEBPACK_IMPORTED_MODULE_0__enums_templateName__["a" /* default */].IR_ACTIVATED_PACKS_DEACTIVATION];for(var i in scenarioResponse.templateNameList){if(templatesWithDynamicParam.includes(scenarioResponse.templateNameList[i])){return true;}}return false;}};ActionHandlerService2.createDynamicParameters=function(scenarioResponse,user_input){var templateDynamicParam={IR_PACKS_ALL:'INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST',IR_Pack_Countries:'INPUT_PARAM-IR_BOOSTER_COUNTRY_NAME',IR_RECO_DYN_PARAM:'INPUT_PARAM-IR_BOOSTER_VALIDITY',IR_PACKS_RECO:'INPUT_PARAM-IR_BOOSTER_ID_ACTIVE_REQUEST',IR_ACTIVATED_PACKS_DEACTIVATION:'DEACTIVATION_IR_PACK_ID'};var dynamicParams={};if(ActionHandlerService2.acceptDynamicParameters(scenarioResponse)&&scenarioResponse&&scenarioResponse.templateNameList&&scenarioResponse.templateNameList.length>0){for(var i in scenarioResponse.templateNameList){if(templateDynamicParam.hasOwnProperty(scenarioResponse.templateNameList[i])){dynamicParams[templateDynamicParam[scenarioResponse.templateNameList[i]]]=user_input;}}}return dynamicParams;};ActionHandlerService2.showAdditionalInfo=function(scenarioResponse,chatItem,resolve){var message_objects=[];if(scenarioResponse.additionalInfo&&Object.keys(scenarioResponse.additionalInfo).length>0&&scenarioResponse.additionalInfo.leap_informCustomerScript){message_objects.push(__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].createChatBotMessageObject(scenarioResponse.additionalInfo.leap_informCustomerScript));}if(scenarioResponse.response){message_objects.push(__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].createChatBotMessageObject(scenarioResponse.response));}resolve({message_objects:message_objects,scenarioResponse:scenarioResponse,chatItem:chatItem});};ActionHandlerService2.isShowAdditionalInfoCase=function(scenarioResponse){// console.log(scenarioResponse)
if(scenarioResponse.scenario&&scenarioResponse.scenario.scenarioLob&&scenarioResponse.scenario.scenarioLob.toLowerCase()==="prepaid"&&scenarioResponse.additionalInfo&&Object.keys(scenarioResponse.additionalInfo).length>0){return true;}return false;};ActionHandlerService2.hasDynamicDescription=function(result){// console.log(result.response, result.response.indexOf('[DYN-DESC]'))
if(result&&result.response&&result.response.indexOf('[DYN-DESC]')!==-1){return true;}return false;};/* harmony default export */ __webpack_exports__["a"] = (ActionHandlerService2);

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__db_read_write_service__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_BotType__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LoginService=function(){function LoginService(){_classCallCheck(this,LoginService);}_createClass(LoginService,null,[{key:'loginInApp',value:function loginInApp(){var _this=this;__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set('loginType',__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].TRACKING_EVENTS_CONSTANTS.loginType.ALREADY_LOGGEDIN);return new Promise(function(resolveLoginInApp,rejectLoginInApp){var appReference=__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("APP_CONTEXT");var method="GET";var uri="https://api.myairtelapp.bsbportal.in/myairtelapp/v2/home/mainAccCard?density=XXHDPI";var payload="";var appHeaders=appReference.getHeaders(method,uri,payload);appHeaders=String(appHeaders).replace(/\n/g,"");appHeaders=JSON.parse(appHeaders);var headers={"x-bsy-dt":String(appHeaders["x-bsy-dt"]).replace(/\n/g,""),"x-bsy-utkn1":String(appHeaders["x-bsy-utkn"]).replace(/\n/g,""),"x-bsy-did":String(appHeaders["x-bsy-did"]).replace(/\n/g,"")};var newappHeaders=appReference.getHeaders(method,"https://www.airtel.in/app/wl-service/airtel-digital-profile/rest/customer/profile/v2/rtn/fetch","");newappHeaders=String(newappHeaders).replace(/\n/g,"");newappHeaders=JSON.parse(newappHeaders);headers["x-bsy-utkn2"]=String(newappHeaders["x-bsy-utkn"]).replace(/\n/g,"");__WEBPACK_IMPORTED_MODULE_1__chatbot_api_service__["a" /* default */].getChatTokenForApp(headers).then(function(result){_this.setLoginData(result);_this.setTrackingLoginData(result);if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("currentBotType")!==__WEBPACK_IMPORTED_MODULE_8__enums_BotType__["a" /* default */].PAYMENTS_BANK){_this.handleUserProfile(result.userProfile);}else{//in case of payments bank track login success without checking profile
__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].LOGIN_SUCCESS);}resolveLoginInApp();},function(err){// TRACK CHAT LAUNCH FAIL
__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].LOGIN_FAIL);rejectLoginInApp();return{status:err};});});}},{key:'loginInWeb',value:function loginInWeb(mobNo,loginType){var _this2=this;__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set('loginType',loginType?loginType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].TRACKING_EVENTS_CONSTANTS.loginType.ALREADY_LOGGEDIN);return new Promise(function(resolveLoginInWeb,rejectLoginInWeb){__WEBPACK_IMPORTED_MODULE_1__chatbot_api_service__["a" /* default */].getChatTokenForWeb(mobNo).then(function(result){if(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].allowUserLogin(result,mobNo)){__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("loginNotAllowed",false);_this2.setLoginData(result);_this2.setTrackingLoginData(result);_this2.handleUserProfile(result.userProfile);}else{__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("loginNotAllowed",true);}resolveLoginInWeb();},function(err){// TRACK CHAT LAUNCH FAIL
__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].LOGIN_FAIL);rejectLoginInWeb();});});}},{key:'setLoginData',value:function setLoginData(result){__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("loggedInToken","Bearer"+result.access_token);var primaryNumber=result&&result.userProfile&&result.userProfile.userAuthToken&&result.userProfile.userAuthToken.primaryMsisdn?result.userProfile.userAuthToken.primaryMsisdn:"";__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("primaryNumber",primaryNumber);__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("isUserLoggedIn",true);// do not set user profile if paymnets bank chatbot 
if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("currentBotType")!==__WEBPACK_IMPORTED_MODULE_8__enums_BotType__["a" /* default */].PAYMENTS_BANK){if(result.userProfile){__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("userProfile",result.userProfile);}if(result.userProfile&&result.userProfile.products){var numbers=__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].getUserProfileNumbersWithAccountType(result.userProfile);__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("userAccounts",numbers);}__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("currentBotType",__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].getBotType(primaryNumber,result.userProfile));}}},{key:'setTrackingLoginData',value:function setTrackingLoginData(result){var trackingData=__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("trackingData");trackingData.circle=result&&result.userProfile&&result.userProfile.userAuthToken&&result.userProfile.userAuthToken.circle?result.userProfile.userAuthToken.circle:"";//update circle for tracking data
__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("trackingData",trackingData);var primaryNumber=result&&result.userProfile&&result.userProfile.userAuthToken&&result.userProfile.userAuthToken.primaryMsisdn?result.userProfile.userAuthToken.primaryMsisdn:"";//NEW TRACKING
__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].setTrackingData({circle:trackingData.circle});}},{key:'handleUserProfile',value:function handleUserProfile(userProfile){var primaryNumber=userProfile&&userProfile.userAuthToken&&userProfile.userAuthToken.primaryMsisdn?userProfile.userAuthToken.primaryMsisdn:"";if(userProfile&&userProfile.products){__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].LOGIN_SUCCESS);if(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].isSingleAccount(userProfile)){__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set('userProfileType','SINGLE');//SET CURRENT NUMBER TO PRIMARY NUMBER IN SINGLE ACCOUNT CASE
__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("currentNumber",primaryNumber);__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].SSO_PROFILE_SINGLE);}else if(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].isMultipleAccount(userProfile)){__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set('userProfileType','MULTIPLE');__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].setTrackingForSSOMultiple(userProfile);__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].SSO_PROFILE_MULTIPLE);}else{//TRACK SSO PROFILE NO ACCOUNT
__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].SSO_PROFILE_NO_ACCOUNT);}}else{//TRACK LOGIN FAILURE
__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_2__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_7__enums_trackingKey__["a" /* default */].LOGIN_FAIL);}}},{key:'afterInitialLoginSuccess',value:function afterInitialLoginSuccess(_ref){var message_comp=_ref.message_comp;if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('currentBotType')===__WEBPACK_IMPORTED_MODULE_8__enums_BotType__["a" /* default */].PAYMENTS_BANK){//if payments bank initiate welcome scenario for payments bank
__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("currentNumber",__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("primaryNumber"));message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject('Welcome to Airtel Payments Bank – Online Chat Support!')]});message_comp.initiateWelcomeScenario();}else if(window.MyAirtelChatAppReact){//app new context supporting chat history
//read the message chat history from db
__WEBPACK_IMPORTED_MODULE_4__db_read_write_service__["a" /* default */].readFromDB();}else if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("APP_CONTEXT")){//app old context
switch(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('userProfileType')){case'SINGLE':{message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].WELCOME)]});message_comp.onNumberSelected({user_response:__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('primaryNumber'),show_number:false});break;}case'MULTIPLE':{message_comp.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU});message_comp.setLoaderOff();message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].WELCOME),__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].SELECT_ACCOUNT)]});break;}}}else{//web case
switch(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('userProfileType')){case'SINGLE':{var chatItem=__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].CONFIRMATION_FOR_SINGLE_ACCOUNT_WEB;chatItem.response=chatItem.response.replace("moblieNumbetPlaceholder",__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('primaryNumber'));message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].WELCOME),__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(chatItem.response)]});message_comp.setState({current_scenario:chatItem,showFeedbackOptions:false,response_options:chatItem,disableBottomBar:true});message_comp.setLoaderOff();break;}case'MULTIPLE':{message_comp.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU});message_comp.setLoaderOff();message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].WELCOME),__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].SELECT_ACCOUNT)]});// WHEN AVATAR OF BOT WILL BE RELEASED
// message_comp.addNewMessages({new_messages:[{component_type:'WELCOME_COMPONENT_MULTIPLE',message:SCRIPTS.WELCOME,messageTime:UtilService.getCurrentTime()}]})
break;}default:{// not logged in case
message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].WELCOME)]});message_comp.initiateWelcomeScenario();}}}}},{key:'afterLoginAtALaterStage',value:function afterLoginAtALaterStage(_ref2){var message_comp=_ref2.message_comp;if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("APP_CONTEXT")){// in case logged in app 
}else{var new_messages=[];if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('isUserLoggedIn')){switch(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('userProfileType')){case'SINGLE':{new_messages.push(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].LOGIN_SUCCESS));message_comp.initiateScenarioAfterLogin();message_comp.closeLoginComp({});break;}case'MULTIPLE':{message_comp.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU});new_messages.push(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].LOGIN_SUCCESS));new_messages.push(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].SELECT_ACCOUNT));__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set("loginViaOtp",true);break;}default:{// if no single or multiple case show a message that profile doesnt have any prepaid or postpaid number 
// so please type a new query
message_comp.closeLoginComp({});new_messages.push(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR));}}}else if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('loginNotAllowed')){new_messages.push(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].LOGIN_FAILED_PLEASE_RELOGIN));message_comp.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT,resetLoginState:true});}else{message_comp.closeLoginComp({});new_messages.push(__WEBPACK_IMPORTED_MODULE_3__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR));}message_comp.addNewMessages({new_messages:new_messages});}}}]);return LoginService;}();/* harmony default export */ __webpack_exports__["a"] = (LoginService);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_util_service__ = __webpack_require__(3);
var PopUp=function PopUp(popup_data,popupVisible,height,width){var isApp=__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].get("APP_CONTEXT")?true:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup_class home'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overlay',style:{height:isApp?'100vh':'calc(100vh - 56px)',marginTop:isApp?0:'56px',visibility:!popupVisible?'hidden':'visible'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"subscribe "+(__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].getOS()==="Windows"?"custom-scrollbar":""),style:{overflow:'auto',height:height?height:'',maxHeight:height?'calc(100% - 28px)':'330px',width:width?width:'280px'}},popup_data)));};/* harmony default export */ __webpack_exports__["a"] = (PopUp);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(47);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "now", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timer", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timerFlush", function() { return __WEBPACK_IMPORTED_MODULE_0__timer__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timeout__ = __webpack_require__(188);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return __WEBPACK_IMPORTED_MODULE_1__timeout__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__interval__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interval", function() { return __WEBPACK_IMPORTED_MODULE_2__interval__["a"]; });







/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = now;
/* harmony export (immutable) */ __webpack_exports__["a"] = Timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = timer;
/* harmony export (immutable) */ __webpack_exports__["d"] = timerFlush;
var frame = 0, // is an animation frame pending?
    timeout = 0, // is a timeout pending?
    interval = 0, // are any timers active?
    pokeDelay = 1000, // how frequently we check for clock skew
    taskHead,
    taskTail,
    clockLast = 0,
    clockNow = 0,
    clockSkew = 0,
    clock = typeof performance === "object" && performance.now ? performance : Date,
    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };

function now() {
  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
}

function clearNow() {
  clockNow = 0;
}

function Timer() {
  this._call =
  this._time =
  this._next = null;
}

Timer.prototype = timer.prototype = {
  constructor: Timer,
  restart: function(callback, delay, time) {
    if (typeof callback !== "function") throw new TypeError("callback is not a function");
    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
    if (!this._next && taskTail !== this) {
      if (taskTail) taskTail._next = this;
      else taskHead = this;
      taskTail = this;
    }
    this._call = callback;
    this._time = time;
    sleep();
  },
  stop: function() {
    if (this._call) {
      this._call = null;
      this._time = Infinity;
      sleep();
    }
  }
};

function timer(callback, delay, time) {
  var t = new Timer;
  t.restart(callback, delay, time);
  return t;
}

function timerFlush() {
  now(); // Get the current time, if not already set.
  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
  var t = taskHead, e;
  while (t) {
    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
    t = t._next;
  }
  --frame;
}

function wake() {
  clockNow = (clockLast = clock.now()) + clockSkew;
  frame = timeout = 0;
  try {
    timerFlush();
  } finally {
    frame = 0;
    nap();
    clockNow = 0;
  }
}

function poke() {
  var now = clock.now(), delay = now - clockLast;
  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
}

function nap() {
  var t0, t1 = taskHead, t2, time = Infinity;
  while (t1) {
    if (t1._call) {
      if (time > t1._time) time = t1._time;
      t0 = t1, t1 = t1._next;
    } else {
      t2 = t1._next, t1._next = null;
      t1 = t0 ? t0._next = t2 : taskHead = t2;
    }
  }
  taskTail = t0;
  sleep(time);
}

function sleep(time) {
  if (frame) return; // Soonest alarm already set, or will be.
  if (timeout) timeout = clearTimeout(timeout);
  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
  if (delay > 24) {
    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
    if (interval) interval = clearInterval(interval);
  } else {
    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
    frame = 1, setFrame(wake);
  }
}


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(78);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(50);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: function() {
    return this.rgb().hex();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: function() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(88);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(94);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return chooseAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_UserActionType__ = __webpack_require__(15);
var chooseAction=function chooseAction(_ref){var scenarioResponse=_ref.scenarioResponse,data=_ref.data;//TODO : improve this part
if(!scenarioResponse&&data&&!data.userResponse&&!data.actionType&&!data.feedbackRequired&&!data.isWelcomeComp){return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].INITIATE,payload:scenarioResponse};// return;
}switch(true){case _isCountrySelect(data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].COUNTRY_SELECT,payload:Object.assign({},data,scenarioResponse)};case _isCreateSrAction(data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CREATE_SR,payload:Object.assign({},data,scenarioResponse)};case _isInitiateAction(scenarioResponse,data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].INITIATE,payload:scenarioResponse};// case _isFeedbackRequiredAction(data):
//     return { action: ChatActionType.FEEDBACK_REQUIRED };
case _isFeedbackAction(data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].FEEDBACK_ACTION,payload:Object.assign({},data)};case data&&data.isWelcomeComp:return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].SHOW_WELCOME_COMP};case data&&data.user_response&&scenarioResponse&&_isFreshIntent(data.user_response,scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CHAT_OUT,payload:Object.assign({},data,scenarioResponse)};case data&&data.user_response&&scenarioResponse&&_isLinkSetOnChoice(data.user_response,scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CHOICE_OPTION_LINK,payload:Object.assign({},data,scenarioResponse)};case data&&data.user_response&&scenarioResponse&&_isBookmarkedScenarioIdForChoice(data.user_response,scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].BOOKMARK,payload:Object.assign({},data,scenarioResponse)};case _isUserResponseSubmitAction(data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].USER_RESPONSE,payload:data.userResponse};case _isChatInAction(scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CHAT_IN,payload:Object.assign({},data,scenarioResponse)};case _isChatOutAction(scenarioResponse,data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CHAT_OUT,payload:Object.assign({},data,scenarioResponse)};case _isInitiateRetryAction(scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].INITIATE_RETRY,payload:scenarioResponse};case _isAskForLoginAction(data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].ASK_FOR_LOGIN,payload:Object.assign({},data,scenarioResponse)};case _isAskForLoginAction(scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].ASK_FOR_LOGIN,payload:scenarioResponse};// case _isNoIntentFoundAction(scenarioResponse, scenarioList):
//     return { action: ChatActionType.NO_INTENT_FOUND, payload: scenarioResponse };
// case _isShowResponseAction(scenarioResponse):
//     return { action: ChatActionType.SHOW_RESPONSE, payload: scenarioResponse };
case _isShowDFFFormAction(scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].SHOW_DFF_FORM,payload:scenarioResponse};case _isShowDffCrmError(scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].SHOW_DFF_CRM_ERROR,payload:scenarioResponse};case _isShowDFFResponseAction(scenarioResponse):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].SHOW_DFF_RESPONSE,payload:scenarioResponse};case _isInitiateWelcomeAction(data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].INITIATE,payload:scenarioResponse};case _isSmartSearchClicked(data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CHAT_OUT,payload:Object.assign({},data,scenarioResponse)};case _isUserInputScenarioMismatch(scenarioResponse,data):return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CHAT_OUT,payload:Object.assign({},data,scenarioResponse)};default:console.log('no action chosen');return{action:__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].NO_ACTION_CHOSEN};}};var _isCountrySelect=function _isCountrySelect(data){return data&&data.actionType&&data.actionType===__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.PLACE;};// const _isInitiateAction = (scenarioResponse, data) => {
//     return (scenarioResponse && scenarioResponse.initiate_after_login ?
//         scenarioResponse.initiate_after_login : scenarioResponse && scenarioResponse.isBookmarkedScenario ? scenarioResponse.isBookmarkedScenario :
//             (data && data.actionType && (data.actionType === "INITIATE" || data.actionType === globalConstants.USER_ACTION_TYPES.CHAT || data.actionType === globalConstants.USER_ACTION_TYPES.CATEGORY)));
// }
var _isInitiateAction=function _isInitiateAction(scenarioResponse,data){if(scenarioResponse&&scenarioResponse.isBookmarkedScenario||data&&data.actionType&&data.actionType==="INITIATE"||scenarioResponse&&data&&data.actionType&&data.actionType===__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CHAT||scenarioResponse&&data&&data.actionType&&data.actionType===__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CATEGORY){return true;}return false;};var _isUserInputScenarioMismatch=function _isUserInputScenarioMismatch(scenarioResponse,data){if(scenarioResponse&&data&&scenarioResponse.enteredText!==data.user_response){return true;}else return false;};var _isUserResponseSubmitAction=function _isUserResponseSubmitAction(data){if(data&&"userResponse"in data&&data.userResponse)return true;else return false;};// const _isFeedbackRequiredAction = (data) => {
//
//     if (data && ("feedbackRequired" in data) && data.feedbackRequired)
//         return true;
//     else
//         return false;
// }
var _isFeedbackAction=function _isFeedbackAction(data){return data&&data.actionType===__WEBPACK_IMPORTED_MODULE_2__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK;};var _isInitiateRetryAction=function _isInitiateRetryAction(scenarioResponse){return scenarioResponse&&scenarioResponse.initiateRetry;};var _isAskForLoginAction=function _isAskForLoginAction(data){return data&&data.askForLogin||data&&data.actionType&&data.actionType===__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].ASK_FOR_LOGIN;};var _isCreateSrAction=function _isCreateSrAction(data){return data&&data.actionType&&data.actionType===__WEBPACK_IMPORTED_MODULE_0__enums_action_types_ChatActionType__["a" /* default */].CREATE_SR;};// const _isNoIntentFoundAction = (scenarioResponse, scenarioList) => {
//     return (scenarioResponse &&
//         scenarioResponse.scenario &&
//         (scenarioResponse.scenario.scenarioId === scenarioList["NO_INTENT_FOUND_1"].scenarioId
//             || scenarioResponse.scenario.scenarioId === scenarioList["NO_INTENT_FOUND_2"].scenarioId));
// }
var _isChatInAction=function _isChatInAction(scenarioResponse){return scenarioResponse&&scenarioResponse.scenarioActive;};var _isChatOutAction=function _isChatOutAction(scenarioResponse,data){return scenarioResponse&&"scenarioActive"in scenarioResponse&&!scenarioResponse.scenarioActive||data&&data.actionType&&data.actionType===__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.DEFAULT;};var _isShowDFFFormAction=function _isShowDFFFormAction(scenarioResponse){return scenarioResponse&&!scenarioResponse.scenarioActive&&scenarioResponse.dffStepResponse&&scenarioResponse.dffStepResponse.scenarioResponse&&scenarioResponse.dffStepResponse.scenarioResponse.length>0;};var _isShowDffCrmError=function _isShowDffCrmError(scenarioResponse){return scenarioResponse&&!scenarioResponse.scenarioActive&&scenarioResponse.dffStepResponse&&scenarioResponse.dffStepResponse.statusCode&&scenarioResponse.dffStepResponse.statusCode==="CRM_CONSUME_SR_API_ERROR";};var _isShowDFFResponseAction=function _isShowDFFResponseAction(scenarioResponse){return scenarioResponse&&!scenarioResponse.scenarioActive&&scenarioResponse.dffStepResponse&&scenarioResponse.dffStepResponse.status&&scenarioResponse.dffStepResponse.status.statusCode&&scenarioResponse.dffStepResponse.status.statusCode==="success";};var _isInitiateWelcomeAction=function _isInitiateWelcomeAction(data){return data&&"isUserLoggedIn"in data&&(data.isUserLoggedIn===false||data.isUserLoggedIn===true);};// smart search and category option click for both ----
//TODO improve name
var _isSmartSearchClicked=function _isSmartSearchClicked(data){return data&&(data.actionType===__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CHAT||data.actionType===__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CATEGORY);};var _isFreshIntent=function _isFreshIntent(enteredText,result){var ScenarioObject=result.scenario;if(ScenarioObject&&ScenarioObject["scenarioStep"]&&ScenarioObject["scenarioStep"]["options"]&&ScenarioObject["scenarioStep"]["options"].length){for(var i=0;i<ScenarioObject["scenarioStep"]["options"].length;i++){if(ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase()===enteredText.toUpperCase()&&ScenarioObject["scenarioStep"]["options"][i]["freshIntent"]&&ScenarioObject["scenarioStep"]["options"][i]["freshIntent"]===true){return true;}}}return false;};var _isLinkSetOnChoice=function _isLinkSetOnChoice(enteredText,result){var ScenarioObject=result.scenario;if(ScenarioObject&&ScenarioObject["scenarioStep"]&&ScenarioObject["scenarioStep"]["options"]&&ScenarioObject["scenarioStep"]["options"].length){for(var i=0;i<ScenarioObject["scenarioStep"]["options"].length;i++){if(ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase()===enteredText.toUpperCase()&&ScenarioObject["scenarioStep"]["options"][i]["stepLink"]){return true;}}}return false;};var _isBookmarkedScenarioIdForChoice=function _isBookmarkedScenarioIdForChoice(enteredText,result){var ScenarioObject=result.scenario;if(ScenarioObject&&ScenarioObject["scenarioStep"]&&ScenarioObject["scenarioStep"]["options"]&&ScenarioObject["scenarioStep"]["options"].length){for(var i=0;i<ScenarioObject["scenarioStep"]["options"].length;i++){if(ScenarioObject["scenarioStep"]["options"][i]["displayText"].toUpperCase()===enteredText.toUpperCase()&&ScenarioObject["scenarioStep"]["options"][i]["bookMark"]&&ScenarioObject["scenarioStep"]["options"][i]["bookMark"]["scenarioId"]){return true;}}}return false;};

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return executeAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_message_components_user_response_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_actions_handler_service__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_actions_handler_service2__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_handle_initialization_errors_service__ = __webpack_require__(159);
var executeAction=function executeAction(actionObject,data,retry_count,chatBotQuery){return new Promise(function(resolveExecuteAction,rejectExecuteAction){var missingInitialParams=__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].checkIfInitializationParamsMissing();if(missingInitialParams){Object(__WEBPACK_IMPORTED_MODULE_9__services_handle_initialization_errors_service__["a" /* handleInitializationErrors */])(missingInitialParams).then(function(result){if(result==='INITIATE_AFTER_LOGIN_IN_MULTIPLE'){var response={};response['INITIATE_AFTER_LOGIN_IN_MULTIPLE']=true;resolveExecuteAction(response);}else{// console.log('errorcehck success')
executeAfterErrorCheck(actionObject,data,retry_count,chatBotQuery).then(function(result){return resolveExecuteAction(result);},function(error){return rejectExecuteAction(error);});}},function(error){// console.log()
rejectExecuteAction();});}else{executeAfterErrorCheck(actionObject,data,retry_count,chatBotQuery).then(function(result){return resolveExecuteAction(result);},function(error){return rejectExecuteAction(error);});}});};var executeAfterErrorCheck=function executeAfterErrorCheck(actionObject,data,retry_count,chatBotQuery){return new Promise(function(resolve,reject){if(isInitiateScenario(actionObject.action)){__WEBPACK_IMPORTED_MODULE_8__services_actions_handler_service2__["a" /* default */].initiateScenario(data&&data.scenarioId?data:data.scenarioResponse,resolve,reject,retry_count);}else if(isFeedbackAction(actionObject.action)){__WEBPACK_IMPORTED_MODULE_8__services_actions_handler_service2__["a" /* default */].initiateScenario(data.scenarioResponse,resolve,reject,retry_count);}else if(isChatInAction(actionObject.action)){__WEBPACK_IMPORTED_MODULE_8__services_actions_handler_service2__["a" /* default */].executeChatIn(data,resolve,reject,retry_count,chatBotQuery);}else if(isChatOutAction(actionObject.action)){__WEBPACK_IMPORTED_MODULE_8__services_actions_handler_service2__["a" /* default */].executeChatOut(actionObject.payload.user_response?actionObject.payload.user_response:data.user_response,resolve,reject,retry_count,chatBotQuery);}else if(isLinkAsChoiceAction(actionObject.action)){__WEBPACK_IMPORTED_MODULE_7__services_actions_handler_service__["a" /* default */].handleLinkAsChoiceWithinScenario(data,resolve,reject);}else if(isBookMarkAction(actionObject.action)){__WEBPACK_IMPORTED_MODULE_7__services_actions_handler_service__["a" /* default */].handleBookmarkOptionWithinScenario(__WEBPACK_IMPORTED_MODULE_7__services_actions_handler_service__["a" /* default */].getBookmarkedScenarioIdForChoice(data.user_response,data.scenarioResponse),resolve,reject,retry_count);}else if(isAskForLoginAction(actionObject.action)){// GlobalStoreService.set("components_handler", {...GlobalStoreService.get('components_handler'),bottom_bar_comp:'login-comp'});
var chatItem={};chatItem.response=__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].login_message;if(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get('loginSessionExpired')){chatItem.response=__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].login_again_message;__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].set('loginSessionExpired',false);}chatItem.sentTime=__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].getCurrentTime();var message_objects=[];message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,bottom_comp:{type:__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT}});}else if(isCreateSrAction(actionObject.action)){var _data=actionObject.payload;__WEBPACK_IMPORTED_MODULE_7__services_actions_handler_service__["a" /* default */].handleCreateSr({data:_data,resolve:resolve,reject:reject});}else if(isCountrySelect(actionObject.action)){__WEBPACK_IMPORTED_MODULE_8__services_actions_handler_service2__["a" /* default */].executeChatIn({"scenarioResponse":actionObject.payload},resolve,reject,retry_count);}else if(isNoActionChosen(actionObject.action)){var _chatItem={};_chatItem['response']=__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].default_error_message;reject({message_objects:[{component_type:'DEFAULT',message:_chatItem.response,messageTime:__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].getCurrentTime()}]});}});};var isInitiateScenario=function isInitiateScenario(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].INITIATE;};var isUserResponseAction=function isUserResponseAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].USER_RESPONSE;};var isFeedbackAction=function isFeedbackAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].FEEDBACK_ACTION;};var isChatInAction=function isChatInAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].CHAT_IN;};var isChatOutAction=function isChatOutAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].CHAT_OUT;};var isLinkAsChoiceAction=function isLinkAsChoiceAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].CHOICE_OPTION_LINK;};var isBookMarkAction=function isBookMarkAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].BOOKMARK;};var isAskForLoginAction=function isAskForLoginAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].ASK_FOR_LOGIN;};var isCreateSrAction=function isCreateSrAction(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].CREATE_SR;};var isCountrySelect=function isCountrySelect(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].COUNTRY_SELECT;};var isNoActionChosen=function isNoActionChosen(actionType){return actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__["a" /* default */].NO_ACTION_CHOSEN;};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var userResponseComponent=function userResponseComponent(_ref){var message=_ref.message,messageTime=_ref.messageTime,is_feedback=_ref.is_feedback;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles-black'},message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,is_feedback&&message&&message==='GOOD_FEEDBACK'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'up'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/like-white.svg',width:'20'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'time'},messageTime.time_in_format)),is_feedback&&message&&message==='BAD_FEEDBACK'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'response-down display-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/like-white.svg',width:'20'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'time'},messageTime.time_in_format)),message&&!is_feedback&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'time'},messageTime.time_in_format)))));};/* harmony default export */ __webpack_exports__["a"] = (userResponseComponent);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var settle = __webpack_require__(116);
var buildURL = __webpack_require__(118);
var parseHeaders = __webpack_require__(119);
var isURLSameOrigin = __webpack_require__(120);
var createError = __webpack_require__(63);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(121);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(122);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(117);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(29), __webpack_require__(131), __webpack_require__(132), __webpack_require__(18), __webpack_require__(19), __webpack_require__(36), __webpack_require__(67), __webpack_require__(133), __webpack_require__(68), __webpack_require__(134), __webpack_require__(135), __webpack_require__(136), __webpack_require__(37), __webpack_require__(137), __webpack_require__(16), __webpack_require__(6), __webpack_require__(138), __webpack_require__(139), __webpack_require__(140), __webpack_require__(141), __webpack_require__(142), __webpack_require__(143), __webpack_require__(144), __webpack_require__(145), __webpack_require__(146), __webpack_require__(147), __webpack_require__(148), __webpack_require__(149), __webpack_require__(150), __webpack_require__(151), __webpack_require__(152), __webpack_require__(153));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./lib-typedarrays", "./enc-utf16", "./enc-base64", "./md5", "./sha1", "./sha256", "./sha224", "./sha512", "./sha384", "./sha3", "./ripemd160", "./hmac", "./pbkdf2", "./evpkdf", "./cipher-core", "./mode-cfb", "./mode-ctr", "./mode-ctr-gladman", "./mode-ofb", "./mode-ecb", "./pad-ansix923", "./pad-iso10126", "./pad-iso97971", "./pad-zeropadding", "./pad-nopadding", "./format-hex", "./aes", "./tripledes", "./rc4", "./rabbit", "./rabbit-legacy"], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS;

}));

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(29));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;

	    function X64Word_create() {
	        return X64Word.create.apply(X64Word, arguments);
	    }

	    // Constants
	    var K = [
	        X64Word_create(0x428a2f98, 0xd728ae22), X64Word_create(0x71374491, 0x23ef65cd),
	        X64Word_create(0xb5c0fbcf, 0xec4d3b2f), X64Word_create(0xe9b5dba5, 0x8189dbbc),
	        X64Word_create(0x3956c25b, 0xf348b538), X64Word_create(0x59f111f1, 0xb605d019),
	        X64Word_create(0x923f82a4, 0xaf194f9b), X64Word_create(0xab1c5ed5, 0xda6d8118),
	        X64Word_create(0xd807aa98, 0xa3030242), X64Word_create(0x12835b01, 0x45706fbe),
	        X64Word_create(0x243185be, 0x4ee4b28c), X64Word_create(0x550c7dc3, 0xd5ffb4e2),
	        X64Word_create(0x72be5d74, 0xf27b896f), X64Word_create(0x80deb1fe, 0x3b1696b1),
	        X64Word_create(0x9bdc06a7, 0x25c71235), X64Word_create(0xc19bf174, 0xcf692694),
	        X64Word_create(0xe49b69c1, 0x9ef14ad2), X64Word_create(0xefbe4786, 0x384f25e3),
	        X64Word_create(0x0fc19dc6, 0x8b8cd5b5), X64Word_create(0x240ca1cc, 0x77ac9c65),
	        X64Word_create(0x2de92c6f, 0x592b0275), X64Word_create(0x4a7484aa, 0x6ea6e483),
	        X64Word_create(0x5cb0a9dc, 0xbd41fbd4), X64Word_create(0x76f988da, 0x831153b5),
	        X64Word_create(0x983e5152, 0xee66dfab), X64Word_create(0xa831c66d, 0x2db43210),
	        X64Word_create(0xb00327c8, 0x98fb213f), X64Word_create(0xbf597fc7, 0xbeef0ee4),
	        X64Word_create(0xc6e00bf3, 0x3da88fc2), X64Word_create(0xd5a79147, 0x930aa725),
	        X64Word_create(0x06ca6351, 0xe003826f), X64Word_create(0x14292967, 0x0a0e6e70),
	        X64Word_create(0x27b70a85, 0x46d22ffc), X64Word_create(0x2e1b2138, 0x5c26c926),
	        X64Word_create(0x4d2c6dfc, 0x5ac42aed), X64Word_create(0x53380d13, 0x9d95b3df),
	        X64Word_create(0x650a7354, 0x8baf63de), X64Word_create(0x766a0abb, 0x3c77b2a8),
	        X64Word_create(0x81c2c92e, 0x47edaee6), X64Word_create(0x92722c85, 0x1482353b),
	        X64Word_create(0xa2bfe8a1, 0x4cf10364), X64Word_create(0xa81a664b, 0xbc423001),
	        X64Word_create(0xc24b8b70, 0xd0f89791), X64Word_create(0xc76c51a3, 0x0654be30),
	        X64Word_create(0xd192e819, 0xd6ef5218), X64Word_create(0xd6990624, 0x5565a910),
	        X64Word_create(0xf40e3585, 0x5771202a), X64Word_create(0x106aa070, 0x32bbd1b8),
	        X64Word_create(0x19a4c116, 0xb8d2d0c8), X64Word_create(0x1e376c08, 0x5141ab53),
	        X64Word_create(0x2748774c, 0xdf8eeb99), X64Word_create(0x34b0bcb5, 0xe19b48a8),
	        X64Word_create(0x391c0cb3, 0xc5c95a63), X64Word_create(0x4ed8aa4a, 0xe3418acb),
	        X64Word_create(0x5b9cca4f, 0x7763e373), X64Word_create(0x682e6ff3, 0xd6b2b8a3),
	        X64Word_create(0x748f82ee, 0x5defb2fc), X64Word_create(0x78a5636f, 0x43172f60),
	        X64Word_create(0x84c87814, 0xa1f0ab72), X64Word_create(0x8cc70208, 0x1a6439ec),
	        X64Word_create(0x90befffa, 0x23631e28), X64Word_create(0xa4506ceb, 0xde82bde9),
	        X64Word_create(0xbef9a3f7, 0xb2c67915), X64Word_create(0xc67178f2, 0xe372532b),
	        X64Word_create(0xca273ece, 0xea26619c), X64Word_create(0xd186b8c7, 0x21c0c207),
	        X64Word_create(0xeada7dd6, 0xcde0eb1e), X64Word_create(0xf57d4f7f, 0xee6ed178),
	        X64Word_create(0x06f067aa, 0x72176fba), X64Word_create(0x0a637dc5, 0xa2c898a6),
	        X64Word_create(0x113f9804, 0xbef90dae), X64Word_create(0x1b710b35, 0x131c471b),
	        X64Word_create(0x28db77f5, 0x23047d84), X64Word_create(0x32caab7b, 0x40c72493),
	        X64Word_create(0x3c9ebe0a, 0x15c9bebc), X64Word_create(0x431d67c4, 0x9c100d4c),
	        X64Word_create(0x4cc5d4be, 0xcb3e42b6), X64Word_create(0x597f299c, 0xfc657e2a),
	        X64Word_create(0x5fcb6fab, 0x3ad6faec), X64Word_create(0x6c44198c, 0x4a475817)
	    ];

	    // Reusable objects
	    var W = [];
	    (function () {
	        for (var i = 0; i < 80; i++) {
	            W[i] = X64Word_create();
	        }
	    }());

	    /**
	     * SHA-512 hash algorithm.
	     */
	    var SHA512 = C_algo.SHA512 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0x6a09e667, 0xf3bcc908), new X64Word.init(0xbb67ae85, 0x84caa73b),
	                new X64Word.init(0x3c6ef372, 0xfe94f82b), new X64Word.init(0xa54ff53a, 0x5f1d36f1),
	                new X64Word.init(0x510e527f, 0xade682d1), new X64Word.init(0x9b05688c, 0x2b3e6c1f),
	                new X64Word.init(0x1f83d9ab, 0xfb41bd6b), new X64Word.init(0x5be0cd19, 0x137e2179)
	            ]);
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var H = this._hash.words;

	            var H0 = H[0];
	            var H1 = H[1];
	            var H2 = H[2];
	            var H3 = H[3];
	            var H4 = H[4];
	            var H5 = H[5];
	            var H6 = H[6];
	            var H7 = H[7];

	            var H0h = H0.high;
	            var H0l = H0.low;
	            var H1h = H1.high;
	            var H1l = H1.low;
	            var H2h = H2.high;
	            var H2l = H2.low;
	            var H3h = H3.high;
	            var H3l = H3.low;
	            var H4h = H4.high;
	            var H4l = H4.low;
	            var H5h = H5.high;
	            var H5l = H5.low;
	            var H6h = H6.high;
	            var H6l = H6.low;
	            var H7h = H7.high;
	            var H7l = H7.low;

	            // Working variables
	            var ah = H0h;
	            var al = H0l;
	            var bh = H1h;
	            var bl = H1l;
	            var ch = H2h;
	            var cl = H2l;
	            var dh = H3h;
	            var dl = H3l;
	            var eh = H4h;
	            var el = H4l;
	            var fh = H5h;
	            var fl = H5l;
	            var gh = H6h;
	            var gl = H6l;
	            var hh = H7h;
	            var hl = H7l;

	            // Rounds
	            for (var i = 0; i < 80; i++) {
	                // Shortcut
	                var Wi = W[i];

	                // Extend message
	                if (i < 16) {
	                    var Wih = Wi.high = M[offset + i * 2]     | 0;
	                    var Wil = Wi.low  = M[offset + i * 2 + 1] | 0;
	                } else {
	                    // Gamma0
	                    var gamma0x  = W[i - 15];
	                    var gamma0xh = gamma0x.high;
	                    var gamma0xl = gamma0x.low;
	                    var gamma0h  = ((gamma0xh >>> 1) | (gamma0xl << 31)) ^ ((gamma0xh >>> 8) | (gamma0xl << 24)) ^ (gamma0xh >>> 7);
	                    var gamma0l  = ((gamma0xl >>> 1) | (gamma0xh << 31)) ^ ((gamma0xl >>> 8) | (gamma0xh << 24)) ^ ((gamma0xl >>> 7) | (gamma0xh << 25));

	                    // Gamma1
	                    var gamma1x  = W[i - 2];
	                    var gamma1xh = gamma1x.high;
	                    var gamma1xl = gamma1x.low;
	                    var gamma1h  = ((gamma1xh >>> 19) | (gamma1xl << 13)) ^ ((gamma1xh << 3) | (gamma1xl >>> 29)) ^ (gamma1xh >>> 6);
	                    var gamma1l  = ((gamma1xl >>> 19) | (gamma1xh << 13)) ^ ((gamma1xl << 3) | (gamma1xh >>> 29)) ^ ((gamma1xl >>> 6) | (gamma1xh << 26));

	                    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
	                    var Wi7  = W[i - 7];
	                    var Wi7h = Wi7.high;
	                    var Wi7l = Wi7.low;

	                    var Wi16  = W[i - 16];
	                    var Wi16h = Wi16.high;
	                    var Wi16l = Wi16.low;

	                    var Wil = gamma0l + Wi7l;
	                    var Wih = gamma0h + Wi7h + ((Wil >>> 0) < (gamma0l >>> 0) ? 1 : 0);
	                    var Wil = Wil + gamma1l;
	                    var Wih = Wih + gamma1h + ((Wil >>> 0) < (gamma1l >>> 0) ? 1 : 0);
	                    var Wil = Wil + Wi16l;
	                    var Wih = Wih + Wi16h + ((Wil >>> 0) < (Wi16l >>> 0) ? 1 : 0);

	                    Wi.high = Wih;
	                    Wi.low  = Wil;
	                }

	                var chh  = (eh & fh) ^ (~eh & gh);
	                var chl  = (el & fl) ^ (~el & gl);
	                var majh = (ah & bh) ^ (ah & ch) ^ (bh & ch);
	                var majl = (al & bl) ^ (al & cl) ^ (bl & cl);

	                var sigma0h = ((ah >>> 28) | (al << 4))  ^ ((ah << 30)  | (al >>> 2)) ^ ((ah << 25) | (al >>> 7));
	                var sigma0l = ((al >>> 28) | (ah << 4))  ^ ((al << 30)  | (ah >>> 2)) ^ ((al << 25) | (ah >>> 7));
	                var sigma1h = ((eh >>> 14) | (el << 18)) ^ ((eh >>> 18) | (el << 14)) ^ ((eh << 23) | (el >>> 9));
	                var sigma1l = ((el >>> 14) | (eh << 18)) ^ ((el >>> 18) | (eh << 14)) ^ ((el << 23) | (eh >>> 9));

	                // t1 = h + sigma1 + ch + K[i] + W[i]
	                var Ki  = K[i];
	                var Kih = Ki.high;
	                var Kil = Ki.low;

	                var t1l = hl + sigma1l;
	                var t1h = hh + sigma1h + ((t1l >>> 0) < (hl >>> 0) ? 1 : 0);
	                var t1l = t1l + chl;
	                var t1h = t1h + chh + ((t1l >>> 0) < (chl >>> 0) ? 1 : 0);
	                var t1l = t1l + Kil;
	                var t1h = t1h + Kih + ((t1l >>> 0) < (Kil >>> 0) ? 1 : 0);
	                var t1l = t1l + Wil;
	                var t1h = t1h + Wih + ((t1l >>> 0) < (Wil >>> 0) ? 1 : 0);

	                // t2 = sigma0 + maj
	                var t2l = sigma0l + majl;
	                var t2h = sigma0h + majh + ((t2l >>> 0) < (sigma0l >>> 0) ? 1 : 0);

	                // Update working variables
	                hh = gh;
	                hl = gl;
	                gh = fh;
	                gl = fl;
	                fh = eh;
	                fl = el;
	                el = (dl + t1l) | 0;
	                eh = (dh + t1h + ((el >>> 0) < (dl >>> 0) ? 1 : 0)) | 0;
	                dh = ch;
	                dl = cl;
	                ch = bh;
	                cl = bl;
	                bh = ah;
	                bl = al;
	                al = (t1l + t2l) | 0;
	                ah = (t1h + t2h + ((al >>> 0) < (t1l >>> 0) ? 1 : 0)) | 0;
	            }

	            // Intermediate hash value
	            H0l = H0.low  = (H0l + al);
	            H0.high = (H0h + ah + ((H0l >>> 0) < (al >>> 0) ? 1 : 0));
	            H1l = H1.low  = (H1l + bl);
	            H1.high = (H1h + bh + ((H1l >>> 0) < (bl >>> 0) ? 1 : 0));
	            H2l = H2.low  = (H2l + cl);
	            H2.high = (H2h + ch + ((H2l >>> 0) < (cl >>> 0) ? 1 : 0));
	            H3l = H3.low  = (H3l + dl);
	            H3.high = (H3h + dh + ((H3l >>> 0) < (dl >>> 0) ? 1 : 0));
	            H4l = H4.low  = (H4l + el);
	            H4.high = (H4h + eh + ((H4l >>> 0) < (el >>> 0) ? 1 : 0));
	            H5l = H5.low  = (H5l + fl);
	            H5.high = (H5h + fh + ((H5l >>> 0) < (fl >>> 0) ? 1 : 0));
	            H6l = H6.low  = (H6l + gl);
	            H6.high = (H6h + gh + ((H6l >>> 0) < (gl >>> 0) ? 1 : 0));
	            H7l = H7.low  = (H7l + hl);
	            H7.high = (H7h + hh + ((H7l >>> 0) < (hl >>> 0) ? 1 : 0));
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 128) >>> 10) << 5) + 31] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Convert hash to 32-bit word array before returning
	            var hash = this._hash.toX32();

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        },

	        blockSize: 1024/32
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */
	    C.SHA512 = Hasher._createHelper(SHA512);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */
	    C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
	}());


	return CryptoJS.SHA512;

}));

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var OnlineEncodeDecodeService=function(){function OnlineEncodeDecodeService(){_classCallCheck(this,OnlineEncodeDecodeService);}_createClass(OnlineEncodeDecodeService,null,[{key:"decryptForOTP",value:function decryptForOTP(encData,decKey){if(encData&&encData.length&&decKey&&decKey.length){try{encData=encData.trim().replace('"',"");decKey=decKey.trim().replace('"',"");var string=JSON.parse(__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.DES.decrypt(encData.replace('"',""),__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8.parse(decKey),{mode:__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.mode.ECB,padding:__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.pad.Pkcs7}).toString(__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8));return JSON.stringify(string);}catch(err){console.log("Either Encryption key or encryption data is invalid.");}}else{console.log("Either encryption key or encryption data is missing!!!");}}}]);return OnlineEncodeDecodeService;}();OnlineEncodeDecodeService._generateEncryptionKeyForOTP=function(){var date=new Date();var components=[date.getYear(),date.getMonth(),date.getDate(),date.getHours(),date.getMinutes(),date.getSeconds(),date.getMilliseconds()];return(components.join("")+Math.random()).replace(".","");};/* harmony default export */ __webpack_exports__["a"] = (OnlineEncodeDecodeService);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_message_components_chat_response_component__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums_action_types_ChatActionType__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_common_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_chatHistory_service__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums_templateName__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums_trackingKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__constants_static_links__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__services_actions_handler_service2__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__enums_scenario_type__ = __webpack_require__(25);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ActionHandlerService=function(){function ActionHandlerService(){_classCallCheck(this,ActionHandlerService);}_createClass(ActionHandlerService,null,[{key:"stripIfJsonFromDescription",value:function stripIfJsonFromDescription(description){if(description&&description.indexOf("[json]")>-1&&description.split("[json]").length===3){description.replace("[json]"+description.split("[json]")[1]+"[json]","");}}}]);return ActionHandlerService;}();ActionHandlerService.handleCreateSr=function(params){__WEBPACK_IMPORTED_MODULE_7__actions_common_service__["a" /* default */].handleCreateSr(params);};ActionHandlerService.handleLinkAsChoiceWithinScenario=function(data,resolve,reject){var linkData=ActionHandlerService.getLinkDataForChoice(data.user_response,data.scenarioResponse);if(linkData){var platformType=__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("platformType");switch(platformType){case __WEBPACK_IMPORTED_MODULE_9__enums_PlatformType__["a" /* default */].WEB:var webLink=linkData["webAppLink"];if(webLink){webLink=ActionHandlerService.getDynamicLinkUrl(webLink,data.scenarioResponse);window.open(webLink);}break;case __WEBPACK_IMPORTED_MODULE_9__enums_PlatformType__["a" /* default */].ANDROID:var androidLink=linkData["androidAppLink"];if(androidLink){androidLink=ActionHandlerService.getDynamicLinkUrl(androidLink,data.scenarioResponse);window.open(androidLink);}break;case __WEBPACK_IMPORTED_MODULE_9__enums_PlatformType__["a" /* default */].IOS:var iosLink=linkData["iosAppLink"];if(iosLink){iosLink=ActionHandlerService.getDynamicLinkUrl(iosLink,data.scenarioResponse);window.open(iosLink);}break;}}// So that we treat a link as the last step
data.scenarioResponse["scenarioActive"]=false;resolve(resolve({scenarioResponse:data.scenarioResponse}));};ActionHandlerService.getDynamicLinkUrl=function(linkUrl,scenarioResponse){var currentNumber=__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentNumber")?__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentNumber"):"";linkUrl=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].replaceAll(linkUrl,"{mobile}",currentNumber);var templateNameList=scenarioResponse.templateNameList;if(templateNameList){switch(true){case templateNameList.indexOf("Outstanding_Amount")>-1:case templateNameList.indexOf("PAY_MY_BILL")>-1:var outstandingAmountResponse=ActionHandlerService.getTemplateResponseObject(scenarioResponse.response);try{var outstandingAmount=JSON.parse(outstandingAmountResponse["template_res_string"]);linkUrl=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].replaceAll(linkUrl,"{amount}",outstandingAmount["Outstanding Amount"]);//remove source and uri params from url if exists in case of old app context
if(window.MyAirtelAppReact){linkUrl=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].removeSourceAndUriParamsFromLink(linkUrl);}}catch(e){}break;}}return linkUrl;};ActionHandlerService.handleBookmarkOptionWithinScenario=function(bookmarkedData,resolve,reject,retry_count){// console.log(bookmarkedData)
var bookmarkedScenario={scenarioId:bookmarkedData.scenarioId,scenarioName:"",scenarioLob:bookmarkedData.lob?bookmarkedData.lob:""};bookmarkedData['isBookmarkedScenario']=true;if(bookmarkedData.askForLogin){if(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("isUserLoggedIn")){__WEBPACK_IMPORTED_MODULE_15__services_actions_handler_service2__["a" /* default */].initiateScenario(bookmarkedScenario,resolve,reject,retry_count);}else{ActionHandlerService.showLoginForm(bookmarkedData,resolve);}}else{__WEBPACK_IMPORTED_MODULE_15__services_actions_handler_service2__["a" /* default */].initiateScenario(bookmarkedScenario,resolve,reject,retry_count);}};ActionHandlerService.getLinkDataForChoice=function(enteredText,result){return __WEBPACK_IMPORTED_MODULE_7__actions_common_service__["a" /* default */].getLinkDataForChoice(enteredText,result);};ActionHandlerService.getBookmarkedScenarioIdForChoice=function(enteredText,result){return __WEBPACK_IMPORTED_MODULE_7__actions_common_service__["a" /* default */].getBookmarkedScenarioIdForChoice(enteredText,result);};ActionHandlerService.chooseTemplateToShow=function(template_list,response,showPopup,chatItem,handleOptionsClick){var response_json=void 0;try{response_json=JSON.parse(response);}catch(e){response_json=undefined;}var message_obj=void 0;if(!response_json||(typeof response_json==="undefined"?"undefined":_typeof(response_json))==='object'&&Object.keys(response_json).length===0){message_obj={component_type:'DEFAULT',message:__WEBPACK_IMPORTED_MODULE_16__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()};}switch(template_list[0]){case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].Data_Balance_Details:if(response_json){message_obj={component_type:__WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__["a" /* default */].DATA_BALANCE,message:response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()};}return{message_obj:message_obj};case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].Outstanding_Amount:if(response_json){message_obj={component_type:__WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__["a" /* default */].OUTSTANDING,message:response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()};}return{message_obj:message_obj};case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].CURRENT_BILL_PLAN:if(response_json){message_obj={component_type:__WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__["a" /* default */].CURRENT_BILL_PLAN,message:response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()};}return{message_obj:message_obj};case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].Eligible_Bill_Plans:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].New_Bill_Plan:if(response_json){message_obj={component_type:__WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__["a" /* default */].MONTHLY_PLAN,message:response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime(),template_name:template_list[0]};}return{message_obj:message_obj,show_cancel_comp:true,cancel_obj:{type:template_list[0]},options_hidden:true};case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].PAY_MY_BILL:return{};case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].PREV_DUPLICATE_BILLS:if(response_json){message_obj={component_type:__WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__["a" /* default */].PREV_DUPLICATE_BILLS,message:response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()};}return{message_obj:message_obj,options_hidden:true};case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].PREV_PAYMENT_RECEIPTS:if(response_json){message_obj={component_type:__WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__["a" /* default */].PREV_PAYMENT_RECEIPTS,message:response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime()};}return{message_obj:message_obj,options_hidden:true};case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_ACTIVATED_PACKS_DEACTIVATION:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_SERVICE_DEACTIVATION:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_MULTIPLE_ZONE_PACKS:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_SINGLE_ZONE_PACKS:if(response_json){message_obj={component_type:__WEBPACK_IMPORTED_MODULE_12__enums_ComponentTypes__["a" /* default */].IR_PACK_DEACTIVATION,message:response,messageTime:__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime(),template_list:template_list,chatItem:chatItem};}return{message_obj:message_obj,show_cancel_comp:true,cancel_obj:{type:__WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_ACTIVATED_PACKS_DEACTIVATION},options_hidden:true};default:return undefined;}};ActionHandlerService.getTemplateResponseFromSystemInfo=function(systemInfo,templateNameList,result){var res=void 0;switch(templateNameList[0]){case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].PREV_DUPLICATE_BILLS:{systemInfo.map(function(info){if(info.tagName==="BOT - LAST 3 BILLS"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Last three bills"){var res_obj={transactionId:result.transactionId,authToken:result.authToken,bills_string:end_info.informationDisplayValue};res=JSON.stringify(res_obj);}});}});return res;}case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].New_Bill_Plan:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].Eligible_Bill_Plans:{systemInfo.map(function(info){if(info.tagName==="BOT - ELIGIBLE BILL PLANS"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Eligible Bill Plans for Change"){res=end_info.informationDisplayValue;}});}});return res;}case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].Data_Balance_Details:{systemInfo.map(function(info){if(info.tagName==="COMPTEL - IN FAMILY QUOTA INFORMATION"||info.tagName==="COMPTEL - SIEBEL - IN Family Quota Info"){info.information&&info.information.length>0&&info.information.map(function(end_info){res=JSON.stringify(info.information);});}});return res;}case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].Outstanding_Amount:{systemInfo.map(function(info){if(info.tagName==="FX - CUSTOMER BILL DETAILS"||info.tagName==="SIEBEL - Cust Account Summary"){info.information&&info.information.length>0&&info.information.map(function(end_info){res=JSON.stringify(info.information);});}});return res;}case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].PREV_PAYMENT_RECEIPTS:{systemInfo.map(function(info){if(info.tagName==="BOT - LAST 3 RECEIPTS"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Last three receipts"){res=end_info.informationDisplayValue;}});}});return res;}case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].CURRENT_BILL_PLAN:{systemInfo.map(function(info){if(info.tagName==="BOT - CURRENT BILL PLAN BENEFITS"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Current Bill Plan Benefits"){res=end_info.informationDisplayValue;}});}});return res;}case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_PACKS_ALL:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_PACKS_RECO:{systemInfo.map(function(info){if(info.tagName==="BOT - IR BOOSTERS PACKS DETAILS"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="IR Pack Details"){res=end_info.informationDisplayValue;}});}});return res;}case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_MULTIPLE_ZONE_PACKS:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_SINGLE_ZONE_PACKS:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_SERVICE_DEACTIVATION:case __WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_ACTIVATED_PACKS_DEACTIVATION:{systemInfo.map(function(info){if(info.tagName==="BOT - IR PACKS SINGLE OR MULTIPLE ZONES"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Activated Packs"){res=end_info.informationDisplayValue;}});}});return res;}}};ActionHandlerService.handleTrackingAfterResponse=function(_ref){var enteredText=_ref.enteredText,result=_ref.result,response=_ref.response;if(ActionHandlerService.isIntentReadingFailResponse(result)){__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].setTrackingData({user_response:enteredText,scenarioName:"",scenarioStrategy:null});// TRACK INTENT READING FAIL
__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_13__enums_trackingKey__["a" /* default */].INTENT_READING_FAIL);}else if(result&&result.scenario&&(result.scenario.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_17__enums_scenario_type__["a" /* default */].DTScenario||result.scenario.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_17__enums_scenario_type__["a" /* default */].FAQScenario||result.scenario.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_17__enums_scenario_type__["a" /* default */].SwitchScenario)){// console.log('track intent reading success')
var intentScore=ActionHandlerService.getIntentScore(response);__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].setTrackingData({user_response:enteredText,scenarioName:result.scenario.scenarioName,scenarioStrategy:result.scenario.scenarioStrategy,intentScore:intentScore});// TRACK INTENT READING SUCEESS
__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_13__enums_trackingKey__["a" /* default */].INTENT_READING_SUCCESS);}};ActionHandlerService.getIntentScore=function(response){if(response&&response.executionContext&&response.executionContext.scenarioMap&&response.executionContext.scenario){var scenarioId=response.executionContext.scenario.scenarioId;for(var score in response.executionContext.scenarioMap){if(response.executionContext.scenarioMap[score].scenarioId===scenarioId){return score;}}}return undefined;};ActionHandlerService.checkIfNeedToReplaceExceptionMessage=function(result,templateList){// console.log(result.response,templateList)
if(templateList&&templateList.length>0){if(templateList.includes(__WEBPACK_IMPORTED_MODULE_11__enums_templateName__["a" /* default */].IR_ACTIVATED_PACKS_DEACTIVATION)&&result&&result.response&&result.response.toLowerCase().includes("exception")){return true;}else{return false;}}return false;};ActionHandlerService.isIntentReadingFailResponse=function(result){if(result&&result.scenario&&__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]&&(result.scenario.scenarioId===__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_1"].scenarioId||result.scenario.scenarioId===__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_2"].scenarioId)){return true;}else return false;};ActionHandlerService.isProcessingExceptionCase=function(result){if(result&&result.dffStepResponse&&result.dffStepResponse.statusCode&&result.dffStepResponse.statusCode==="PROCESSING_EXCEPTION"){return true;}else{return false;}};ActionHandlerService.isResponseUnauthorized=function(response){if(response&&response.status&&response.status==="UNAUTHORIZED"){return true;}return false;};ActionHandlerService.isDffResponseSuccess=function(result){if(result&&!result.scenarioActive&&result.dffStepResponse&&result.dffStepResponse.status&&result.dffStepResponse.status.statusCode&&result.dffStepResponse.status.statusCode==="success"){return true;}return false;};ActionHandlerService.isLoginRequired=function(result){if(result&&result.scenario&&result.scenario.msisdnRequired){return true;}else if(result.askForLogin){return true;}else{return false;}};ActionHandlerService.isShowDffFormCase=function(result){if(result&&result.dffStepResponse&&result.dffStepResponse.result&&result.dffStepResponse.result.length>0){return true;}return false;};ActionHandlerService.isCrmConsumeSrApiError=function(result){if(result&&result.dffStepResponse&&result.dffStepResponse.statusCode&&result.dffStepResponse.statusCode==="CRM_CONSUME_SR_API_ERROR"){return true;}return false;};ActionHandlerService.showLoginForm=function(result,resolve){// console.log('show login form')
var chatItem={};var message_objects=[];chatItem.response=__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].login_message;if(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get('loginSessionExpired')){chatItem.response=__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].login_again_message;__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].set('loginSessionExpired',false);}result['initiate_after_login']=true;chatItem.sentTime=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getCurrentTime();message_objects.push({component_type:'DEFAULT',message:chatItem.response,messageTime:chatItem.sentTime});resolve({message_objects:message_objects,scenarioResponse:result,bottom_comp:{type:__WEBPACK_IMPORTED_MODULE_2__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT}});};ActionHandlerService.getTemplateResponseObject=function(res){var json_start_index=res.indexOf('[json]');var part_str=res.substr(json_start_index+6);var json_end_index=json_start_index+6+part_str.indexOf('[json]')+6;var chat_res_string=res.substr(0,json_start_index)+res.substr(json_end_index);var template_res_string=part_str.substr(0,part_str.indexOf('[json]'));return{chat_res_string:chat_res_string,template_res_string:template_res_string};};ActionHandlerService.getDynamicDescriptionString=function(result){var res=result.response;var json_start_index=res.indexOf('[DYN-DESC]');var part_str=res.substr(json_start_index+10);var dynamicDescString=part_str.substr(0,part_str.indexOf('[DYN-DESC]'));var templateSpecificDynamicDesc=ActionHandlerService.getTemplateSpecificDynamicDescription(result,dynamicDescString);var final_res=templateSpecificDynamicDesc!==""?res.replace(dynamicDescString,ActionHandlerService.getTemplateSpecificDynamicDescription(result,dynamicDescString)).replace(/\[DYN-DESC\]/g,''):__WEBPACK_IMPORTED_MODULE_16__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE;return final_res;};ActionHandlerService.getTemplateSpecificDynamicDescription=function(result,dynamicDescString){// console.log(result.templateNameList)
if(result&&result.templateNameList&&result.templateNameList.length>0&&result.systemInfo&&result.systemInfo.length>0){switch(true){case result.templateNameList.includes('ACCOUNT_BALANCE_ACCUMULATOR')||result.templateNameList.includes('ACCOUNT_BALANCE_DETAILS'):{var main_account_balance=void 0,data_validity=void 0,daily_data=void 0,remaining_data=void 0,outgoing_validity=void 0,data_4g=void 0,data_3g=void 0;result.systemInfo.map(function(info){if(info.tagName==="Comptel In Main/DA Balance"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Main Account"){main_account_balance=end_info.informationDisplayValue;}if(end_info.tagName==="DATA BALANCE 3G 1"){data_3g=end_info.informationDisplayValue;}if(end_info.tagName==="DATA BALANCE 4G 1"){data_4g=end_info.informationDisplayValue;}});}if(info.tagName==="COMPTEL - ACCUMULATOR DAILY DATA"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Accumulator 1 (Daily Limit)"){daily_data=end_info.informationDisplayValue;}if(end_info.tagName==="Accumulator 1 (Validity)"){data_validity=end_info.informationDisplayValue;}if(end_info.tagName==="Accumulator 1 (Remaining Data)"){remaining_data=end_info.informationDisplayValue;}});}if(info.tagName==="COMPTEL - OUTGOING BARRED"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Outgoing validity date"){outgoing_validity=end_info.informationDisplayValue;}});}});var message="";if(result.templateNameList.includes('ACCOUNT_BALANCE_ACCUMULATOR')){message="Unlimited Local & STD calls\n                            <div>"+daily_data+" daily data</div>\n                            <div>You're left with "+remaining_data+"</div>\n                            "+(data_validity?"<div>This bundle is valid till :  "+data_validity+"</div>":"")+"</br>\n                            <div>You've a main account balance : "+main_account_balance+" & outgoing call validity is till : "+outgoing_validity+"</div>\n                            "+(data_4g?"In addition to daily data you have an additional 4G balance of "+data_4g:"");}else if(result.templateNameList.includes('ACCOUNT_BALANCE_DETAILS')){message="Main account balance is Rs."+main_account_balance+"\n                        <div>Outgoing call validity is till "+outgoing_validity+"</div>\n                        "+(data_4g?"<div>4G data balance: "+data_4g+"</div>":"")+"\n                        "+(data_3g?"<div>3G data balance: "+data_3g+"</div>":"");}return message;}case result.templateNameList.includes('LOAN_ELIGIBLE'):{var loan_amount=void 0;result.systemInfo.map(function(info){if(info.tagName==="ESB - LOAN NEW"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="Loan Eligible_1_creditType"){loan_amount=end_info.informationDisplayValue;}});}});var _message=(loan_amount||"Loan-10")+" Rs";return _message;}case result.templateNameList.includes('HELLO_TUNE_DEACT'):{var tune1=void 0,tune2=void 0,tune3=void 0;result.systemInfo.map(function(info){if(info.tagName==="HT STATUS NEW"){info.information&&info.information.length>0&&info.information.map(function(end_info){if(end_info.tagName==="HT TuneDetail Song_1_Name"){tune1=end_info.informationDisplayValue;}if(end_info.tagName==="HT TuneDetail Song_2_Name"){tune2=end_info.informationDisplayValue;}if(end_info.tagName==="HT TuneDetail Song_3_Name"){tune2=end_info.informationDisplayValue;}});}});var _message2=tune1||tune2||tune3?(tune1?"\""+tune1+"\"":"")+" "+(tune2?", \""+tune2+"\"":"")+" "+(tune3?", \""+tune3+"\"":""):"";return _message2;}case result.templateNameList.includes('ACTIVE_VAS'):{var obj={};result.systemInfo.map(function(info){if(info.tagName==="SE - VAS Check New"){info.information&&info.information.length>0&&info.information.map(function(end_info){for(var i=1;i<=5;i++){if(end_info.tagName==="Active Vas_"+i+"_Name"||end_info.tagName==="Active Vas_"+i+"_Subscription_Date"){obj[end_info.tagName]=end_info.informationDisplayValue;}}});}});var arr=[];if(Object.keys(obj).length>0){for(var j=1;j<=5;j++){if(obj&&obj.hasOwnProperty("Active Vas_"+j+"_Name")&&obj.hasOwnProperty("Active Vas_"+j+"_Subscription_Date")){arr.push(obj["Active Vas_"+j+"_Name"]+" , subscribed on "+obj["Active Vas_"+j+"_Subscription_Date"]);}}}var _message3='';arr.map(function(offer,index){_message3=_message3+(index+1+". "+offer)+"</br>";});return _message3;}case result.templateNameList.includes('LAST_FEW_RECHARGES'):{var _obj={};result.systemInfo.map(function(info){if(info.tagName==="DARTS - RECHARGE DETAILS"){info.information&&info.information.length>0&&info.information.map(function(end_info){for(var i=1;i<=5;i++){if(end_info.tagName==="Recharge Amount "+i||end_info.tagName==="Recharge Date "+i){_obj[end_info.tagName]=end_info.informationDisplayValue;}}});}});var _arr=[];if(Object.keys(_obj).length>0){for(var _j=1;_j<=5;_j++){if(_obj&&_obj.hasOwnProperty("Recharge Amount "+_j)&&_obj.hasOwnProperty("Recharge Date "+_j)){_arr.push("Rs. "+_obj["Recharge Amount "+_j]+" , done on "+_obj["Recharge Date "+_j]);}}}var _message4='';_arr.map(function(offer,index){_message4=_message4+(index+1+". "+offer)+"</br>";});return _message4;}case result.templateNameList.includes('MAMO_COMBO_OFFERS'):{var _arr2=[];result.systemInfo.map(function(info){if(info.tagName==="MAMO - OFFERS COMBO NEW"){info.information&&info.information.length>0&&info.information.map(function(end_info){for(var i=1;i<=4;i++){if(end_info.tagName==="COMBO Offer_"+i+"_Description"){_arr2.push(end_info.informationDisplayValue);}}});}});var _message5='';_arr2.map(function(offer,index){_message5=_message5+(index+1+". "+offer+" ")+"</br > ";});return _message5;}case result.templateNameList.includes('MAMO_VOICE_OFFERS'):{var _arr3=[];result.systemInfo.map(function(info){if(info.tagName==="MAMO - OFFERS TALKTIME NEW"){info.information&&info.information.length>0&&info.information.map(function(end_info){for(var i=1;i<=3;i++){if(end_info.tagName==="TALKTIME Offer_"+i+"_Description"){_arr3.push(end_info.informationDisplayValue);}}});}if(info.tagName==="MAMO - OFFERS VOICE NEW"){info.information&&info.information.length>0&&info.information.map(function(end_info){for(var i=1;i<=3;i++){if(end_info.tagName==="VOICE Offer_"+i+"_Description"){_arr3.push(end_info.informationDisplayValue);}}});}});var _message6='';_arr3.map(function(offer,index){_message6=_message6+(index+1+". "+offer+" ")+"</br > ";});return _message6;}default:{return dynamicDescString;}}}};/* harmony default export */ __webpack_exports__["a"] = (ActionHandlerService);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_handler_service2__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_common_service__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BotSwitchService=function(){function BotSwitchService(){_classCallCheck(this,BotSwitchService);}_createClass(BotSwitchService,null,[{key:'getWhichBot',value:function getWhichBot(chatResponse){// try {
//     const scenarioLob = chatResponse.scenario.scenarioLob ?
//         chatResponse.scenario.scenarioLob : GlobalStoreService.get("currentBotType");
//     switch (scenarioLob.toUpperCase()) {
//         case BotType.POSTPAID:
//             return _handlePostpaidBot(chatResponse);
//         case BotType.PREPAID:
//             return _handlePrepaidBot(chatResponse, GlobalStoreService.get("scenarioList")[BotType.PREPAID]);
//     }
//     return currentBotType;
// } catch (e) {
//     return currentBotType;
// }
}},{key:'handleBotSwitch',value:function handleBotSwitch(result,chatItem,resolve,reject,query,retry_count){//check if logged in user
var newBotType=result.scenario.scenarioLob;if(BotSwitchService.checkIfLobEnabled(newBotType)){if(__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].get('isUserLoggedIn')){if(__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].get('userProfile')){var userProfile=__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].get('userProfile');var accounts=getAccountsForBotType(userProfile,newBotType);if(accounts&&accounts.length>0){resolve({message_objects:[{component_type:'SWITCH_ACCOUNT_MESSAGE',message:newBotType.toLowerCase(),messageTime:__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].getCurrentTime()}]});}else{//no new bot type number in user profile
resolve({message_objects:[{component_type:'DEFAULT',message:'Hey!! You have enquired about a '+(newBotType&&newBotType.toLowerCase())+' number, currently no '+(newBotType&&newBotType.toLowerCase())+' numbers are added into your profile.',messageTime:__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].getCurrentTime()}]});}}else{// no user profile found
__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].set('isUserLoggedIn',false);__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].set('loggedInToken',null);__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].set('currentBotType',result.scenario.scenarioLob.toUpperCase());__WEBPACK_IMPORTED_MODULE_3__actions_handler_service2__["a" /* default */].executeChatOut(query,resolve,reject,retry_count,query);}}else{// handle if logged out
__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].set('currentBotType',result.scenario.scenarioLob.toUpperCase());__WEBPACK_IMPORTED_MODULE_3__actions_handler_service2__["a" /* default */].executeChatOut(query,resolve,reject,retry_count,query);}}else{resolve({message_objects:BotSwitchService.getChatMessageIfBotLobDisabled(result,newBotType)});}}}]);return BotSwitchService;}();BotSwitchService.checkIfLobEnabled=function(newBotType){if(__WEBPACK_IMPORTED_MODULE_4__config_config__["a" /* default */].lob_list.includes(newBotType.toUpperCase())){return true;}return false;};BotSwitchService.getChatMessageIfBotLobDisabled=function(result,newBotType){// console.log(result)
var message=void 0;if(result&&result.searchReply){message=__WEBPACK_IMPORTED_MODULE_5__actions_common_service__["a" /* default */].getPlatformSpecificSearchReply(result)||__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].LOB_SPECIFIC_NO_RESOLUTION_VOC.replace('{LOB}',newBotType.toLowerCase().charAt(0).toUpperCase()+newBotType.toLowerCase().slice(1));}else{message=__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].LOB_SPECIFIC_NO_RESOLUTION_VOC.replace('{LOB}',newBotType.toLowerCase().charAt(0).toUpperCase()+newBotType.toLowerCase().slice(1));}// console.log(message)
return[{component_type:'DEFAULT',message:message,messageTime:__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].getCurrentTime()}];};/* harmony default export */ __webpack_exports__["a"] = (BotSwitchService);var getAccountsForBotType=function getAccountsForBotType(userProfile,BotType){var botTypeAccounts=[];BotType=BotType.toUpperCase();if(userProfile&&userProfile.products&&userProfile.products[BotType]){botTypeAccounts=userProfile.products[BotType];}return botTypeAccounts;};var _handlePostpaidBot=function _handlePostpaidBot(chatResponse){return __WEBPACK_IMPORTED_MODULE_0__enums_BotType__["a" /* default */].POSTPAID;};var _handlePrepaidBot=function _handlePrepaidBot(chatResponse,welcomeConfig){if(chatResponse.scenario.scenarioId===welcomeConfig["NO_INTENT_FOUND_1"]["scenarioId"]){return __WEBPACK_IMPORTED_MODULE_0__enums_BotType__["a" /* default */].POSTPAID;}return __WEBPACK_IMPORTED_MODULE_0__enums_BotType__["a" /* default */].PREPAID;};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_trackingKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums_TrackingPlatform__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var InitializeChatBotService=function(){function InitializeChatBotService(){_classCallCheck(this,InitializeChatBotService);}_createClass(InitializeChatBotService,null,[{key:'getBasicTokenAndInitializeChatBotData',value:function getBasicTokenAndInitializeChatBotData(){var _this=this;// console.log('get param value for lob', UtilService.getParamValue('lob'))
if(__WEBPACK_IMPORTED_MODULE_6__util_service__["a" /* default */].getParamValue('lob')==='paymentsbank'&&__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('APP_CONTEXT')){//current bot type is payments bank
// console.log('bot type-- payments bank')
__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set('currentBotType',__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */].PAYMENTS_BANK);}return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_0__chatbot_api_service__["a" /* default */].getChatToken().then(function(result){if(__WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* default */].env!=="local"){__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set("basicToken","Bearer"+result.access_token);}else{__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set("basicToken","Bearer"+result.access_token);__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set("isUserLoggedIn",true);__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set("primaryNumber","");__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set("currentNumber","");// GlobalStoreService.set('currentBotType', BotType.PREPAID)
// GlobalStoreService.set("userProfile", GLOBAL_CONFIG.userProfileFor)
// let numbers = UtilService.getUserProfileNumbersWithAccountType(GLOBAL_CONFIG.userProfileFor);
// GlobalStoreService.set("userAccounts", numbers);
// GlobalStoreService.set("loggedInToken", "Bearer   " + GLOBAL_CONFIG.tokenFor);
}//fetch categories
_this.getInitialOptionsCategories();}).then(function(){//get default scenarios for the current bot type
_this.getDefaultScenariosPromise(__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('currentBotType')).then(function(result){resolve();},function(error){__WEBPACK_IMPORTED_MODULE_4__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_5__enums_trackingKey__["a" /* default */].ERROR_BACKEND);reject();});}).then(function(){if(__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('currentBotType')!==__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */].PAYMENTS_BANK){//get default scenarios for any other bot type remaining 
Object.keys(__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */]).filter(function(type){return typeof __WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */][type]==='string';}).map(function(botTypeKey){if(__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */][botTypeKey]!==__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('currentBotType')&&__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */][botTypeKey]!==__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */].PAYMENTS_BANK){_this.getDefaultScenariosPromise(__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */][botTypeKey]).then(function(result){// console.log('got default scenarios for', botTypeKey)
},function(error){// console.log('default scenarios rejected -- error case', error)
__WEBPACK_IMPORTED_MODULE_4__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_5__enums_trackingKey__["a" /* default */].ERROR_BACKEND);});}});}}).catch(function(error){reject();});});}},{key:'getDefaultScenariosPromise',value:function getDefaultScenariosPromise(botType){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_0__chatbot_api_service__["a" /* default */].getBotTypeDefaultScenarios(botType).then(function(response){resolve();var scenarioListStoreData=__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get("scenarioList");scenarioListStoreData[botType]=response;__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set("scenarioList",scenarioListStoreData);},function(error){reject(error);});});}},{key:'getInitialOptionsCategories',value:function getInitialOptionsCategories(){// console.log('fetch categories')
if(!__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('categoriesFetched')[__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */][__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('currentBotType')]]){__WEBPACK_IMPORTED_MODULE_0__chatbot_api_service__["a" /* default */].getOptionsCategories().then(function(res){__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].set("categoriesFetched",Object.assign({},__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('categoriesFetched'),_defineProperty({},__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */][__WEBPACK_IMPORTED_MODULE_1__global_store_service__["a" /* default */].get('currentBotType')],res)));},function(err){// console.log(err) 
});}}}]);return InitializeChatBotService;}();/* harmony default export */ __webpack_exports__["a"] = (InitializeChatBotService);

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_BotType__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DBReadWriteService=function(){function DBReadWriteService(){_classCallCheck(this,DBReadWriteService);this.db_read_offset=0;this.db_write_queue=[];this.dbWriteStatus=true;this.messagesSentToBeWritten=[];this.writeCallbackReturned=true;this.readCallbackReturned=true;}//write status returned in write to db callback
//write callback returned or not -- this is independent of the status that is returned in the write callback
_createClass(DBReadWriteService,[{key:"writeMessagesToDBQueue",value:function writeMessagesToDBQueue(new_messages){//check if new app context
if(window.MyAirtelChatAppReact&&__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("currentBotType")!==__WEBPACK_IMPORTED_MODULE_2__enums_BotType__["a" /* default */].PAYMENTS_BANK){//filter the messages not to be written to DB for n messages method
new_messages=new_messages.filter(function(message){return!message.notToBeWrittenToDB;});var messags_to_write=[];new_messages.map(function(message){messags_to_write.push(privateMethods.createDBMessageWriteObject(message));});// for n messages to be written
if(messags_to_write&&messags_to_write.length>0){this.db_write_queue=[].concat(_toConsumableArray(this.db_write_queue),messags_to_write);//call writeToDB whenever messages are required to be sent to DB
privateMethods.writeToDB();}}}},{key:"popMessageFromWriteNewMessageQueue",value:function popMessageFromWriteNewMessageQueue(){this.new_messages_to_write_to_queue.pop();}},{key:"setDBReadOffset",value:function setDBReadOffset(offset){this.db_read_offset=offset;}},{key:"readFromDB",value:function readFromDB(){if(window.MyAirtelChatAppReact){if(window.MyAirtelChatAppReact.readMessageWith){if(this.db_read_offset!==-1&&this.readCallbackReturned){this.readCallbackReturned=false;window.MyAirtelChatAppReact.readMessageWith(this.db_read_offset,"","readReturnFunction");}}else{//do nothing
}}}},{key:"handleReadReturn",value:function handleReadReturn(response){var data=response&&response.data?response.data:[];if(data&&data.length>0){data.map(function(message_obj){message_obj.content=privateMethods.decodeContentString(message_obj.content);});//filter if content field is undefined
data=data.filter(function(message_obj){return message_obj.content;});}if(response&&response.offset){//set db read offset that was received
this.db_read_offset=response.offset;}if(response){window.ourComponent.readReturnMethod(data,response.offset);}this.readCallbackReturned=true;}},{key:"handleWriteReturn",value:function handleWriteReturn(response){var _this=this;//set the db write status
this.dbWriteStatus=response.status?true:false;if(response.status){// if db write status is true filter the db write queue and delete the messages that were written to db
this.db_write_queue=this.db_write_queue.filter(function(queue_elem){return!_this.messagesSentToBeWritten.includes(queue_elem.timestamp);});}// set the write callback returned to true
this.writeCallbackReturned=true;}},{key:"setMessagesSentToBeWritten",value:function setMessagesSentToBeWritten(message_array){var array_sent=[];message_array.map(function(message){return array_sent.push(message.timestamp);});this.messagesSentToBeWritten=array_sent;}}]);return DBReadWriteService;}();var dbReadWriteService=new DBReadWriteService();/* harmony default export */ __webpack_exports__["a"] = (dbReadWriteService);var privateMethods={createDBMessageWriteObject:function createDBMessageWriteObject(message_content){if(message_content&&(!message_content.messageTime||message_content.messageTime&&!message_content.messageTime.timestamp)){message_content.messageTime=__WEBPACK_IMPORTED_MODULE_1__util_service__["a" /* default */].getCurrentTime();}return{content:this.encodeContentString(JSON.stringify(message_content)),serial_id:'abcd',timestamp:message_content.messageTime&&message_content.messageTime.timestamp||__WEBPACK_IMPORTED_MODULE_1__util_service__["a" /* default */].getCurrentTime().timestamp,session_id:'abc123',si_number:__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('currentNumber')?__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('currentNumber'):__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('primaryNumber')?__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('primaryNumber'):""};},encodeContentString:function encodeContentString(str){return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,function toSolidBytes(match,p1){return String.fromCharCode('0x'+p1);}));},decodeContentString:function decodeContentString(str){var decodedstr=void 0;try{decodedstr=decodeURIComponent(atob(str).split('').map(function(c){return'%'+('00'+c.charCodeAt(0).toString(16)).slice(-2);}).join(''));}catch(e){decodedstr=undefined;}return decodedstr;},writeToDB:function writeToDB(){var message_array=[];if(dbReadWriteService.db_write_queue){message_array=dbReadWriteService.db_write_queue;}//if db write callbackreturned for previous calls , call fir next messages in queue
if(message_array.length>0&&dbReadWriteService.writeCallbackReturned){//set the messages that are to be sent to bw written 
dbReadWriteService.setMessagesSentToBeWritten(message_array);var send_object={data:message_array};var message_arr_str=JSON.stringify(send_object);if(window.MyAirtelChatAppReact){if(window.MyAirtelChatAppReact.writeMessageFor){//set writecallback returned to false just before calling writemessagefor function
dbReadWriteService.writeCallbackReturned=false;window.MyAirtelChatAppReact.writeMessageFor(message_arr_str,"writeReturnFunction");}else{//do nothing
}}}}};window.readReturnFunction=function(response){setTimeout(function(){try{response=atob(response);response=JSON.parse(response);}catch(e){console.log(e);}dbReadWriteService.handleReadReturn(response);},0);};window.writeReturnFunction=function(response){try{response=atob(response);response=JSON.parse(response);}catch(e){console.log(e);}dbReadWriteService.handleWriteReturn(response);};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateOptionsPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateOptionsLeftPosition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_PlatformType__ = __webpack_require__(5);
var calculateOptionsPosition=function calculateOptionsPosition(){// console.log('calculate options')
if(document.getElementById('main')&&document.getElementById('main').scrollHeight>60){if(document.getElementById('options_scroll_bar')){if(document.getElementById('options_scroll_bar').scrollWidth>document.getElementById('options_scroll_bar').offsetWidth){document.getElementById('options_scroll_bar').style.justifyContent='';}else{document.getElementById('options_scroll_bar').style.justifyContent='center';}}var total_height=document.getElementById('chat_list_id').scrollHeight+(document.getElementById('options_bar_position_id')?document.getElementById('options_bar_position_id').scrollHeight:0);var fixed_height=document.getElementById('chat_message_id').clientHeight;// console.log(total_height,fixed_height)
if(document.getElementById('options_bar_position_id')){if(total_height>=fixed_height){document.getElementById('options_bar_position_id').style.position='static';}else if(total_height<fixed_height){document.getElementById('options_bar_position_id').style.position='absolute';}}}};var calculateOptionsLeftPosition=function calculateOptionsLeftPosition(){if(__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get('platformType')!==__WEBPACK_IMPORTED_MODULE_1__enums_PlatformType__["a" /* default */].WEB&&document.getElementsByClassName("choice_list_item")&&document.getElementById('options_scroll_bar')){var items=document.getElementsByClassName("choice_list_item");// document.getElementById('options_scroll_bar').scrollRight = 56
var total_width=0;if(items&&items.length>0){// items[0].style.paddingLeft = '51px'
for(var i=0;i<items.length;i++){total_width=total_width+items[i].offsetWidth+10;if(Math.abs(total_width>document.getElementById('options_scroll_bar').offsetWidth)){items[0].style.paddingLeft='61px';// document.getElementById('options_scroll_bar').scrollLeft = 50
break;}}}}};

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(23);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(51);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(48);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(48);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(32);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_chooseAction__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_execute_action__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__chatHistory_service__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums_action_types_ChatActionType__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bot_switch_service__ = __webpack_require__(71);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UserAction=function(){function UserAction(){_classCallCheck(this,UserAction);}_createClass(UserAction,null,[{key:'handleUserAction',value:function handleUserAction(userActionObject,messageComp){// console.log(userActionObject)
if(!messageComp.state.disableOptionClicks){messageComp.setState({fieldType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT});__WEBPACK_IMPORTED_MODULE_6__idle_timeout_service__["a" /* default */].updateIdleState();UserAction.addMessagesToChat(userActionObject,messageComp);var chatBotQuery=UserAction.getChatBotQuery(userActionObject);UserAction.handleUserActionTracking(userActionObject,messageComp.state.current_scenario);if(userActionObject.actionType!==__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].RETRY_CLICK){messageComp.clearRetry();}if(true){messageComp.scrollToBottom();messageComp.clearResponseOptions();messageComp.hideFeedbackOptions();UserAction.handleApiRequests(userActionObject,messageComp,chatBotQuery);}}}},{key:'addMessagesToChat',value:function addMessagesToChat(userActionObject,messageComp){var new_messages=[];var switchScenarioMessages=[];if(userActionObject&&!userActionObject.afterBotSwitch){new_messages=UserAction.getChatMessagesOnUserAction(userActionObject);}if(userActionObject.actionType===__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].SNS_CLICKED){if(userActionObject.snsObject.scenarioStrategy&&userActionObject.snsObject.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__["a" /* default */].SwitchScenario){switchScenarioMessages=UserAction.handleSwitchScenario(userActionObject.snsObject,messageComp);}}new_messages&&new_messages.length>0&&messageComp.addNewMessages({new_messages:[].concat(_toConsumableArray(new_messages),_toConsumableArray(switchScenarioMessages))});}},{key:'handleApiRequests',value:function handleApiRequests(userActionObject,messageComp,chatBotQuery){switch(userActionObject.actionType){case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK:{var scenarioObject=__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentBotType")][userActionObject.inputQuery];UserAction.sendApiRequest({actionType:userActionObject.actionType,user_response:chatBotQuery,scenarioResponse:scenarioObject},messageComp,chatBotQuery);break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CATEGORY_OPTION_CLICKED:{if(userActionObject.categoryObject.scenarioResponse&&userActionObject.categoryObject.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__["a" /* default */].FAQScenario){messageComp.setState({disableInputField:false});messageComp.showFeedbackOptions();return;}if(userActionObject.categoryObject.scenario&&userActionObject.categoryObject.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__["a" /* default */].DTScenario){UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CATEGORY,user_response:chatBotQuery,scenarioResponse:userActionObject.categoryObject.scenario},messageComp,chatBotQuery);}else{UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CATEGORY,user_response:chatBotQuery},messageComp,chatBotQuery);}break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHAT_TEXT_ENTER:{UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.DEFAULT,user_response:chatBotQuery,user_res:chatBotQuery},messageComp,chatBotQuery);break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED:{if(userActionObject.inputQuery==='Previous Step'){__WEBPACK_IMPORTED_MODULE_9__chatHistory_service__["a" /* default */].goToPrevious(messageComp);}else if(messageComp.state.current_scenario&&messageComp.state.current_scenario.scenarioType&&messageComp.state.current_scenario.scenarioType==="ASK_NUMBER_CONFIRMATION_WEB"){UserAction.handleAskNumberConfirmationForSingleAccountWeb(chatBotQuery,messageComp);}else{UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CHOICE_CLICKED,user_response:chatBotQuery,user_res:chatBotQuery,scenarioResponse:messageComp.state.current_scenario},messageComp,chatBotQuery);}break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].COUNTRY_SELECT:{UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.COUNTRY_SELECT,user_response:chatBotQuery,user_res:chatBotQuery,scenarioResponse:messageComp.state.current_scenario},messageComp,chatBotQuery);break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].SNS_CLICKED:{var snsObject=userActionObject.snsObject;if(snsObject.scenarioStrategy&&snsObject.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__["a" /* default */].FAQScenario&&snsObject.scenarioResponse){messageComp.setState({disableInputField:false});messageComp.showFeedbackOptions();return;}else if(snsObject.scenarioObject&&snsObject.scenarioStrategy&&snsObject.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__["a" /* default */].DTScenario){UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CHAT,user_response:chatBotQuery,user_res:chatBotQuery,scenarioResponse:userActionObject.snsObject.scenarioObject.scenario},messageComp,chatBotQuery);}else if(snsObject.scenarioStrategy&&snsObject.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__["a" /* default */].SwitchScenario){// nothing
}else{UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.CHAT,user_response:chatBotQuery,user_res:chatBotQuery},messageComp,chatBotQuery);}break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].RETRY_CLICK:{messageComp.retry_count=messageComp.retry_count+1;var query=UserAction.getChatBotQuery(messageComp.state.userActionObject);UserAction.handleApiRequests(messageComp.state.userActionObject,messageComp,query);messageComp.setState({show_retry:false});break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CREATE_SR:{// console.log(userActionObject, chatBotQuery)
UserAction.sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_12__enums_action_types_ChatActionType__["a" /* default */].CREATE_SR,user_response:chatBotQuery,user_res:chatBotQuery,scenarioResponse:messageComp.state.current_scenario,aditionalData:userActionObject.additionalData},messageComp,chatBotQuery);// UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.CREATE_SR, user_response: chatBotQuery, user_res: chatBotQuery, scenarioResponse: messageComp.state.current_scenario, aditionalData: userActionObject.aditionalData }, messageComp, chatBotQuery)
break;}}}},{key:'sendApiRequest',value:function sendApiRequest(_ref,messageComp,chatBotQuery){var user_response=_ref.user_response,scenarioResponse=_ref.scenarioResponse,actionType=_ref.actionType,user_res=_ref.user_res,aditionalData=_ref.aditionalData;messageComp.setLoaderOn();messageComp.scrollToBottom();messageComp.disableOptionClicks(true);var selectedAction=Object(__WEBPACK_IMPORTED_MODULE_1__actions_chooseAction__["a" /* chooseAction */])({scenarioResponse:actionType===__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.DEFAULT||actionType===__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.PLACE?messageComp.state.current_scenario:scenarioResponse,data:{user_response:user_response?user_response:null,actionType:actionType?actionType:null,user_res:user_res?user_res:null,aditionalData:aditionalData?aditionalData:null}});// console.log('action selected', selectedAction)
if(selectedAction){var resultantComponentPromise=Object(__WEBPACK_IMPORTED_MODULE_2__actions_execute_action__["a" /* executeAction */])(selectedAction,{scenarioResponse:actionType===__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.DEFAULT?messageComp.state.current_scenario:scenarioResponse,user_response:user_response},messageComp.retry_count,chatBotQuery);resultantComponentPromise.then(function(response){messageComp.handleResponseAfterExecution({response:response,user_response:user_response,actionType:actionType,user_res:user_res,scenarioResponse:scenarioResponse,aditionalData:aditionalData});},function(error){messageComp.handleErrorAfterExecution(error,selectedAction);});}}},{key:'getChatBotQuery',value:function getChatBotQuery(userActionObject){var inputQuery=userActionObject.inputQuery;var actionType=userActionObject.actionType;var categoryObject=userActionObject.categoryObject;var snsObject=userActionObject.snsObject;switch(actionType){case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK:{return inputQuery;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CATEGORY_OPTION_CLICKED:{if(categoryObject.scenarioResponse){return null;}return categoryObject.scenarioTitle;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].COUNTRY_SELECT:{return snsObject.shortKey;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].SNS_CLICKED:{return snsObject.shortKey;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHAT_TEXT_ENTER:case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED:default:{return inputQuery;}}}},{key:'getChatMessagesOnUserAction',value:function getChatMessagesOnUserAction(userActionObject){var inputQuery=userActionObject.inputQuery;var shownQuery=userActionObject.shownQuery;var actionType=userActionObject.actionType;var categoryObject=userActionObject.categoryObject;var snsObject=userActionObject.snsObject;var messages=[];switch(actionType){case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK:{messages.push(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].createUserMessageObject(inputQuery,true));break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CATEGORY_OPTION_CLICKED:{messages.push(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].createUserMessageObject(categoryObject.scenarioTitle));if(categoryObject.scenarioResponse){messages.push(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].createChatBotMessageObject(categoryObject.scenarioResponse));}break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].COUNTRY_SELECT:{messages.push(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].createUserMessageObject(snsObject.longKey));break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].SNS_CLICKED:{messages.push(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].createUserMessageObject(snsObject.longKey));if(snsObject.scenarioStrategy&&snsObject.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_11__enums_scenario_type__["a" /* default */].FAQScenario&&snsObject.scenarioResponse){messages.push(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].createChatBotMessageObject(snsObject.scenarioResponse));}break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHAT_TEXT_ENTER:case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED:{messages.push(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].createUserMessageObject(shownQuery));break;}default:{}}return messages;}}]);return UserAction;}();UserAction.handleAskNumberConfirmationForSingleAccountWeb=function(chatBotQuery,messageComp){if(chatBotQuery.toLowerCase()!=="no"){// Number confirmed and initiate welcome scenario
__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",true);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("currentNumber",__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("primaryNumber"));messageComp.onNumberSelected({user_response:'Yes',show_number:true});messageComp.enableBottomBar();}else{// User is logged off and initiate welcome scenario
messageComp.enableBottomBar();__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("isUserLoggedIn",false);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("loggedInToken",null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set("currentNumber",__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("primaryNumber"));messageComp.onNumberSelected({user_response:'No',show_number:true});}return;};UserAction.handleUserActionTracking=function(userActionObject,Scenario){if(userActionObject.actionType!==__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK){var feedbackSkippedTracking=UserAction.checkForFeedbackSkippedTracking(userActionObject,Scenario);if(feedbackSkippedTracking){__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(feedbackSkippedTracking);}}if(__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].isBadFeedbackScenario(Scenario)){UserAction.setTrackingDataOnUserAction(userActionObject,true);}else{UserAction.setTrackingDataOnUserAction(userActionObject);}switch(userActionObject.actionType){case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK:{if(userActionObject.inputQuery&&userActionObject.inputQuery=="GOOD_FEEDBACK"){__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].FEEDBACK_HAPPY);}else{__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].FEEDBACK_SAD);}break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CATEGORY_OPTION_CLICKED:{__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].SCENARIO_QUERY);break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].SNS_CLICKED:{if(userActionObject.snsObject.scenarioStrategy&&userActionObject.snsObject.scenarioObject){__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].INTENT_READING_SUCCESS);}break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED:{if(UserAction.isBadFeedbackScenario(Scenario)){__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].IMPROVE_FEEDBACK);}if(UserAction.isGridClickScenario(Scenario)){__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].GRID_CLICKS);}break;}default:{}}};UserAction.setTrackingDataOnUserAction=function(userActionObject,isSuggestion){var enteredTextMode=void 0,user_suggestion=void 0,user_response=void 0,scenarioName=void 0,scenarioStrategy=void 0;switch(userActionObject.actionType){case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CATEGORY_OPTION_CLICKED:{enteredTextMode='click';user_response=userActionObject.categoryObject.scenarioTitle;scenarioName=userActionObject.categoryObject.scenarioTitle;scenarioStrategy=userActionObject.categoryObject.scenarioStrategy||'DTScenario';break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED:{enteredTextMode='click';if(isSuggestion)user_suggestion=userActionObject.inputQuery;else user_response=userActionObject.inputQuery;break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].COUNTRY_SELECT:{enteredTextMode='click';user_response=userActionObject.snsObject.shortKey;scenarioName=userActionObject.snsObject.longKey;break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHAT_TEXT_ENTER:{enteredTextMode='write';user_response=userActionObject.inputQuery;break;}case __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].SNS_CLICKED:{enteredTextMode='click';user_response=userActionObject.snsObject.shortKey,scenarioName=userActionObject.snsObject.longKey;break;}}__WEBPACK_IMPORTED_MODULE_10__tracking_middleware_service__["a" /* default */].setTrackingData({enteredTextMode:enteredTextMode,user_response:user_response,user_suggestion:user_suggestion,scenarioName:scenarioName,scenarioStrategy:scenarioStrategy});};UserAction.checkForFeedbackSkippedTracking=function(userActionObject,Scenario){if(document.getElementById("feedback-up")){return __WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].FEEDBACK_SKIPPED;}if((userActionObject&&userActionObject.actionType!==__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED||!userActionObject)&&UserAction.isBadFeedbackScenario(Scenario)&&Scenario.scenarioActive){return __WEBPACK_IMPORTED_MODULE_8__enums_trackingKey__["a" /* default */].IMPROVE_FEEDBACK_SKIPPED;}else return undefined;};UserAction.isBadFeedbackScenario=function(Scenario){if(Scenario&&Scenario.scenario&&Scenario.scenario.scenarioId===__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentBotType")]['BAD_FEEDBACK'].scenarioId){return true;}else return false;};UserAction.isGridClickScenario=function(current_scenario){var isGridClickScenario=false;if(current_scenario&&current_scenario.scenario&&current_scenario.scenario.scenarioId){switch(current_scenario.scenario.scenarioId){case __WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentBotType")]["WELCOME"].scenarioId:case __WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentBotType")]["FAILURE"].scenarioId:case __WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_1"].scenarioId:case __WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get("currentBotType")]["NO_INTENT_FOUND_2"].scenarioId:{isGridClickScenario=true;break;}}}return isGridClickScenario;};UserAction.handleSwitchScenario=function(snsObject,messageComp,chatBotQuery){//switch the bot 
var message_objects=[];var newBotType=snsObject.scenarioObject.scenario.scenarioLob;if(__WEBPACK_IMPORTED_MODULE_13__bot_switch_service__["a" /* default */].checkIfLobEnabled(newBotType)){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get('isUserLoggedIn')){if(__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get('userProfile')){var userProfile=__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].get('userProfile');var accounts=__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].getAccountsForBotType(userProfile,newBotType);if(accounts&&accounts.length>0){message_objects=[{component_type:'DEFAULT',message:'Hey!! You have enquired about a '+(newBotType&&newBotType.toLowerCase())+' number.Please switch to a '+newBotType.toLowerCase()+' number and ask your query!',messageTime:__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].getCurrentTime()}];}else{//no new bot type number in user profile
message_objects=[{component_type:'DEFAULT',message:'Hey!! You have enquired about a '+(newBotType&&newBotType.toLowerCase())+' number, currently no '+(newBotType&&newBotType.toLowerCase())+' numbers are added into your profile.',messageTime:__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].getCurrentTime()}];}}else{// no user profile found
__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set('isUserLoggedIn',false);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set('loggedInToken',null);__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set('currentBotType',snsObject.scenarioObject.scenario.scenarioLob.toUpperCase());messageComp.initiateWelcomeScenarioForCurrentBot();}}else{// handle if logged out
__WEBPACK_IMPORTED_MODULE_3__global_store_service__["a" /* default */].set('currentBotType',snsObject.scenarioObject.scenario.scenarioLob.toUpperCase());messageComp.initiateWelcomeScenarioForCurrentBot();}}else{snsObject['searchReply']=snsObject.scenarioObject;message_objects=__WEBPACK_IMPORTED_MODULE_13__bot_switch_service__["a" /* default */].getChatMessageIfBotLobDisabled(snsObject,newBotType);}return message_objects;};UserAction.createUserMessageObject=function(message,is_feedback){return{component_type:'USER_RESPONSE',message:message,messageTime:__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].getCurrentTime(),is_feedback:is_feedback};};UserAction.createChatBotMessageObject=function(message){return{component_type:'DEFAULT',message:message,messageTime:__WEBPACK_IMPORTED_MODULE_4__util_service__["a" /* default */].getCurrentTime()};};/* harmony default export */ __webpack_exports__["a"] = (UserAction);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var HeaderActionType={"MINIMIZE":"MINIMIZE","MAXIMIZE":"MAXIMIZE","CLOSE":"CLOSE"};/* harmony default export */ __webpack_exports__["a"] = (HeaderActionType);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(86);
module.exports = __webpack_require__(92);


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(87).enable();
  window.Promise = __webpack_require__(90);
}

// fetch() polyfill for making API calls.
__webpack_require__(91);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(33);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(52);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(89)))

/***/ }),
/* 89 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(52);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__ = __webpack_require__(238);
// import './App.css';
// import registerServiceWorker from './registerServiceWorker';
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_4__registerServiceWorker__["a" /* unregister */])();// registerServiceWorker();

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(33),n=__webpack_require__(53),p=__webpack_require__(54),q=__webpack_require__(55),r="function"===typeof Symbol&&Symbol.for,t=r?Symbol.for("react.element"):60103,u=r?Symbol.for("react.portal"):60106,v=r?Symbol.for("react.fragment"):60107,w=r?Symbol.for("react.strict_mode"):60108,x=r?Symbol.for("react.profiler"):60114,y=r?Symbol.for("react.provider"):60109,z=r?Symbol.for("react.context"):60110,A=r?Symbol.for("react.async_mode"):60111,B=
r?Symbol.for("react.forward_ref"):60112;r&&Symbol.for("react.timeout");var C="function"===typeof Symbol&&Symbol.iterator;function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);n(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}
var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function F(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function G(){}
G.prototype=F.prototype;function H(a,b,e){this.props=a;this.context=b;this.refs=p;this.updater=e||E}var I=H.prototype=new G;I.constructor=H;k(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:t,type:a,key:g,ref:h,props:d,_owner:J.current}}
function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===t}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,e,c){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case t:case u:g=!0}}if(g)return e(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+T(d,h);g+=S(d,f,e,c)}else if(null===a||"undefined"===typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),
h=0;!(d=a.next()).done;)d=d.value,f=b+T(d,h++),g+=S(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function U(a,b){a.func.call(a.context,b,a.count++)}
function V(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,q.thatReturnsArgument):null!=a&&(N(a)&&(b=d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+e,a={$$typeof:t,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(O,"$&/")+"/");b=Q(b,g,c,d);null==a||S(a,"",V,b);R(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=Q(null,null,b,e);null==a||S(a,"",U,b);R(b)},count:function(a){return null==a?0:S(a,"",q.thatReturnsNull,null)},toArray:function(a){var b=[];W(a,b,null,q.thatReturnsArgument);return b},only:function(a){N(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:F,PureComponent:H,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:z,
_calculateChangedBits:b,_defaultValue:a,_currentValue:a,_currentValue2:a,_changedBits:0,_changedBits2:0,Provider:null,Consumer:null};a.Provider={$$typeof:y,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:B,render:a}},Fragment:v,StrictMode:w,unstable_AsyncMode:A,unstable_Profiler:x,createElement:M,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==
b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:t,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.4.2",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:J,
assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default?Z.default:Z;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(53),ba=__webpack_require__(0),m=__webpack_require__(95),p=__webpack_require__(33),v=__webpack_require__(55),da=__webpack_require__(96),ea=__webpack_require__(97),fa=__webpack_require__(98),ha=__webpack_require__(54);
function A(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}ba?void 0:A("227");
function ia(a,b,c,d,e,f,g,h,k){this._hasCaughtError=!1;this._caughtError=null;var n=Array.prototype.slice.call(arguments,3);try{b.apply(c,n)}catch(r){this._caughtError=r,this._hasCaughtError=!0}}
var B={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,invokeGuardedCallback:function(a,b,c,d,e,f,g,h,k){ia.apply(B,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){B.invokeGuardedCallback.apply(this,arguments);if(B.hasCaughtError()){var n=B.clearCaughtError();B._hasRethrowError||(B._hasRethrowError=!0,B._rethrowError=n)}},rethrowCaughtError:function(){return ka.apply(B,arguments)},hasCaughtError:function(){return B._hasCaughtError},clearCaughtError:function(){if(B._hasCaughtError){var a=
B._caughtError;B._caughtError=null;B._hasCaughtError=!1;return a}A("198")}};function ka(){if(B._hasRethrowError){var a=B._rethrowError;B._rethrowError=null;B._hasRethrowError=!1;throw a;}}var la=null,ma={};
function na(){if(la)for(var a in ma){var b=ma[a],c=la.indexOf(a);-1<c?void 0:A("96",a);if(!oa[c]){b.extractEvents?void 0:A("97",a);oa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;pa.hasOwnProperty(h)?A("99",h):void 0;pa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&qa(k[e],g,h);e=!0}else f.registrationName?(qa(f.registrationName,g,h),e=!0):e=!1;e?void 0:A("98",d,a)}}}}
function qa(a,b,c){ra[a]?A("100",a):void 0;ra[a]=b;sa[a]=b.eventTypes[c].dependencies}var oa=[],pa={},ra={},sa={};function ta(a){la?A("101"):void 0;la=Array.prototype.slice.call(a);na()}function ua(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];ma.hasOwnProperty(c)&&ma[c]===d||(ma[c]?A("102",c):void 0,ma[c]=d,b=!0)}b&&na()}
var va={plugins:oa,eventNameDispatchConfigs:pa,registrationNameModules:ra,registrationNameDependencies:sa,possibleRegistrationNames:null,injectEventPluginOrder:ta,injectEventPluginsByName:ua},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);B.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
function Aa(a,b){null==b?A("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;
function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}var Ga={injectEventPluginOrder:ta,injectEventPluginsByName:ua};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?A("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?A("95"):void 0,B.rethrowCaughtError())}function Ja(a,b,c,d){for(var e=null,f=0;f<oa.length;f++){var g=oa[f];g&&(g=g.extractEvents(a,b,c,d))&&(e=Aa(e,g))}Ia(e,!1)}var Ka={injection:Ga,getListener:Ha,runEventsInBatch:Ia,runExtractedEventsInBatch:Ja},La=Math.random().toString(36).slice(2),C="__reactInternalInstance$"+La,Ma="__reactEventHandlers$"+La;
function Na(a){if(a[C])return a[C];for(;!a[C];)if(a.parentNode)a=a.parentNode;else return null;a=a[C];return 5===a.tag||6===a.tag?a:null}function Oa(a){if(5===a.tag||6===a.tag)return a.stateNode;A("33")}function Pa(a){return a[Ma]||null}var Qa={precacheFiberNode:function(a,b){b[C]=a},getClosestInstanceFromNode:Na,getInstanceFromNode:function(a){a=a[C];return!a||5!==a.tag&&6!==a.tag?null:a},getNodeFromInstance:Oa,getFiberCurrentPropsFromNode:Pa,updateFiberProps:function(a,b){a[Ma]=b}};
function F(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Ra(a,b,c){for(var d=[];a;)d.push(a),a=F(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}function Ta(a){a&&a.dispatchConfig.phasedRegistrationNames&&Ra(a._targetInst,Sa,a)}
function Ua(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?F(b):null;Ra(b,Sa,a)}}function Va(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Xa(a){a&&a.dispatchConfig.registrationName&&Va(a._targetInst,null,a)}function Ya(a){Ba(a,Ta)}
function Za(a,b,c,d){if(c&&d)a:{var e=c;for(var f=d,g=0,h=e;h;h=F(h))g++;h=0;for(var k=f;k;k=F(k))h++;for(;0<g-h;)e=F(e),g--;for(;0<h-g;)f=F(f),h--;for(;g--;){if(e===f||e===f.alternate)break a;e=F(e);f=F(f)}e=null}else e=null;f=e;for(e=[];c&&c!==f;){g=c.alternate;if(null!==g&&g===f)break;e.push(c);c=F(c)}for(c=[];d&&d!==f;){g=d.alternate;if(null!==g&&g===f)break;c.push(d);d=F(d)}for(d=0;d<e.length;d++)Va(e[d],"bubbled",a);for(a=c.length;0<a--;)Va(c[a],"captured",b)}
var $a={accumulateTwoPhaseDispatches:Ya,accumulateTwoPhaseDispatchesSkipTarget:function(a){Ba(a,Ua)},accumulateEnterLeaveDispatches:Za,accumulateDirectDispatches:function(a){Ba(a,Xa)}};function ab(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var bb={animationend:ab("Animation","AnimationEnd"),animationiteration:ab("Animation","AnimationIteration"),animationstart:ab("Animation","AnimationStart"),transitionend:ab("Transition","TransitionEnd")},cb={},db={};m.canUseDOM&&(db=document.createElement("div").style,"AnimationEvent"in window||(delete bb.animationend.animation,delete bb.animationiteration.animation,delete bb.animationstart.animation),"TransitionEvent"in window||delete bb.transitionend.transition);
function eb(a){if(cb[a])return cb[a];if(!bb[a])return a;var b=bb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in db)return cb[a]=b[c];return a}var fb=eb("animationend"),gb=eb("animationiteration"),hb=eb("animationstart"),ib=eb("transitionend"),jb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),kb=null;
function lb(){!kb&&m.canUseDOM&&(kb="textContent"in document.documentElement?"textContent":"innerText");return kb}var G={_root:null,_startText:null,_fallbackText:null};function mb(){if(G._fallbackText)return G._fallbackText;var a,b=G._startText,c=b.length,d,e=nb(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);G._fallbackText=e.slice(a,1<d?1-d:void 0);return G._fallbackText}function nb(){return"value"in G._root?G._root.value:G._root[lb()]}
var ob="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),pb={type:null,target:null,currentTarget:v.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function H(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?v.thatReturnsTrue:v.thatReturnsFalse;this.isPropagationStopped=v.thatReturnsFalse;return this}
p(H.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=v.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=v.thatReturnsTrue)},persist:function(){this.isPersistent=v.thatReturnsTrue},isPersistent:v.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<ob.length;a++)this[ob[a]]=null}});H.Interface=pb;H.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;qb(c);return c};qb(H);
function rb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function sb(a){a instanceof this?void 0:A("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function qb(a){a.eventPool=[];a.getPooled=rb;a.release=sb}var tb=H.extend({data:null}),ub=H.extend({data:null}),vb=[9,13,27,32],wb=m.canUseDOM&&"CompositionEvent"in window,xb=null;m.canUseDOM&&"documentMode"in document&&(xb=document.documentMode);
var yb=m.canUseDOM&&"TextEvent"in window&&!xb,zb=m.canUseDOM&&(!wb||xb&&8<xb&&11>=xb),Ab=String.fromCharCode(32),Bb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Cb=!1;
function Db(a,b){switch(a){case "keyup":return-1!==vb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Eb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Fb=!1;function Gb(a,b){switch(a){case "compositionend":return Eb(b);case "keypress":if(32!==b.which)return null;Cb=!0;return Ab;case "textInput":return a=b.data,a===Ab&&Cb?null:a;default:return null}}
function Hb(a,b){if(Fb)return"compositionend"===a||!wb&&Db(a,b)?(a=mb(),G._root=null,G._startText=null,G._fallbackText=null,Fb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return zb?null:b.data;default:return null}}
var Ib={eventTypes:Bb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(wb)b:{switch(a){case "compositionstart":e=Bb.compositionStart;break b;case "compositionend":e=Bb.compositionEnd;break b;case "compositionupdate":e=Bb.compositionUpdate;break b}e=void 0}else Fb?Db(a,c)&&(e=Bb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Bb.compositionStart);e?(zb&&(Fb||e!==Bb.compositionStart?e===Bb.compositionEnd&&Fb&&(f=mb()):(G._root=d,G._startText=nb(),Fb=!0)),e=tb.getPooled(e,b,c,d),f?e.data=
f:(f=Eb(c),null!==f&&(e.data=f)),Ya(e),f=e):f=null;(a=yb?Gb(a,c):Hb(a,c))?(b=ub.getPooled(Bb.beforeInput,b,c,d),b.data=a,Ya(b)):b=null;return null===f?b:null===b?f:[f,b]}},Jb=null,Kb={injectFiberControlledHostComponent:function(a){Jb=a}},Lb=null,Mb=null;function Nb(a){if(a=xa(a)){Jb&&"function"===typeof Jb.restoreControlledState?void 0:A("194");var b=wa(a.stateNode);Jb.restoreControlledState(a.stateNode,a.type,b)}}function Ob(a){Lb?Mb?Mb.push(a):Mb=[a]:Lb=a}
function Pb(){return null!==Lb||null!==Mb}function Qb(){if(Lb){var a=Lb,b=Mb;Mb=Lb=null;Nb(a);if(b)for(a=0;a<b.length;a++)Nb(b[a])}}var Rb={injection:Kb,enqueueStateRestore:Ob,needsStateRestore:Pb,restoreStateIfNeeded:Qb};function Sb(a,b){return a(b)}function Tb(a,b,c){return a(b,c)}function Ub(){}var Vb=!1;function Wb(a,b){if(Vb)return a(b);Vb=!0;try{return Sb(a,b)}finally{Vb=!1,Pb()&&(Ub(),Qb())}}
var Xb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Yb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Xb[a.type]:"textarea"===b?!0:!1}function Zb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}
function $b(a,b){if(!m.canUseDOM||b&&!("addEventListener"in document))return!1;a="on"+a;b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function ac(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function bc(a){var b=ac(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function cc(a){a._valueTracker||(a._valueTracker=bc(a))}function dc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=ac(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var ec=ba.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,fc="function"===typeof Symbol&&Symbol.for,gc=fc?Symbol.for("react.element"):60103,hc=fc?Symbol.for("react.portal"):60106,ic=fc?Symbol.for("react.fragment"):60107,jc=fc?Symbol.for("react.strict_mode"):60108,kc=fc?Symbol.for("react.profiler"):60114,lc=fc?Symbol.for("react.provider"):60109,mc=fc?Symbol.for("react.context"):60110,pc=fc?Symbol.for("react.async_mode"):60111,qc=fc?Symbol.for("react.forward_ref"):60112,rc=fc?Symbol.for("react.timeout"):
60113,sc="function"===typeof Symbol&&Symbol.iterator;function tc(a){if(null===a||"undefined"===typeof a)return null;a=sc&&a[sc]||a["@@iterator"];return"function"===typeof a?a:null}
function uc(a){var b=a.type;if("function"===typeof b)return b.displayName||b.name;if("string"===typeof b)return b;switch(b){case pc:return"AsyncMode";case mc:return"Context.Consumer";case ic:return"ReactFragment";case hc:return"ReactPortal";case kc:return"Profiler("+a.pendingProps.id+")";case lc:return"Context.Provider";case jc:return"StrictMode";case rc:return"Timeout"}if("object"===typeof b&&null!==b)switch(b.$$typeof){case qc:return a=b.render.displayName||b.render.name||"",""!==a?"ForwardRef("+
a+")":"ForwardRef"}return null}function vc(a){var b="";do{a:switch(a.tag){case 0:case 1:case 2:case 5:var c=a._debugOwner,d=a._debugSource;var e=uc(a);var f=null;c&&(f=uc(c));c=d;e="\n    in "+(e||"Unknown")+(c?" (at "+c.fileName.replace(/^.*[\\\/]/,"")+":"+c.lineNumber+")":f?" (created by "+f+")":"");break a;default:e=""}b+=e;a=a.return}while(a);return b}
var wc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,xc=Object.prototype.hasOwnProperty,zc={},Ac={};
function Bc(a){if(xc.call(Ac,a))return!0;if(xc.call(zc,a))return!1;if(wc.test(a))return Ac[a]=!0;zc[a]=!0;return!1}function Cc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Dc(a,b,c,d){if(null===b||"undefined"===typeof b||Cc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function I(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var J={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){J[a]=new I(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];J[b]=new I(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){J[a]=new I(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","preserveAlpha"].forEach(function(a){J[a]=new I(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){J[a]=new I(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){J[a]=new I(a,3,!0,a.toLowerCase(),null)});
["capture","download"].forEach(function(a){J[a]=new I(a,4,!1,a.toLowerCase(),null)});["cols","rows","size","span"].forEach(function(a){J[a]=new I(a,6,!1,a.toLowerCase(),null)});["rowSpan","start"].forEach(function(a){J[a]=new I(a,5,!1,a.toLowerCase(),null)});var Ec=/[\-:]([a-z])/g;function Fc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ec,
Fc);J[b]=new I(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ec,Fc);J[b]=new I(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});J.tabIndex=new I("tabIndex",1,!1,"tabindex",null);
function Gc(a,b,c,d){var e=J.hasOwnProperty(b)?J[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Dc(b,c,e,d)&&(c=null),d||null===e?Bc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Hc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Ic(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Jc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Kc(a,b){b=b.checked;null!=b&&Gc(a,"checked",b,!1)}
function Lc(a,b){Kc(a,b);var c=Jc(b.value);if(null!=c)if("number"===b.type){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);b.hasOwnProperty("value")?Mc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Mc(a,b.type,Jc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Nc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){b=""+a._wrapperState.initialValue;var d=a.value;c||b===d||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==c&&(a.name=c)}function Mc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}
function Jc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}var Oc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Pc(a,b,c){a=H.getPooled(Oc.change,a,b,c);a.type="change";Ob(c);Ya(a);return a}var Qc=null,Rc=null;function Sc(a){Ia(a,!1)}function Tc(a){var b=Oa(a);if(dc(b))return a}
function Uc(a,b){if("change"===a)return b}var Vc=!1;m.canUseDOM&&(Vc=$b("input")&&(!document.documentMode||9<document.documentMode));function Wc(){Qc&&(Qc.detachEvent("onpropertychange",Xc),Rc=Qc=null)}function Xc(a){"value"===a.propertyName&&Tc(Rc)&&(a=Pc(Rc,a,Zb(a)),Wb(Sc,a))}function Yc(a,b,c){"focus"===a?(Wc(),Qc=b,Rc=c,Qc.attachEvent("onpropertychange",Xc)):"blur"===a&&Wc()}function Zc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Tc(Rc)}
function $c(a,b){if("click"===a)return Tc(b)}function ad(a,b){if("input"===a||"change"===a)return Tc(b)}
var bd={eventTypes:Oc,_isInputEventSupported:Vc,extractEvents:function(a,b,c,d){var e=b?Oa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Uc:Yb(e)?Vc?f=ad:(f=Zc,g=Yc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=$c);if(f&&(f=f(a,b)))return Pc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Mc(e,"number",e.value)}},cd=H.extend({view:null,detail:null}),dd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function ed(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=dd[a])?!!b[a]:!1}function fd(){return ed}
var gd=cd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:fd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}}),hd=gd.extend({pointerId:null,width:null,height:null,pressure:null,tiltX:null,tiltY:null,pointerType:null,isPrimary:null}),id={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},
mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},jd={eventTypes:id,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||
e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,n=void 0;if("mouseout"===a||"mouseover"===a)g=gd,h=id.mouseLeave,k=id.mouseEnter,n="mouse";else if("pointerout"===a||"pointerover"===a)g=hd,h=id.pointerLeave,k=id.pointerEnter,n="pointer";a=null==f?e:Oa(f);e=null==b?e:Oa(b);h=g.getPooled(h,f,c,d);h.type=n+"leave";h.target=a;h.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=n+"enter";c.target=e;c.relatedTarget=a;Za(h,
c,f,b);return[h,c]}};function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?A("188"):void 0}
function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?A("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}A("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:A("189")}}c.alternate!==d?A("190"):void 0}3!==c.tag?A("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function od(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child&&4!==b.tag)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}var pd=H.extend({animationName:null,elapsedTime:null,pseudoElement:null}),qd=H.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),rd=cd.extend({relatedTarget:null});
function sd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var td={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},ud={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},vd=cd.extend({key:function(a){if(a.key){var b=td[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=sd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?ud[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:fd,charCode:function(a){return"keypress"===
a.type?sd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?sd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),wd=gd.extend({dataTransfer:null}),xd=cd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:fd}),yd=H.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),zd=gd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Ad=[["abort","abort"],[fb,"animationEnd"],[gb,"animationIteration"],[hb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[ib,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Bd={},Cd={};function Dd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Bd[a]=b;Cd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],["pointerdown","pointerDown"],
["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Dd(a,!0)});Ad.forEach(function(a){Dd(a,!1)});
var Ed={eventTypes:Bd,isInteractiveTopLevelEventType:function(a){a=Cd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Cd[a];if(!e)return null;switch(a){case "keypress":if(0===sd(c))return null;case "keydown":case "keyup":a=vd;break;case "blur":case "focus":a=rd;break;case "click":if(2===c.button)return null;case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=gd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
wd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=xd;break;case fb:case gb:case hb:a=pd;break;case ib:a=yd;break;case "scroll":a=cd;break;case "wheel":a=zd;break;case "copy":case "cut":case "paste":a=qd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=hd;break;default:a=H}b=a.getPooled(e,b,c,d);Ya(b);return b}},Fd=Ed.isInteractiveTopLevelEventType,
Gd=[];function Hd(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c;for(c=b;c.return;)c=c.return;c=3!==c.tag?null:c.stateNode.containerInfo;if(!c)break;a.ancestors.push(b);b=Na(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],Ja(a.topLevelType,b,a.nativeEvent,Zb(a.nativeEvent))}var Id=!0;function Kd(a){Id=!!a}function K(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!1)}
function Nd(a,b){if(!b)return null;var c=(Fd(a)?Ld:Md).bind(null,a);b.addEventListener(a,c,!0)}function Ld(a,b){Tb(Md,a,b)}function Md(a,b){if(Id){var c=Zb(b);c=Na(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Gd.length){var d=Gd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Wb(Hd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Gd.length&&Gd.push(a)}}}
var Od={get _enabled(){return Id},setEnabled:Kd,isEnabled:function(){return Id},trapBubbledEvent:K,trapCapturedEvent:Nd,dispatchEvent:Md},Pd={},Qd=0,Rd="_reactListenersID"+(""+Math.random()).slice(2);function Sd(a){Object.prototype.hasOwnProperty.call(a,Rd)||(a[Rd]=Qd++,Pd[a[Rd]]={});return Pd[a[Rd]]}function Td(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Ud(a,b){var c=Td(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Td(c)}}function Vd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Wd=m.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Xd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Yd=null,Zd=null,$d=null,ae=!1;
function be(a,b){if(ae||null==Yd||Yd!==da())return null;var c=Yd;"selectionStart"in c&&Vd(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $d&&ea($d,c)?null:($d=c,a=H.getPooled(Xd.select,Zd,a,b),a.type="select",a.target=Yd,Ya(a),a)}
var ce={eventTypes:Xd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Sd(e);f=sa.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Oa(b):window;switch(a){case "focus":if(Yb(e)||"true"===e.contentEditable)Yd=e,Zd=b,$d=null;break;case "blur":$d=Zd=Yd=null;break;case "mousedown":ae=!0;break;case "contextmenu":case "mouseup":return ae=!1,be(c,d);case "selectionchange":if(Wd)break;
case "keydown":case "keyup":return be(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa.getFiberCurrentPropsFromNode;xa=Qa.getInstanceFromNode;ya=Qa.getNodeFromInstance;Ga.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:jd,ChangeEventPlugin:bd,SelectEventPlugin:ce,BeforeInputEventPlugin:Ib});
var de="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,ee=Date,fe=setTimeout,ge=clearTimeout,he=void 0;if("object"===typeof performance&&"function"===typeof performance.now){var ie=performance;he=function(){return ie.now()}}else he=function(){return ee.now()};var je=void 0,ke=void 0;
if(m.canUseDOM){var le="function"===typeof de?de:function(){A("276")},L=null,me=null,ne=-1,oe=!1,pe=!1,qe=0,re=33,se=33,te={didTimeout:!1,timeRemaining:function(){var a=qe-he();return 0<a?a:0}},ve=function(a,b){var c=a.scheduledCallback,d=!1;try{c(b),d=!0}finally{ke(a),d||(oe=!0,window.postMessage(ue,"*"))}},ue="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){if(a.source===window&&a.data===ue&&(oe=!1,null!==L)){if(null!==L){var b=he();if(!(-1===
ne||ne>b)){a=-1;for(var c=[],d=L;null!==d;){var e=d.timeoutTime;-1!==e&&e<=b?c.push(d):-1!==e&&(-1===a||e<a)&&(a=e);d=d.next}if(0<c.length)for(te.didTimeout=!0,b=0,d=c.length;b<d;b++)ve(c[b],te);ne=a}}for(a=he();0<qe-a&&null!==L;)a=L,te.didTimeout=!1,ve(a,te),a=he();null===L||pe||(pe=!0,le(we))}},!1);var we=function(a){pe=!1;var b=a-qe+se;b<se&&re<se?(8>b&&(b=8),se=b<re?re:b):re=b;qe=a+se;oe||(oe=!0,window.postMessage(ue,"*"))};je=function(a,b){var c=-1;null!=b&&"number"===typeof b.timeout&&(c=he()+
b.timeout);if(-1===ne||-1!==c&&c<ne)ne=c;a={scheduledCallback:a,timeoutTime:c,prev:null,next:null};null===L?L=a:(b=a.prev=me,null!==b&&(b.next=a));me=a;pe||(pe=!0,le(we));return a};ke=function(a){if(null!==a.prev||L===a){var b=a.next,c=a.prev;a.next=null;a.prev=null;null!==b?null!==c?(c.next=b,b.prev=c):(b.prev=null,L=b):null!==c?(c.next=null,me=c):me=L=null}}}else{var xe=new Map;je=function(a){var b={scheduledCallback:a,timeoutTime:0,next:null,prev:null},c=fe(function(){a({timeRemaining:function(){return Infinity},
didTimeout:!1})});xe.set(a,c);return b};ke=function(a){var b=xe.get(a.scheduledCallback);xe.delete(a);ge(b)}}function ye(a){var b="";ba.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}function ze(a,b){a=p({children:void 0},b);if(b=ye(b.children))a.children=b;return a}
function Ae(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+c;b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Be(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}}function Ce(a,b){null!=b.dangerouslySetInnerHTML?A("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function De(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?A("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:A("93"),b=b[0]),c=""+b),null==c&&(c=""));a._wrapperState={initialValue:""+c}}
function Ee(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)}function Fe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Ge={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function He(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ie(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?He(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Je=void 0,Ke=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ge.svg||"innerHTML"in a)a.innerHTML=b;else{Je=Je||document.createElement("div");Je.innerHTML="<svg>"+b+"</svg>";for(b=Je.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Le(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Me={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,
stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ne=["Webkit","ms","Moz","O"];Object.keys(Me).forEach(function(a){Ne.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Me[b]=Me[a]})});
function Oe(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Me.hasOwnProperty(e)&&Me[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Pe=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Qe(a,b,c){b&&(Pe[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?A("137",a,c()):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?A("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:A("61")),null!=b.style&&"object"!==typeof b.style?A("62",c()):void 0)}
function Re(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var Se=v.thatReturns("");
function Te(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Sd(a);b=sa[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Nd("scroll",a);break;case "focus":case "blur":Nd("focus",a);Nd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":$b(e,!0)&&Nd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===jb.indexOf(e)&&K(e,a)}c[e]=!0}}}
function Ue(a,b,c,d){c=9===c.nodeType?c:c.ownerDocument;d===Ge.html&&(d=He(a));d===Ge.html?"script"===a?(a=c.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a}function Ve(a,b){return(9===b.nodeType?b:b.ownerDocument).createTextNode(a)}
function We(a,b,c,d){var e=Re(b,c);switch(b){case "iframe":case "object":K("load",a);var f=c;break;case "video":case "audio":for(f=0;f<jb.length;f++)K(jb[f],a);f=c;break;case "source":K("error",a);f=c;break;case "img":case "image":case "link":K("error",a);K("load",a);f=c;break;case "form":K("reset",a);K("submit",a);f=c;break;case "details":K("toggle",a);f=c;break;case "input":Ic(a,c);f=Hc(a,c);K("invalid",a);Te(d,"onChange");break;case "option":f=ze(a,c);break;case "select":Be(a,c);f=p({},c,{value:void 0});
K("invalid",a);Te(d,"onChange");break;case "textarea":De(a,c);f=Ce(a,c);K("invalid",a);Te(d,"onChange");break;default:f=c}Qe(b,f,Se);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===h?Oe(a,k,Se):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Ke(a,k)):"children"===h?"string"===typeof k?("textarea"!==b||""!==k)&&Le(a,k):"number"===typeof k&&Le(a,""+k):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ra.hasOwnProperty(h)?null!=k&&Te(d,
h):null!=k&&Gc(a,h,k,e))}switch(b){case "input":cc(a);Nc(a,c,!1);break;case "textarea":cc(a);Fe(a,c);break;case "option":null!=c.value&&a.setAttribute("value",c.value);break;case "select":a.multiple=!!c.multiple;b=c.value;null!=b?Ae(a,!!c.multiple,b,!1):null!=c.defaultValue&&Ae(a,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof f.onClick&&(a.onclick=v)}}
function Xe(a,b,c,d,e){var f=null;switch(b){case "input":c=Hc(a,c);d=Hc(a,d);f=[];break;case "option":c=ze(a,c);d=ze(a,d);f=[];break;case "select":c=p({},c,{value:void 0});d=p({},d,{value:void 0});f=[];break;case "textarea":c=Ce(a,c);d=Ce(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=v)}Qe(b,d,Se);b=a=void 0;var g=null;for(a in c)if(!d.hasOwnProperty(a)&&c.hasOwnProperty(a)&&null!=c[a])if("style"===a){var h=c[a];for(b in h)h.hasOwnProperty(b)&&(g||
(g={}),g[b]="")}else"dangerouslySetInnerHTML"!==a&&"children"!==a&&"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&"autoFocus"!==a&&(ra.hasOwnProperty(a)?f||(f=[]):(f=f||[]).push(a,null));for(a in d){var k=d[a];h=null!=c?c[a]:void 0;if(d.hasOwnProperty(a)&&k!==h&&(null!=k||null!=h))if("style"===a)if(h){for(b in h)!h.hasOwnProperty(b)||k&&k.hasOwnProperty(b)||(g||(g={}),g[b]="");for(b in k)k.hasOwnProperty(b)&&h[b]!==k[b]&&(g||(g={}),g[b]=k[b])}else g||(f||(f=[]),f.push(a,g)),
g=k;else"dangerouslySetInnerHTML"===a?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(a,""+k)):"children"===a?h===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(a,""+k):"suppressContentEditableWarning"!==a&&"suppressHydrationWarning"!==a&&(ra.hasOwnProperty(a)?(null!=k&&Te(e,a),f||h===k||(f=[])):(f=f||[]).push(a,k))}g&&(f=f||[]).push("style",g);return f}
function Ye(a,b,c,d,e){"input"===c&&"radio"===e.type&&null!=e.name&&Kc(a,e);Re(c,d);d=Re(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?Oe(a,h,Se):"dangerouslySetInnerHTML"===g?Ke(a,h):"children"===g?Le(a,h):Gc(a,g,h,d)}switch(c){case "input":Lc(a,e);break;case "textarea":Ee(a,e);break;case "select":a._wrapperState.initialValue=void 0,b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?Ae(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?
Ae(a,!!e.multiple,e.defaultValue,!0):Ae(a,!!e.multiple,e.multiple?[]:"",!1))}}
function Ze(a,b,c,d,e){switch(b){case "iframe":case "object":K("load",a);break;case "video":case "audio":for(d=0;d<jb.length;d++)K(jb[d],a);break;case "source":K("error",a);break;case "img":case "image":case "link":K("error",a);K("load",a);break;case "form":K("reset",a);K("submit",a);break;case "details":K("toggle",a);break;case "input":Ic(a,c);K("invalid",a);Te(e,"onChange");break;case "select":Be(a,c);K("invalid",a);Te(e,"onChange");break;case "textarea":De(a,c),K("invalid",a),Te(e,"onChange")}Qe(b,
c,Se);d=null;for(var f in c)if(c.hasOwnProperty(f)){var g=c[f];"children"===f?"string"===typeof g?a.textContent!==g&&(d=["children",g]):"number"===typeof g&&a.textContent!==""+g&&(d=["children",""+g]):ra.hasOwnProperty(f)&&null!=g&&Te(e,f)}switch(b){case "input":cc(a);Nc(a,c,!0);break;case "textarea":cc(a);Fe(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=v)}return d}function $e(a,b){return a.nodeValue!==b}
var af={createElement:Ue,createTextNode:Ve,setInitialProperties:We,diffProperties:Xe,updateProperties:Ye,diffHydratedProperties:Ze,diffHydratedText:$e,warnForUnmatchedText:function(){},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,b,c){switch(b){case "input":Lc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;
c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Pa(d);e?void 0:A("90");dc(d);Lc(d,e)}}}break;case "textarea":Ee(a,c);break;case "select":b=c.value,null!=b&&Ae(a,!!c.multiple,b,!1)}}},bf=null,cf=null;function df(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function ef(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&"string"===typeof b.dangerouslySetInnerHTML.__html}var ff=he,gf=je,hf=ke;function jf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function kf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var lf=[],mf=-1;function nf(a){return{current:a}}
function M(a){0>mf||(a.current=lf[mf],lf[mf]=null,mf--)}function N(a,b){mf++;lf[mf]=a.current;a.current=b}var of=nf(ha),O=nf(!1),pf=ha;function qf(a){return rf(a)?pf:of.current}
function sf(a,b){var c=a.type.contextTypes;if(!c)return ha;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function rf(a){return 2===a.tag&&null!=a.type.childContextTypes}function tf(a){rf(a)&&(M(O,a),M(of,a))}function uf(a){M(O,a);M(of,a)}
function vf(a,b,c){of.current!==ha?A("168"):void 0;N(of,b,a);N(O,c,a)}function wf(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:A("108",uc(a)||"Unknown",e);return p({},b,c)}function xf(a){if(!rf(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||ha;pf=of.current;N(of,b,a);N(O,O.current,a);return!0}
function yf(a,b){var c=a.stateNode;c?void 0:A("169");if(b){var d=wf(a,pf);c.__reactInternalMemoizedMergedChildContext=d;M(O,a);M(of,a);N(of,d,a)}else M(O,a);N(O,b,a)}
function zf(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=null;this.index=0;this.ref=null;this.pendingProps=b;this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.expirationTime=0;this.alternate=null}
function Af(a,b,c){var d=a.alternate;null===d?(d=new zf(a.tag,b,a.key,a.mode),d.type=a.type,d.stateNode=a.stateNode,d.alternate=a,a.alternate=d):(d.pendingProps=b,d.effectTag=0,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null);d.expirationTime=c;d.child=a.child;d.memoizedProps=a.memoizedProps;d.memoizedState=a.memoizedState;d.updateQueue=a.updateQueue;d.sibling=a.sibling;d.index=a.index;d.ref=a.ref;return d}
function Bf(a,b,c){var d=a.type,e=a.key;a=a.props;if("function"===typeof d)var f=d.prototype&&d.prototype.isReactComponent?2:0;else if("string"===typeof d)f=5;else switch(d){case ic:return Cf(a.children,b,c,e);case pc:f=11;b|=3;break;case jc:f=11;b|=2;break;case kc:return d=new zf(15,a,e,b|4),d.type=kc,d.expirationTime=c,d;case rc:f=16;b|=2;break;default:a:{switch("object"===typeof d&&null!==d?d.$$typeof:null){case lc:f=13;break a;case mc:f=12;break a;case qc:f=14;break a;default:A("130",null==d?
d:typeof d,"")}f=void 0}}b=new zf(f,a,e,b);b.type=d;b.expirationTime=c;return b}function Cf(a,b,c,d){a=new zf(10,a,d,b);a.expirationTime=c;return a}function Df(a,b,c){a=new zf(6,a,null,b);a.expirationTime=c;return a}function Ef(a,b,c){b=new zf(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function Ff(a,b,c){b=new zf(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,pendingCommitExpirationTime:0,finishedWork:null,context:null,pendingContext:null,hydrate:c,remainingExpirationTime:0,firstBatch:null,nextScheduledRoot:null};return b.stateNode=a}var Gf=null,Hf=null;function If(a){return function(b){try{return a(b)}catch(c){}}}
function Jf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Gf=If(function(a){return b.onCommitFiberRoot(c,a)});Hf=If(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}function Kf(a){"function"===typeof Gf&&Gf(a)}function Lf(a){"function"===typeof Hf&&Hf(a)}var Mf=!1;
function Nf(a){return{expirationTime:0,baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Of(a){return{expirationTime:a.expirationTime,baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Pf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Qf(a,b,c){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b);if(0===a.expirationTime||a.expirationTime>c)a.expirationTime=c}
function Rf(a,b,c){var d=a.alternate;if(null===d){var e=a.updateQueue;var f=null;null===e&&(e=a.updateQueue=Nf(a.memoizedState))}else e=a.updateQueue,f=d.updateQueue,null===e?null===f?(e=a.updateQueue=Nf(a.memoizedState),f=d.updateQueue=Nf(d.memoizedState)):e=a.updateQueue=Of(f):null===f&&(f=d.updateQueue=Of(e));null===f||e===f?Qf(e,b,c):null===e.lastUpdate||null===f.lastUpdate?(Qf(e,b,c),Qf(f,b,c)):(Qf(e,b,c),f.lastUpdate=b)}
function Sf(a,b,c){var d=a.updateQueue;d=null===d?a.updateQueue=Nf(a.memoizedState):Tf(a,d);null===d.lastCapturedUpdate?d.firstCapturedUpdate=d.lastCapturedUpdate=b:(d.lastCapturedUpdate.next=b,d.lastCapturedUpdate=b);if(0===d.expirationTime||d.expirationTime>c)d.expirationTime=c}function Tf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Of(b));return b}
function Uf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case 2:Mf=!0}return d}
function Vf(a,b,c,d,e){Mf=!1;if(!(0===b.expirationTime||b.expirationTime>e)){b=Tf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,n=f;null!==k;){var r=k.expirationTime;if(r>e){if(null===g&&(g=k,f=n),0===h||h>r)h=r}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}r=null;for(k=b.firstCapturedUpdate;null!==k;){var w=k.expirationTime;if(w>e){if(null===r&&(r=k,null===
g&&(f=n)),0===h||h>w)h=w}else n=Uf(a,b,k,n,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===r?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===r&&(f=n);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=r;b.expirationTime=h;a.memoizedState=n}}
function Wf(a,b){"function"!==typeof a?A("191",a):void 0;a.call(b)}
function Xf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);a=b.firstEffect;for(b.firstEffect=b.lastEffect=null;null!==a;){var d=a.callback;null!==d&&(a.callback=null,Wf(d,c));a=a.nextEffect}a=b.firstCapturedEffect;for(b.firstCapturedEffect=b.lastCapturedEffect=null;null!==a;)b=a.callback,null!==b&&(a.callback=null,Wf(b,c)),a=a.nextEffect}
function Yf(a,b){return{value:a,source:b,stack:vc(b)}}var Zf=nf(null),$f=nf(null),ag=nf(0);function bg(a){var b=a.type._context;N(ag,b._changedBits,a);N($f,b._currentValue,a);N(Zf,a,a);b._currentValue=a.pendingProps.value;b._changedBits=a.stateNode}function cg(a){var b=ag.current,c=$f.current;M(Zf,a);M($f,a);M(ag,a);a=a.type._context;a._currentValue=c;a._changedBits=b}var dg={},eg=nf(dg),fg=nf(dg),gg=nf(dg);function hg(a){a===dg?A("174"):void 0;return a}
function jg(a,b){N(gg,b,a);N(fg,a,a);N(eg,dg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ie(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ie(b,c)}M(eg,a);N(eg,b,a)}function kg(a){M(eg,a);M(fg,a);M(gg,a)}function lg(a){fg.current===a&&(M(eg,a),M(fg,a))}function mg(a,b,c){var d=a.memoizedState;b=b(c,d);d=null===b||void 0===b?d:p({},d,b);a.memoizedState=d;a=a.updateQueue;null!==a&&0===a.expirationTime&&(a.baseState=d)}
var qg={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=ng();d=og(d,a);var e=Pf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Rf(a,e,d);pg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=ng();c=og(c,a);var d=Pf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Rf(a,d,c);pg(a,c)}};function rg(a,b,c,d,e,f){var g=a.stateNode;a=a.type;return"function"===typeof g.shouldComponentUpdate?g.shouldComponentUpdate(c,e,f):a.prototype&&a.prototype.isPureReactComponent?!ea(b,c)||!ea(d,e):!0}
function sg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&qg.enqueueReplaceState(b,b.state,null)}
function tg(a,b){var c=a.type,d=a.stateNode,e=a.pendingProps,f=qf(a);d.props=e;d.state=a.memoizedState;d.refs=ha;d.context=sf(a,f);f=a.updateQueue;null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState);f=a.type.getDerivedStateFromProps;"function"===typeof f&&(mg(a,f,e),d.state=a.memoizedState);"function"===typeof c.getDerivedStateFromProps||"function"===typeof d.getSnapshotBeforeUpdate||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||(c=d.state,"function"===typeof d.componentWillMount&&
d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount(),c!==d.state&&qg.enqueueReplaceState(d,d.state,null),f=a.updateQueue,null!==f&&(Vf(a,f,e,d,b),d.state=a.memoizedState));"function"===typeof d.componentDidMount&&(a.effectTag|=4)}var ug=Array.isArray;
function vg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(2!==c.tag?A("110"):void 0,d=c.stateNode);d?void 0:A("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs===ha?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?A("148"):void 0;c._owner?void 0:A("254",a)}return a}
function wg(a,b){"textarea"!==a.type&&A("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function xg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Af(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Df(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.type===c.type)return d=e(b,c.props,d),d.ref=vg(a,b,c),d.return=a,d;d=Bf(c,a.mode,d);d.ref=vg(a,b,c);d.return=a;return d}function n(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Ef(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function r(a,b,c,d,f){if(null===b||10!==b.tag)return b=Cf(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function w(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Df(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case gc:return c=Bf(b,a.mode,c),c.ref=vg(a,null,b),c.return=a,c;case hc:return b=Ef(b,a.mode,c),b.return=a,b}if(ug(b)||tc(b))return b=Cf(b,a.mode,c,null),b.return=
a,b;wg(a,b)}return null}function P(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case gc:return c.key===e?c.type===ic?r(a,b,c.props.children,d,e):k(a,b,c,d):null;case hc:return c.key===e?n(a,b,c,d):null}if(ug(c)||tc(c))return null!==e?null:r(a,b,c,d,null);wg(a,c)}return null}function nc(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,h(b,a,""+d,e);
if("object"===typeof d&&null!==d){switch(d.$$typeof){case gc:return a=a.get(null===d.key?c:d.key)||null,d.type===ic?r(b,a,d.props.children,e,d.key):k(b,a,d,e);case hc:return a=a.get(null===d.key?c:d.key)||null,n(b,a,d,e)}if(ug(d)||tc(d))return a=a.get(c)||null,r(b,a,d,e,null);wg(b,d)}return null}function Jd(e,g,h,k){for(var u=null,x=null,t=g,q=g=0,n=null;null!==t&&q<h.length;q++){t.index>q?(n=t,t=null):n=t.sibling;var l=P(e,t,h[q],k);if(null===l){null===t&&(t=n);break}a&&t&&null===l.alternate&&b(e,
t);g=f(l,g,q);null===x?u=l:x.sibling=l;x=l;t=n}if(q===h.length)return c(e,t),u;if(null===t){for(;q<h.length;q++)if(t=w(e,h[q],k))g=f(t,g,q),null===x?u=t:x.sibling=t,x=t;return u}for(t=d(e,t);q<h.length;q++)if(n=nc(t,e,q,h[q],k))a&&null!==n.alternate&&t.delete(null===n.key?q:n.key),g=f(n,g,q),null===x?u=n:x.sibling=n,x=n;a&&t.forEach(function(a){return b(e,a)});return u}function E(e,g,h,k){var u=tc(h);"function"!==typeof u?A("150"):void 0;h=u.call(h);null==h?A("151"):void 0;for(var t=u=null,n=g,x=
g=0,y=null,l=h.next();null!==n&&!l.done;x++,l=h.next()){n.index>x?(y=n,n=null):y=n.sibling;var r=P(e,n,l.value,k);if(null===r){n||(n=y);break}a&&n&&null===r.alternate&&b(e,n);g=f(r,g,x);null===t?u=r:t.sibling=r;t=r;n=y}if(l.done)return c(e,n),u;if(null===n){for(;!l.done;x++,l=h.next())l=w(e,l.value,k),null!==l&&(g=f(l,g,x),null===t?u=l:t.sibling=l,t=l);return u}for(n=d(e,n);!l.done;x++,l=h.next())l=nc(n,e,x,l.value,k),null!==l&&(a&&null!==l.alternate&&n.delete(null===l.key?x:l.key),g=f(l,g,x),null===
t?u=l:t.sibling=l,t=l);a&&n.forEach(function(a){return b(e,a)});return u}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ic&&null===f.key;k&&(f=f.props.children);var n="object"===typeof f&&null!==f;if(n)switch(f.$$typeof){case gc:a:{n=f.key;for(k=d;null!==k;){if(k.key===n)if(10===k.tag?f.type===ic:k.type===f.type){c(a,k.sibling);d=e(k,f.type===ic?f.props.children:f.props,h);d.ref=vg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=k.sibling}f.type===ic?(d=Cf(f.props.children,
a.mode,h,f.key),d.return=a,a=d):(h=Bf(f,a.mode,h),h.ref=vg(a,d,f),h.return=a,a=h)}return g(a);case hc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Ef(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=
a,a=d):(c(a,d),d=Df(f,a.mode,h),d.return=a,a=d),g(a);if(ug(f))return Jd(a,d,f,h);if(tc(f))return E(a,d,f,h);n&&wg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 2:case 1:h=a.type,A("152",h.displayName||h.name||"Component")}return c(a,d)}}var yg=xg(!0),zg=xg(!1),Ag=null,Bg=null,Cg=!1;function Dg(a,b){var c=new zf(5,null,null,0);c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Eg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}function Fg(a){if(Cg){var b=Bg;if(b){var c=b;if(!Eg(a,b)){b=jf(c);if(!b||!Eg(a,b)){a.effectTag|=2;Cg=!1;Ag=a;return}Dg(Ag,c)}Ag=a;Bg=kf(b)}else a.effectTag|=2,Cg=!1,Ag=a}}
function Gg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Ag=a}function Hg(a){if(a!==Ag)return!1;if(!Cg)return Gg(a),Cg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!ef(b,a.memoizedProps))for(b=Bg;b;)Dg(a,b),b=jf(b);Gg(a);Bg=Ag?jf(a.stateNode):null;return!0}function Ig(){Bg=Ag=null;Cg=!1}function Q(a,b,c){Jg(a,b,c,b.expirationTime)}function Jg(a,b,c,d){b.child=null===a?zg(b,null,c,d):yg(b,a.child,c,d)}
function Kg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Lg(a,b,c,d,e){Kg(a,b);var f=0!==(b.effectTag&64);if(!c&&!f)return d&&yf(b,!1),R(a,b);c=b.stateNode;ec.current=b;var g=f?null:c.render();b.effectTag|=1;f&&(Jg(a,b,null,e),b.child=null);Jg(a,b,g,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&yf(b,!0);return b.child}
function Mg(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);jg(a,b.containerInfo)}
function Ng(a,b,c,d){var e=a.child;null!==e&&(e.return=a);for(;null!==e;){switch(e.tag){case 12:var f=e.stateNode|0;if(e.type===b&&0!==(f&c)){for(f=e;null!==f;){var g=f.alternate;if(0===f.expirationTime||f.expirationTime>d)f.expirationTime=d,null!==g&&(0===g.expirationTime||g.expirationTime>d)&&(g.expirationTime=d);else if(null!==g&&(0===g.expirationTime||g.expirationTime>d))g.expirationTime=d;else break;f=f.return}f=null}else f=e.child;break;case 13:f=e.type===a.type?null:e.child;break;default:f=
e.child}if(null!==f)f.return=e;else for(f=e;null!==f;){if(f===a){f=null;break}e=f.sibling;if(null!==e){e.return=f.return;f=e;break}f=f.return}e=f}}
function Rg(a,b,c){var d=b.type._context,e=b.pendingProps,f=b.memoizedProps,g=!0;if(O.current)g=!1;else if(f===e)return b.stateNode=0,bg(b),R(a,b);var h=e.value;b.memoizedProps=e;if(null===f)h=1073741823;else if(f.value===e.value){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else{var k=f.value;if(k===h&&(0!==k||1/k===1/h)||k!==k&&h!==h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b);h=0}else if(h="function"===typeof d._calculateChangedBits?d._calculateChangedBits(k,
h):1073741823,h|=0,0===h){if(f.children===e.children&&g)return b.stateNode=0,bg(b),R(a,b)}else Ng(b,d,h,c)}b.stateNode=h;bg(b);Q(a,b,e.children);return b.child}function R(a,b){null!==a&&b.child!==a.child?A("153"):void 0;if(null!==b.child){a=b.child;var c=Af(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Af(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function Sg(a,b,c){if(0===b.expirationTime||b.expirationTime>c){switch(b.tag){case 3:Mg(b);break;case 2:xf(b);break;case 4:jg(b,b.stateNode.containerInfo);break;case 13:bg(b)}return null}switch(b.tag){case 0:null!==a?A("155"):void 0;var d=b.type,e=b.pendingProps,f=qf(b);f=sf(b,f);d=d(e,f);b.effectTag|=1;"object"===typeof d&&null!==d&&"function"===typeof d.render&&void 0===d.$$typeof?(f=b.type,b.tag=2,b.memoizedState=null!==d.state&&void 0!==d.state?d.state:null,f=f.getDerivedStateFromProps,"function"===
typeof f&&mg(b,f,e),e=xf(b),d.updater=qg,b.stateNode=d,d._reactInternalFiber=b,tg(b,c),a=Lg(a,b,!0,e,c)):(b.tag=1,Q(a,b,d),b.memoizedProps=e,a=b.child);return a;case 1:return e=b.type,c=b.pendingProps,O.current||b.memoizedProps!==c?(d=qf(b),d=sf(b,d),e=e(c,d),b.effectTag|=1,Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 2:e=xf(b);if(null===a)if(null===b.stateNode){var g=b.pendingProps,h=b.type;d=qf(b);var k=2===b.tag&&null!=b.type.contextTypes;f=k?sf(b,d):ha;g=new h(g,f);b.memoizedState=null!==
g.state&&void 0!==g.state?g.state:null;g.updater=qg;b.stateNode=g;g._reactInternalFiber=b;k&&(k=b.stateNode,k.__reactInternalMemoizedUnmaskedChildContext=d,k.__reactInternalMemoizedMaskedChildContext=f);tg(b,c);d=!0}else{h=b.type;d=b.stateNode;k=b.memoizedProps;f=b.pendingProps;d.props=k;var n=d.context;g=qf(b);g=sf(b,g);var r=h.getDerivedStateFromProps;(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(k!==f||n!==g)&&sg(b,d,f,g);Mf=!1;var w=b.memoizedState;n=d.state=w;var P=b.updateQueue;null!==P&&(Vf(b,P,f,d,c),n=b.memoizedState);k!==f||w!==n||O.current||Mf?("function"===typeof r&&(mg(b,r,f),n=b.memoizedState),(k=Mf||rg(b,k,f,w,n,g))?(h||"function"!==typeof d.UNSAFE_componentWillMount&&"function"!==typeof d.componentWillMount||("function"===typeof d.componentWillMount&&d.componentWillMount(),"function"===typeof d.UNSAFE_componentWillMount&&d.UNSAFE_componentWillMount()),"function"===typeof d.componentDidMount&&
(b.effectTag|=4)):("function"===typeof d.componentDidMount&&(b.effectTag|=4),b.memoizedProps=f,b.memoizedState=n),d.props=f,d.state=n,d.context=g,d=k):("function"===typeof d.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.type,d=b.stateNode,f=b.memoizedProps,k=b.pendingProps,d.props=f,n=d.context,g=qf(b),g=sf(b,g),r=h.getDerivedStateFromProps,(h="function"===typeof r||"function"===typeof d.getSnapshotBeforeUpdate)||"function"!==typeof d.UNSAFE_componentWillReceiveProps&&"function"!==typeof d.componentWillReceiveProps||
(f!==k||n!==g)&&sg(b,d,k,g),Mf=!1,n=b.memoizedState,w=d.state=n,P=b.updateQueue,null!==P&&(Vf(b,P,k,d,c),w=b.memoizedState),f!==k||n!==w||O.current||Mf?("function"===typeof r&&(mg(b,r,k),w=b.memoizedState),(r=Mf||rg(b,f,k,n,w,g))?(h||"function"!==typeof d.UNSAFE_componentWillUpdate&&"function"!==typeof d.componentWillUpdate||("function"===typeof d.componentWillUpdate&&d.componentWillUpdate(k,w,g),"function"===typeof d.UNSAFE_componentWillUpdate&&d.UNSAFE_componentWillUpdate(k,w,g)),"function"===typeof d.componentDidUpdate&&
(b.effectTag|=4),"function"===typeof d.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),b.memoizedProps=k,b.memoizedState=w),d.props=k,d.state=w,d.context=g,d=r):("function"!==typeof d.componentDidUpdate||f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=4),"function"!==typeof d.getSnapshotBeforeUpdate||
f===a.memoizedProps&&n===a.memoizedState||(b.effectTag|=256),d=!1);return Lg(a,b,d,e,c);case 3:Mg(b);e=b.updateQueue;if(null!==e)if(d=b.memoizedState,d=null!==d?d.element:null,Vf(b,e,b.pendingProps,null,c),e=b.memoizedState.element,e===d)Ig(),a=R(a,b);else{d=b.stateNode;if(d=(null===a||null===a.child)&&d.hydrate)Bg=kf(b.stateNode.containerInfo),Ag=b,d=Cg=!0;d?(b.effectTag|=2,b.child=zg(b,null,e,c)):(Ig(),Q(a,b,e));a=b.child}else Ig(),a=R(a,b);return a;case 5:a:{hg(gg.current);e=hg(eg.current);d=Ie(e,
b.type);e!==d&&(N(fg,b,b),N(eg,d,b));null===a&&Fg(b);e=b.type;k=b.memoizedProps;d=b.pendingProps;f=null!==a?a.memoizedProps:null;if(!O.current&&k===d){if(k=b.mode&1&&!!d.hidden)b.expirationTime=1073741823;if(!k||1073741823!==c){a=R(a,b);break a}}k=d.children;ef(e,d)?k=null:f&&ef(e,f)&&(b.effectTag|=16);Kg(a,b);1073741823!==c&&b.mode&1&&d.hidden?(b.expirationTime=1073741823,b.memoizedProps=d,a=null):(Q(a,b,k),b.memoizedProps=d,a=b.child)}return a;case 6:return null===a&&Fg(b),b.memoizedProps=b.pendingProps,
null;case 16:return null;case 4:return jg(b,b.stateNode.containerInfo),e=b.pendingProps,O.current||b.memoizedProps!==e?(null===a?b.child=yg(b,null,e,c):Q(a,b,e),b.memoizedProps=e,a=b.child):a=R(a,b),a;case 14:return e=b.type.render,c=b.pendingProps,d=b.ref,O.current||b.memoizedProps!==c||d!==(null!==a?a.ref:null)?(e=e(c,d),Q(a,b,e),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 10:return c=b.pendingProps,O.current||b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 11:return c=
b.pendingProps.children,O.current||null!==c&&b.memoizedProps!==c?(Q(a,b,c),b.memoizedProps=c,a=b.child):a=R(a,b),a;case 15:return c=b.pendingProps,b.memoizedProps===c?a=R(a,b):(Q(a,b,c.children),b.memoizedProps=c,a=b.child),a;case 13:return Rg(a,b,c);case 12:a:if(d=b.type,f=b.pendingProps,k=b.memoizedProps,e=d._currentValue,g=d._changedBits,O.current||0!==g||k!==f){b.memoizedProps=f;h=f.unstable_observedBits;if(void 0===h||null===h)h=1073741823;b.stateNode=h;if(0!==(g&h))Ng(b,d,g,c);else if(k===f){a=
R(a,b);break a}c=f.children;c=c(e);b.effectTag|=1;Q(a,b,c);a=b.child}else a=R(a,b);return a;default:A("156")}}function Tg(a){a.effectTag|=4}var Ug=void 0,Vg=void 0,Wg=void 0;Ug=function(){};Vg=function(a,b,c){(b.updateQueue=c)&&Tg(b)};Wg=function(a,b,c,d){c!==d&&Tg(b)};
function Xg(a,b){var c=b.pendingProps;switch(b.tag){case 1:return null;case 2:return tf(b),null;case 3:kg(b);uf(b);var d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)Hg(b),b.effectTag&=-3;Ug(b);return null;case 5:lg(b);d=hg(gg.current);var e=b.type;if(null!==a&&null!=b.stateNode){var f=a.memoizedProps,g=b.stateNode,h=hg(eg.current);g=Xe(g,e,f,c,d);Vg(a,b,g,e,f,c,d,h);a.ref!==b.ref&&(b.effectTag|=128)}else{if(!c)return null===b.stateNode?
A("166"):void 0,null;a=hg(eg.current);if(Hg(b))c=b.stateNode,e=b.type,f=b.memoizedProps,c[C]=b,c[Ma]=f,d=Ze(c,e,f,a,d),b.updateQueue=d,null!==d&&Tg(b);else{a=Ue(e,c,d,a);a[C]=b;a[Ma]=c;a:for(f=b.child;null!==f;){if(5===f.tag||6===f.tag)a.appendChild(f.stateNode);else if(4!==f.tag&&null!==f.child){f.child.return=f;f=f.child;continue}if(f===b)break;for(;null===f.sibling;){if(null===f.return||f.return===b)break a;f=f.return}f.sibling.return=f.return;f=f.sibling}We(a,e,c,d);df(e,c)&&Tg(b);b.stateNode=
a}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)Wg(a,b,a.memoizedProps,c);else{if("string"!==typeof c)return null===b.stateNode?A("166"):void 0,null;d=hg(gg.current);hg(eg.current);Hg(b)?(d=b.stateNode,c=b.memoizedProps,d[C]=b,$e(d,c)&&Tg(b)):(d=Ve(c,d),d[C]=b,b.stateNode=d)}return null;case 14:return null;case 16:return null;case 10:return null;case 11:return null;case 15:return null;case 4:return kg(b),Ug(b),null;case 13:return cg(b),null;case 12:return null;case 0:A("167");
default:A("156")}}function Yg(a,b){var c=b.source;null===b.stack&&null!==c&&vc(c);null!==c&&uc(c);b=b.value;null!==a&&2===a.tag&&uc(a);try{b&&b.suppressReactErrorLogging||console.error(b)}catch(d){d&&d.suppressReactErrorLogging||console.error(d)}}function Zg(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){$g(a,c)}else b.current=null}
function ah(a){"function"===typeof Lf&&Lf(a);switch(a.tag){case 2:Zg(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){$g(a,c)}break;case 5:Zg(a);break;case 4:bh(a)}}function ch(a){return 5===a.tag||3===a.tag||4===a.tag}
function dh(a){a:{for(var b=a.return;null!==b;){if(ch(b)){var c=b;break a}b=b.return}A("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:A("161")}c.effectTag&16&&(Le(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ch(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(f=b,g=e.stateNode,8===f.nodeType?f.parentNode.insertBefore(g,f):f.appendChild(g)):b.appendChild(e.stateNode);else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===
e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function bh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?A("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(ah(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?d=b.stateNode.containerInfo:ah(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function eh(a,b){switch(b.tag){case 2:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&(c[Ma]=d,Ye(c,f,e,a,d))}break;case 6:null===b.stateNode?A("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 15:break;case 16:break;default:A("163")}}function fh(a,b,c){c=Pf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gh(d);Yg(a,b)};return c}
function hh(a,b,c){c=Pf(c);c.tag=3;var d=a.stateNode;null!==d&&"function"===typeof d.componentDidCatch&&(c.callback=function(){null===ih?ih=new Set([this]):ih.add(this);var c=b.value,d=b.stack;Yg(a,b);this.componentDidCatch(c,{componentStack:null!==d?d:""})});return c}
function jh(a,b,c,d,e,f){c.effectTag|=512;c.firstEffect=c.lastEffect=null;d=Yf(d,c);a=b;do{switch(a.tag){case 3:a.effectTag|=1024;d=fh(a,d,f);Sf(a,d,f);return;case 2:if(b=d,c=a.stateNode,0===(a.effectTag&64)&&null!==c&&"function"===typeof c.componentDidCatch&&(null===ih||!ih.has(c))){a.effectTag|=1024;d=hh(a,b,f);Sf(a,d,f);return}}a=a.return}while(null!==a)}
function kh(a){switch(a.tag){case 2:tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return kg(a),uf(a),b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 5:return lg(a),null;case 16:return b=a.effectTag,b&1024?(a.effectTag=b&-1025|64,a):null;case 4:return kg(a),null;case 13:return cg(a),null;default:return null}}var lh=ff(),mh=2,nh=lh,oh=0,ph=0,qh=!1,S=null,rh=null,T=0,sh=-1,th=!1,U=null,uh=!1,vh=!1,ih=null;
function wh(){if(null!==S)for(var a=S.return;null!==a;){var b=a;switch(b.tag){case 2:tf(b);break;case 3:kg(b);uf(b);break;case 5:lg(b);break;case 4:kg(b);break;case 13:cg(b)}a=a.return}rh=null;T=0;sh=-1;th=!1;S=null;vh=!1}
function xh(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){b=Xg(b,a,T);var e=a;if(1073741823===T||1073741823!==e.expirationTime){var f=0;switch(e.tag){case 3:case 2:var g=e.updateQueue;null!==g&&(f=g.expirationTime)}for(g=e.child;null!==g;)0!==g.expirationTime&&(0===f||f>g.expirationTime)&&(f=g.expirationTime),g=g.sibling;e.expirationTime=f}if(null!==b)return b;null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&
(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{vh=!0;break}}else{a=kh(a,th,T);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512);if(null!==d)return d;if(null!==c)a=c;else break}}return null}
function yh(a){var b=Sg(a.alternate,a,T);null===b&&(b=xh(a));ec.current=null;return b}
function zh(a,b,c){qh?A("243"):void 0;qh=!0;if(b!==T||a!==rh||null===S)wh(),rh=a,T=b,sh=-1,S=Af(rh.current,null,T),a.pendingCommitExpirationTime=0;var d=!1;th=!c||T<=mh;do{try{if(c)for(;null!==S&&!Ah();)S=yh(S);else for(;null!==S;)S=yh(S)}catch(f){if(null===S)d=!0,gh(f);else{null===S?A("271"):void 0;c=S;var e=c.return;if(null===e){d=!0;gh(f);break}jh(a,e,c,f,th,T,nh);S=xh(c)}}break}while(1);qh=!1;if(d)return null;if(null===S){if(vh)return a.pendingCommitExpirationTime=b,a.current.alternate;th?A("262"):
void 0;0<=sh&&setTimeout(function(){var b=a.current.expirationTime;0!==b&&(0===a.remainingExpirationTime||a.remainingExpirationTime<b)&&Bh(a,b)},sh);Ch(a.current.expirationTime)}return null}
function $g(a,b){var c;a:{qh&&!uh?A("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 2:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromCatch||"function"===typeof d.componentDidCatch&&(null===ih||!ih.has(d))){a=Yf(b,a);a=hh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}break;case 3:a=Yf(b,a);a=fh(c,a,1);Rf(c,a,1);pg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=Yf(b,a),c=fh(a,c,1),Rf(a,c,1),pg(a,1));c=void 0}return c}
function Dh(){var a=2+25*(((ng()-2+500)/25|0)+1);a<=oh&&(a=oh+1);return oh=a}function og(a,b){a=0!==ph?ph:qh?uh?1:T:b.mode&1?Eh?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1):1;Eh&&(0===Fh||a>Fh)&&(Fh=a);return a}
function pg(a,b){for(;null!==a;){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;null!==a.alternate&&(0===a.alternate.expirationTime||a.alternate.expirationTime>b)&&(a.alternate.expirationTime=b);if(null===a.return)if(3===a.tag){var c=a.stateNode;!qh&&0!==T&&b<T&&wh();var d=c.current.expirationTime;qh&&!uh&&rh===c||Bh(c,d);Gh>Hh&&A("185")}else break;a=a.return}}function ng(){nh=ff()-lh;return mh=(nh/10|0)+2}
function Ih(a){var b=ph;ph=2+25*(((ng()-2+500)/25|0)+1);try{return a()}finally{ph=b}}function Jh(a,b,c,d,e){var f=ph;ph=1;try{return a(b,c,d,e)}finally{ph=f}}var Kh=null,V=null,Lh=0,Mh=void 0,W=!1,X=null,Y=0,Fh=0,Nh=!1,Oh=!1,Ph=null,Qh=null,Z=!1,Rh=!1,Eh=!1,Sh=null,Hh=1E3,Gh=0,Th=1;function Uh(a){if(0!==Lh){if(a>Lh)return;null!==Mh&&hf(Mh)}var b=ff()-lh;Lh=a;Mh=gf(Vh,{timeout:10*(a-2)-b})}
function Bh(a,b){if(null===a.nextScheduledRoot)a.remainingExpirationTime=b,null===V?(Kh=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=Kh);else{var c=a.remainingExpirationTime;if(0===c||b<c)a.remainingExpirationTime=b}W||(Z?Rh&&(X=a,Y=1,Wh(a,1,!1)):1===b?Xh():Uh(b))}
function Yh(){var a=0,b=null;if(null!==V)for(var c=V,d=Kh;null!==d;){var e=d.remainingExpirationTime;if(0===e){null===c||null===V?A("244"):void 0;if(d===d.nextScheduledRoot){Kh=V=d.nextScheduledRoot=null;break}else if(d===Kh)Kh=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=Kh;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;
c=d;d=d.nextScheduledRoot}}c=X;null!==c&&c===b&&1===a?Gh++:Gh=0;X=b;Y=a}function Vh(a){Zh(0,!0,a)}function Xh(){Zh(1,!1,null)}function Zh(a,b,c){Qh=c;Yh();if(b)for(;null!==X&&0!==Y&&(0===a||a>=Y)&&(!Nh||ng()>=Y);)ng(),Wh(X,Y,!Nh),Yh();else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Wh(X,Y,!1),Yh();null!==Qh&&(Lh=0,Mh=null);0!==Y&&Uh(Y);Qh=null;Nh=!1;$h()}function ai(a,b){W?A("253"):void 0;X=a;Y=b;Wh(a,b,!1);Xh();$h()}
function $h(){Gh=0;if(null!==Sh){var a=Sh;Sh=null;for(var b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){Oh||(Oh=!0,Ph=d)}}}if(Oh)throw a=Ph,Ph=null,Oh=!1,a;}function Wh(a,b,c){W?A("245"):void 0;W=!0;c?(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!0),null!==c&&(Ah()?a.finishedWork=c:bi(a,c,b)))):(c=a.finishedWork,null!==c?bi(a,c,b):(c=zh(a,b,!1),null!==c&&bi(a,c,b)));W=!1}
function bi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===Sh?Sh=[d]:Sh.push(d),d._defer)){a.finishedWork=b;a.remainingExpirationTime=0;return}a.finishedWork=null;uh=qh=!0;c=b.stateNode;c.current===b?A("177"):void 0;d=c.pendingCommitExpirationTime;0===d?A("261"):void 0;c.pendingCommitExpirationTime=0;ng();ec.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var e=b.firstEffect}else e=b;else e=b.firstEffect;bf=Id;var f=da();if(Vd(f)){if("selectionStart"in
f)var g={start:f.selectionStart,end:f.selectionEnd};else a:{var h=window.getSelection&&window.getSelection();if(h&&0!==h.rangeCount){g=h.anchorNode;var k=h.anchorOffset,n=h.focusNode;h=h.focusOffset;try{g.nodeType,n.nodeType}catch(Wa){g=null;break a}var r=0,w=-1,P=-1,nc=0,Jd=0,E=f,t=null;b:for(;;){for(var x;;){E!==g||0!==k&&3!==E.nodeType||(w=r+k);E!==n||0!==h&&3!==E.nodeType||(P=r+h);3===E.nodeType&&(r+=E.nodeValue.length);if(null===(x=E.firstChild))break;t=E;E=x}for(;;){if(E===f)break b;t===g&&
++nc===k&&(w=r);t===n&&++Jd===h&&(P=r);if(null!==(x=E.nextSibling))break;E=t;t=E.parentNode}E=x}g=-1===w||-1===P?null:{start:w,end:P}}else g=null}g=g||{start:0,end:0}}else g=null;cf={focusedElem:f,selectionRange:g};Kd(!1);for(U=e;null!==U;){f=!1;g=void 0;try{for(;null!==U;){if(U.effectTag&256){var u=U.alternate;k=U;switch(k.tag){case 2:if(k.effectTag&256&&null!==u){var y=u.memoizedProps,D=u.memoizedState,ja=k.stateNode;ja.props=k.memoizedProps;ja.state=k.memoizedState;var ni=ja.getSnapshotBeforeUpdate(y,
D);ja.__reactInternalSnapshotBeforeUpdate=ni}break;case 3:case 5:case 6:case 4:break;default:A("163")}}U=U.nextEffect}}catch(Wa){f=!0,g=Wa}f&&(null===U?A("178"):void 0,$g(U,g),null!==U&&(U=U.nextEffect))}for(U=e;null!==U;){u=!1;y=void 0;try{for(;null!==U;){var q=U.effectTag;q&16&&Le(U.stateNode,"");if(q&128){var z=U.alternate;if(null!==z){var l=z.ref;null!==l&&("function"===typeof l?l(null):l.current=null)}}switch(q&14){case 2:dh(U);U.effectTag&=-3;break;case 6:dh(U);U.effectTag&=-3;eh(U.alternate,
U);break;case 4:eh(U.alternate,U);break;case 8:D=U,bh(D),D.return=null,D.child=null,D.alternate&&(D.alternate.child=null,D.alternate.return=null)}U=U.nextEffect}}catch(Wa){u=!0,y=Wa}u&&(null===U?A("178"):void 0,$g(U,y),null!==U&&(U=U.nextEffect))}l=cf;z=da();q=l.focusedElem;u=l.selectionRange;if(z!==q&&fa(document.documentElement,q)){null!==u&&Vd(q)&&(z=u.start,l=u.end,void 0===l&&(l=z),"selectionStart"in q?(q.selectionStart=z,q.selectionEnd=Math.min(l,q.value.length)):window.getSelection&&(z=window.getSelection(),
y=q[lb()].length,l=Math.min(u.start,y),u=void 0===u.end?l:Math.min(u.end,y),!z.extend&&l>u&&(y=u,u=l,l=y),y=Ud(q,l),D=Ud(q,u),y&&D&&(1!==z.rangeCount||z.anchorNode!==y.node||z.anchorOffset!==y.offset||z.focusNode!==D.node||z.focusOffset!==D.offset)&&(ja=document.createRange(),ja.setStart(y.node,y.offset),z.removeAllRanges(),l>u?(z.addRange(ja),z.extend(D.node,D.offset)):(ja.setEnd(D.node,D.offset),z.addRange(ja)))));z=[];for(l=q;l=l.parentNode;)1===l.nodeType&&z.push({element:l,left:l.scrollLeft,
top:l.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<z.length;q++)l=z[q],l.element.scrollLeft=l.left,l.element.scrollTop=l.top}cf=null;Kd(bf);bf=null;c.current=b;for(U=e;null!==U;){e=!1;q=void 0;try{for(z=d;null!==U;){var ig=U.effectTag;if(ig&36){var oc=U.alternate;l=U;u=z;switch(l.tag){case 2:var ca=l.stateNode;if(l.effectTag&4)if(null===oc)ca.props=l.memoizedProps,ca.state=l.memoizedState,ca.componentDidMount();else{var xi=oc.memoizedProps,yi=oc.memoizedState;ca.props=l.memoizedProps;
ca.state=l.memoizedState;ca.componentDidUpdate(xi,yi,ca.__reactInternalSnapshotBeforeUpdate)}var Og=l.updateQueue;null!==Og&&(ca.props=l.memoizedProps,ca.state=l.memoizedState,Xf(l,Og,ca,u));break;case 3:var Pg=l.updateQueue;if(null!==Pg){y=null;if(null!==l.child)switch(l.child.tag){case 5:y=l.child.stateNode;break;case 2:y=l.child.stateNode}Xf(l,Pg,y,u)}break;case 5:var zi=l.stateNode;null===oc&&l.effectTag&4&&df(l.type,l.memoizedProps)&&zi.focus();break;case 6:break;case 4:break;case 15:break;case 16:break;
default:A("163")}}if(ig&128){l=void 0;var yc=U.ref;if(null!==yc){var Qg=U.stateNode;switch(U.tag){case 5:l=Qg;break;default:l=Qg}"function"===typeof yc?yc(l):yc.current=l}}var Ai=U.nextEffect;U.nextEffect=null;U=Ai}}catch(Wa){e=!0,q=Wa}e&&(null===U?A("178"):void 0,$g(U,q),null!==U&&(U=U.nextEffect))}qh=uh=!1;"function"===typeof Kf&&Kf(b.stateNode);b=c.current.expirationTime;0===b&&(ih=null);a.remainingExpirationTime=b}function Ah(){return null===Qh||Qh.timeRemaining()>Th?!1:Nh=!0}
function gh(a){null===X?A("246"):void 0;X.remainingExpirationTime=0;Oh||(Oh=!0,Ph=a)}function Ch(a){null===X?A("246"):void 0;X.remainingExpirationTime=a}function ci(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Xh()}}function di(a,b){if(Z&&!Rh){Rh=!0;try{return a(b)}finally{Rh=!1}}return a(b)}function ei(a,b){W?A("187"):void 0;var c=Z;Z=!0;try{return Jh(a,b)}finally{Z=c,Xh()}}
function fi(a,b,c){if(Eh)return a(b,c);Z||W||0===Fh||(Zh(Fh,!1,null),Fh=0);var d=Eh,e=Z;Z=Eh=!0;try{return a(b,c)}finally{Eh=d,(Z=e)||W||Xh()}}function gi(a){var b=Z;Z=!0;try{Jh(a)}finally{(Z=b)||W||Zh(1,!1,null)}}
function hi(a,b,c,d,e){var f=b.current;if(c){c=c._reactInternalFiber;var g;b:{2===kd(c)&&2===c.tag?void 0:A("170");for(g=c;3!==g.tag;){if(rf(g)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}(g=g.return)?void 0:A("171")}g=g.stateNode.context}c=rf(c)?wf(c,g):g}else c=ha;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Pf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);Rf(f,e,d);pg(f,d);return d}
function ii(a){var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?A("188"):A("268",Object.keys(a)));a=nd(b);return null===a?null:a.stateNode}function ji(a,b,c,d){var e=b.current,f=ng();e=og(f,e);return hi(a,b,c,e,d)}function ki(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}
function li(a){var b=a.findFiberByHostInstance;return Jf(p({},a,{findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))}
var mi={updateContainerAtExpirationTime:hi,createContainer:function(a,b,c){return Ff(a,b,c)},updateContainer:ji,flushRoot:ai,requestWork:Bh,computeUniqueAsyncExpiration:Dh,batchedUpdates:ci,unbatchedUpdates:di,deferredUpdates:Ih,syncUpdates:Jh,interactiveUpdates:fi,flushInteractiveUpdates:function(){W||0===Fh||(Zh(Fh,!1,null),Fh=0)},flushControlled:gi,flushSync:ei,getPublicRootInstance:ki,findHostInstance:ii,findHostInstanceWithNoPortals:function(a){a=od(a);return null===a?null:a.stateNode},injectIntoDevTools:li};
function oi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:hc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}Kb.injectFiberControlledHostComponent(af);function pi(a){this._expirationTime=Dh();this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}
pi.prototype.render=function(a){this._defer?void 0:A("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new qi;hi(a,b,null,c,d._onCommit);return d};pi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
pi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:A("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?A("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;ai(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};pi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function qi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}qi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
qi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?A("191",c):void 0;c()}}};function ri(a,b,c){this._internalRoot=Ff(a,b,c)}ri.prototype.render=function(a,b){var c=this._internalRoot,d=new qi;b=void 0===b?null:b;null!==b&&d.then(b);ji(a,c,null,d._onCommit);return d};
ri.prototype.unmount=function(a){var b=this._internalRoot,c=new qi;a=void 0===a?null:a;null!==a&&c.then(a);ji(null,b,null,c._onCommit);return c};ri.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new qi;c=void 0===c?null:c;null!==c&&e.then(c);ji(b,d,a,e._onCommit);return e};
ri.prototype.createBatch=function(){var a=new pi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function si(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Sb=mi.batchedUpdates;Tb=mi.interactiveUpdates;Ub=mi.flushInteractiveUpdates;
function ti(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new ri(a,!1,b)}
function ui(a,b,c,d,e){si(c)?void 0:A("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=ki(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=ti(c,d);if("function"===typeof e){var h=e;e=function(){var a=ki(f._internalRoot);h.call(a)}}di(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return ki(f._internalRoot)}
function vi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;si(b)?void 0:A("200");return oi(a,b,null,c)}
var wi={createPortal:vi,findDOMNode:function(a){return null==a?null:1===a.nodeType?a:ii(a)},hydrate:function(a,b,c){return ui(null,a,b,!0,c)},render:function(a,b,c){return ui(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?A("38"):void 0;return ui(a,b,c,!1,d)},unmountComponentAtNode:function(a){si(a)?void 0:A("40");return a._reactRootContainer?(di(function(){ui(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return vi.apply(void 0,
arguments)},unstable_batchedUpdates:ci,unstable_deferredUpdates:Ih,unstable_interactiveUpdates:fi,flushSync:ei,unstable_flushControlled:gi,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Ka,EventPluginRegistry:va,EventPropagators:$a,ReactControlledComponent:Rb,ReactDOMComponentTree:Qa,ReactDOMEventListener:Od},unstable_createRoot:function(a,b){return new ri(a,!0,null!=b&&!0===b.hydrate)}};li({findFiberByHostInstance:Na,bundleType:0,version:"16.4.2",rendererPackageName:"react-dom"});
var Bi={default:wi},Ci=Bi&&wi||Bi;module.exports=Ci.default?Ci.default:Ci;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(99);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(100);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_chat_app_component__ = __webpack_require__(103);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import './App.css';
var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_chat_app_component__["a" /* default */],null);}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_App_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_css_App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_css_App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_progress_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_css_progress_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_css_progress_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__chatMessageComponent__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__header_components_header_component__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums_action_types_HeaderActionType__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_components_popup__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_components_confirmation_box_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__services_tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__enums_trackingKey__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatApp=function(_Component){_inherits(ChatApp,_Component);function ChatApp(props){_classCallCheck(this,ChatApp);var _this=_possibleConstructorReturn(this,(ChatApp.__proto__||Object.getPrototypeOf(ChatApp)).call(this,props));_this.handleHeaderClick=function(params){__WEBPACK_IMPORTED_MODULE_10__services_idle_timeout_service__["a" /* default */].updateIdleState();if(params.actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_HeaderActionType__["a" /* default */].MINIMIZE){_this.setState({isMinimize:true,popupVisible:false});}else if(params.actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_HeaderActionType__["a" /* default */].MAXIMIZE){_this.setState({isMinimize:false,popupVisible:true});}else if(params.actionType===__WEBPACK_IMPORTED_MODULE_6__enums_action_types_HeaderActionType__["a" /* default */].CLOSE){if(!__WEBPACK_IMPORTED_MODULE_7__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){window.parent.postMessage("MAXIMIZE",__WEBPACK_IMPORTED_MODULE_8__config_config__["a" /* default */].parentOrigin);}_this.setState({isMinimize:false,showCloseBanner:true,popupVisible:true,showCloseChatConfirmationPopup:true});_this.showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_components_confirmation_box_component__["a" /* default */],{title:'Close Chat',messages:['Do you wish to close this session?'],buttons:[{label:'NO',onClick:function onClick(){_this.showPopup(undefined);_this.submitCloseSessionFromUser('NO');}},{highlight:true,label:'YES',onClick:function onClick(){_this.showPopup(undefined);_this.submitCloseSessionFromUser('YES');}}]}));}};_this.submitCloseSessionFromUser=function(value){__WEBPACK_IMPORTED_MODULE_10__services_idle_timeout_service__["a" /* default */].updateIdleState();if(value==="YES"){window.parent.postMessage("CLOSE_CHAT_WINDOW",__WEBPACK_IMPORTED_MODULE_8__config_config__["a" /* default */].parentOrigin);if(_this.feedbackRequired&&_this.trackingKey){__WEBPACK_IMPORTED_MODULE_13__services_tracking_middleware_service__["a" /* default */].trackEvent(_this.trackingKey);}_this.setState({isChatOpen:false,showCloseChatConfirmationPopup:false});// TRACKING CLOSE CHAT YES SELECT
__WEBPACK_IMPORTED_MODULE_13__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_14__enums_trackingKey__["a" /* default */].CLOSE_CHAT_YES);}else{_this.setState({showCloseBanner:false,showCloseChatConfirmationPopup:false});// TRACKING CLOSE CHAT NO SELECT
__WEBPACK_IMPORTED_MODULE_13__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_14__enums_trackingKey__["a" /* default */].CLOSE_CHAT_NO);}};_this.showPopup=function(popup_comp){if(popup_comp)_this.setState({show_popup:true,popup_data:popup_comp});else _this.setState({show_popup:false,popup_data:undefined});};_this.setFeedbackRequired=function(feedbackRequired,trackingKey){_this.feedbackRequired=feedbackRequired;_this.trackingKey=trackingKey;};window.pageName=__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].TRACKING_EVENTS_CONSTANTS.pageName;__WEBPACK_IMPORTED_MODULE_7__services_global_store_service__["a" /* default */].set("platformType",__WEBPACK_IMPORTED_MODULE_9__services_util_service__["a" /* default */].getPlatformType());// set global app context 
if(window.MyAirtelChatAppReact){__WEBPACK_IMPORTED_MODULE_7__services_global_store_service__["a" /* default */].set("APP_CONTEXT",window.MyAirtelChatAppReact);}else if(window.MyAirtelAppReact){__WEBPACK_IMPORTED_MODULE_7__services_global_store_service__["a" /* default */].set("APP_CONTEXT",window.MyAirtelAppReact);}else{__WEBPACK_IMPORTED_MODULE_7__services_global_store_service__["a" /* default */].set("APP_CONTEXT",undefined);}_this.feedbackRequired=false;_this.state={isChatOpen:true,showCloseBanner:false,isMinimize:false,showHeader:__WEBPACK_IMPORTED_MODULE_7__services_global_store_service__["a" /* default */].get("APP_CONTEXT")?false:true,isFocussedInApp:false,popupVisible:true,showCloseChatConfirmationPopup:false};__WEBPACK_IMPORTED_MODULE_10__services_idle_timeout_service__["a" /* default */].trackIdleChat();return _this;}_createClass(ChatApp,[{key:'render',value:function render(){var showheader=this.state.showHeader;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.isMinimize?'open':''},!this.state.show_multiple_user_accounts_screen&&this.state.isChatOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('main',{id:'main',style:{maxWidth:'100%',maxHeight:'100%'}},showheader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__header_components_header_component__["a" /* default */],{handleHeaderClick:this.handleHeaderClick,isMinimized:this.state.isMinimize}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__chatMessageComponent__["a" /* default */],{ref:function ref(ourComponent){window.ourComponent=ourComponent;},isMaximized:!this.state.isMinimize,hideMessagePopup:this.state.show_popup,showCloseChatConfirmationPopup:this.state.showCloseChatConfirmationPopup,setFeedbackRequired:this.setFeedbackRequired})):null,this.state.show_popup&&this.state.popup_data&&Object(__WEBPACK_IMPORTED_MODULE_11__common_components_popup__["a" /* default */])(this.state.popup_data,this.state.popupVisible));}}]);return ChatApp;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatApp);

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_chooseAction__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_execute_action__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__message_components_loading_response_component__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_db_read_write_service__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scenario_options_components_options_response_component__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums_action_types_ChatActionType__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__message_components_retry_message_component__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_components_popup__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_components_confirmation_box_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__services_chooseComponentToRender_service__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_initialize_chatbot_data_service__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_UICalculations_service__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__bottom_component__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__services_handle_chat_history_from_db_service__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__services_handle_user_login_service__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__enums_ComponentTypes__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__objectClasses_user_action_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__enums_UserActionType__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__enums_TrackingPlatform__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatMessage=function(_Component){_inherits(ChatMessage,_Component);function ChatMessage(props){_classCallCheck(this,ChatMessage);var _this=_possibleConstructorReturn(this,(ChatMessage.__proto__||Object.getPrototypeOf(ChatMessage)).call(this,props));_this.readReturnMethod=function(data){Object(__WEBPACK_IMPORTED_MODULE_22__services_handle_chat_history_from_db_service__["a" /* handleReadReturnFromDB */])({data:data,message_comp:_this,readOnScroll:_this.state.readOnScroll});if(_this.state.readOnScroll){setTimeout(function(){_this.setState({readFromDBReturned:true});},300);}};_this.addNewMessages=function(_ref){var new_messages=_ref.new_messages,pop_count=_ref.pop_count;//new_messages is an array of messages
var messages_arr=_this.state.messages_arr;if(pop_count!==undefined){messages_arr.pop();}__WEBPACK_IMPORTED_MODULE_6__services_db_read_write_service__["a" /* default */].writeMessagesToDBQueue(new_messages);_this.setState({messages_arr:[].concat(_toConsumableArray(_this.state.messages_arr),_toConsumableArray(new_messages))});setTimeout(function(){__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].handleDtLink(_this.handleDtLink.bind(_this));},300);_this.scrollToBottom();};_this.afterLoginAtALaterStage=function(){__WEBPACK_IMPORTED_MODULE_23__services_handle_user_login_service__["a" /* default */].afterLoginAtALaterStage({message_comp:_this});};_this.handleBottomBarCompState=function(value){if(_this.state.bottom_bar_comp!==value){_this.setState({bottom_bar_comp:value});}};_this.clearRetry=function(){// console.log('clear retry')
_this.retry_count=0;_this.setState({show_retry:false});};_this.hideFeedbackOptions=function(){_this.setState({showFeedbackOptions:false});};_this.showFeedbackOptions=function(){_this.setState({showFeedbackOptions:true});};_this.setResponseOptions=function(new_options){_this.setState({response_options:new_options});};_this.clearResponseOptions=function(){_this.setState({response_options:undefined});};_this.setCurrentScenario=function(scenario){_this.setState({current_scenario:scenario});};_this.disableBottomBar=function(){_this.setState({disableBottomBar:true});};_this.enableBottomBar=function(){_this.setState({disableBottomBar:false});};_this.showNumbersToSwitchBot=function(){_this.setState({showNumbersToSwitchBot:true});};_this.disableNumbersToSwitchBot=function(){__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].disableSwitchMessageButtonClick();_this.setState({showNumbersToSwitchBot:false});};_this.setLoaderOn=function(){_this.setState({responseAwaiting:true});_this.hideFeedbackOptions();_this.scrollToBottom();};_this.setLoaderOff=function(){_this.setState({responseAwaiting:false});};_this.showHistoryMessages=function(){if(_this.state.chatHistoryMessages&&_this.state.chatHistoryMessages.length>0){_this.setState({readFromDBReturned:false});setTimeout(function(){_this.setState({showHistoryMessages:true,readFromDBReturned:true});},1000);}};_this.onSkipClick=function(_ref2){var pop_count=_ref2.pop_count;_this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].SKIP_MESSAGE)],pop_count:pop_count});_this.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});if(_this.state.current_scenario.initiate_after_login){_this.setState({current_scenario:Object.assign({},_this.state.current_scenario,{initiate_after_login:false})});}};_this.setBottomBarComponentState=function(bottom_comp_obj){_this.setState({bottom_comp:bottom_comp_obj});};_this.closeLoginComp=function(_ref3){var skip=_ref3.skip;if(skip){_this.onSkipClick({});}_this.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});// this.setState({ current_scenario: { ...this.state.current_scenario, initiate_after_login: false } })
_this.setState({current_scenario:Object.assign({},_this.state.current_scenario)});};_this.handleDtLink=function(data){_this.setLoaderOn();// console.log('handle dt link', data)
var userAction=new __WEBPACK_IMPORTED_MODULE_26__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_27__enums_UserActionType__["a" /* default */].DT_LINK_CLICK,null,null,null,null,null,data.scenarioResponse);_this.setState({userActionObject:userAction});__WEBPACK_IMPORTED_MODULE_16__services_idle_timeout_service__["a" /* default */].updateIdleState();var selectedAction=Object(__WEBPACK_IMPORTED_MODULE_1__actions_chooseAction__["a" /* chooseAction */])({data:data,scenarioResponse:data.scenarioResponse});var result=Object(__WEBPACK_IMPORTED_MODULE_2__actions_execute_action__["a" /* executeAction */])(selectedAction,{scenarioResponse:data.scenarioResponse},_this.retry_count);result.then(function(response){// console.log(response)
if(response.hasOwnProperty('show_cancel_comp')&&response.show_cancel_comp){__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].set("components_handler",Object.assign({},__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('components_handler'),{bottom_bar_comp:'cancel-comp'}));_this.setState({bottom_bar_comp:'cancel-comp',cancel_obj:response.cancel_obj});}if(response.bottom_comp){_this.setBottomBarComponentState(response.bottom_comp);if(response.bottom_comp&&response.bottom_comp.type===__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT){_this.setState({initiateScenarioAfterLoginParams:{scenarioResponse:data.scenarioResponse}});}}if(response&&response.initiateRetry){_this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});}if(response.message_objects){_this.addNewMessages({new_messages:response.message_objects});}//TRACK SCENARIO QUERY FOR EXECUTE DT LINK
if(response.scenarioResponse){__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].setTrackingData({scenarioName:response.scenarioResponse.scenario.scenarioName||"",scenarioStrategy:"DTScenario"});}// TrackingMiddlewareService.trackEvent(TrackingKey.SCENARIO_QUERY)
_this.setLoaderOff();_this.setCurrentScenario(response.scenarioResponse);_this.setResponseOptions(response.chatItem);},function(error){// console.log(error);
_this.handleErrorAfterExecution(error,selectedAction);});};_this.disableOptionClicks=function(value){_this.setState({disableOptionClicks:value});};_this.endCurrentScenario=function(){_this.setState({current_scenario:Object.assign({},_this.state.current_scenario,{scenarioActive:false,templateNameList:[]}),fieldType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT});_this.setBottomBarToInput();};_this.handleUserAction=function(userActionObject){// if (this.state.showNumbersToSwitchBot) {
_this.disableNumbersToSwitchBot();// }
if(userActionObject&&userActionObject.actionType!==__WEBPACK_IMPORTED_MODULE_27__enums_UserActionType__["a" /* default */].RETRY_CLICK){_this.setState({userActionObject:userActionObject});}if(userActionObject){__WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__["a" /* default */].handleUserAction(userActionObject,_this);}else{_this.endCurrentScenario();}};_this.showPopup=function(popup_comp,popup_height,popup_width){if(popup_comp)_this.setState({show_popup:true,popup_data:popup_comp,popup_height:popup_height,popup_width:popup_width});else _this.setState({show_popup:false,popup_data:undefined});};_this.responseHasDefaultMessage=function(response){if(response&&response.message_objects&&response.message_objects.length>0){for(var i=0;i<response.message_objects.length;i++){var message_obj=response.message_objects[i];if(message_obj.component_type===__WEBPACK_IMPORTED_MODULE_24__enums_ComponentTypes__["a" /* default */].DEFAULT){return __WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getSpeechResponse(message_obj.message);}}}else{return false;}};_this.handleSpeechSynthesis=function(response){var speech_message=_this.responseHasDefaultMessage(response);if(speech_message){// var synth = window.speechSynthesis;
// let voice_chosen
if(_this.synth){// console.log(synth)
if(_this.voice_chosen&&_this.voice_chosen.voiceURI!=='Veena'||!_this.voice_chosen){_this.synth.getVoices().map(function(voice){// console.log(voice)
if(voice.voiceURI==="Veena"){_this.voice_chosen=voice;return;}});}if(_this.synth.speaking){return;}var utterThis=new SpeechSynthesisUtterance(speech_message);if(utterThis){utterThis.voice=_this.voice_chosen;}utterThis.onend=function(event){};utterThis.onerror=function(event){};}}};_this.handleResponseAfterExecution=function(_ref4){var response=_ref4.response,user_response=_ref4.user_response,user_res=_ref4.user_res,scenarioResponse=_ref4.scenarioResponse,aditionalData=_ref4.aditionalData,actionType=_ref4.actionType,end_scenario=_ref4.end_scenario;//    response && this.handleSpeechSynthesis(response);
if(response&&response.hasOwnProperty('INITIATE_AFTER_LOGIN_IN_MULTIPLE')){_this.setState({initiate_after_login_in_multiple:response['INITIATE_AFTER_LOGIN_IN_MULTIPLE']});_this.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU});_this.setLoaderOff();_this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].SELECT_ACCOUNT)]});}else if(response&&response.initiateRetry){_this.setState({show_retry:true});_this.scrollToBottom();//CHECK-- in case retry shown after country select step the field type should change to default to chat
if(response&&response.scenarioResponse&&response.scenarioResponse.templateNameList&&__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].isCountryTemplate(response.scenarioResponse.templateNameList)){_this.setState({fieldType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.PLACE});}else{_this.setState({fieldType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT});}}else{if(response.bottom_comp){_this.setBottomBarComponentState(response.bottom_comp);if(response.bottom_comp&&response.bottom_comp.type===__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT){_this.setState({initiateScenarioAfterLoginParams:{user_response:user_response,user_res:user_res,scenarioResponse:scenarioResponse,aditionalData:aditionalData,actionType:actionType}});}}else{_this.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});}if(!response){_this.setLoaderOff();_this.disableOptionClicks(false);var current_scenario=Object.assign({},_this.state.current_scenario);current_scenario.scenarioActive=false;_this.setState({current_scenario:current_scenario});return;}if(response.message_objects){_this.addNewMessages({new_messages:response.message_objects});}if(response&&response.scenarioResponse&&response.scenarioResponse.templateNameList&&__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].isCountryTemplate(response.scenarioResponse.templateNameList)){_this.setState({fieldType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.PLACE});}else{_this.setState({fieldType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT});}if(response&&response.scenarioResponse&&response.scenarioResponse.templateNameList&&__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].hasTemplateDisableInput(response.scenarioResponse.templateNameList)){_this.setState({disableInputField:true});}else{_this.setState({disableInputField:false});}if(response&&response.scenarioResponse&&response.scenarioResponse.scenario&&response.scenarioResponse.scenario.feedbackRequired&&!response.scenarioResponse.scenarioActive&&!response.scenarioResponse.initiate_after_login&&(!response.bottom_comp||response.bottom_comp&&response.bottom_comp.type!==__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.DFF_FORM_COMPONENT)){_this.showFeedbackOptions();}else{_this.hideFeedbackOptions();}_this.setCurrentScenario(response.scenarioResponse);_this.setResponseOptions(response.chatItem);}_this.scrollToBottom();_this.setLoaderOff();_this.disableOptionClicks(false);};_this.handleErrorAfterExecution=function(error,selectedAction){console.log(error);if(error&&error.message_objects){_this.addNewMessages({new_messages:error.message_objects});}else{_this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});}_this.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});_this.setLoaderOff();_this.disableOptionClicks(false);if(selectedAction!==__WEBPACK_IMPORTED_MODULE_11__enums_action_types_ChatActionType__["a" /* default */].NO_ACTION_CHOSEN){var scenarioName=_this.state&&_this.state.current_scenario&&_this.state.current_scenario.scenario&&_this.state.current_scenario.scenario.scenarioName?_this.state.current_scenario.scenario.scenarioName:"";//TRACK ERROR BACKEND
__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].ERROR_BACKEND);}};_this.initiateScenarioAfterLogin=function(){if(_this.state.userActionObject){if(_this.state.userActionObject.actionType===__WEBPACK_IMPORTED_MODULE_27__enums_UserActionType__["a" /* default */].DT_LINK_CLICK&&_this.state.userActionObject.dtLinkScenario){_this.setLoaderOn();__WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__["a" /* default */].sendApiRequest({actionType:"INITIATE",scenarioResponse:Object.assign({},_this.state.userActionObject.dtLinkScenario)},_this);}else{var query=__WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__["a" /* default */].getChatBotQuery(_this.state.userActionObject);if(query){_this.setLoaderOn();__WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__["a" /* default */].sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.DEFAULT,user_response:query,user_res:query},_this,query);}else{_this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});}}}};_this.onSwitchNumber=function(account){var prevBotType=__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("currentBotType");__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].set("currentNumber",account.siNumber);__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].set("currentBotType",account.type);if(account&&account.type!=prevBotType){if(account.type===__WEBPACK_IMPORTED_MODULE_13__enums_BotType__["a" /* default */].POSTPAID){//TRACK SWITCH PRE TO POST
__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].SWITCH_CLICK_PRE_TO_POST);}else{//TRACK SWITCH POST TO PRE
__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].SWITCH_CLICK_POST_TO_PRE);}}__WEBPACK_IMPORTED_MODULE_16__services_idle_timeout_service__["a" /* default */].updateIdleState();//since number switched selected current scenario needs to exit and new chat out call to execute in next response
_this.endCurrentScenario();_this.clearResponseOptions();_this.clearRetry();_this.hideFeedbackOptions();_this.setState({disableInputField:false});var new_messages=[];new_messages.push(__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createUserMessageObject(''+account.siNumber));new_messages.push(__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].successful_switch_message+account.siNumber));_this.addNewMessages({new_messages:new_messages});_this.addNewMessages({new_messages:new_messages});if(_this.state.showNumbersToSwitchBot&&_this.state.userActionObject){_this.disableNumbersToSwitchBot();// console.log('user action before login form', this.state.userActionObject)
var query=__WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__["a" /* default */].getChatBotQuery(_this.state.userActionObject);// console.log('query for bot', query)
if(query){_this.setLoaderOn();// console.log('send query request')
__WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__["a" /* default */].sendApiRequest({actionType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].USER_ACTION_TYPES.DEFAULT,user_response:query,user_res:query},_this,query);}// this.handleUserAction({ ...this.state.userActionObject, afterBotSwitch: true })
}};_this.hideLogo=function(messages_array,currentMessage,currentIndex){if(messages_array&&messages_array[currentIndex-1]&&currentMessage.component_type===__WEBPACK_IMPORTED_MODULE_24__enums_ComponentTypes__["a" /* default */].DEFAULT&&messages_array[currentIndex-1].component_type===__WEBPACK_IMPORTED_MODULE_24__enums_ComponentTypes__["a" /* default */].DEFAULT){return true;}else{return false;}};_this.renderCurrentMessages=function(){var messageComponents=[].concat(_toConsumableArray(_this.state.messages_arr)).map(function(message,key){var hide_logo=_this.hideLogo(_this.state.messages_arr,message,key);var firstTimeMultiple=false;if(message.component_type==='WELCOME_COMPONENT_MULTIPLE'&&key===_this.state.messages_arr.length-1){firstTimeMultiple=true;}var component=__WEBPACK_IMPORTED_MODULE_17__services_chooseComponentToRender_service__["a" /* default */].chooseComponentToRender({message:message,handleUserAction:_this.handleUserAction,showPopup:_this.showPopup,hide_logo:hide_logo,firstTimeMultiple:firstTimeMultiple,setBottomBarToInput:_this.setBottomBarToInput,showNumbersToSwitchBot:_this.showNumbersToSwitchBot});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-left-block',key:key},component);});return messageComponents;};_this.renderHistoryMessages=function(){var messageComponents=[].concat(_toConsumableArray(_this.state.chatHistoryMessages)).map(function(message,key){var hide_logo=_this.hideLogo(_this.state.chatHistoryMessages,message,key);var component=__WEBPACK_IMPORTED_MODULE_17__services_chooseComponentToRender_service__["a" /* default */].chooseComponentToRender({message:message,handleUserAction:_this.handleUserAction,showPopup:_this.showPopup,hide_logo:hide_logo,firstTimeMultiple:false,showNumbersToSwitchBot:_this.showNumbersToSwitchBot});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'chat-left-block',key:key},component);});return messageComponents;};_this.initiateWelcomeScenario=function(){var selectedAction=Object(__WEBPACK_IMPORTED_MODULE_1__actions_chooseAction__["a" /* chooseAction */])({data:_this.loginDetails});var resultantComponentPromise=Object(__WEBPACK_IMPORTED_MODULE_2__actions_execute_action__["a" /* executeAction */])(selectedAction,__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("currentBotType")]['WELCOME'],_this.retry_count);resultantComponentPromise.then(function(response){_this.setLoaderOff();if(response&&response.initiateRetry){_this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});}else{if(response.message_objects){_this.addNewMessages({new_messages:response.message_objects});}_this.setResponseOptions(response.chatItem);_this.setCurrentScenario(response.scenarioResponse);}// TRACK CHAT LAUNCH SUCCESS
__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].START_CHAT_SUCCESS);},function(error){// TRACK CHAT LAUNCH FAIL
__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].START_CHAT_FAIL);_this.handleErrorAfterExecution(error,selectedAction);});};_this.initiateWelcomeScenarioForCurrentBot=function(){_this.setLoaderOn();// console.log('initiate welcome scenario')
var selectedAction=Object(__WEBPACK_IMPORTED_MODULE_1__actions_chooseAction__["a" /* chooseAction */])({data:_this.loginDetails});var resultantComponentPromise=Object(__WEBPACK_IMPORTED_MODULE_2__actions_execute_action__["a" /* executeAction */])(selectedAction,__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("scenarioList")[__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("currentBotType")]['WELCOME'],_this.retry_count);resultantComponentPromise.then(function(response){_this.setLoaderOff();if(response&&response.initiateRetry){_this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});}else{if(response.message_objects){_this.addNewMessages({new_messages:response.message_objects});}_this.setResponseOptions(response.chatItem);_this.setCurrentScenario(response.scenarioResponse);}},function(error){_this.handleErrorAfterExecution(error,selectedAction);});};_this.onNumberSelected=function(_ref5){var user_response=_ref5.user_response,show_number=_ref5.show_number;_this.setState({response_options:undefined});_this.setLoaderOn();var new_messages=[];if(show_number){new_messages.push({component_type:'USER_RESPONSE',message:user_response?user_response:__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("currentNumber"),messageTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime()});new_messages.push({component_type:'DEFAULT',message:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].number_selected_acknowledgement_msg,messageTime:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getCurrentTime()});}_this.showHistoryMessages();_this.addNewMessages({new_messages:new_messages});_this.initiateWelcomeScenario();};_this.scrollToBottom=function(){var scrolltimer=setTimeout(function(){_this.messagesEnd&&_this.messagesEnd.scrollIntoView({behavior:"instant",block:"end"});clearTimeout(scrolltimer);},100);};_this.setBottomBarToInput=function(){_this.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});};_this.handleCancelButtonClick=function(){__WEBPACK_IMPORTED_MODULE_16__services_idle_timeout_service__["a" /* default */].updateIdleState();_this.showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_components_confirmation_box_component__["a" /* default */],{title:_this.state.bottom_comp.cancel_obj.type?__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].CANCEL_CASES[_this.state.bottom_comp.cancel_obj.type].title:'Cancel current chat?',messages:[_this.state.bottom_comp.cancel_obj.type?__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].CANCEL_CASES[_this.state.bottom_comp.cancel_obj.type].message:'This will end your current chat'],buttons:[{label:'NO',onClick:function onClick(){_this.showPopup(undefined);}},{highlight:true,label:'YES',onClick:function onClick(){_this.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});_this.showPopup(undefined);if(_this.state.bottom_comp.cancel_obj){var chatItem=_this.state.bottom_comp.cancel_obj.chatItem;chatItem.scenarioResponse.templateNameList=[];_this.handleUserAction(new __WEBPACK_IMPORTED_MODULE_26__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_27__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,'CANCEL',null,null,__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].CANCEL_CASES[_this.state.bottom_comp.cancel_obj.type].cancel_user_response));switch(_this.state.bottom_comp.cancel_obj.type){case'IR_PACK':{__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].disableActivateIrCardLink();}case'IR_ACTIVATED_PACKS_DEACTIVATION':{__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].disableDeactivateIrCardLink();}default:{}}}}}]}));};_this.setReadOnScroll=function(){_this.setState({readOnScroll:true,readFromDBReturned:false});};_this.getChatHistoryOnScroll=function(event){// console.log('on scroll')
if(__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){var scrolltop=event.target.scrollTop;var scrollHeight=event.target.scrollHeight;if(event.target.scrollHeight>event.target.clientHeight&&scrolltop<20&&__WEBPACK_IMPORTED_MODULE_6__services_db_read_write_service__["a" /* default */].db_read_offset!==-1&&__WEBPACK_IMPORTED_MODULE_6__services_db_read_write_service__["a" /* default */].db_read_offset>0){//READ CHAT HISTORY
_this.setReadOnScroll();__WEBPACK_IMPORTED_MODULE_6__services_db_read_write_service__["a" /* default */].readFromDB();}}};_this.state={responseAwaiting:false,disableOptionClicks:false,current_scenario:undefined,response_options:undefined,fieldType:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT,show_retry:false,show_popup:false,messages_arr:[],popupVisible:true,disableInputField:false,chatHistoryMessages:[],readOnScroll:false,bottom_comp:{type:__WEBPACK_IMPORTED_MODULE_9__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR},showHistoryMessages:false,readFromDBReturned:true,redirectCase:false,showNumbersToSwitchBot:false,userActionObject:null};_this.retry_count=0;_this.allMessagesRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.historyMessagesRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.currentMessagesRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.chatOptionsRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.loginDetails={isUserLoggedIn:false,loggedInMsisdn:""};return _this;}_createClass(ChatMessage,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.setLoaderOn();// console.log('chat bot')
__WEBPACK_IMPORTED_MODULE_18__services_initialize_chatbot_data_service__["a" /* default */].getBasicTokenAndInitializeChatBotData().then(function(response){if(__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){__WEBPACK_IMPORTED_MODULE_23__services_handle_user_login_service__["a" /* default */].loginInApp().then(function(){__WEBPACK_IMPORTED_MODULE_23__services_handle_user_login_service__["a" /* default */].afterInitialLoginSuccess({message_comp:_this2});}).catch(function(err){_this2.setLoaderOff();_this2.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});});}if(!__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){window.addEventListener("message",_this2.receiveMessage.bind(_this2),false);window.parent.postMessage("INITIATED",__WEBPACK_IMPORTED_MODULE_8__config_config__["a" /* default */].parentOrigin);}},function(error){__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].ERROR_BACKEND);_this2.setLoaderOff();_this2.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});});this.synth=window.speechSynthesis;if(this.synth){this.synth.getVoices().map(function(voice){// console.log(voice)
if(voice.voiceURI==="Veena"){_this2.voice_chosen=voice;return;}});}}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){__WEBPACK_IMPORTED_MODULE_16__services_idle_timeout_service__["a" /* default */].updateIdleState();if(prevState.current_scenario!==this.state.current_scenario){//NEW TRACKING - UPDATE CURRENT SCENARIO IN TRACKING
__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].setTrackingData({current_scenario:this.state.current_scenario});var currentMessagesDiv=this.currentMessagesRef.current;if(currentMessagesDiv.scrollHeight>currentMessagesDiv.clientHeight){currentMessagesDiv.style.height="auto";}}// if (prevState.messages_arr.length !== this.state.messages_arr.length || this.state.responseAwaiting) {
//     // this.scrollToBottom();
//     this.messagesEnd && this.messagesEnd.scrollIntoView({ behavior: "instant", block: "end" });
// }
if(document.getElementById('welcome_multiple_div')&&document.getElementById('welcome_multiple_image')){var diff=document.getElementById('welcome_multiple_image').clientHeight>document.getElementById('welcome_multiple_div').clientHeight?document.getElementById('welcome_multiple_div').clientHeight-document.getElementById('welcome_multiple_image').clientHeight:0;document.getElementById('welcome_multiple_image').style.bottom=diff+'px';}//popup visible or not handled
if(snapshot&&snapshot.hasOwnProperty('popupVisible')&&snapshot.popupVisible!==this.state.popupVisible){this.setState({popupVisible:snapshot.popupVisible});}// ------ calculate position for options (fixed to bottom or scrollable with messages)
Object(__WEBPACK_IMPORTED_MODULE_19__services_UICalculations_service__["b" /* calculateOptionsPosition */])();if(this.state.response_options){Object(__WEBPACK_IMPORTED_MODULE_19__services_UICalculations_service__["a" /* calculateOptionsLeftPosition */])();}if(snapshot&&snapshot.showHistoryMessages){var _currentMessagesDiv=this.currentMessagesRef.current;var chatOptionsDiv=this.chatOptionsRef.current;var currentDivHeight=_currentMessagesDiv.scrollHeight;if(!this.state.redirectCase&&snapshot.showHistoryMessages&&_currentMessagesDiv.scrollHeight+chatOptionsDiv.scrollHeight<snapshot.showHistoryMessages){_currentMessagesDiv.style.height=snapshot.showHistoryMessages-81+"px";currentDivHeight=snapshot.showHistoryMessages-chatOptionsDiv.scrollHeight;}var allMessagesDiv=this.allMessagesRef.current;var currentHeight=allMessagesDiv.scrollHeight;// console.log('current height',currentHeight)
document.getElementById('chat_message_id').scrollTop=currentHeight-currentDivHeight;}//set the scroll position on reading history messages
if(snapshot&&snapshot.readOnScroll){var _allMessagesDiv=this.allMessagesRef.current;var _currentHeight=_allMessagesDiv.scrollHeight;// console.log('current height',currentHeight)
document.getElementById('chat_message_id').scrollTop=_currentHeight-snapshot.readOnScroll;}__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].checkForCarouselWebScrollArrows();}},{key:'getSnapshotBeforeUpdate',value:function getSnapshotBeforeUpdate(prevProps,prevState){var popupVisible=this.state.popupVisible;if(prevProps.showCloseChatConfirmationPopup){var feedbackSkippedTracking=__WEBPACK_IMPORTED_MODULE_28__services_handle_user_action_service__["a" /* default */].checkForFeedbackSkippedTracking(null,this.state.current_scenario);if(feedbackSkippedTracking||true){this.props.setFeedbackRequired(true,feedbackSkippedTracking);}}if(prevState.popupVisible!==this.state.popupVisible){popupVisible=this.state.popupVisible;}else if(prevProps.hideMessagePopup!==this.props.hideMessagePopup&&this.props.hideMessagePopup){popupVisible=false;}else if(prevProps.hideMessagePopup!==this.props.hideMessagePopup&&!this.props.hideMessagePopup){popupVisible=true;}if(prevProps.isMaximized!==this.props.isMaximized&&this.props.isMaximized&&!this.props.hideMessagePopup){popupVisible=true;}else if(prevProps.isMaximized!==this.props.isMaximized&&!this.props.isMaximized||this.props.hideMessagePopup){popupVisible=false;}if(this.state.showHistoryMessages!==prevState.showHistoryMessages){var allMessagesDiv=this.allMessagesRef.current;return{'showHistoryMessages':allMessagesDiv.scrollHeight,popupVisible:popupVisible};}if(this.state.response_options!==prevState.response_options){var chatOptionsDiv=this.chatOptionsRef.current;return{'responseOptions':chatOptionsDiv.scrollHeight,popupVisible:popupVisible};}if(prevState.chatHistoryMessages.length<this.state.chatHistoryMessages.length){var _allMessagesDiv2=this.allMessagesRef.current;return{'readOnScroll':_allMessagesDiv2.scrollHeight,popupVisible:popupVisible};}return{popupVisible:popupVisible};}},{key:'receiveMessage',value:function receiveMessage(event){var _this3=this;if(event.data&&typeof event.data==="string"){try{if(__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){// LoginInAppService.handleLoginInApp({ message_comp: this });
}else if(event&&event.data&&event.data.indexOf("loginDetails")!=-1){var dataReceivedFromAirtelUI=JSON.parse(event.data);this.loginDetails=dataReceivedFromAirtelUI.loginDetails;if(this.loginDetails.isUserLoggedIn){var mobNo=this.loginDetails.loggedInMsisdn;__WEBPACK_IMPORTED_MODULE_23__services_handle_user_login_service__["a" /* default */].loginInWeb(mobNo).then(function(){__WEBPACK_IMPORTED_MODULE_23__services_handle_user_login_service__["a" /* default */].afterInitialLoginSuccess({message_comp:_this3});}).catch(function(err){_this3.setLoaderOff();_this3.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});});}else{//CHECK 
this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].WELCOME)]});this.initiateWelcomeScenario();}}}catch(exception){// console.log('receive message exception',exception);
this.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_10__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});// TRACK CHAT LAUNCH FAIL
__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].START_CHAT_FAIL);__WEBPACK_IMPORTED_MODULE_21__services_tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_25__enums_trackingKey__["a" /* default */].ERROR_FRONTEND);}}return true;}},{key:'render',value:function render(){var _this4=this;var isApp=__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("APP_CONTEXT")?true:false;var ios_class=__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getIosSpecificClass();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'main-inner',style:{display:'grid',gridTemplateRows:'1fr max-content',height:isApp?'100%':'calc(100% - 56px)',marginTop:isApp?0:'56px',overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'chat_message_id',ref:this.allMessagesRef,className:"chatMessage home mt-0 "+" "+(__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getOS()==="Windows"?"custom-scrollbar":"")+" "+ios_class,style:{display:'block',overflowY:'scroll',position:'relative'},onScroll:function onScroll(event){_this4.getChatHistoryOnScroll(event);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'chat_list_id',className:"pb-10"+" "+ios_class,style:{width:'100%'}},!this.state.readFromDBReturned&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{textAlign:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/messagesLoader.gif',width:'25px'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'historyMessagesDiv',className:"overflow-scroll"+" "+ios_class,ref:this.historyMessagesRef},this.state.showHistoryMessages&&this.renderHistoryMessages()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'currentMessagesDiv',className:"overflow-scroll"+" "+ios_class,ref:this.currentMessagesRef},this.renderCurrentMessages(),this.state.responseAwaiting&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__message_components_loading_response_component__["a" /* LoadingResponseComponent */],{messages:this.state.messages_arr})),this.state.show_retry&&Object(__WEBPACK_IMPORTED_MODULE_12__message_components_retry_message_component__["a" /* default */])(this.handleRetry)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'chat_options_id',ref:this.chatOptionsRef},(this.state.response_options||this.state.showFeedbackOptions||this.state.show_retry)&&Object(__WEBPACK_IMPORTED_MODULE_7__scenario_options_components_options_response_component__["a" /* default */])({chatItem:this.state.response_options,handleUserAction:this.handleUserAction,showFeedbackOptions:this.state.showFeedbackOptions,show_retry:this.state.show_retry,showPopup:this.showPopup})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:"left",clear:"both"},id:'messagesEnd',ref:function ref(el){_this4.messagesEnd=el;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{pointerEvents:this.state.responseAwaiting||this.state.disableBottomBar?'none':'auto'}},Object(__WEBPACK_IMPORTED_MODULE_20__bottom_component__["a" /* default */])({messageComp:this})),this.state.show_popup&&this.state.popup_data&&Object(__WEBPACK_IMPORTED_MODULE_14__common_components_popup__["a" /* default */])(this.state.popup_data,this.state.popupVisible,this.state.popup_height,this.state.popup_width));}}]);return ChatMessage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatMessage);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({env:"local",lob_list:['POSTPAID'],parentOrigin:"http://localhost/airtel-ui/airtel/help/",baseUrlWithoutAuth:"http://10.5.205.104:8080/",baseUrlWithAuth:"http://10.5.205.104:8080/",botTypeBaseUrl:{POSTPAID:"chatMediator",PREPAID:"chatMediatorPrePaid",PAYMENTSBANK:"chatMediatorBank",SIEBEL:"chatMediatorSiebel"},tokenFor:"",userProfileFor:{},monthlyPlanNewAppContext:{'WEB':'https://www.airtel.in/ts2/longurl/thx/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}','ANDROID':'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}','IOS':'myairtel://change_myplan?n={mobile}&billplancode={code}'},monthlyPlan:{'WEB':'https://www.airtel.in/ts2/longurl/thx/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}','ANDROID':'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}','IOS':'myairtel://change_myplan?n={mobile}&billplancode={code}'},planRental:{'WEB':'https://www.airtel.in/s/selfcare/postpaid/si/planAndService?action=viewservices','ANDROID':'myairtel://myplan?siNumber={mobile}','IOS':'myairtel://change_myplan?n={mobile}'},duplicateBills:{'ANDROID':'myairtel://account?n={mobile}&p=AccPosBilCon&sec=AccPosBilSum','IOS':'myairtel://account?p=bill_detail&n={mobile}'},irPackTnc:'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/TnC-International-Roaming.pdf',irPackStandardCharges:'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/Prepaid-and-Postpaid-Website-Rate-Dump-Internaional-Roaming.pdf',forbiddenHTMLTags:['applet','base','basefont','command','embed','frame','frameset','iframe','keygen','link','meta','noframes','noscript','object','param','script','title']});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({env:"staging",lob_list:['POSTPAID'],parentOrigin:"https://www.airtel.in/testhelpsupport/airtel-ui/help/",baseUrlWithoutAuth:"https://www.airtel.in/chatbotstage/",baseUrlWithAuth:"https://www.airtel.in/ds2/chatbotstage/",botTypeBaseUrl:{POSTPAID:"chatMediator",PREPAID:"chatMediatorPrePaid",PAYMENTSBANK:"chatMediatorBank",SIEBEL:"chatMediatorSiebel"},monthlyPlanNewAppContext:{'WEB':'https://www.airtel.in/ts2/longurl/thx/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}','ANDROID':'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}&source=chatbot&uri=myairtel://chat/?au=https://www.airtel.in/testhelpsupport/dist/?icpf=true&siNumber={mobile}&data={code}','IOS':'myairtel://change_myplan?n={mobile}&billplancode={code}&source=chatbot&uri=myairtel://webview/?ax=https://www.airtel.in/testhelpsupport/dist/?n={mobile}&billplancode={code}'},monthlyPlan:{'WEB':'https://www.airtel.in/ts2/longurl/thx/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}','ANDROID':'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}','IOS':'myairtel://change_myplan?n={mobile}&billplancode={code}'},planRental:{'WEB':'https://www.airtel.in/s/selfcare/postpaid/si/planAndService?action=viewservices','ANDROID':'myairtel://myplan?siNumber={mobile}','IOS':'myairtel://change_myplan?n={mobile}'},duplicateBills:{'ANDROID':'myairtel://account?n={mobile}&p=AccPosBilCon&sec=AccPosBilSum','IOS':'myairtel://account?p=bill_detail&n={mobile}'},irPackTnc:'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/TnC-International-Roaming.pdf',irPackStandardCharges:'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/Prepaid-and-Postpaid-Website-Rate-Dump-Internaional-Roaming.pdf',forbiddenHTMLTags:['applet','base','basefont','command','embed','frame','frameset','iframe','keygen','link','meta','noframes','noscript','object','param','script','title']});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({env:"prod",lob_list:['POSTPAID'],parentOrigin:"https://www.airtel.in/help/",baseUrlWithoutAuth:"https://www.airtel.in/chatbot/",baseUrlWithAuth:"https://www.airtel.in/s/chatbot/",botTypeBaseUrl:{POSTPAID:"postpaid/chatMediator",PREPAID:"prepaid/chatMediator",PAYMENTSBANK:"paymentsbank/chatMediator",SIEBEL:"siebel/chatMediator"},monthlyPlanNewAppContext:{'WEB':'https://www.airtel.in/s/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}','ANDROID':'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}&source=chatbot&uri=myairtel://chat/?au=https://www.airtel.in/help/chat/?icpf=true&siNumber={mobile}&data={code}','IOS':'myairtel://change_myplan?n={mobile}&billplancode={code}&source=chatbot&uri=myairtel://webview/?ax=https://www.airtel.in/help/chat/?n={mobile}&billplancode={code}'},monthlyPlan:{'WEB':'https://www.airtel.in/s/selfcare/postpaid/{mobile}/planAndService?action=updateRental&planCode={code}','ANDROID':'myairtel://myplan?icpf=true&siNumber={mobile}&data={code}','IOS':'myairtel://change_myplan?n={mobile}&billplancode={code}'},planRental:{'WEB':'https://www.airtel.in/s/selfcare/postpaid/si/planAndService?action=viewservices','ANDROID':'myairtel://myplan?siNumber={mobile}','IOS':'myairtel://change_myplan?n={mobile}'},duplicateBills:{'ANDROID':'myairtel://account?n={mobile}&p=AccPosBilCon&sec=AccPosBilSum','IOS':'myairtel://account?p=bill_detail&n={mobile}'},irPackTnc:'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/TnC-International-Roaming.pdf',irPackStandardCharges:'https://s3.ap-south-1.amazonaws.com/airtel-cms/bsy/iportal/images/Prepaid-and-Postpaid-Website-Rate-Dump-Internaional-Roaming.pdf',forbiddenHTMLTags:['applet','base','basefont','command','embed','frame','frameset','iframe','keygen','link','meta','noframes','noscript','object','param','script','title']});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_util_service__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var BotAnalyticsService=function(){function BotAnalyticsService(){_classCallCheck(this,BotAnalyticsService);}_createClass(BotAnalyticsService,null,[{key:"startChatSuccess",value:function startChatSuccess(key,pageName,mobilenumber,Circle,platform){// console.log('track start chat success',{key,pageName,mobilenumber,Circle,platform})
if(key==="start_chat_success"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.platform=platform;window.sessionID=__WEBPACK_IMPORTED_MODULE_0__services_util_service__["a" /* default */].generateUniqueSessionId();window._satellite.track("chatbot");}}},{key:"startChatFail",value:function startChatFail(key,pageName,mobilenumber){// console.log('track start chat fail',{key, pageName, mobilenumber})
if(key==="start_chat_fail"){window.my_data=key;window.mobileNumber=mobilenumber;if(window.scenario){delete window.scenario;}window._satellite.track("chatbot");}}},{key:"loginSuccess",value:function loginSuccess(key,pageName,mobileNumber,Circle,otp,Scenario){// console.log('track login success',{key, pageName, mobileNumber, Circle, otp, Scenario})
if(key==="login_success"){window.my_data=key;window.mobileNumber=mobileNumber;window.circle=Circle;window.scenario=Scenario;window.loginType=otp;window._satellite.track("chatbot");}}},{key:"loginFail",value:function loginFail(key,pagename,mobilenumber,Circle,Scenario){// console.log('track login fail',{key, pagename, mobilenumber, Circle, Scenario})
window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;if(window.scenario==="chatbot_greeting"){delete window.scenario;}window.my_data="login_fail";window._satellite.track("chatbot");}},{key:"trackSecondaryMobileNumber",value:function trackSecondaryMobileNumber(key,mobilenumber,secondaryMobileNo,isPrimaryMN,Scenario,optionSelected,Circle){// console.log('track secondary mobile number',{key, mobilenumber, secondaryMobileNo, isPrimaryMN, Scenario, optionSelected, Circle})
var option=optionSelected.replace(/&#32;/g," ");if(key==="secondary_mobileNumber"){window.my_data=key;window.mobileNumber=mobilenumber;window.secondaryMN=secondaryMobileNo;window.primaryMN=isPrimaryMN;window.circle=Circle;window.scenario=Scenario;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"trackPrimaryMobileNumber",value:function trackPrimaryMobileNumber(key,pagename,mobilenumber,Circle,Scenario,isPrimaryMN,optionSelected){// console.log('track primary mobile  number',{key, pagename, mobilenumber, Circle, Scenario, isPrimaryMN, optionSelected})
var option=optionSelected.replace(/&#32;/g," ");if(key==="primary_mobileNumber"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;window.primaryMN=isPrimaryMN;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"faqQuery",value:function faqQuery(key,pagename,mobilenumber,Circle,Scenario,optionSelected,selectedBy,intentType){// console.log('track faq query',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
if(key==="faq_query"){window.my_data=key;window.pageName=pagename;window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;window.selectedBy=selectedBy;window.intentType=intentType;window.optionSelected=optionSelected;window._satellite.track("chatbot");}}},{key:"scenarioQuery",value:function scenarioQuery(key,pagename,mobilenumber,Circle,Scenario,optionSelected){// console.log('track scenario query',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
if(key==="scenario_query"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;window.optionSelected=optionSelected;window._satellite.track("chatbot");}}},{key:"feedbackSuccess",value:function feedbackSuccess(key,pagename,mobilenumber,Circle,optionSelected,Scenario){// console.log('track feedback success',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
if(key==="feedback_success"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window._satellite.track("chatbot");}}},{key:"feedbackFail",value:function feedbackFail(key,pagename,mobilenumber,Circle,optionSelected,Scenario){// console.log('track feedback fail',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
if(key==="feedback_fail"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window._satellite.track("chatbot");}}},{key:"feedbackSkipped",value:function feedbackSkipped(key,pagename,mobilenumber,Circle,optionSelected,Scenario,intentType,selectedBy,sad_skipped){// console.log('track feedback skipped',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
if(key==="feedback_skipped"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window.intentType=intentType;window.selectedBy=selectedBy;window.feedbackSuggestion=sad_skipped;window._satellite.track("chatbot");}}},{key:"feedbackNotGiven",value:function feedbackNotGiven(key,pagename,mobilenumber,Circle,Scenario,optionSelected){// console.log('track feedback not given',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
if(key==="feedback_not_given"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;window.optionSelected=optionSelected;window._satellite.track("chatbot");}}},{key:"scenarioFeedbackSuccess",value:function scenarioFeedbackSuccess(key,pagename,mobilenumber,Circle,optionSelected,Scenario){// console.log('track scenario_feedback_success',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
if(key==="scenario_feedback_success"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;optionSelected=optionSelected;window.scenario=Scenario;window._satellite.track("chatbot");}}},{key:"scenarioFeedbackFail",value:function scenarioFeedbackFail(key,pagename,mobilenumber,Circle,optionSelected,Scenario){// console.log('track scenario_feedback_fail ',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
if(key==="scenario_feedback_fail"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window._satellite.track("chatbot");}}},{key:"scenarioFeedbackSkipped",value:function scenarioFeedbackSkipped(key,pagename,mobilenumber,Circle,optionSelected,Scenario){// console.log('track scenario_feedback_skipped',{key, pagename, mobilenumber, Circle, optionSelected, Scenario})
if(key==="scenario_feedback_skipped"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window._satellite.track("chatbot");}}},{key:"scenarioFeedbackNotGiven",value:function scenarioFeedbackNotGiven(key,pagename,mobilenumber,Circle,Scenario,optionSelected){if(key==="scenario_feedback_not_given"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;window.optionSelected=optionSelected;window._satellite.track("chatbot");}}},{key:"closeChatYes",value:function closeChatYes(key,pageName,mobilenumber,Circle,sessionTime,Scenario,queryCount,optionSelected){// console.log('track close chat yes',{key, pageName, mobilenumber, Circle, sessionTime, Scenario, queryCount, optionSelected})
if(key==="close_chat_yes"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.sessionTime=sessionTime;window.scenario=Scenario;window.queryCount=queryCount;window.optionSelected=optionSelected;window._satellite.track("chatbot");}}},{key:"closeChatNo",value:function closeChatNo(key,pageName,mobilenumber,Circle,sessionTime,Scenario,queryCount,optionSelected){// console.log('track close_chat_no',{key, pageName, mobilenumber, Circle, sessionTime, Scenario, queryCount, optionSelected})
if(key==="close_chat_no"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.sessionTime=sessionTime;window.scenario=Scenario;window.queryCount=queryCount;window.optionSelected=optionSelected;window._satellite.track("chatbot");}}},{key:"intentReadingSuccess",value:function intentReadingSuccess(key,pageName,mobilenumber,Circle,optionSelected,Scenario,intentType,enteredTextMode){// console.log('track intent reading success',{key, pageName, mobilenumber, Circle, optionSelected, Scenario, intentType, enteredTextMode})
var option=optionSelected.replace(/&#32;/g," ");if(key==="intent_reading_success"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=option;window.scenario=Scenario;window.intentType=intentType;window.feedbackSuggestion=undefined;window.selectedBy=enteredTextMode;window._satellite.track("chatbot");delete window.intentType;delete window.selectedBy;}}},{key:"intentReadingFail",value:function intentReadingFail(key,pagename,mobilenumber,Circle,sessionTime,Scenario,optionSelected,enteredTextMode){// console.log('track intent_reading_fail',{key, pagename, mobilenumber, Circle, sessionTime, Scenario, optionSelected, enteredTextMode})
var option=optionSelected.replace(/&#32;/g," ");if(key==="intent_reading_fail"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.sessionTime=sessionTime;delete window.scenario;delete window.intentType;window.optionSelected=option;window.selectedBy=enteredTextMode;window._satellite.track("chatbot");delete window.optionSelected;delete window.selectedBy;}}},{key:"ssoProfileSuccess",value:function ssoProfileSuccess(key,pageName,Circle,mobilenumber,Scenario,optionSelected){var option=optionSelected.replace(/&#32;/g," ");if(key==="sso_profile_success"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"ssoProfileFail",value:function ssoProfileFail(key,pageName,mobilenumber,Circle,Scenario,optionSelected){var option=optionSelected.replace(/&#32;/g," ");if(key==="sso_profile_fail"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.scenario=Scenario;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"ssoProfileNumberSelectedSuccess",value:function ssoProfileNumberSelectedSuccess(key,pagename,mobilenumber,ssoNumber,Circle,scenario,optionSelected){var option=optionSelected.replace(/&#32;/g," ");if(key==="sso_profile_number_selected_success"){window.my_data=key;window.mobileNumber=mobilenumber;window.ssoNumber=ssoNumber;window.circle=Circle;window.scenario=scenario;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"ssoProfileNumberSelectedFail",value:function ssoProfileNumberSelectedFail(key,pagename,mobilenumber,Circle,sessionTime,scenario,optionSelected){// console.log('track sso profile number selected fail',{key, pagename, mobilenumber, Circle, sessionTime, scenario, optionSelected})
var option=optionSelected.replace(/&#32;/g," ");if(key==="sso_profile_number_selected_fail"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.sessionTime=sessionTime;window.scenario=scenario;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"errorFrontend",value:function errorFrontend(key,pagename,mobilenumber,Circle,sessionTime,scenario,errorType,optionSelected){// console.log('track error frontend',{key, pagename, mobilenumber, Circle, sessionTime, scenario, errorType, optionSelected})
var option=optionSelected.replace(/&#32;/g," ");if(key==="error_frontend"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.sessionTime=sessionTime;window.scenario=scenario;window.errorType=errorType;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"errorBackend",value:function errorBackend(key,pagename,mobilenumber,circle,scenario,errorType,optionSelected){// console.log('track error backend',{key, pagename, mobilenumber, circle, scenario, errorType, optionSelected})
var option=optionSelected.replace(/&#32;/g," ");if(key==="error_backend"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=circle;window.scenario=scenario;window.errorType=errorType;window.optionSelected=optionSelected;window._satellite&&window._satellite.track("chatbot");}}},{key:"idleChat",value:function idleChat(key,pagename,mobilenumber,Circle,resp,scenario,optionSelected){// console.log('track idle chat',{key, pagename, mobilenumber, Circle, resp, scenario, optionSelected})
var option=optionSelected.replace(/&#32;/g," ");if(key==="idle_chat"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.resp=resp;window.scenario=scenario;window.optionSelected=option;window._satellite.track("chatbot");}}},{key:"retryOption",value:function retryOption(key,pagename,mobileNumber,Circle,intentType,Scenario){// console.log('track retry option',{key, pagename, mobileNumber, Circle, intentType, Scenario})
if(key==="retry_option"){window.my_data=key;mobileNumber=mobileNumber;window.circle=Circle;window.intentType=intentType;window.scenario=Scenario;window._satellite.track("chatbot");delete window.intentType;}}},{key:"trackfeedbackSatisfied",value:function trackfeedbackSatisfied(key,pagename,mobilenumber,Circle,Scenario,optionSelected){// console.log('track feedback satisfied',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
if(key==="feedback_satisfied"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window._satellite.track("chatbot");}}},{key:"trackFeedbackHappy",value:function trackFeedbackHappy(key,pagename,mobilenumber,Circle,Scenario,optionSelected,intentType,selectedBy){// console.log('track feedback happy',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
if(key==="feedback_happy"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window.intentType=intentType;window.selectedBy=selectedBy;window._satellite.track("chatbot");}}},{key:"trackFeedbackSad",value:function trackFeedbackSad(key,pagename,mobilenumber,Circle,Scenario,optionSelected,intentType,selectedBy){// console.log('track feedback sad',{key, pagename, mobilenumber, Circle, Scenario, optionSelected})
if(key==="feedback_sad"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window.intentType=intentType;window.selectedBy=selectedBy;window._satellite.track("chatbot");delete window.feedbackType;delete window.feedbackSuggestion;}}},{key:"trackImproveFeedback",value:function trackImproveFeedback(key,pagename,mobilenumber,Circle,Scenario,feedbackSuggestion,feedbackType,intentType,optionSelected,selectedBy){// console.log('track improve feedback',{key, pagename, mobilenumber, Circle, Scenario, feedbackSuggestion, feedbackType, intentType, optionSelected})
if(key==="improve_feedback"){window.my_data=key;window.mobileNumber=mobilenumber;window.circle=Circle;window.optionSelected=optionSelected;window.scenario=Scenario;window.feedbackType=feedbackType;window.feedbackSuggestion=feedbackSuggestion;window.intentType=intentType;window.selectedBy=selectedBy;window._satellite.track("chatbot");delete window.feedbackType;delete window.feedbackSuggestion;delete window.intentType;}}}]);return BotAnalyticsService;}();BotAnalyticsService.trackSsoProfileSingle=function(key,mobileNumber,age,numberType,loginType,circle,scenario,selectedBy,optionSelected,intentType,platform){// console.log('track sso profile single',{key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform})
if(key==='sso_profile_single'){window.mobileNumber=mobileNumber;window.age=age;window.numberType=numberType;window.loginType=loginType;window.circle=circle;window.scenario=scenario;window.selectedBy=selectedBy;window.optionSelected=optionSelected;window.intentType=intentType;window.platform=platform;window._satellite.track("chatbot");}};BotAnalyticsService.trackSsoProfileMultiple=function(key,mobileNumber,age,numberType,loginType,circle,scenario,selectedBy,optionSelected,intentType,platform){// console.log('track sso profile multiple',{key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform})
if(key==='sso_profile_multiple'){window.my_data=key;window.mobileNumber=mobileNumber;window.age=age;window.numberType=numberType;window.loginType=loginType;window.circle=circle;window.scenario=scenario;window.selectedBy=selectedBy;window.optionSelected=optionSelected;window.intentType=intentType;window.platform=platform;window._satellite.track("chatbot");}};BotAnalyticsService.trackSsoProfileNoAccount=function(key,mobileNumber,age,numberType,loginType,circle,scenario,selectedBy,optionSelected,intentType,platform){// console.log('track sso_profile_no_account',{key, mobileNumber, age, numberType , loginType , circle, scenario, selectedBy, optionSelected, intentType, platform})
if(key==='sso_profile_no_account'){window.my_data=key;window.mobileNumber=mobileNumber;window.age=age;window.numberType=numberType;window.loginType=loginType;window.circle=circle;window.scenario=scenario;window.selectedBy=selectedBy;window.optionSelected=optionSelected;window.intentType=intentType;window.platform=platform;window._satellite.track("chatbot");}};BotAnalyticsService.trackGridClicks=function(key,circle,mobileNumber,scenario,selectedBy,optionSelected,intentType,platform){// console.log('track grid_clicks',{key, circle, mobileNumber, scenario, selectedBy, optionSelected, intentType, platform})
if(key=='grid_clicks'){window.my_data=key;window.mobileNumber=mobileNumber;window.circle=circle;window.scenario=scenario;window.selectedBy=selectedBy;window.optionSelected=optionSelected;window.intentType=intentType;window.platform=platform;window._satellite.track("chatbot");}};BotAnalyticsService.trackLinkClick=function(key,mobileNumber,circle,scenario,selectedBy,optionSelected,intentType,platform,numberType){// console.log('track link_clicks',{key, mobileNumber, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType})
// SHEKHAR
if(key=='link_clicks'){window.my_data=key;window.linkName=key;window.mobileNumber=mobileNumber;window.circle=circle;window.scenario=scenario;window.selectedBy=selectedBy;window.optionSelected=optionSelected;window.intentType=intentType;window.platform=platform;window.numberType=numberType;window._satellite.track("generic-click");}};BotAnalyticsService.trackSwitchClickPreToPost=function(key,mobileNumber,switchType,circle,scenario,selectedBy,optionSelected,intentType,platform,numberType){// console.log('track switch_click_pre_to_post',{key, mobileNumber,  switchType, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType})
if(key=='switch_click_pre_to_post'){window.my_data=key;window.linkName=key;window.mobileNumber=mobileNumber;window.switchType=switchType;window.circle=circle;window.scenario=scenario;window.selectedBy=selectedBy;window.optionSelected=optionSelected;window.intentType=intentType;window.platform=platform;window.numberType=numberType;window._satellite.track("generic-click");}};BotAnalyticsService.trackSwitchClickPostToPre=function(key,mobileNumber,switchType,circle,scenario,selectedBy,optionSelected,intentType,platform,numberType){// console.log('track switch_click_post_to_pre',{key, mobileNumber,  switchType, circle, scenario, selectedBy, optionSelected, intentType, platform, numberType})
if(key=='switch_click_post_to_pre'){window.my_data=key;window.linkName=key;window.mobileNumber=mobileNumber;window.switchType=switchType;window.circle=circle;window.scenario=scenario;window.selectedBy=selectedBy;window.optionSelected=optionSelected;window.intentType=intentType;window.platform=platform;window.numberType=numberType;window._satellite.track("generic-click");}};/* unused harmony default export */ var _unused_webpack_default_export = (BotAnalyticsService);

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(112);

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var bind = __webpack_require__(60);
var Axios = __webpack_require__(114);
var defaults = __webpack_require__(35);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(65);
axios.CancelToken = __webpack_require__(128);
axios.isCancel = __webpack_require__(64);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(129);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(35);
var utils = __webpack_require__(9);
var InterceptorManager = __webpack_require__(123);
var dispatchRequest = __webpack_require__(124);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(63);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);
var transformData = __webpack_require__(125);
var isCancel = __webpack_require__(64);
var defaults = __webpack_require__(35);
var isAbsoluteURL = __webpack_require__(126);
var combineURLs = __webpack_require__(127);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(9);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(65);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_crypto_js__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ChatBotEncodeDecodeService=function(){function ChatBotEncodeDecodeService(){_classCallCheck(this,ChatBotEncodeDecodeService);}_createClass(ChatBotEncodeDecodeService,null,[{key:"encode",value:function encode(data){var base64Key="dHJhaW5lcl9hdXRoUGxheQ==";var key=__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Base64.parse(base64Key);var encryptedData=__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.AES.encrypt(JSON.stringify(data),key,{mode:__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.mode.ECB,padding:__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.pad.Pkcs7});return encryptedData.toString();}},{key:"decode",value:function decode(data){var base64Key="dHJhaW5lcl9hdXRoUGxheQ==";var key=__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Base64.parse(base64Key);var decryptedData=__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.AES.decrypt(data,key,{mode:__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.mode.ECB,padding:__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.pad.Pkcs7});return JSON.parse(decryptedData.toString(__WEBPACK_IMPORTED_MODULE_0_crypto_js___default.a.enc.Utf8));}}]);return ChatBotEncodeDecodeService;}();/* harmony default export */ __webpack_exports__["a"] = (ChatBotEncodeDecodeService);

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * UTF-16 BE encoding strategy.
	     */
	    var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
	        /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = (words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff;
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= utf16Str.charCodeAt(i) << (16 - (i % 2) * 16);
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    /**
	     * UTF-16 LE encoding strategy.
	     */
	    C_enc.Utf16LE = {
	        /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var utf16Chars = [];
	            for (var i = 0; i < sigBytes; i += 2) {
	                var codePoint = swapEndian((words[i >>> 2] >>> (16 - (i % 4) * 8)) & 0xffff);
	                utf16Chars.push(String.fromCharCode(codePoint));
	            }

	            return utf16Chars.join('');
	        },

	        /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */
	        parse: function (utf16Str) {
	            // Shortcut
	            var utf16StrLength = utf16Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < utf16StrLength; i++) {
	                words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << (16 - (i % 2) * 16));
	            }

	            return WordArray.create(words, utf16StrLength * 2);
	        }
	    };

	    function swapEndian(word) {
	        return ((word << 8) & 0xff00ff00) | ((word >>> 8) & 0x00ff00ff);
	    }
	}());


	return CryptoJS.enc.Utf16;

}));

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(67));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA256 = C_algo.SHA256;

	    /**
	     * SHA-224 hash algorithm.
	     */
	    var SHA224 = C_algo.SHA224 = SHA256.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init([
	                0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
	                0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA256._doFinalize.call(this);

	            hash.sigBytes -= 4;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */
	    C.SHA224 = SHA256._createHelper(SHA224);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */
	    C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
	}());


	return CryptoJS.SHA224;

}));

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(29), __webpack_require__(68));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core", "./sha512"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var X64WordArray = C_x64.WordArray;
	    var C_algo = C.algo;
	    var SHA512 = C_algo.SHA512;

	    /**
	     * SHA-384 hash algorithm.
	     */
	    var SHA384 = C_algo.SHA384 = SHA512.extend({
	        _doReset: function () {
	            this._hash = new X64WordArray.init([
	                new X64Word.init(0xcbbb9d5d, 0xc1059ed8), new X64Word.init(0x629a292a, 0x367cd507),
	                new X64Word.init(0x9159015a, 0x3070dd17), new X64Word.init(0x152fecd8, 0xf70e5939),
	                new X64Word.init(0x67332667, 0xffc00b31), new X64Word.init(0x8eb44a87, 0x68581511),
	                new X64Word.init(0xdb0c2e0d, 0x64f98fa7), new X64Word.init(0x47b5481d, 0xbefa4fa4)
	            ]);
	        },

	        _doFinalize: function () {
	            var hash = SHA512._doFinalize.call(this);

	            hash.sigBytes -= 16;

	            return hash;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */
	    C.SHA384 = SHA512._createHelper(SHA384);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */
	    C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
	}());


	return CryptoJS.SHA384;

}));

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(29));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./x64-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_x64 = C.x64;
	    var X64Word = C_x64.Word;
	    var C_algo = C.algo;

	    // Constants tables
	    var RHO_OFFSETS = [];
	    var PI_INDEXES  = [];
	    var ROUND_CONSTANTS = [];

	    // Compute Constants
	    (function () {
	        // Compute rho offset constants
	        var x = 1, y = 0;
	        for (var t = 0; t < 24; t++) {
	            RHO_OFFSETS[x + 5 * y] = ((t + 1) * (t + 2) / 2) % 64;

	            var newX = y % 5;
	            var newY = (2 * x + 3 * y) % 5;
	            x = newX;
	            y = newY;
	        }

	        // Compute pi index constants
	        for (var x = 0; x < 5; x++) {
	            for (var y = 0; y < 5; y++) {
	                PI_INDEXES[x + 5 * y] = y + ((2 * x + 3 * y) % 5) * 5;
	            }
	        }

	        // Compute round constants
	        var LFSR = 0x01;
	        for (var i = 0; i < 24; i++) {
	            var roundConstantMsw = 0;
	            var roundConstantLsw = 0;

	            for (var j = 0; j < 7; j++) {
	                if (LFSR & 0x01) {
	                    var bitPosition = (1 << j) - 1;
	                    if (bitPosition < 32) {
	                        roundConstantLsw ^= 1 << bitPosition;
	                    } else /* if (bitPosition >= 32) */ {
	                        roundConstantMsw ^= 1 << (bitPosition - 32);
	                    }
	                }

	                // Compute next LFSR
	                if (LFSR & 0x80) {
	                    // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
	                    LFSR = (LFSR << 1) ^ 0x71;
	                } else {
	                    LFSR <<= 1;
	                }
	            }

	            ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
	        }
	    }());

	    // Reusable objects for temporary values
	    var T = [];
	    (function () {
	        for (var i = 0; i < 25; i++) {
	            T[i] = X64Word.create();
	        }
	    }());

	    /**
	     * SHA-3 hash algorithm.
	     */
	    var SHA3 = C_algo.SHA3 = Hasher.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */
	        cfg: Hasher.cfg.extend({
	            outputLength: 512
	        }),

	        _doReset: function () {
	            var state = this._state = []
	            for (var i = 0; i < 25; i++) {
	                state[i] = new X64Word.init();
	            }

	            this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcuts
	            var state = this._state;
	            var nBlockSizeLanes = this.blockSize / 2;

	            // Absorb
	            for (var i = 0; i < nBlockSizeLanes; i++) {
	                // Shortcuts
	                var M2i  = M[offset + 2 * i];
	                var M2i1 = M[offset + 2 * i + 1];

	                // Swap endian
	                M2i = (
	                    (((M2i << 8)  | (M2i >>> 24)) & 0x00ff00ff) |
	                    (((M2i << 24) | (M2i >>> 8))  & 0xff00ff00)
	                );
	                M2i1 = (
	                    (((M2i1 << 8)  | (M2i1 >>> 24)) & 0x00ff00ff) |
	                    (((M2i1 << 24) | (M2i1 >>> 8))  & 0xff00ff00)
	                );

	                // Absorb message into state
	                var lane = state[i];
	                lane.high ^= M2i1;
	                lane.low  ^= M2i;
	            }

	            // Rounds
	            for (var round = 0; round < 24; round++) {
	                // Theta
	                for (var x = 0; x < 5; x++) {
	                    // Mix column lanes
	                    var tMsw = 0, tLsw = 0;
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        tMsw ^= lane.high;
	                        tLsw ^= lane.low;
	                    }

	                    // Temporary values
	                    var Tx = T[x];
	                    Tx.high = tMsw;
	                    Tx.low  = tLsw;
	                }
	                for (var x = 0; x < 5; x++) {
	                    // Shortcuts
	                    var Tx4 = T[(x + 4) % 5];
	                    var Tx1 = T[(x + 1) % 5];
	                    var Tx1Msw = Tx1.high;
	                    var Tx1Lsw = Tx1.low;

	                    // Mix surrounding columns
	                    var tMsw = Tx4.high ^ ((Tx1Msw << 1) | (Tx1Lsw >>> 31));
	                    var tLsw = Tx4.low  ^ ((Tx1Lsw << 1) | (Tx1Msw >>> 31));
	                    for (var y = 0; y < 5; y++) {
	                        var lane = state[x + 5 * y];
	                        lane.high ^= tMsw;
	                        lane.low  ^= tLsw;
	                    }
	                }

	                // Rho Pi
	                for (var laneIndex = 1; laneIndex < 25; laneIndex++) {
	                    // Shortcuts
	                    var lane = state[laneIndex];
	                    var laneMsw = lane.high;
	                    var laneLsw = lane.low;
	                    var rhoOffset = RHO_OFFSETS[laneIndex];

	                    // Rotate lanes
	                    if (rhoOffset < 32) {
	                        var tMsw = (laneMsw << rhoOffset) | (laneLsw >>> (32 - rhoOffset));
	                        var tLsw = (laneLsw << rhoOffset) | (laneMsw >>> (32 - rhoOffset));
	                    } else /* if (rhoOffset >= 32) */ {
	                        var tMsw = (laneLsw << (rhoOffset - 32)) | (laneMsw >>> (64 - rhoOffset));
	                        var tLsw = (laneMsw << (rhoOffset - 32)) | (laneLsw >>> (64 - rhoOffset));
	                    }

	                    // Transpose lanes
	                    var TPiLane = T[PI_INDEXES[laneIndex]];
	                    TPiLane.high = tMsw;
	                    TPiLane.low  = tLsw;
	                }

	                // Rho pi at x = y = 0
	                var T0 = T[0];
	                var state0 = state[0];
	                T0.high = state0.high;
	                T0.low  = state0.low;

	                // Chi
	                for (var x = 0; x < 5; x++) {
	                    for (var y = 0; y < 5; y++) {
	                        // Shortcuts
	                        var laneIndex = x + 5 * y;
	                        var lane = state[laneIndex];
	                        var TLane = T[laneIndex];
	                        var Tx1Lane = T[((x + 1) % 5) + 5 * y];
	                        var Tx2Lane = T[((x + 2) % 5) + 5 * y];

	                        // Mix rows
	                        lane.high = TLane.high ^ (~Tx1Lane.high & Tx2Lane.high);
	                        lane.low  = TLane.low  ^ (~Tx1Lane.low  & Tx2Lane.low);
	                    }
	                }

	                // Iota
	                var lane = state[0];
	                var roundConstant = ROUND_CONSTANTS[round];
	                lane.high ^= roundConstant.high;
	                lane.low  ^= roundConstant.low;;
	            }
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;
	            var blockSizeBits = this.blockSize * 32;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x1 << (24 - nBitsLeft % 32);
	            dataWords[((Math.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits) >>> 5) - 1] |= 0x80;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var state = this._state;
	            var outputLengthBytes = this.cfg.outputLength / 8;
	            var outputLengthLanes = outputLengthBytes / 8;

	            // Squeeze
	            var hashWords = [];
	            for (var i = 0; i < outputLengthLanes; i++) {
	                // Shortcuts
	                var lane = state[i];
	                var laneMsw = lane.high;
	                var laneLsw = lane.low;

	                // Swap endian
	                laneMsw = (
	                    (((laneMsw << 8)  | (laneMsw >>> 24)) & 0x00ff00ff) |
	                    (((laneMsw << 24) | (laneMsw >>> 8))  & 0xff00ff00)
	                );
	                laneLsw = (
	                    (((laneLsw << 8)  | (laneLsw >>> 24)) & 0x00ff00ff) |
	                    (((laneLsw << 24) | (laneLsw >>> 8))  & 0xff00ff00)
	                );

	                // Squeeze state to retrieve hash
	                hashWords.push(laneLsw);
	                hashWords.push(laneMsw);
	            }

	            // Return final computed hash
	            return new WordArray.init(hashWords, outputLengthBytes);
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);

	            var state = clone._state = this._state.slice(0);
	            for (var i = 0; i < 25; i++) {
	                state[i] = state[i].clone();
	            }

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */
	    C.SHA3 = Hasher._createHelper(SHA3);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */
	    C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
	}(Math));


	return CryptoJS.SHA3;

}));

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Constants table
	    var _zl = WordArray.create([
	        0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15,
	        7,  4, 13,  1, 10,  6, 15,  3, 12,  0,  9,  5,  2, 14, 11,  8,
	        3, 10, 14,  4,  9, 15,  8,  1,  2,  7,  0,  6, 13, 11,  5, 12,
	        1,  9, 11, 10,  0,  8, 12,  4, 13,  3,  7, 15, 14,  5,  6,  2,
	        4,  0,  5,  9,  7, 12,  2, 10, 14,  1,  3,  8, 11,  6, 15, 13]);
	    var _zr = WordArray.create([
	        5, 14,  7,  0,  9,  2, 11,  4, 13,  6, 15,  8,  1, 10,  3, 12,
	        6, 11,  3,  7,  0, 13,  5, 10, 14, 15,  8, 12,  4,  9,  1,  2,
	        15,  5,  1,  3,  7, 14,  6,  9, 11,  8, 12,  2, 10,  0,  4, 13,
	        8,  6,  4,  1,  3, 11, 15,  0,  5, 12,  2, 13,  9,  7, 10, 14,
	        12, 15, 10,  4,  1,  5,  8,  7,  6,  2, 13, 14,  0,  3,  9, 11]);
	    var _sl = WordArray.create([
	         11, 14, 15, 12,  5,  8,  7,  9, 11, 13, 14, 15,  6,  7,  9,  8,
	        7, 6,   8, 13, 11,  9,  7, 15,  7, 12, 15,  9, 11,  7, 13, 12,
	        11, 13,  6,  7, 14,  9, 13, 15, 14,  8, 13,  6,  5, 12,  7,  5,
	          11, 12, 14, 15, 14, 15,  9,  8,  9, 14,  5,  6,  8,  6,  5, 12,
	        9, 15,  5, 11,  6,  8, 13, 12,  5, 12, 13, 14, 11,  8,  5,  6 ]);
	    var _sr = WordArray.create([
	        8,  9,  9, 11, 13, 15, 15,  5,  7,  7,  8, 11, 14, 14, 12,  6,
	        9, 13, 15,  7, 12,  8,  9, 11,  7,  7, 12,  7,  6, 15, 13, 11,
	        9,  7, 15, 11,  8,  6,  6, 14, 12, 13,  5, 14, 13, 13,  7,  5,
	        15,  5,  8, 11, 14, 14,  6, 14,  6,  9, 12,  9, 12,  5, 15,  8,
	        8,  5, 12,  9, 12,  5, 14,  6,  8, 13,  6,  5, 15, 13, 11, 11 ]);

	    var _hl =  WordArray.create([ 0x00000000, 0x5A827999, 0x6ED9EBA1, 0x8F1BBCDC, 0xA953FD4E]);
	    var _hr =  WordArray.create([ 0x50A28BE6, 0x5C4DD124, 0x6D703EF3, 0x7A6D76E9, 0x00000000]);

	    /**
	     * RIPEMD160 hash algorithm.
	     */
	    var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
	        _doReset: function () {
	            this._hash  = WordArray.create([0x67452301, 0xEFCDAB89, 0x98BADCFE, 0x10325476, 0xC3D2E1F0]);
	        },

	        _doProcessBlock: function (M, offset) {

	            // Swap endian
	            for (var i = 0; i < 16; i++) {
	                // Shortcuts
	                var offset_i = offset + i;
	                var M_offset_i = M[offset_i];

	                // Swap
	                M[offset_i] = (
	                    (((M_offset_i << 8)  | (M_offset_i >>> 24)) & 0x00ff00ff) |
	                    (((M_offset_i << 24) | (M_offset_i >>> 8))  & 0xff00ff00)
	                );
	            }
	            // Shortcut
	            var H  = this._hash.words;
	            var hl = _hl.words;
	            var hr = _hr.words;
	            var zl = _zl.words;
	            var zr = _zr.words;
	            var sl = _sl.words;
	            var sr = _sr.words;

	            // Working variables
	            var al, bl, cl, dl, el;
	            var ar, br, cr, dr, er;

	            ar = al = H[0];
	            br = bl = H[1];
	            cr = cl = H[2];
	            dr = dl = H[3];
	            er = el = H[4];
	            // Computation
	            var t;
	            for (var i = 0; i < 80; i += 1) {
	                t = (al +  M[offset+zl[i]])|0;
	                if (i<16){
		            t +=  f1(bl,cl,dl) + hl[0];
	                } else if (i<32) {
		            t +=  f2(bl,cl,dl) + hl[1];
	                } else if (i<48) {
		            t +=  f3(bl,cl,dl) + hl[2];
	                } else if (i<64) {
		            t +=  f4(bl,cl,dl) + hl[3];
	                } else {// if (i<80) {
		            t +=  f5(bl,cl,dl) + hl[4];
	                }
	                t = t|0;
	                t =  rotl(t,sl[i]);
	                t = (t+el)|0;
	                al = el;
	                el = dl;
	                dl = rotl(cl, 10);
	                cl = bl;
	                bl = t;

	                t = (ar + M[offset+zr[i]])|0;
	                if (i<16){
		            t +=  f5(br,cr,dr) + hr[0];
	                } else if (i<32) {
		            t +=  f4(br,cr,dr) + hr[1];
	                } else if (i<48) {
		            t +=  f3(br,cr,dr) + hr[2];
	                } else if (i<64) {
		            t +=  f2(br,cr,dr) + hr[3];
	                } else {// if (i<80) {
		            t +=  f1(br,cr,dr) + hr[4];
	                }
	                t = t|0;
	                t =  rotl(t,sr[i]) ;
	                t = (t+er)|0;
	                ar = er;
	                er = dr;
	                dr = rotl(cr, 10);
	                cr = br;
	                br = t;
	            }
	            // Intermediate hash value
	            t    = (H[1] + cl + dr)|0;
	            H[1] = (H[2] + dl + er)|0;
	            H[2] = (H[3] + el + ar)|0;
	            H[3] = (H[4] + al + br)|0;
	            H[4] = (H[0] + bl + cr)|0;
	            H[0] =  t;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = (
	                (((nBitsTotal << 8)  | (nBitsTotal >>> 24)) & 0x00ff00ff) |
	                (((nBitsTotal << 24) | (nBitsTotal >>> 8))  & 0xff00ff00)
	            );
	            data.sigBytes = (dataWords.length + 1) * 4;

	            // Hash final blocks
	            this._process();

	            // Shortcuts
	            var hash = this._hash;
	            var H = hash.words;

	            // Swap endian
	            for (var i = 0; i < 5; i++) {
	                // Shortcut
	                var H_i = H[i];

	                // Swap
	                H[i] = (((H_i << 8)  | (H_i >>> 24)) & 0x00ff00ff) |
	                       (((H_i << 24) | (H_i >>> 8))  & 0xff00ff00);
	            }

	            // Return final computed hash
	            return hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });


	    function f1(x, y, z) {
	        return ((x) ^ (y) ^ (z));

	    }

	    function f2(x, y, z) {
	        return (((x)&(y)) | ((~x)&(z)));
	    }

	    function f3(x, y, z) {
	        return (((x) | (~(y))) ^ (z));
	    }

	    function f4(x, y, z) {
	        return (((x) & (z)) | ((y)&(~(z))));
	    }

	    function f5(x, y, z) {
	        return ((x) ^ ((y) |(~(z))));

	    }

	    function rotl(x,n) {
	        return (x<<n) | (x>>>(32-n));
	    }


	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */
	    C.RIPEMD160 = Hasher._createHelper(RIPEMD160);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */
	    C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
	}(Math));


	return CryptoJS.RIPEMD160;

}));

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(36), __webpack_require__(37));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha1", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var WordArray = C_lib.WordArray;
	    var C_algo = C.algo;
	    var SHA1 = C_algo.SHA1;
	    var HMAC = C_algo.HMAC;

	    /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */
	    var PBKDF2 = C_algo.PBKDF2 = Base.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */
	        cfg: Base.extend({
	            keySize: 128/32,
	            hasher: SHA1,
	            iterations: 1
	        }),

	        /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */
	        init: function (cfg) {
	            this.cfg = this.cfg.extend(cfg);
	        },

	        /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */
	        compute: function (password, salt) {
	            // Shortcut
	            var cfg = this.cfg;

	            // Init HMAC
	            var hmac = HMAC.create(cfg.hasher, password);

	            // Initial values
	            var derivedKey = WordArray.create();
	            var blockIndex = WordArray.create([0x00000001]);

	            // Shortcuts
	            var derivedKeyWords = derivedKey.words;
	            var blockIndexWords = blockIndex.words;
	            var keySize = cfg.keySize;
	            var iterations = cfg.iterations;

	            // Generate key
	            while (derivedKeyWords.length < keySize) {
	                var block = hmac.update(salt).finalize(blockIndex);
	                hmac.reset();

	                // Shortcuts
	                var blockWords = block.words;
	                var blockWordsLength = blockWords.length;

	                // Iterations
	                var intermediate = block;
	                for (var i = 1; i < iterations; i++) {
	                    intermediate = hmac.finalize(intermediate);
	                    hmac.reset();

	                    // Shortcut
	                    var intermediateWords = intermediate.words;

	                    // XOR intermediate with block
	                    for (var j = 0; j < blockWordsLength; j++) {
	                        blockWords[j] ^= intermediateWords[j];
	                    }
	                }

	                derivedKey.concat(block);
	                blockIndexWords[0]++;
	            }
	            derivedKey.sigBytes = keySize * 4;

	            return derivedKey;
	        }
	    });

	    /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */
	    C.PBKDF2 = function (password, salt, cfg) {
	        return PBKDF2.create(cfg).compute(password, salt);
	    };
	}());


	return CryptoJS.PBKDF2;

}));

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Cipher Feedback block mode.
	 */
	CryptoJS.mode.CFB = (function () {
	    var CFB = CryptoJS.lib.BlockCipherMode.extend();

	    CFB.Encryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // Remember this block to use with next block
	            this._prevBlock = words.slice(offset, offset + blockSize);
	        }
	    });

	    CFB.Decryptor = CFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher;
	            var blockSize = cipher.blockSize;

	            // Remember this block to use with next block
	            var thisBlock = words.slice(offset, offset + blockSize);

	            generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);

	            // This block becomes the previous block
	            this._prevBlock = thisBlock;
	        }
	    });

	    function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
	        // Shortcut
	        var iv = this._iv;

	        // Generate keystream
	        if (iv) {
	            var keystream = iv.slice(0);

	            // Remove IV for subsequent blocks
	            this._iv = undefined;
	        } else {
	            var keystream = this._prevBlock;
	        }
	        cipher.encryptBlock(keystream, 0);

	        // Encrypt
	        for (var i = 0; i < blockSize; i++) {
	            words[offset + i] ^= keystream[i];
	        }
	    }

	    return CFB;
	}());


	return CryptoJS.mode.CFB;

}));

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Counter block mode.
	 */
	CryptoJS.mode.CTR = (function () {
	    var CTR = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = CTR.Encryptor = CTR.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Increment counter
	            counter[blockSize - 1] = (counter[blockSize - 1] + 1) | 0

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTR.Decryptor = Encryptor;

	    return CTR;
	}());


	return CryptoJS.mode.CTR;

}));

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */
	CryptoJS.mode.CTRGladman = (function () {
	    var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();

		function incWord(word)
		{
			if (((word >> 24) & 0xff) === 0xff) { //overflow
			var b1 = (word >> 16)&0xff;
			var b2 = (word >> 8)&0xff;
			var b3 = word & 0xff;

			if (b1 === 0xff) // overflow b1
			{
			b1 = 0;
			if (b2 === 0xff)
			{
				b2 = 0;
				if (b3 === 0xff)
				{
					b3 = 0;
				}
				else
				{
					++b3;
				}
			}
			else
			{
				++b2;
			}
			}
			else
			{
			++b1;
			}

			word = 0;
			word += (b1 << 16);
			word += (b2 << 8);
			word += b3;
			}
			else
			{
			word += (0x01 << 24);
			}
			return word;
		}

		function incCounter(counter)
		{
			if ((counter[0] = incWord(counter[0])) === 0)
			{
				// encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
				counter[1] = incWord(counter[1]);
			}
			return counter;
		}

	    var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var counter = this._counter;

	            // Generate keystream
	            if (iv) {
	                counter = this._counter = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }

				incCounter(counter);

				var keystream = counter.slice(0);
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    CTRGladman.Decryptor = Encryptor;

	    return CTRGladman;
	}());




	return CryptoJS.mode.CTRGladman;

}));

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Output Feedback block mode.
	 */
	CryptoJS.mode.OFB = (function () {
	    var OFB = CryptoJS.lib.BlockCipherMode.extend();

	    var Encryptor = OFB.Encryptor = OFB.extend({
	        processBlock: function (words, offset) {
	            // Shortcuts
	            var cipher = this._cipher
	            var blockSize = cipher.blockSize;
	            var iv = this._iv;
	            var keystream = this._keystream;

	            // Generate keystream
	            if (iv) {
	                keystream = this._keystream = iv.slice(0);

	                // Remove IV for subsequent blocks
	                this._iv = undefined;
	            }
	            cipher.encryptBlock(keystream, 0);

	            // Encrypt
	            for (var i = 0; i < blockSize; i++) {
	                words[offset + i] ^= keystream[i];
	            }
	        }
	    });

	    OFB.Decryptor = Encryptor;

	    return OFB;
	}());


	return CryptoJS.mode.OFB;

}));

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Electronic Codebook block mode.
	 */
	CryptoJS.mode.ECB = (function () {
	    var ECB = CryptoJS.lib.BlockCipherMode.extend();

	    ECB.Encryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.encryptBlock(words, offset);
	        }
	    });

	    ECB.Decryptor = ECB.extend({
	        processBlock: function (words, offset) {
	            this._cipher.decryptBlock(words, offset);
	        }
	    });

	    return ECB;
	}());


	return CryptoJS.mode.ECB;

}));

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ANSI X.923 padding strategy.
	 */
	CryptoJS.pad.AnsiX923 = {
	    pad: function (data, blockSize) {
	        // Shortcuts
	        var dataSigBytes = data.sigBytes;
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;

	        // Compute last byte position
	        var lastBytePos = dataSigBytes + nPaddingBytes - 1;

	        // Pad
	        data.clamp();
	        data.words[lastBytePos >>> 2] |= nPaddingBytes << (24 - (lastBytePos % 4) * 8);
	        data.sigBytes += nPaddingBytes;
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Ansix923;

}));

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO 10126 padding strategy.
	 */
	CryptoJS.pad.Iso10126 = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Count padding bytes
	        var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;

	        // Pad
	        data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).
	             concat(CryptoJS.lib.WordArray.create([nPaddingBytes << 24], 1));
	    },

	    unpad: function (data) {
	        // Get number of padding bytes from last byte
	        var nPaddingBytes = data.words[(data.sigBytes - 1) >>> 2] & 0xff;

	        // Remove padding
	        data.sigBytes -= nPaddingBytes;
	    }
	};


	return CryptoJS.pad.Iso10126;

}));

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */
	CryptoJS.pad.Iso97971 = {
	    pad: function (data, blockSize) {
	        // Add 0x80 byte
	        data.concat(CryptoJS.lib.WordArray.create([0x80000000], 1));

	        // Zero pad the rest
	        CryptoJS.pad.ZeroPadding.pad(data, blockSize);
	    },

	    unpad: function (data) {
	        // Remove zero padding
	        CryptoJS.pad.ZeroPadding.unpad(data);

	        // Remove one more byte -- the 0x80 byte
	        data.sigBytes--;
	    }
	};


	return CryptoJS.pad.Iso97971;

}));

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * Zero padding strategy.
	 */
	CryptoJS.pad.ZeroPadding = {
	    pad: function (data, blockSize) {
	        // Shortcut
	        var blockSizeBytes = blockSize * 4;

	        // Pad
	        data.clamp();
	        data.sigBytes += blockSizeBytes - ((data.sigBytes % blockSizeBytes) || blockSizeBytes);
	    },

	    unpad: function (data) {
	        // Shortcut
	        var dataWords = data.words;

	        // Unpad
	        var i = data.sigBytes - 1;
	        while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
	            i--;
	        }
	        data.sigBytes = i + 1;
	    }
	};


	return CryptoJS.pad.ZeroPadding;

}));

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	/**
	 * A noop padding strategy.
	 */
	CryptoJS.pad.NoPadding = {
	    pad: function () {
	    },

	    unpad: function () {
	    }
	};


	return CryptoJS.pad.NoPadding;

}));

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (undefined) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var CipherParams = C_lib.CipherParams;
	    var C_enc = C.enc;
	    var Hex = C_enc.Hex;
	    var C_format = C.format;

	    var HexFormatter = C_format.Hex = {
	        /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */
	        stringify: function (cipherParams) {
	            return cipherParams.ciphertext.toString(Hex);
	        },

	        /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */
	        parse: function (input) {
	            var ciphertext = Hex.parse(input);
	            return CipherParams.create({ ciphertext: ciphertext });
	        }
	    };
	}());


	return CryptoJS.format.Hex;

}));

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(18), __webpack_require__(19), __webpack_require__(16), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Lookup tables
	    var SBOX = [];
	    var INV_SBOX = [];
	    var SUB_MIX_0 = [];
	    var SUB_MIX_1 = [];
	    var SUB_MIX_2 = [];
	    var SUB_MIX_3 = [];
	    var INV_SUB_MIX_0 = [];
	    var INV_SUB_MIX_1 = [];
	    var INV_SUB_MIX_2 = [];
	    var INV_SUB_MIX_3 = [];

	    // Compute lookup tables
	    (function () {
	        // Compute double table
	        var d = [];
	        for (var i = 0; i < 256; i++) {
	            if (i < 128) {
	                d[i] = i << 1;
	            } else {
	                d[i] = (i << 1) ^ 0x11b;
	            }
	        }

	        // Walk GF(2^8)
	        var x = 0;
	        var xi = 0;
	        for (var i = 0; i < 256; i++) {
	            // Compute sbox
	            var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4);
	            sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63;
	            SBOX[x] = sx;
	            INV_SBOX[sx] = x;

	            // Compute multiplication
	            var x2 = d[x];
	            var x4 = d[x2];
	            var x8 = d[x4];

	            // Compute sub bytes, mix columns tables
	            var t = (d[sx] * 0x101) ^ (sx * 0x1010100);
	            SUB_MIX_0[x] = (t << 24) | (t >>> 8);
	            SUB_MIX_1[x] = (t << 16) | (t >>> 16);
	            SUB_MIX_2[x] = (t << 8)  | (t >>> 24);
	            SUB_MIX_3[x] = t;

	            // Compute inv sub bytes, inv mix columns tables
	            var t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100);
	            INV_SUB_MIX_0[sx] = (t << 24) | (t >>> 8);
	            INV_SUB_MIX_1[sx] = (t << 16) | (t >>> 16);
	            INV_SUB_MIX_2[sx] = (t << 8)  | (t >>> 24);
	            INV_SUB_MIX_3[sx] = t;

	            // Compute next counter
	            if (!x) {
	                x = xi = 1;
	            } else {
	                x = x2 ^ d[d[d[x8 ^ x2]]];
	                xi ^= d[d[xi]];
	            }
	        }
	    }());

	    // Precomputed Rcon lookup
	    var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36];

	    /**
	     * AES block cipher algorithm.
	     */
	    var AES = C_algo.AES = BlockCipher.extend({
	        _doReset: function () {
	            // Skip reset of nRounds has been set before and key did not change
	            if (this._nRounds && this._keyPriorReset === this._key) {
	                return;
	            }

	            // Shortcuts
	            var key = this._keyPriorReset = this._key;
	            var keyWords = key.words;
	            var keySize = key.sigBytes / 4;

	            // Compute number of rounds
	            var nRounds = this._nRounds = keySize + 6;

	            // Compute number of key schedule rows
	            var ksRows = (nRounds + 1) * 4;

	            // Compute key schedule
	            var keySchedule = this._keySchedule = [];
	            for (var ksRow = 0; ksRow < ksRows; ksRow++) {
	                if (ksRow < keySize) {
	                    keySchedule[ksRow] = keyWords[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 1];

	                    if (!(ksRow % keySize)) {
	                        // Rot word
	                        t = (t << 8) | (t >>> 24);

	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];

	                        // Mix Rcon
	                        t ^= RCON[(ksRow / keySize) | 0] << 24;
	                    } else if (keySize > 6 && ksRow % keySize == 4) {
	                        // Sub word
	                        t = (SBOX[t >>> 24] << 24) | (SBOX[(t >>> 16) & 0xff] << 16) | (SBOX[(t >>> 8) & 0xff] << 8) | SBOX[t & 0xff];
	                    }

	                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
	                }
	            }

	            // Compute inv key schedule
	            var invKeySchedule = this._invKeySchedule = [];
	            for (var invKsRow = 0; invKsRow < ksRows; invKsRow++) {
	                var ksRow = ksRows - invKsRow;

	                if (invKsRow % 4) {
	                    var t = keySchedule[ksRow];
	                } else {
	                    var t = keySchedule[ksRow - 4];
	                }

	                if (invKsRow < 4 || ksRow <= 4) {
	                    invKeySchedule[invKsRow] = t;
	                } else {
	                    invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[(t >>> 16) & 0xff]] ^
	                                               INV_SUB_MIX_2[SBOX[(t >>> 8) & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
	                }
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
	        },

	        decryptBlock: function (M, offset) {
	            // Swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;

	            this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);

	            // Inv swap 2nd and 4th rows
	            var t = M[offset + 1];
	            M[offset + 1] = M[offset + 3];
	            M[offset + 3] = t;
	        },

	        _doCryptBlock: function (M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
	            // Shortcut
	            var nRounds = this._nRounds;

	            // Get input, add round key
	            var s0 = M[offset]     ^ keySchedule[0];
	            var s1 = M[offset + 1] ^ keySchedule[1];
	            var s2 = M[offset + 2] ^ keySchedule[2];
	            var s3 = M[offset + 3] ^ keySchedule[3];

	            // Key schedule row counter
	            var ksRow = 4;

	            // Rounds
	            for (var round = 1; round < nRounds; round++) {
	                // Shift rows, sub bytes, mix columns, add round key
	                var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[(s1 >>> 16) & 0xff] ^ SUB_MIX_2[(s2 >>> 8) & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
	                var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[(s2 >>> 16) & 0xff] ^ SUB_MIX_2[(s3 >>> 8) & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
	                var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[(s3 >>> 16) & 0xff] ^ SUB_MIX_2[(s0 >>> 8) & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
	                var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[(s0 >>> 16) & 0xff] ^ SUB_MIX_2[(s1 >>> 8) & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];

	                // Update state
	                s0 = t0;
	                s1 = t1;
	                s2 = t2;
	                s3 = t3;
	            }

	            // Shift rows, sub bytes, add round key
	            var t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
	            var t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
	            var t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
	            var t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];

	            // Set output
	            M[offset]     = t0;
	            M[offset + 1] = t1;
	            M[offset + 2] = t2;
	            M[offset + 3] = t3;
	        },

	        keySize: 256/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */
	    C.AES = BlockCipher._createHelper(AES);
	}());


	return CryptoJS.AES;

}));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(18), __webpack_require__(19), __webpack_require__(16), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var BlockCipher = C_lib.BlockCipher;
	    var C_algo = C.algo;

	    // Permuted Choice 1 constants
	    var PC1 = [
	        57, 49, 41, 33, 25, 17, 9,  1,
	        58, 50, 42, 34, 26, 18, 10, 2,
	        59, 51, 43, 35, 27, 19, 11, 3,
	        60, 52, 44, 36, 63, 55, 47, 39,
	        31, 23, 15, 7,  62, 54, 46, 38,
	        30, 22, 14, 6,  61, 53, 45, 37,
	        29, 21, 13, 5,  28, 20, 12, 4
	    ];

	    // Permuted Choice 2 constants
	    var PC2 = [
	        14, 17, 11, 24, 1,  5,
	        3,  28, 15, 6,  21, 10,
	        23, 19, 12, 4,  26, 8,
	        16, 7,  27, 20, 13, 2,
	        41, 52, 31, 37, 47, 55,
	        30, 40, 51, 45, 33, 48,
	        44, 49, 39, 56, 34, 53,
	        46, 42, 50, 36, 29, 32
	    ];

	    // Cumulative bit shift constants
	    var BIT_SHIFTS = [1,  2,  4,  6,  8,  10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28];

	    // SBOXes and round permutation constants
	    var SBOX_P = [
	        {
	            0x0: 0x808200,
	            0x10000000: 0x8000,
	            0x20000000: 0x808002,
	            0x30000000: 0x2,
	            0x40000000: 0x200,
	            0x50000000: 0x808202,
	            0x60000000: 0x800202,
	            0x70000000: 0x800000,
	            0x80000000: 0x202,
	            0x90000000: 0x800200,
	            0xa0000000: 0x8200,
	            0xb0000000: 0x808000,
	            0xc0000000: 0x8002,
	            0xd0000000: 0x800002,
	            0xe0000000: 0x0,
	            0xf0000000: 0x8202,
	            0x8000000: 0x0,
	            0x18000000: 0x808202,
	            0x28000000: 0x8202,
	            0x38000000: 0x8000,
	            0x48000000: 0x808200,
	            0x58000000: 0x200,
	            0x68000000: 0x808002,
	            0x78000000: 0x2,
	            0x88000000: 0x800200,
	            0x98000000: 0x8200,
	            0xa8000000: 0x808000,
	            0xb8000000: 0x800202,
	            0xc8000000: 0x800002,
	            0xd8000000: 0x8002,
	            0xe8000000: 0x202,
	            0xf8000000: 0x800000,
	            0x1: 0x8000,
	            0x10000001: 0x2,
	            0x20000001: 0x808200,
	            0x30000001: 0x800000,
	            0x40000001: 0x808002,
	            0x50000001: 0x8200,
	            0x60000001: 0x200,
	            0x70000001: 0x800202,
	            0x80000001: 0x808202,
	            0x90000001: 0x808000,
	            0xa0000001: 0x800002,
	            0xb0000001: 0x8202,
	            0xc0000001: 0x202,
	            0xd0000001: 0x800200,
	            0xe0000001: 0x8002,
	            0xf0000001: 0x0,
	            0x8000001: 0x808202,
	            0x18000001: 0x808000,
	            0x28000001: 0x800000,
	            0x38000001: 0x200,
	            0x48000001: 0x8000,
	            0x58000001: 0x800002,
	            0x68000001: 0x2,
	            0x78000001: 0x8202,
	            0x88000001: 0x8002,
	            0x98000001: 0x800202,
	            0xa8000001: 0x202,
	            0xb8000001: 0x808200,
	            0xc8000001: 0x800200,
	            0xd8000001: 0x0,
	            0xe8000001: 0x8200,
	            0xf8000001: 0x808002
	        },
	        {
	            0x0: 0x40084010,
	            0x1000000: 0x4000,
	            0x2000000: 0x80000,
	            0x3000000: 0x40080010,
	            0x4000000: 0x40000010,
	            0x5000000: 0x40084000,
	            0x6000000: 0x40004000,
	            0x7000000: 0x10,
	            0x8000000: 0x84000,
	            0x9000000: 0x40004010,
	            0xa000000: 0x40000000,
	            0xb000000: 0x84010,
	            0xc000000: 0x80010,
	            0xd000000: 0x0,
	            0xe000000: 0x4010,
	            0xf000000: 0x40080000,
	            0x800000: 0x40004000,
	            0x1800000: 0x84010,
	            0x2800000: 0x10,
	            0x3800000: 0x40004010,
	            0x4800000: 0x40084010,
	            0x5800000: 0x40000000,
	            0x6800000: 0x80000,
	            0x7800000: 0x40080010,
	            0x8800000: 0x80010,
	            0x9800000: 0x0,
	            0xa800000: 0x4000,
	            0xb800000: 0x40080000,
	            0xc800000: 0x40000010,
	            0xd800000: 0x84000,
	            0xe800000: 0x40084000,
	            0xf800000: 0x4010,
	            0x10000000: 0x0,
	            0x11000000: 0x40080010,
	            0x12000000: 0x40004010,
	            0x13000000: 0x40084000,
	            0x14000000: 0x40080000,
	            0x15000000: 0x10,
	            0x16000000: 0x84010,
	            0x17000000: 0x4000,
	            0x18000000: 0x4010,
	            0x19000000: 0x80000,
	            0x1a000000: 0x80010,
	            0x1b000000: 0x40000010,
	            0x1c000000: 0x84000,
	            0x1d000000: 0x40004000,
	            0x1e000000: 0x40000000,
	            0x1f000000: 0x40084010,
	            0x10800000: 0x84010,
	            0x11800000: 0x80000,
	            0x12800000: 0x40080000,
	            0x13800000: 0x4000,
	            0x14800000: 0x40004000,
	            0x15800000: 0x40084010,
	            0x16800000: 0x10,
	            0x17800000: 0x40000000,
	            0x18800000: 0x40084000,
	            0x19800000: 0x40000010,
	            0x1a800000: 0x40004010,
	            0x1b800000: 0x80010,
	            0x1c800000: 0x0,
	            0x1d800000: 0x4010,
	            0x1e800000: 0x40080010,
	            0x1f800000: 0x84000
	        },
	        {
	            0x0: 0x104,
	            0x100000: 0x0,
	            0x200000: 0x4000100,
	            0x300000: 0x10104,
	            0x400000: 0x10004,
	            0x500000: 0x4000004,
	            0x600000: 0x4010104,
	            0x700000: 0x4010000,
	            0x800000: 0x4000000,
	            0x900000: 0x4010100,
	            0xa00000: 0x10100,
	            0xb00000: 0x4010004,
	            0xc00000: 0x4000104,
	            0xd00000: 0x10000,
	            0xe00000: 0x4,
	            0xf00000: 0x100,
	            0x80000: 0x4010100,
	            0x180000: 0x4010004,
	            0x280000: 0x0,
	            0x380000: 0x4000100,
	            0x480000: 0x4000004,
	            0x580000: 0x10000,
	            0x680000: 0x10004,
	            0x780000: 0x104,
	            0x880000: 0x4,
	            0x980000: 0x100,
	            0xa80000: 0x4010000,
	            0xb80000: 0x10104,
	            0xc80000: 0x10100,
	            0xd80000: 0x4000104,
	            0xe80000: 0x4010104,
	            0xf80000: 0x4000000,
	            0x1000000: 0x4010100,
	            0x1100000: 0x10004,
	            0x1200000: 0x10000,
	            0x1300000: 0x4000100,
	            0x1400000: 0x100,
	            0x1500000: 0x4010104,
	            0x1600000: 0x4000004,
	            0x1700000: 0x0,
	            0x1800000: 0x4000104,
	            0x1900000: 0x4000000,
	            0x1a00000: 0x4,
	            0x1b00000: 0x10100,
	            0x1c00000: 0x4010000,
	            0x1d00000: 0x104,
	            0x1e00000: 0x10104,
	            0x1f00000: 0x4010004,
	            0x1080000: 0x4000000,
	            0x1180000: 0x104,
	            0x1280000: 0x4010100,
	            0x1380000: 0x0,
	            0x1480000: 0x10004,
	            0x1580000: 0x4000100,
	            0x1680000: 0x100,
	            0x1780000: 0x4010004,
	            0x1880000: 0x10000,
	            0x1980000: 0x4010104,
	            0x1a80000: 0x10104,
	            0x1b80000: 0x4000004,
	            0x1c80000: 0x4000104,
	            0x1d80000: 0x4010000,
	            0x1e80000: 0x4,
	            0x1f80000: 0x10100
	        },
	        {
	            0x0: 0x80401000,
	            0x10000: 0x80001040,
	            0x20000: 0x401040,
	            0x30000: 0x80400000,
	            0x40000: 0x0,
	            0x50000: 0x401000,
	            0x60000: 0x80000040,
	            0x70000: 0x400040,
	            0x80000: 0x80000000,
	            0x90000: 0x400000,
	            0xa0000: 0x40,
	            0xb0000: 0x80001000,
	            0xc0000: 0x80400040,
	            0xd0000: 0x1040,
	            0xe0000: 0x1000,
	            0xf0000: 0x80401040,
	            0x8000: 0x80001040,
	            0x18000: 0x40,
	            0x28000: 0x80400040,
	            0x38000: 0x80001000,
	            0x48000: 0x401000,
	            0x58000: 0x80401040,
	            0x68000: 0x0,
	            0x78000: 0x80400000,
	            0x88000: 0x1000,
	            0x98000: 0x80401000,
	            0xa8000: 0x400000,
	            0xb8000: 0x1040,
	            0xc8000: 0x80000000,
	            0xd8000: 0x400040,
	            0xe8000: 0x401040,
	            0xf8000: 0x80000040,
	            0x100000: 0x400040,
	            0x110000: 0x401000,
	            0x120000: 0x80000040,
	            0x130000: 0x0,
	            0x140000: 0x1040,
	            0x150000: 0x80400040,
	            0x160000: 0x80401000,
	            0x170000: 0x80001040,
	            0x180000: 0x80401040,
	            0x190000: 0x80000000,
	            0x1a0000: 0x80400000,
	            0x1b0000: 0x401040,
	            0x1c0000: 0x80001000,
	            0x1d0000: 0x400000,
	            0x1e0000: 0x40,
	            0x1f0000: 0x1000,
	            0x108000: 0x80400000,
	            0x118000: 0x80401040,
	            0x128000: 0x0,
	            0x138000: 0x401000,
	            0x148000: 0x400040,
	            0x158000: 0x80000000,
	            0x168000: 0x80001040,
	            0x178000: 0x40,
	            0x188000: 0x80000040,
	            0x198000: 0x1000,
	            0x1a8000: 0x80001000,
	            0x1b8000: 0x80400040,
	            0x1c8000: 0x1040,
	            0x1d8000: 0x80401000,
	            0x1e8000: 0x400000,
	            0x1f8000: 0x401040
	        },
	        {
	            0x0: 0x80,
	            0x1000: 0x1040000,
	            0x2000: 0x40000,
	            0x3000: 0x20000000,
	            0x4000: 0x20040080,
	            0x5000: 0x1000080,
	            0x6000: 0x21000080,
	            0x7000: 0x40080,
	            0x8000: 0x1000000,
	            0x9000: 0x20040000,
	            0xa000: 0x20000080,
	            0xb000: 0x21040080,
	            0xc000: 0x21040000,
	            0xd000: 0x0,
	            0xe000: 0x1040080,
	            0xf000: 0x21000000,
	            0x800: 0x1040080,
	            0x1800: 0x21000080,
	            0x2800: 0x80,
	            0x3800: 0x1040000,
	            0x4800: 0x40000,
	            0x5800: 0x20040080,
	            0x6800: 0x21040000,
	            0x7800: 0x20000000,
	            0x8800: 0x20040000,
	            0x9800: 0x0,
	            0xa800: 0x21040080,
	            0xb800: 0x1000080,
	            0xc800: 0x20000080,
	            0xd800: 0x21000000,
	            0xe800: 0x1000000,
	            0xf800: 0x40080,
	            0x10000: 0x40000,
	            0x11000: 0x80,
	            0x12000: 0x20000000,
	            0x13000: 0x21000080,
	            0x14000: 0x1000080,
	            0x15000: 0x21040000,
	            0x16000: 0x20040080,
	            0x17000: 0x1000000,
	            0x18000: 0x21040080,
	            0x19000: 0x21000000,
	            0x1a000: 0x1040000,
	            0x1b000: 0x20040000,
	            0x1c000: 0x40080,
	            0x1d000: 0x20000080,
	            0x1e000: 0x0,
	            0x1f000: 0x1040080,
	            0x10800: 0x21000080,
	            0x11800: 0x1000000,
	            0x12800: 0x1040000,
	            0x13800: 0x20040080,
	            0x14800: 0x20000000,
	            0x15800: 0x1040080,
	            0x16800: 0x80,
	            0x17800: 0x21040000,
	            0x18800: 0x40080,
	            0x19800: 0x21040080,
	            0x1a800: 0x0,
	            0x1b800: 0x21000000,
	            0x1c800: 0x1000080,
	            0x1d800: 0x40000,
	            0x1e800: 0x20040000,
	            0x1f800: 0x20000080
	        },
	        {
	            0x0: 0x10000008,
	            0x100: 0x2000,
	            0x200: 0x10200000,
	            0x300: 0x10202008,
	            0x400: 0x10002000,
	            0x500: 0x200000,
	            0x600: 0x200008,
	            0x700: 0x10000000,
	            0x800: 0x0,
	            0x900: 0x10002008,
	            0xa00: 0x202000,
	            0xb00: 0x8,
	            0xc00: 0x10200008,
	            0xd00: 0x202008,
	            0xe00: 0x2008,
	            0xf00: 0x10202000,
	            0x80: 0x10200000,
	            0x180: 0x10202008,
	            0x280: 0x8,
	            0x380: 0x200000,
	            0x480: 0x202008,
	            0x580: 0x10000008,
	            0x680: 0x10002000,
	            0x780: 0x2008,
	            0x880: 0x200008,
	            0x980: 0x2000,
	            0xa80: 0x10002008,
	            0xb80: 0x10200008,
	            0xc80: 0x0,
	            0xd80: 0x10202000,
	            0xe80: 0x202000,
	            0xf80: 0x10000000,
	            0x1000: 0x10002000,
	            0x1100: 0x10200008,
	            0x1200: 0x10202008,
	            0x1300: 0x2008,
	            0x1400: 0x200000,
	            0x1500: 0x10000000,
	            0x1600: 0x10000008,
	            0x1700: 0x202000,
	            0x1800: 0x202008,
	            0x1900: 0x0,
	            0x1a00: 0x8,
	            0x1b00: 0x10200000,
	            0x1c00: 0x2000,
	            0x1d00: 0x10002008,
	            0x1e00: 0x10202000,
	            0x1f00: 0x200008,
	            0x1080: 0x8,
	            0x1180: 0x202000,
	            0x1280: 0x200000,
	            0x1380: 0x10000008,
	            0x1480: 0x10002000,
	            0x1580: 0x2008,
	            0x1680: 0x10202008,
	            0x1780: 0x10200000,
	            0x1880: 0x10202000,
	            0x1980: 0x10200008,
	            0x1a80: 0x2000,
	            0x1b80: 0x202008,
	            0x1c80: 0x200008,
	            0x1d80: 0x0,
	            0x1e80: 0x10000000,
	            0x1f80: 0x10002008
	        },
	        {
	            0x0: 0x100000,
	            0x10: 0x2000401,
	            0x20: 0x400,
	            0x30: 0x100401,
	            0x40: 0x2100401,
	            0x50: 0x0,
	            0x60: 0x1,
	            0x70: 0x2100001,
	            0x80: 0x2000400,
	            0x90: 0x100001,
	            0xa0: 0x2000001,
	            0xb0: 0x2100400,
	            0xc0: 0x2100000,
	            0xd0: 0x401,
	            0xe0: 0x100400,
	            0xf0: 0x2000000,
	            0x8: 0x2100001,
	            0x18: 0x0,
	            0x28: 0x2000401,
	            0x38: 0x2100400,
	            0x48: 0x100000,
	            0x58: 0x2000001,
	            0x68: 0x2000000,
	            0x78: 0x401,
	            0x88: 0x100401,
	            0x98: 0x2000400,
	            0xa8: 0x2100000,
	            0xb8: 0x100001,
	            0xc8: 0x400,
	            0xd8: 0x2100401,
	            0xe8: 0x1,
	            0xf8: 0x100400,
	            0x100: 0x2000000,
	            0x110: 0x100000,
	            0x120: 0x2000401,
	            0x130: 0x2100001,
	            0x140: 0x100001,
	            0x150: 0x2000400,
	            0x160: 0x2100400,
	            0x170: 0x100401,
	            0x180: 0x401,
	            0x190: 0x2100401,
	            0x1a0: 0x100400,
	            0x1b0: 0x1,
	            0x1c0: 0x0,
	            0x1d0: 0x2100000,
	            0x1e0: 0x2000001,
	            0x1f0: 0x400,
	            0x108: 0x100400,
	            0x118: 0x2000401,
	            0x128: 0x2100001,
	            0x138: 0x1,
	            0x148: 0x2000000,
	            0x158: 0x100000,
	            0x168: 0x401,
	            0x178: 0x2100400,
	            0x188: 0x2000001,
	            0x198: 0x2100000,
	            0x1a8: 0x0,
	            0x1b8: 0x2100401,
	            0x1c8: 0x100401,
	            0x1d8: 0x400,
	            0x1e8: 0x2000400,
	            0x1f8: 0x100001
	        },
	        {
	            0x0: 0x8000820,
	            0x1: 0x20000,
	            0x2: 0x8000000,
	            0x3: 0x20,
	            0x4: 0x20020,
	            0x5: 0x8020820,
	            0x6: 0x8020800,
	            0x7: 0x800,
	            0x8: 0x8020000,
	            0x9: 0x8000800,
	            0xa: 0x20800,
	            0xb: 0x8020020,
	            0xc: 0x820,
	            0xd: 0x0,
	            0xe: 0x8000020,
	            0xf: 0x20820,
	            0x80000000: 0x800,
	            0x80000001: 0x8020820,
	            0x80000002: 0x8000820,
	            0x80000003: 0x8000000,
	            0x80000004: 0x8020000,
	            0x80000005: 0x20800,
	            0x80000006: 0x20820,
	            0x80000007: 0x20,
	            0x80000008: 0x8000020,
	            0x80000009: 0x820,
	            0x8000000a: 0x20020,
	            0x8000000b: 0x8020800,
	            0x8000000c: 0x0,
	            0x8000000d: 0x8020020,
	            0x8000000e: 0x8000800,
	            0x8000000f: 0x20000,
	            0x10: 0x20820,
	            0x11: 0x8020800,
	            0x12: 0x20,
	            0x13: 0x800,
	            0x14: 0x8000800,
	            0x15: 0x8000020,
	            0x16: 0x8020020,
	            0x17: 0x20000,
	            0x18: 0x0,
	            0x19: 0x20020,
	            0x1a: 0x8020000,
	            0x1b: 0x8000820,
	            0x1c: 0x8020820,
	            0x1d: 0x20800,
	            0x1e: 0x820,
	            0x1f: 0x8000000,
	            0x80000010: 0x20000,
	            0x80000011: 0x800,
	            0x80000012: 0x8020020,
	            0x80000013: 0x20820,
	            0x80000014: 0x20,
	            0x80000015: 0x8020000,
	            0x80000016: 0x8000000,
	            0x80000017: 0x8000820,
	            0x80000018: 0x8020820,
	            0x80000019: 0x8000020,
	            0x8000001a: 0x8000800,
	            0x8000001b: 0x0,
	            0x8000001c: 0x20800,
	            0x8000001d: 0x820,
	            0x8000001e: 0x20020,
	            0x8000001f: 0x8020800
	        }
	    ];

	    // Masks that select the SBOX input
	    var SBOX_MASK = [
	        0xf8000001, 0x1f800000, 0x01f80000, 0x001f8000,
	        0x0001f800, 0x00001f80, 0x000001f8, 0x8000001f
	    ];

	    /**
	     * DES block cipher algorithm.
	     */
	    var DES = C_algo.DES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Select 56 bits according to PC1
	            var keyBits = [];
	            for (var i = 0; i < 56; i++) {
	                var keyBitPos = PC1[i] - 1;
	                keyBits[i] = (keyWords[keyBitPos >>> 5] >>> (31 - keyBitPos % 32)) & 1;
	            }

	            // Assemble 16 subkeys
	            var subKeys = this._subKeys = [];
	            for (var nSubKey = 0; nSubKey < 16; nSubKey++) {
	                // Create subkey
	                var subKey = subKeys[nSubKey] = [];

	                // Shortcut
	                var bitShift = BIT_SHIFTS[nSubKey];

	                // Select 48 bits according to PC2
	                for (var i = 0; i < 24; i++) {
	                    // Select from the left 28 key bits
	                    subKey[(i / 6) | 0] |= keyBits[((PC2[i] - 1) + bitShift) % 28] << (31 - i % 6);

	                    // Select from the right 28 key bits
	                    subKey[4 + ((i / 6) | 0)] |= keyBits[28 + (((PC2[i + 24] - 1) + bitShift) % 28)] << (31 - i % 6);
	                }

	                // Since each subkey is applied to an expanded 32-bit input,
	                // the subkey can be broken into 8 values scaled to 32-bits,
	                // which allows the key to be used without expansion
	                subKey[0] = (subKey[0] << 1) | (subKey[0] >>> 31);
	                for (var i = 1; i < 7; i++) {
	                    subKey[i] = subKey[i] >>> ((i - 1) * 4 + 3);
	                }
	                subKey[7] = (subKey[7] << 5) | (subKey[7] >>> 27);
	            }

	            // Compute inverse subkeys
	            var invSubKeys = this._invSubKeys = [];
	            for (var i = 0; i < 16; i++) {
	                invSubKeys[i] = subKeys[15 - i];
	            }
	        },

	        encryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._subKeys);
	        },

	        decryptBlock: function (M, offset) {
	            this._doCryptBlock(M, offset, this._invSubKeys);
	        },

	        _doCryptBlock: function (M, offset, subKeys) {
	            // Get input
	            this._lBlock = M[offset];
	            this._rBlock = M[offset + 1];

	            // Initial permutation
	            exchangeLR.call(this, 4,  0x0f0f0f0f);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeLR.call(this, 1,  0x55555555);

	            // Rounds
	            for (var round = 0; round < 16; round++) {
	                // Shortcuts
	                var subKey = subKeys[round];
	                var lBlock = this._lBlock;
	                var rBlock = this._rBlock;

	                // Feistel function
	                var f = 0;
	                for (var i = 0; i < 8; i++) {
	                    f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
	                }
	                this._lBlock = rBlock;
	                this._rBlock = lBlock ^ f;
	            }

	            // Undo swap from last round
	            var t = this._lBlock;
	            this._lBlock = this._rBlock;
	            this._rBlock = t;

	            // Final permutation
	            exchangeLR.call(this, 1,  0x55555555);
	            exchangeRL.call(this, 8,  0x00ff00ff);
	            exchangeRL.call(this, 2,  0x33333333);
	            exchangeLR.call(this, 16, 0x0000ffff);
	            exchangeLR.call(this, 4,  0x0f0f0f0f);

	            // Set output
	            M[offset] = this._lBlock;
	            M[offset + 1] = this._rBlock;
	        },

	        keySize: 64/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    // Swap bits across the left and right words
	    function exchangeLR(offset, mask) {
	        var t = ((this._lBlock >>> offset) ^ this._rBlock) & mask;
	        this._rBlock ^= t;
	        this._lBlock ^= t << offset;
	    }

	    function exchangeRL(offset, mask) {
	        var t = ((this._rBlock >>> offset) ^ this._lBlock) & mask;
	        this._lBlock ^= t;
	        this._rBlock ^= t << offset;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */
	    C.DES = BlockCipher._createHelper(DES);

	    /**
	     * Triple-DES block cipher algorithm.
	     */
	    var TripleDES = C_algo.TripleDES = BlockCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;

	            // Create DES instances
	            this._des1 = DES.createEncryptor(WordArray.create(keyWords.slice(0, 2)));
	            this._des2 = DES.createEncryptor(WordArray.create(keyWords.slice(2, 4)));
	            this._des3 = DES.createEncryptor(WordArray.create(keyWords.slice(4, 6)));
	        },

	        encryptBlock: function (M, offset) {
	            this._des1.encryptBlock(M, offset);
	            this._des2.decryptBlock(M, offset);
	            this._des3.encryptBlock(M, offset);
	        },

	        decryptBlock: function (M, offset) {
	            this._des3.decryptBlock(M, offset);
	            this._des2.encryptBlock(M, offset);
	            this._des1.decryptBlock(M, offset);
	        },

	        keySize: 192/32,

	        ivSize: 64/32,

	        blockSize: 64/32
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */
	    C.TripleDES = BlockCipher._createHelper(TripleDES);
	}());


	return CryptoJS.TripleDES;

}));

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(18), __webpack_require__(19), __webpack_require__(16), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    /**
	     * RC4 stream cipher algorithm.
	     */
	    var RC4 = C_algo.RC4 = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var key = this._key;
	            var keyWords = key.words;
	            var keySigBytes = key.sigBytes;

	            // Init sbox
	            var S = this._S = [];
	            for (var i = 0; i < 256; i++) {
	                S[i] = i;
	            }

	            // Key setup
	            for (var i = 0, j = 0; i < 256; i++) {
	                var keyByteIndex = i % keySigBytes;
	                var keyByte = (keyWords[keyByteIndex >>> 2] >>> (24 - (keyByteIndex % 4) * 8)) & 0xff;

	                j = (j + S[i] + keyByte) % 256;

	                // Swap
	                var t = S[i];
	                S[i] = S[j];
	                S[j] = t;
	            }

	            // Counters
	            this._i = this._j = 0;
	        },

	        _doProcessBlock: function (M, offset) {
	            M[offset] ^= generateKeystreamWord.call(this);
	        },

	        keySize: 256/32,

	        ivSize: 0
	    });

	    function generateKeystreamWord() {
	        // Shortcuts
	        var S = this._S;
	        var i = this._i;
	        var j = this._j;

	        // Generate keystream word
	        var keystreamWord = 0;
	        for (var n = 0; n < 4; n++) {
	            i = (i + 1) % 256;
	            j = (j + S[i]) % 256;

	            // Swap
	            var t = S[i];
	            S[i] = S[j];
	            S[j] = t;

	            keystreamWord |= S[(S[i] + S[j]) % 256] << (24 - n * 8);
	        }

	        // Update counters
	        this._i = i;
	        this._j = j;

	        return keystreamWord;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4 = StreamCipher._createHelper(RC4);

	    /**
	     * Modified RC4 stream cipher algorithm.
	     */
	    var RC4Drop = C_algo.RC4Drop = RC4.extend({
	        /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */
	        cfg: RC4.cfg.extend({
	            drop: 192
	        }),

	        _doReset: function () {
	            RC4._doReset.call(this);

	            // Drop
	            for (var i = this.cfg.drop; i > 0; i--) {
	                generateKeystreamWord.call(this);
	            }
	        }
	    });

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */
	    C.RC4Drop = StreamCipher._createHelper(RC4Drop);
	}());


	return CryptoJS.RC4;

}));

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(18), __webpack_require__(19), __webpack_require__(16), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm
	     */
	    var Rabbit = C_algo.Rabbit = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Swap endian
	            for (var i = 0; i < 4; i++) {
	                K[i] = (((K[i] << 8)  | (K[i] >>> 24)) & 0x00ff00ff) |
	                       (((K[i] << 24) | (K[i] >>> 8))  & 0xff00ff00);
	            }

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */
	    C.Rabbit = StreamCipher._createHelper(Rabbit);
	}());


	return CryptoJS.Rabbit;

}));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(2), __webpack_require__(18), __webpack_require__(19), __webpack_require__(16), __webpack_require__(6));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./enc-base64", "./md5", "./evpkdf", "./cipher-core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var StreamCipher = C_lib.StreamCipher;
	    var C_algo = C.algo;

	    // Reusable objects
	    var S  = [];
	    var C_ = [];
	    var G  = [];

	    /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */
	    var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
	        _doReset: function () {
	            // Shortcuts
	            var K = this._key.words;
	            var iv = this.cfg.iv;

	            // Generate initial state values
	            var X = this._X = [
	                K[0], (K[3] << 16) | (K[2] >>> 16),
	                K[1], (K[0] << 16) | (K[3] >>> 16),
	                K[2], (K[1] << 16) | (K[0] >>> 16),
	                K[3], (K[2] << 16) | (K[1] >>> 16)
	            ];

	            // Generate initial counter values
	            var C = this._C = [
	                (K[2] << 16) | (K[2] >>> 16), (K[0] & 0xffff0000) | (K[1] & 0x0000ffff),
	                (K[3] << 16) | (K[3] >>> 16), (K[1] & 0xffff0000) | (K[2] & 0x0000ffff),
	                (K[0] << 16) | (K[0] >>> 16), (K[2] & 0xffff0000) | (K[3] & 0x0000ffff),
	                (K[1] << 16) | (K[1] >>> 16), (K[3] & 0xffff0000) | (K[0] & 0x0000ffff)
	            ];

	            // Carry bit
	            this._b = 0;

	            // Iterate the system four times
	            for (var i = 0; i < 4; i++) {
	                nextState.call(this);
	            }

	            // Modify the counters
	            for (var i = 0; i < 8; i++) {
	                C[i] ^= X[(i + 4) & 7];
	            }

	            // IV setup
	            if (iv) {
	                // Shortcuts
	                var IV = iv.words;
	                var IV_0 = IV[0];
	                var IV_1 = IV[1];

	                // Generate four subvectors
	                var i0 = (((IV_0 << 8) | (IV_0 >>> 24)) & 0x00ff00ff) | (((IV_0 << 24) | (IV_0 >>> 8)) & 0xff00ff00);
	                var i2 = (((IV_1 << 8) | (IV_1 >>> 24)) & 0x00ff00ff) | (((IV_1 << 24) | (IV_1 >>> 8)) & 0xff00ff00);
	                var i1 = (i0 >>> 16) | (i2 & 0xffff0000);
	                var i3 = (i2 << 16)  | (i0 & 0x0000ffff);

	                // Modify counter values
	                C[0] ^= i0;
	                C[1] ^= i1;
	                C[2] ^= i2;
	                C[3] ^= i3;
	                C[4] ^= i0;
	                C[5] ^= i1;
	                C[6] ^= i2;
	                C[7] ^= i3;

	                // Iterate the system four times
	                for (var i = 0; i < 4; i++) {
	                    nextState.call(this);
	                }
	            }
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var X = this._X;

	            // Iterate the system
	            nextState.call(this);

	            // Generate four keystream words
	            S[0] = X[0] ^ (X[5] >>> 16) ^ (X[3] << 16);
	            S[1] = X[2] ^ (X[7] >>> 16) ^ (X[5] << 16);
	            S[2] = X[4] ^ (X[1] >>> 16) ^ (X[7] << 16);
	            S[3] = X[6] ^ (X[3] >>> 16) ^ (X[1] << 16);

	            for (var i = 0; i < 4; i++) {
	                // Swap endian
	                S[i] = (((S[i] << 8)  | (S[i] >>> 24)) & 0x00ff00ff) |
	                       (((S[i] << 24) | (S[i] >>> 8))  & 0xff00ff00);

	                // Encrypt
	                M[offset + i] ^= S[i];
	            }
	        },

	        blockSize: 128/32,

	        ivSize: 64/32
	    });

	    function nextState() {
	        // Shortcuts
	        var X = this._X;
	        var C = this._C;

	        // Save old counter values
	        for (var i = 0; i < 8; i++) {
	            C_[i] = C[i];
	        }

	        // Calculate new counter values
	        C[0] = (C[0] + 0x4d34d34d + this._b) | 0;
	        C[1] = (C[1] + 0xd34d34d3 + ((C[0] >>> 0) < (C_[0] >>> 0) ? 1 : 0)) | 0;
	        C[2] = (C[2] + 0x34d34d34 + ((C[1] >>> 0) < (C_[1] >>> 0) ? 1 : 0)) | 0;
	        C[3] = (C[3] + 0x4d34d34d + ((C[2] >>> 0) < (C_[2] >>> 0) ? 1 : 0)) | 0;
	        C[4] = (C[4] + 0xd34d34d3 + ((C[3] >>> 0) < (C_[3] >>> 0) ? 1 : 0)) | 0;
	        C[5] = (C[5] + 0x34d34d34 + ((C[4] >>> 0) < (C_[4] >>> 0) ? 1 : 0)) | 0;
	        C[6] = (C[6] + 0x4d34d34d + ((C[5] >>> 0) < (C_[5] >>> 0) ? 1 : 0)) | 0;
	        C[7] = (C[7] + 0xd34d34d3 + ((C[6] >>> 0) < (C_[6] >>> 0) ? 1 : 0)) | 0;
	        this._b = (C[7] >>> 0) < (C_[7] >>> 0) ? 1 : 0;

	        // Calculate the g-values
	        for (var i = 0; i < 8; i++) {
	            var gx = X[i] + C[i];

	            // Construct high and low argument for squaring
	            var ga = gx & 0xffff;
	            var gb = gx >>> 16;

	            // Calculate high and low result of squaring
	            var gh = ((((ga * ga) >>> 17) + ga * gb) >>> 15) + gb * gb;
	            var gl = (((gx & 0xffff0000) * gx) | 0) + (((gx & 0x0000ffff) * gx) | 0);

	            // High XOR low
	            G[i] = gh ^ gl;
	        }

	        // Calculate new state values
	        X[0] = (G[0] + ((G[7] << 16) | (G[7] >>> 16)) + ((G[6] << 16) | (G[6] >>> 16))) | 0;
	        X[1] = (G[1] + ((G[0] << 8)  | (G[0] >>> 24)) + G[7]) | 0;
	        X[2] = (G[2] + ((G[1] << 16) | (G[1] >>> 16)) + ((G[0] << 16) | (G[0] >>> 16))) | 0;
	        X[3] = (G[3] + ((G[2] << 8)  | (G[2] >>> 24)) + G[1]) | 0;
	        X[4] = (G[4] + ((G[3] << 16) | (G[3] >>> 16)) + ((G[2] << 16) | (G[2] >>> 16))) | 0;
	        X[5] = (G[5] + ((G[4] << 8)  | (G[4] >>> 24)) + G[3]) | 0;
	        X[6] = (G[6] + ((G[5] << 16) | (G[5] >>> 16)) + ((G[4] << 16) | (G[4] >>> 16))) | 0;
	        X[7] = (G[7] + ((G[6] << 8)  | (G[6] >>> 24)) + G[5]) | 0;
	    }

	    /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */
	    C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
	}());


	return CryptoJS.RabbitLegacy;

}));

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(155);
exports.encode = exports.stringify = __webpack_require__(156);


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefreshTokenService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__ = __webpack_require__(11);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var RefreshTokenService=function RefreshTokenService(){_classCallCheck(this,RefreshTokenService);};RefreshTokenService.refreshLoginToken=function(){return new Promise(function(resolveRefreshLoginToken,rejectRefreshLoginToken){var method="GET";var app_reference=__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].get("APP_CONTEXT");var uri="https://api.myairtelapp.bsbportal.in/myairtelapp/v2/home/mainAccCard?density=XXHDPI";var payload="";var appHeaders=app_reference.getHeaders(method,uri,payload);appHeaders=String(appHeaders).replace(/\n/g,"");appHeaders=JSON.parse(appHeaders);var headers={"x-bsy-dt":String(appHeaders["x-bsy-dt"]).replace(/\n/g,""),"x-bsy-utkn1":String(appHeaders["x-bsy-utkn"]).replace(/\n/g,""),"x-bsy-did":String(appHeaders["x-bsy-did"]).replace(/\n/g,"")};var newappHeaders=app_reference.getHeaders(method,"https://www.airtel.in/app/wl-service/airtel-digital-profile/rest/customer/profile/v2/rtn/fetch","");newappHeaders=String(newappHeaders).replace(/\n/g,"");newappHeaders=JSON.parse(newappHeaders);headers["x-bsy-utkn2"]=String(newappHeaders["x-bsy-utkn"]).replace(/\n/g,"");__WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__["a" /* default */].getChatTokenForApp(headers).then(function(result){if(result&&result.access_token){__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("loggedInToken","Bearer"+result.access_token);resolveRefreshLoginToken();}},function(err){console.log(err);rejectRefreshLoginToken();});});};RefreshTokenService.refreshBasicToken=function(){return new Promise(function(resolveRefreshBasicToken,rejectRefreshBasicToken){__WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__["a" /* default */].getChatToken().then(function(result){if(result&&result.access_token){__WEBPACK_IMPORTED_MODULE_0__services_global_store_service__["a" /* default */].set("basicToken","Bearer"+result.access_token);resolveRefreshBasicToken();}},function(err){console.log(err);rejectRefreshBasicToken();});});};

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe =
    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function(path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};


exports.basename = function(path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};


exports.extname = function(path) {
  return splitPath(path)[3];
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61)))

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleInitializationErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracking_middleware_service__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__initialize_chatbot_data_service__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__handle_user_login_service__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__ = __webpack_require__(10);
var checkAndResolveBasicToken=function checkAndResolveBasicToken(){return new Promise(function(resolve,reject){if(!__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("basicToken")){__WEBPACK_IMPORTED_MODULE_2__initialize_chatbot_data_service__["a" /* default */].getBasicTokenAndInitializeChatBotData().then(function(){resolve();}).catch(function(){reject();});}else{resolve();}});};var checkAndResolveDefaultScenarios=function checkAndResolveDefaultScenarios(){return new Promise(function(resolve,reject){var scenarioList=__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('scenarioList');if(!scenarioList||scenarioList&&(!scenarioList[__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('currentBotType')]||scenarioList[__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('currentBotType')]&&scenarioList[__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('currentBotType')].length===0)){__WEBPACK_IMPORTED_MODULE_2__initialize_chatbot_data_service__["a" /* default */].getDefaultScenariosPromise(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('currentBotType')).then(function(){resolve();},function(){// TrackingMiddlewareService.trackErrorBackend("");
__WEBPACK_IMPORTED_MODULE_1__tracking_middleware_service__["a" /* default */].trackEvent(__WEBPACK_IMPORTED_MODULE_4__enums_trackingKey__["a" /* default */].ERROR_BACKEND);reject();});}else{resolve();}});};var checkAndResolveLoggedInToken=function checkAndResolveLoggedInToken(){return new Promise(function(resolve,reject){if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("APP_CONTEXT")){if(!__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('loggedInToken')){__WEBPACK_IMPORTED_MODULE_3__handle_user_login_service__["a" /* default */].loginInApp().then(function(){resolve();}).catch(function(){reject();});}else{resolve();}}else{resolve();}});};var handleInitializationErrors=function handleInitializationErrors(errors){return new Promise(function(resolveErrors,rejectErrors){checkAndResolveBasicToken().then(function(){checkAndResolveDefaultScenarios().then(function(){checkAndResolveLoggedInToken().then(function(){if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get("APP_CONTEXT")){switch(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('userProfileType')){case'SINGLE':{resolveErrors();break;}case'MULTIPLE':{if(__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('primaryNumber')){__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].set('currentNumber',__WEBPACK_IMPORTED_MODULE_0__global_store_service__["a" /* default */].get('primaryNumber'));}resolveErrors('INITIATE_AFTER_LOGIN_IN_MULTIPLE');}}}else{resolveErrors();}}).catch(function(){rejectErrors();});}).catch(function(){rejectErrors();});}).catch(function(){rejectErrors();});});};

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingResponseComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_ComponentTypes__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_BotType__ = __webpack_require__(7);
var LoadingResponseComponent=function LoadingResponseComponent(props){var messages=props.messages;var hideLogo=false;if(messages&&messages.length>0&&messages[messages.length-1]&&messages[messages.length-1].component_type===__WEBPACK_IMPORTED_MODULE_1__enums_ComponentTypes__["a" /* default */].DEFAULT){hideLogo=true;}else{hideLogo=false;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get("currentBotType")===__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */].PAYMENTS_BANK?"arya new paymentsbank":"arya new",style:{visibility:hideLogo?'hidden':'visible'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles relate'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{style:{padding:'0px 10px 0px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wave'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dot'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dot'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'dot'})),'\u200B')));};

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dompurify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_components_confirmation_box_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__ = __webpack_require__(15);
//import '.././App.css';
var CommonOptionsResponseComponent=function CommonOptionsResponseComponent(_ref){var _ref$chatItem=_ref.chatItem,chatItem=_ref$chatItem===undefined?{}:_ref$chatItem,handleUserAction=_ref.handleUserAction,showFeedbackOptions=_ref.showFeedbackOptions,show_retry=_ref.show_retry,onRetryClick=_ref.onRetryClick,showPopup=_ref.showPopup;var response=chatItem.response,options=chatItem.options,type=chatItem.type,sentTime=chatItem.sentTime,scenarioObject=chatItem.scenarioObject,scenarioActive=chatItem.scenarioActive,scenarioResponse=chatItem.scenarioResponse;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'options_bar_position_id',style:{width:'100%'}},show_retry&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btm-links2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'options_scroll_bar',style:__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_3__enums_PlatformType__["a" /* default */].WEB?{flexWrap:'wrap',justifyContent:'center',width:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getOS()==="Windows"?'calc(100vw - 20px)':'100vw'}:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(){// onRetryClick()
handleUserAction(new __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].RETRY_CLICK));}},'Retry')))),!show_retry&&!showFeedbackOptions&&options&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'btm-links2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{id:'options_scroll_bar',style:__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_3__enums_PlatformType__["a" /* default */].WEB?{flexWrap:'wrap',justifyContent:'center',width:__WEBPACK_IMPORTED_MODULE_5__services_util_service__["a" /* default */].getOS()==="Windows"?'calc(100vw - 20px)':'100vw'}:{}},options.map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{// style={(GlobalStoreService.get('platformType')!==PlatformType.WEB && index===0)?{paddingLeft:'51px'}:{}}
className:'choice_list_item',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:function onClick(){if(scenarioResponse&&scenarioResponse.templateNameList&&scenarioResponse.templateNameList.includes('IR_149_SERVICE_PROV')&&option.displayText==='Yes'){showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_components_confirmation_box_component__["a" /* default */],{title:'IR Service Activation',messages:['By subscribing this service, you will incur a charge of Rs. 149. Are you sure you want to proceed?'],buttons:[{label:'NO',onClick:function onClick(){showPopup(undefined);handleUserAction(new __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,'No'));}},{highlight:true,label:'YES',onClick:function onClick(){showPopup(undefined);handleUserAction(new __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,'Yes'));}}]}));}else{handleUserAction(new __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,option.displayText));}}},option.displayText));}))),!show_retry&&showFeedbackOptions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rate text-center',style:{padding:'10px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'feedback-up',shref:'javascript:void(0)',className:'up',onClick:function onClick(){handleUserAction(new __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK,'GOOD_FEEDBACK'));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/like.svg',width:'20'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{id:'feedback-down',href:'javascript:void(0)',className:'response-down text-center',onClick:function onClick(){handleUserAction(new __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].FEEDBACK_CLICK,'BAD_FEEDBACK'));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/like.svg',width:'20'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-grey fs-10'},'How would you rate this solution?')));};/* harmony default export */ __webpack_exports__["a"] = (CommonOptionsResponseComponent);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_BotType__ = __webpack_require__(7);
//import '.././App.css';
var retryMessageComponent=function retryMessageComponent(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{paddingTop:'5px',paddingBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentBotType")===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].PAYMENTS_BANK?"arya new paymentsbank":"arya new"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"bubbles relate"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Ooops.. something went wrong!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"time"},__WEBPACK_IMPORTED_MODULE_2__services_util_service__["a" /* default */].getCurrentTime().time_in_format)))));};/* harmony default export */ __webpack_exports__["a"] = (retryMessageComponent);

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_message_components_data_balance_component__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_message_components_outstanding_amount_component__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_message_components_monthly_plan_component__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_message_components_ir_packs_components_ir_recommended_packs_component__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_message_components_plan_rental_component__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_message_components_chat_response_component__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_message_components_user_response_component__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_message_components_history_date_component__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_message_components_loggedInWelcome_component__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_message_components_duplicate_bills_component__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_message_components_payment_receipts_component__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_message_components_deactivate_ir_pack_component__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_message_components_switch_account_message_component__ = __webpack_require__(181);
var chooseComponentToRender=function chooseComponentToRender(_ref){var message=_ref.message,handleUserAction=_ref.handleUserAction,showPopup=_ref.showPopup,hide_logo=_ref.hide_logo,_ref$firstTimeMultipl=_ref.firstTimeMultiple,firstTimeMultiple=_ref$firstTimeMultipl===undefined?false:_ref$firstTimeMultipl,setBottomBarToInput=_ref.setBottomBarToInput,showNumbersToSwitchBot=_ref.showNumbersToSwitchBot;switch(message.component_type){case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].DEFAULT:return Object(__WEBPACK_IMPORTED_MODULE_5__components_message_components_chat_response_component__["a" /* ChatResponse */])(Object.assign({},message,{hide_logo:hide_logo}));case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].CURRENT_BILL_PLAN:return Object(__WEBPACK_IMPORTED_MODULE_4__components_message_components_plan_rental_component__["a" /* default */])(message);case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].DATA_BALANCE:return Object(__WEBPACK_IMPORTED_MODULE_0__components_message_components_data_balance_component__["a" /* default */])(message);case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].OUTSTANDING:return Object(__WEBPACK_IMPORTED_MODULE_1__components_message_components_outstanding_amount_component__["a" /* default */])(message);case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].MONTHLY_PLAN:return Object(__WEBPACK_IMPORTED_MODULE_2__components_message_components_monthly_plan_component__["a" /* default */])(Object.assign({},message,{handleUserAction:handleUserAction,showPopup:showPopup}));case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].IR_PACK:return Object(__WEBPACK_IMPORTED_MODULE_3__components_message_components_ir_packs_components_ir_recommended_packs_component__["a" /* default */])(message,setBottomBarToInput,showPopup,handleUserAction);case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].USER_RESPONSE:return Object(__WEBPACK_IMPORTED_MODULE_6__components_message_components_user_response_component__["a" /* default */])(message);case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].LOGIN_COMPONENT:return Object(__WEBPACK_IMPORTED_MODULE_5__components_message_components_chat_response_component__["a" /* ChatResponse */])(message);case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].HISTORY_DATE_COMPONENT:return Object(__WEBPACK_IMPORTED_MODULE_7__components_message_components_history_date_component__["a" /* default */])(message);case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].WELCOME_COMPONENT_MULTIPLE:{return Object(__WEBPACK_IMPORTED_MODULE_9__components_message_components_loggedInWelcome_component__["a" /* default */])(Object.assign({firstTimeMultiple:firstTimeMultiple},message,{hide_logo:hide_logo}));}case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].PREV_DUPLICATE_BILLS:{return Object(__WEBPACK_IMPORTED_MODULE_10__components_message_components_duplicate_bills_component__["a" /* default */])(Object.assign({},message,{showPopup:showPopup}));}case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].PREV_PAYMENT_RECEIPTS:{return Object(__WEBPACK_IMPORTED_MODULE_11__components_message_components_payment_receipts_component__["a" /* default */])(Object.assign({},message,{showPopup:showPopup}));}case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].IR_PACK_DEACTIVATION:{return Object(__WEBPACK_IMPORTED_MODULE_12__components_message_components_deactivate_ir_pack_component__["a" /* default */])(Object.assign({},message,{showPopup:showPopup,handleUserAction:handleUserAction,setBottomBarToInput:setBottomBarToInput}));}case __WEBPACK_IMPORTED_MODULE_8__enums_ComponentTypes__["a" /* default */].SWITCH_ACCOUNT_MESSAGE:{return Object(__WEBPACK_IMPORTED_MODULE_13__components_message_components_switch_account_message_component__["a" /* default */])(Object.assign({},message,{showNumbersToSwitchBot:showNumbersToSwitchBot}));}default:return Object(__WEBPACK_IMPORTED_MODULE_5__components_message_components_chat_response_component__["a" /* ChatResponse */])(message);}};/* harmony default export */ __webpack_exports__["a"] = ({chooseComponentToRender:chooseComponentToRender});

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var DataBalance=function DataBalance(_ref){var message=_ref.message;var response=void 0;try{response=JSON.parse(message);}catch(e){response=undefined;}var total_quota=void 0,available_quota=void 0,pack_quota=void 0,prev_month_rollover=void 0;if(response&&response.length&&response.length>0){response.map(function(key){switch(key.tagName){case'Total Quota : Available':available_quota=key.informationDisplayValue;break;case'Total Quota : Total':total_quota=key.informationDisplayValue;break;case'Pack Quota : Total':pack_quota=key.informationDisplayValue;break;case'Previous Month Rollover Quota : Total':prev_month_rollover=key.informationDisplayValue;break;}});}else{if(Object.keys(response)&&Object.keys(response).length>0){Object.keys(response).map(function(key){switch(key){case'Total Quota : Available':available_quota=response[key];break;case'Total Quota : Total':total_quota=response[key];break;case'Pack Quota : Total':pack_quota=response[key];break;case'Previous Month Rollover Quota':prev_month_rollover=response[key];break;}});}}// console.log({available_quota,total_quota,pack_quota,prev_month_rollover})
var percent=available_quota&&total_quota?100-parseInt(available_quota.split(' ')[0]/total_quota.split(' ')[0]*100):0;// let percent = 100 - parseInt((response['Total Quota : Available'].split(' ')[0]/response['Total Quota : Total'].split(' ')[0])*100)
if(percent<0){percent=0;}// TODO discuss when to show orange for data exhausted
var data_exhausted=percent>50;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' mr-10  ',style:{marginLeft:'60px',overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rental-plan text-left pt-30 width-full pb-30 data_balance_new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plan-left-part width-50percent pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"progress-circle "+('p'+percent)+(percent>50?' over50 ':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text color-white fs-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,available_quota&&available_quota.split(' ')[0],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-10'},available_quota&&available_quota.split(' ')[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-10'},'of ',total_quota,' left')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left-half-clipper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'first50-bar'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value-bar'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plan-right-part width-50percent pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-8 color-white'},'CURRENT PLAN DATA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-20 color-white'},pack_quota&&pack_quota.split(' ')[0],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-8'},pack_quota&&pack_quota.split(' ')[1])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-8 color-white pt-20'},'PREVIOUS UNUSED DATA'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-20 color-white'},prev_month_rollover&&prev_month_rollover.split(' ')[0],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-8'},prev_month_rollover&&prev_month_rollover.split(' ')[1]&&prev_month_rollover.split(' ')[1]))))));};/* harmony default export */ __webpack_exports__["a"] = (DataBalance);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var OutstandingAmount=function OutstandingAmount(_ref){var message=_ref.message;var response=JSON.parse(message);var payment_due_date=void 0,outstanding_amount=void 0;if(response&&Object.keys(response)&&Object.keys(response).length>0&&Object.keys(response).includes('Payment Due Date'||'Outstanding Amount'||'Bill Amount'||'Next Bill Date')){Object.keys(response).map(function(key){// console.log(key)
switch(key){case'Next Bill Date':payment_due_date=response[key];break;case'Payment Due Date':payment_due_date=response[key];break;case'Bill Amount':outstanding_amount=response[key];break;case'Outstanding Amount':outstanding_amount=response[key];break;}});}else{response&&response.map(function(key){switch(key.tagName){case'Payment Due Date':payment_due_date=key.informationDisplayValue;break;case'Next Bill Date':payment_due_date=key.informationDisplayValue;break;case'Bill Amount':outstanding_amount=key.informationDisplayValue;break;case'Outstanding Amount':outstanding_amount=key.informationDisplayValue;break;}});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-10 ',style:{marginLeft:'60px',overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rental-plan text-left pt-30 width-full pb-30 data_balance_new'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'outstanding-amount'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fs-10 pb-5'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'OUTSTANDING AMOUNT')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pb-15'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-30'},'Rs. ',outstanding_amount&&outstanding_amount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-10 opacity-6'},'DUE DATE: ',payment_due_date&&payment_due_date))))));};/* harmony default export */ __webpack_exports__["a"] = (OutstandingAmount);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_static_links__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__ = __webpack_require__(5);
//import '.././App.css';
var MonthlyPlan=function MonthlyPlan(_ref){var message=_ref.message,showPopup=_ref.showPopup,template_name=_ref.template_name,handleUserAction=_ref.handleUserAction,messageTime=_ref.messageTime;var data=message;try{data=JSON.parse(data);}catch(e){data=undefined;}var monthly_plans=data&&data.hasOwnProperty('Eligible Bill Plans for Change')?data['Eligible Bill Plans for Change']:data?data:undefined;var proceed_click_count=0;var getPlanLink=function getPlanLink(){if(__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')!=="WEB"){if(window.MyAirtelChatAppReact){//new app context
return __WEBPACK_IMPORTED_MODULE_1__constants_static_links__["a" /* static_links */].monthly_plans[__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')]['NEW_APP_CONTEXT'];}else if(window.MyAirtelAppReact){//old app context
return __WEBPACK_IMPORTED_MODULE_1__constants_static_links__["a" /* static_links */].monthly_plans[__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')]['OLD_APP_CONTEXT'];}}else{return __WEBPACK_IMPORTED_MODULE_1__constants_static_links__["a" /* static_links */].monthly_plans[__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')];}};var onProceed=function onProceed(plan){var planLink=getPlanLink();var mobileNumberReplacedLink=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].replaceAll(planLink,"{mobile}",__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentNumber'));showPopup(undefined);// const link = mobileNumberReplacedLink.replace("{code}", plan.code);
var link=__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].replaceAll(mobileNumberReplacedLink,"{code}",plan.code);if(link.indexOf("&uri=")>-1){var splitLink=link.split("&uri=");link=splitLink[0]+"&uri="+encodeURIComponent(splitLink[1]);}window.open(link);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"plans_scroll_"+messageTime.timestamp,style:{alignItems:'center',display:'flex'},className:"monthly-plan monthly-plan-scroll "+( false?'pl-10':'monthly-plan-single pl-67')},!monthly_plans&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"bubbles relate pl-67 relate-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_4__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE))),__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].getPlatformType()===__WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__["a" /* default */].WEB&&monthly_plans&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"carousel_web_arrows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"arrow_button_left",onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].startScrollingLeft("plans_scroll_"+messageTime.timestamp);}},"\u2039")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"arrow_button_right",onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_3__services_util_service__["a" /* default */].startScrollingRight("plans_scroll_"+messageTime.timestamp);}},"\u203A"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"carousel_list"},monthly_plans&&monthly_plans.map(function(plan,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index,className:"monthly_plan_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" plan-details color-black"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"fs-8 display-block color-grey pl-10  pt-15"},"MONTHLY PLAN"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"fs-20 display-block color-dark-grey  pl-10"},"Rs. ",plan.price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"line"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"benifits"},plan.benefits&&plan.benefits.map(function(benefit,index2){if(index2<3){switch(benefit.shortText){case'Local + STD':case'Monthly Internet':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index2},benefit.finalDisplayText+' '+benefit.displayPackDescription);case'SMS':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index2},benefit.finalDisplayText);default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index2},benefit.finalDisplayText);}}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){handleUserAction(null);onProceed(plan);},className:" cursor-pointer billplan-card-links color-link fs-12 display-block  activate"},template_name==='New_Bill_Plan'?'VIEW DETAILS':'PROCEED')));})));};/* harmony default export */ __webpack_exports__["a"] = (MonthlyPlan);

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_confirm_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_confirm_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_confirm_alert_src_react_confirm_alert_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_components_popup__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__packbenefits__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_components_confirmation_box_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__objectClasses_user_action_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__enums_UserActionType__ = __webpack_require__(15);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var IrRecommendedPacks=function IrRecommendedPacks(message,setBottomBarToInput,showPopup,handleUserAction){var packDetails=message.packDetails,chatItem=message.chatItem,templateName=message.templateName,messageTime=message.messageTime;// console.log(packDetails)
try{packDetails=JSON.parse(packDetails);}catch(e){packDetails=undefined;}var irPackList=[];packDetails=packDetails.hasOwnProperty('IR Pack Details')?packDetails['IR Pack Details']:packDetails;if(packDetails&&packDetails.suggestedIRPack){packDetails.suggestedIRPack['suggested_pack']=true;irPackList.push(packDetails.suggestedIRPack);}if(packDetails&&packDetails.otherIRPacks){irPackList.push.apply(irPackList,_toConsumableArray(packDetails.otherIRPacks));}var isSubscribedAnyPack=false;var subscribedPack={};for(var i=0;i<irPackList.length;i++){if(irPackList[i].subscribed&&irPackList[i].subscribed==='true'){isSubscribedAnyPack=true;subscribedPack=irPackList[i];}}var showMorePlans=function showMorePlans(){var monthly_plans=__WEBPACK_IMPORTED_MODULE_4_jquery___default()('.monthly_plan_item');for(var _i=0;_i<monthly_plans.length;_i++){monthly_plans[_i].style.display='table-cell';}__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#show_more_plan_link').remove();// $('#ir_packs_parent_id').addClass('monthly-plan-scroll pl-10')
// $('#ir_packs_parent_id').removeClass('monthly-plan-single pl-67')
};if(!(chatItem&&chatItem.scenarioResponse&&chatItem.scenarioResponse.templateNameList&&chatItem.scenarioResponse.templateNameList.length>0&&chatItem.scenarioResponse.templateNameList[0].includes(__WEBPACK_IMPORTED_MODULE_1__constants_globalConstants__["a" /* globalConstants */].Scenario_Template_List.IR_PACKS_RECO))){setTimeout(function(){//  showMorePlans();
});}var onProceed=function onProceed(pack){__WEBPACK_IMPORTED_MODULE_9__services_idle_timeout_service__["a" /* default */].updateIdleState();if(isSubscribedAnyPack){handleAlreadySubscribedCase(pack);}else{handleNoSubscriptioncase(pack);}};var handleNoSubscriptioncase=function handleNoSubscriptioncase(pack){showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_components_confirmation_box_component__["a" /* default */],{title:'Subscribe New Pack',messages:['Validity & Rental of Rs. '+pack.price+' would apply only when you reach the country covered under the pack. Are you sure you want to proceed?','Note: Pack rental would not be charged while in India, also pack would be renewed in case of mobile usage abroad post pack validity.'],buttons:[{label:'No',onClick:function onClick(){showPopup(undefined);setBottomBarToInput();__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].disableActivateIrCardLink();if(chatItem&&chatItem.scenarioResponse&&chatItem.scenarioResponse.templateNameList){chatItem.scenarioResponse.templateNameList=[];}// {cancel_comp_set}
__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].set("components_handler",Object.assign({},__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get('components_handler'),{bottom_bar_comp:'chat-bar-comp'}));// handleOptionsClick({option_params:{ ...chatItem,
//         option_selected:"No",
//         actionType: 'CHOICE_CLICKED'},
//         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')
//     })
handleUserAction(new __WEBPACK_IMPORTED_MODULE_13__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_14__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,'No'));}},{highlight:true,label:'Yes',onClick:function onClick(){showPopup(undefined);setBottomBarToInput();__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].disableActivateIrCardLink();// {cancel_comp_set}
__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].set("components_handler",Object.assign({},__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get('components_handler'),{bottom_bar_comp:'chat-bar-comp'}));// handleOptionsClick({option_params:{ ...chatItem,
//         option_selected:pack.id,
//         pack:pack,
//         actionType: 'CHOICE_CLICKED'},
//         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,pack.id,null,null,`I want to activate pack of Rs. ${pack.price}`)
//     })
handleUserAction(new __WEBPACK_IMPORTED_MODULE_13__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_14__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,pack.id,null,null,'I want to activate pack of Rs. '+pack.price));}}]}));};var handleAlreadySubscribedCase=function handleAlreadySubscribedCase(pack){__WEBPACK_IMPORTED_MODULE_9__services_idle_timeout_service__["a" /* default */].updateIdleState();showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_components_confirmation_box_component__["a" /* default */],{title:'Subscribe New Pack',messages:['Validity & Rental of Rs. '+pack.price+' would apply only when you reach the country covered under the pack. Are you sure you want to proceed?','Note: Pack rental would not be charged while in India, also pack would be renewed in case of mobile usage abroad post pack validity.'],buttons:[{label:'No',onClick:function onClick(){showPopup(undefined);setBottomBarToInput();__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].disableActivateIrCardLink();if(chatItem&&chatItem.scenarioResponse&&chatItem.scenarioResponse.templateNameList){chatItem.scenarioResponse.templateNameList=[];}chatItem.scenarioResponse.templateNameList=[];// handleOptionsClick({option_params:{ ...chatItem,
//         option_selected:"No",
//         actionType: 'CHOICE_CLICKED'},
//         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')})
handleUserAction(new __WEBPACK_IMPORTED_MODULE_13__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_14__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,'No'));}},{highlight:true,label:'Yes',onClick:function onClick(){showPopup(undefined);handleConfirmationForAlreadySubscribedCase(pack);}}]}));};var handleConfirmationForAlreadySubscribedCase=function handleConfirmationForAlreadySubscribedCase(pack){__WEBPACK_IMPORTED_MODULE_9__services_idle_timeout_service__["a" /* default */].updateIdleState();showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_components_confirmation_box_component__["a" /* default */],{title:'Subscribe New Pack',messages:['You have an existing pack '+subscribedPack.price+'. In order to activate the '+pack.price+' pack, we will deactivate the existing pack. Are you sure you want to continue?'],buttons:[{label:'No',onClick:function onClick(){showPopup(undefined);setBottomBarToInput();__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].disableActivateIrCardLink();if(chatItem&&chatItem.scenarioResponse&&chatItem.scenarioResponse.templateNameList){chatItem.scenarioResponse.templateNameList=[];}// handleOptionsClick({option_params:{ ...chatItem,
//         option_selected:"No",
//         actionType: 'CHOICE_CLICKED'},
//         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')})
handleUserAction(new __WEBPACK_IMPORTED_MODULE_13__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_14__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,'No'));}},{highlight:true,label:'Yes',onClick:function onClick(){showPopup(undefined);setBottomBarToInput();__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].disableActivateIrCardLink();// handleOptionsClick({option_params:{ ...chatItem,
//         option_selected:pack.id,
//         pack:pack,
//         actionType: 'CHOICE_CLICKED'},
//         userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,pack.id,null,null,`I want to activate pack of Rs. ${pack.price}`)})
handleUserAction(new __WEBPACK_IMPORTED_MODULE_13__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_14__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,pack.id,null,null,'I want to activate pack of Rs. '+pack.price));}}]}));};var showPackDetails=function showPackDetails(pack){__WEBPACK_IMPORTED_MODULE_9__services_idle_timeout_service__["a" /* default */].updateIdleState();showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__packbenefits__["a" /* default */],{pack:pack,showPopup:showPopup}));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'plans_scroll_'+messageTime.timestamp,style:{alignItems:'center',display:'flex'},className:'monthly-plan monthly-plan-scroll '+(templateName==='IR_PACKS_ALL'&&false&&irPackList.length>1?'monthly-plan-scroll pl-10':'monthly-plan-single pl-67')},__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].getPlatformType()===__WEBPACK_IMPORTED_MODULE_11__enums_PlatformType__["a" /* default */].WEB&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow_button_left',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].startScrollingLeft('plans_scroll_'+messageTime.timestamp);}},'\u2039')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow_button_right',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_10__services_util_service__["a" /* default */].startScrollingRight('plans_scroll_'+messageTime.timestamp);}},'\u203A'))),!irPackList&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles relate pl-67 relate-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_12__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,irPackList&&irPackList.map(function(pack,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'monthly_plan_item',style:{display:templateName!=='IR_PACKS_ALL'&&irPackList.length>1&&index!==0?'none':''}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plan-details color-black pos-rel'},pack.suggested_pack&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'favorite'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/favorite.svg',width:'15'})),pack.subscribed&&pack.subscribed==="true"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'active-plan'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/active-plan-new.png',width:'20'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-8 display-block color-grey pl-10  pt-15',title:pack.validity&&pack.validity},pack.validity&&pack.validity.toString().length>13?pack.validity.toString().substr(0,13)+'...':pack.validity),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-20 display-block color-dark-grey  pl-10'},'Rs. ',pack.price,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-10 color-link cursor-pointer',onClick:function onClick(){showPackDetails(pack);}},'\u24D8')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'benifits'},pack.packBenefits&&pack.packBenefits.map(function(benefit,index){if(index<3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,benefit.quota,' ',benefit.label,' ',pack.packBenefits.length>3&&index===2?'+ '+(pack.packBenefits.length-3)+' more...':'');}else{return"";}})),pack.subscribed==='false'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:message.fromHistory?true:false,style:{opacity:message.fromHistory?0.5:1},className:'ir-card-links color-link fs-12 activate cursor-pointer',onClick:function onClick(){onProceed(pack);}},'ACTIVATE')));}),templateName!=='IR_PACKS_ALL'&&irPackList.length>1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'show_more_plan_link',className:'plan-details link text-center width-auto cursor-pointer',onClick:function onClick(){showMorePlans();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'more-packs text-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/packs-arrow.svg',width:'15',className:'pt-10'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-12 color-grey'},'MORE PACKS')))));};/* harmony default export */ __webpack_exports__["a"] = (IrRecommendedPacks);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

exports.confirmAlert = confirmAlert;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(26);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(56);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactConfirmAlert = (_temp2 = _class = function (_Component) {
  _inherits(ReactConfirmAlert, _Component);

  function ReactConfirmAlert() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactConfirmAlert);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactConfirmAlert.__proto__ || Object.getPrototypeOf(ReactConfirmAlert)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickButton = function (button) {
      if (button.onClick) button.onClick();
      _this.close();
    }, _this.close = function () {
      removeElementReconfirm();
      removeSVGBlurReconfirm();
    }, _this.componentWillUnmount = function () {
      _this.props.willUnmount();
    }, _this.renderCustomUI = function () {
      var _this$props = _this.props,
          title = _this$props.title,
          message = _this$props.message,
          customUI = _this$props.customUI;

      var dataCustomUI = {
        title: title,
        message: message,
        onClose: _this.close
      };

      return customUI(dataCustomUI);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactConfirmAlert, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          title = _props.title,
          message = _props.message,
          buttons = _props.buttons,
          childrenElement = _props.childrenElement,
          customUI = _props.customUI;


      return _react2.default.createElement(
        'div',
        { className: 'react-confirm-alert-overlay' },
        _react2.default.createElement(
          'div',
          { className: 'react-confirm-alert' },
          customUI ? this.renderCustomUI() : _react2.default.createElement(
            'div',
            { className: 'react-confirm-alert-body' },
            title && _react2.default.createElement(
              'h1',
              null,
              title
            ),
            message,
            childrenElement(),
            _react2.default.createElement(
              'div',
              { className: 'react-confirm-alert-button-group' },
              buttons.map(function (button, i) {
                return _react2.default.createElement(
                  'button',
                  {
                    key: i,
                    onClick: function onClick() {
                      return _this2.handleClickButton(button);
                    }
                  },
                  button.label
                );
              })
            )
          )
        )
      );
    }
  }]);

  return ReactConfirmAlert;
}(_react.Component), _class.propTypes = {
  title: _propTypes2.default.string,
  message: _propTypes2.default.string,
  buttons: _propTypes2.default.array.isRequired,
  childrenElement: _propTypes2.default.func,
  customUI: _propTypes2.default.func,
  willUnmount: _propTypes2.default.func
}, _class.defaultProps = {
  buttons: [{
    label: 'Cancel',
    onClick: function onClick() {
      return null;
    }
  }, {
    label: 'Confirm',
    onClick: function onClick() {
      return null;
    }
  }],
  childrenElement: function childrenElement() {
    return null;
  },
  willUnmount: function willUnmount() {
    return null;
  }
}, _temp2);
exports.default = ReactConfirmAlert;


function createSVGBlurReconfirm() {
  var svgNS = 'http://www.w3.org/2000/svg';
  var feGaussianBlur = document.createElementNS(svgNS, 'feGaussianBlur');
  feGaussianBlur.setAttribute('stdDeviation', '0.7');

  var filter = document.createElementNS(svgNS, 'filter');
  filter.setAttribute('id', 'gaussian-blur');
  filter.appendChild(feGaussianBlur);

  var svgElem = document.createElementNS(svgNS, 'svg');
  svgElem.setAttribute('id', 'react-confirm-alert-firm-svg');
  svgElem.setAttribute('class', 'react-confirm-alert-svg');
  svgElem.appendChild(filter);

  document.body.appendChild(svgElem);
}

function removeSVGBlurReconfirm() {
  var svg = document.getElementById('react-confirm-alert-firm-svg');
  svg.parentNode.removeChild(svg);
  document.body.children[0].classList.remove('react-confirm-alert-blur');
}

function createElementReconfirm(properties) {
  document.body.children[0].classList.add('react-confirm-alert-blur');
  var divTarget = document.createElement('div');
  divTarget.id = 'react-confirm-alert';
  document.body.appendChild(divTarget);
  (0, _reactDom.render)(_react2.default.createElement(ReactConfirmAlert, properties), divTarget);
}

function removeElementReconfirm() {
  var target = document.getElementById('react-confirm-alert');
  (0, _reactDom.unmountComponentAtNode)(target);
  target.parentNode.removeChild(target);
}

function confirmAlert(properties) {
  createSVGBlurReconfirm();
  createElementReconfirm(properties);
}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(170);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_static_links__ = __webpack_require__(24);
var PackBenefits=function PackBenefits(_ref){var pack=_ref.pack,showPopup=_ref.showPopup;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"pull-right cursor-pointer",onClick:function onClick(){showPopup();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/help/chat"+"/assets/images/outlined-cross.svg",width:"15"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"fs-20 color-dark-grey"},"Charges post consumption of pack benefits"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"pack-benifits"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"width-full border-collapse"},pack.standardCharges.map(function(benefit,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"border-bottom-bar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-bottom-bar pt-10 pb-10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"fs-12 color-6-grey"},benefit.label)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"border-bottom-bar pt-10 pb-10 text-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"fs-12 color-6-grey"},benefit.quota)));}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"fs-14 fs-regular"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:__WEBPACK_IMPORTED_MODULE_1__constants_static_links__["a" /* static_links */].ir_pack_tnc},"Terms & Conditions "),"and ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:__WEBPACK_IMPORTED_MODULE_1__constants_static_links__["a" /* static_links */].ir_pack_standard_charges},"Standard roaming charges")," applicable")));};/* harmony default export */ __webpack_exports__["a"] = (PackBenefits);

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_util_service__ = __webpack_require__(3);
var PlanRental=function PlanRental(_ref){var message=_ref.message;var data=message;try{data=JSON.parse(data);}catch(e){data=undefined;}var current_bill_plan=data&&data['Current Bill Plan Benefits']?data['Current Bill Plan Benefits']:data?data:undefined;var viewDetailLink=__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].getPlatformWiseLinkForPlanDeatils();var benefit_object={'Local':{class:'india',priority:1},'Local + STD':{class:'india',priority:1},'Internet':{class:'internet',priority:2},'SMS':{class:'sms',priority:6},'Roam. Out.':{class:'roaming',priority:4},'Roam. Inco.':{class:'roaming',priority:5},'Movies':{class:'airtel-tv',priority:8},'Music':{class:'wynk',priority:9},'Airtel Secure':{class:'secure',priority:7},'child':{class:'child',priority:3},'default':{class:'default',priority:20}};var sorted_benefits=void 0;if(current_bill_plan&&current_bill_plan.benefits&&current_bill_plan.benefits.length>0){sorted_benefits=current_bill_plan.benefits.sort(function(a,b){if(benefit_object.hasOwnProperty(a.shortText)&&benefit_object.hasOwnProperty(b.shortText)){return benefit_object[a.shortText].priority-benefit_object[b.shortText].priority;}return 0;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mr-20',style:{marginLeft:'60px',overflow:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rental-plan text-left pt-10 width-full data_balance_new'},!current_bill_plan&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:' color-white pt-10',style:{padding:'10px'}},'No plans to show'),current_bill_plan&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:' pl-20 fs-9 color-white pt-10'},'Plan Rental'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-20 pl-20 color-white pb-5'},'Rs. ',current_bill_plan&&current_bill_plan.price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,current_bill_plan&&current_bill_plan.benefits&&sorted_benefits&&sorted_benefits.map(function(benefit,index){if(index<3&&Object.keys(benefit).length>0){var displayText="";if(benefit){if(benefit.displayPackDescription&&benefit.displayPackDescription==="4G/3G Internet"){displayText=''+(benefit.quota?benefit.quota:"")+(benefit.unit?benefit.unit:"")+' '+(benefit.displayPackDescription?benefit.displayPackDescription:"");}else{displayText=(benefit.quota?benefit.quota:"")+' '+(benefit.displayPackDescription?benefit.displayPackDescription:"");}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i',{className:'icons '+(benefit_object.hasOwnProperty(benefit.shortText)?benefit_object[benefit.shortText].class:benefit_object.default.class)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'color-white fs-11 fs-light'},displayText));}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:viewDetailLink,target:'_blank',className:'display-block text-right color-white fs-11 pb-15 pr-10 fs-light'},'VIEW DETAILS \u203A')))));};/* harmony default export */ __webpack_exports__["a"] = (PlanRental);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var HistoryDate=function HistoryDate(_ref){var message=_ref.message,messageTime=_ref.messageTime;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"historyDateDiv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"historyDateText"},message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"bg-line"}));};/* harmony default export */ __webpack_exports__["a"] = (HistoryDate);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dompurify__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dompurify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dompurify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_staticScripts__ = __webpack_require__(8);
var loggedInWelcomeComponent=function loggedInWelcomeComponent(_ref){var firstTimeMultiple=_ref.firstTimeMultiple,message=_ref.message,messageTime=_ref.messageTime,hide_logo=_ref.hide_logo,hideSelectAccountText=_ref.hideSelectAccountText,fromHistory=_ref.fromHistory;var image_width=window.innerWidth*0.3;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,firstTimeMultiple&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"welcome_multiple_div",style:{height:document.getElementById('chat_message_id').clientHeight-20+"px",padding:'0 20px',position:'absolute',overflow:'hidden',bottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{id:"welcome_multiple_image",src:"assets/images/arya.png",style:{position:'absolute',width:'30vw',height:'auto',marginTop:'20px'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"bubblesNew relateNew"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_1_dompurify___default.a.sanitize(message,{ALLOW_UNKNOWN_PROTOCOLS:true})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"time"},messageTime.time_in_format)),!hideSelectAccountText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{style:{width:'90%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Just choose a connection for which you want to talk about."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"time"},messageTime.time_in_format))))),!firstTimeMultiple&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"arya new",style:{visibility:hide_logo?'hidden':'visible'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"bubbles relate"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_1_dompurify___default.a.sanitize(message,{ALLOW_UNKNOWN_PROTOCOLS:true})}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"time"},messageTime.time_in_format)),!hideSelectAccountText&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{style:{width:'90%',marginTop:'8px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Just choose a connection for which you want to talk about."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"time"},messageTime.time_in_format)))));};/* harmony default export */ __webpack_exports__["a"] = (loggedInWelcomeComponent);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__unused_components_show_pdf_component__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_static_links__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__ = __webpack_require__(8);
var DuplicateBills=function DuplicateBills(_ref){var message=_ref.message,showPopup=_ref.showPopup,template_name=_ref.template_name,handleUserAction=_ref.handleUserAction,messageTime=_ref.messageTime;var data=message;var bills=void 0;try{data=JSON.parse(data);bills=JSON.parse(data['bills_string']);}catch(e){data=undefined;}var viewBillClick=function viewBillClick(bill){var reqData={"invoiceNumber":bill.invoiceNumber,"billAccountNumber":bill.billAccountNumber,"authToken":data.authToken,"transactionId":data.transactionId};if(__WEBPACK_IMPORTED_MODULE_6__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){//ADD DEEP LINK FOR APP
var billDeepLink=__WEBPACK_IMPORTED_MODULE_4__constants_static_links__["a" /* static_links */].duplicate_bills[__WEBPACK_IMPORTED_MODULE_6__services_global_store_service__["a" /* default */].get('platformType')];billDeepLink=__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].replaceAll(billDeepLink,"{mobile}",__WEBPACK_IMPORTED_MODULE_6__services_global_store_service__["a" /* default */].get('currentNumber'));window.open(billDeepLink);}else{__WEBPACK_IMPORTED_MODULE_2__services_chatbot_api_service__["a" /* default */].getPostPaidBill(reqData).then(function(res){var linkSource='data:application/pdf;base64,'+res;var downloadLink=document.createElement("a");var fileName='bill_'+bill.invoiceNumber+'.pdf';downloadLink.download=fileName;downloadLink.href=linkSource;downloadLink.click();}).catch(function(err){console.log('get bill err',err);});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'plans_scroll_'+messageTime.timestamp,style:{alignItems:'center',display:'flex'},className:'monthly-plan monthly-plan-scroll '+( false?'pl-10':'monthly-plan-single pl-67')},!bills&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles relate pl-67 relate-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE))),__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].getPlatformType()===__WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__["a" /* default */].WEB&&bills&&bills.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'carousel_web_arrows'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow_button_left',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].startScrollingLeft('plans_scroll_'+messageTime.timestamp);}},'\u2039')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow_button_right',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].startScrollingRight('plans_scroll_'+messageTime.timestamp);}},'\u203A'))),bills&&bills.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'carousel_list'},bills&&bills.map(function(bill,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'monthly_plan_item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' plan-details color-black',style:{height:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-8 display-block color-grey pl-10  pt-15'},'BILL'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-20 display-block color-dark-grey  pl-10'},'Rs. ',bill.monthlyCharges),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'benifits'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Bill Date ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),bill.billDate),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Invoice Number ',bill.invoiceNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,'Account Number ',bill.billAccountNumber)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){viewBillClick(bill);},className:' cursor-pointer billplan-card-links color-link fs-12 display-block  activate'},'DOWNLOAD')));})),bills&&bills.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles relate pl-67 relate-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_7__constants_staticScripts__["a" /* SCRIPTS */].NO_BILLS))));};/* harmony default export */ __webpack_exports__["a"] = (DuplicateBills);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowPDF=function(_Component){_inherits(ShowPDF,_Component);function ShowPDF(props){_classCallCheck(this,ShowPDF);var _this=_possibleConstructorReturn(this,(ShowPDF.__proto__||Object.getPrototypeOf(ShowPDF)).call(this,props));_this.onDocumentLoadSuccess=function(_ref){var numPages=_ref.numPages;_this.setState({pdf_pages:numPages});};_this.state={pdf_pages:null};return _this;}_createClass(ShowPDF,[{key:'render',value:function render(){var width=window.innerWidth-40;var options={cMapUrl:'cmaps/',cMapPacked:true};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}]);return ShowPDF;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (ShowPDF);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_staticScripts__ = __webpack_require__(8);
var PaymentReceipts=function PaymentReceipts(_ref){var message=_ref.message,showPopup=_ref.showPopup,template_name=_ref.template_name,handleUserAction=_ref.handleUserAction,messageTime=_ref.messageTime;var data=message;try{data=JSON.parse(data);}catch(e){data=undefined;}var receipts=data?data:undefined;var display_keys={paymentDate:'Payment Date',time:'Time',name:'Name',accountNumber:'Account Number',mobileNumber:'Mobile Number',payVia:'Pay Via',amountPaid:'Amount Paid'};var viewReceiptClick=function viewReceiptClick(receipt){showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"pull-right cursor-pointer",onClick:function onClick(){showPopup();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:"/help/chat"+"/assets/images/outlined-cross.svg",width:"15"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"fs-20 color-dark-grey"},"Payment Receipt"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"payment-page body-white"},Object.keys(receipt).map(function(detail_name,index){if(detail_name==='amountPaid'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"display-flex pull-left width-full pt-10 pb-70"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"pull-left pl-10 fs-bold width-50percent"},display_keys[detail_name]?display_keys[detail_name]:detail_name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"pull-right pr-10 fs-bold"},receipt[detail_name]));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:index,className:"border-bottom-grey pt-10 pb-10 width-50percent pull-left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"pl-10 fs-14 color-dark-grey"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"display-block fs-9 color-grey"},display_keys[detail_name]?display_keys[detail_name]:detail_name),receipt[detail_name]));}}))),'100vh','100vw');};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"plans_scroll_"+messageTime.timestamp,style:{alignItems:'center',display:'flex'},className:"monthly-plan monthly-plan-scroll "+( false?'pl-10':'monthly-plan-single pl-67')},!receipts&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"bubbles relate pl-67 relate-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_3__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE))),__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].getPlatformType()===__WEBPACK_IMPORTED_MODULE_2__enums_PlatformType__["a" /* default */].WEB&&receipts&&receipts.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"carousel_web_arrows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"arrow_button_left",onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].startScrollingLeft("plans_scroll_"+messageTime.timestamp);}},"\u2039")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"arrow_button_right",onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].startScrollingRight("plans_scroll_"+messageTime.timestamp);}},"\u203A"))),receipts&&receipts.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"carousel_list"},receipts&&receipts.map(function(receipt,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index,className:"monthly_plan_item"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:" plan-details color-black",style:{height:'200px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"fs-8 display-block color-grey pl-10  pt-15"},"RECEIPT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"fs-20 display-block color-dark-grey  pl-10"},"Rs. ",receipt.amountPaid),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"line"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"benifits"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,'Mobile Number '+receipt.mobileNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,'Account Number '+receipt.accountNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,'Payment Date ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),receipt.paymentDate)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){viewReceiptClick(receipt);},className:" cursor-pointer billplan-card-links color-link fs-12 display-block  activate"},"VIEW RECEIPT")));})),receipts&&receipts.length===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"bubbles relate pl-67 relate-0"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_3__constants_staticScripts__["a" /* SCRIPTS */].NO_RECEIPTS))));};/* harmony default export */ __webpack_exports__["a"] = (PaymentReceipts);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_components_confirmation_box_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_InternationRoamingPacksAndCountriesMapping__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_templateName__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__objectClasses_user_action_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_UserActionType__ = __webpack_require__(15);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var DeactivateIrPack=function DeactivateIrPack(_ref){var message=_ref.message,showPopup=_ref.showPopup,template_name=_ref.template_name,handleUserAction=_ref.handleUserAction,messageTime=_ref.messageTime,template_list=_ref.template_list,chatItem=_ref.chatItem,setBottomBarToInput=_ref.setBottomBarToInput;// console.log(template_list)
var data=message;try{data=JSON.parse(data);}catch(e){data=undefined;}//    console.log(data)
var packs=data?data:undefined;if(!template_list.includes(__WEBPACK_IMPORTED_MODULE_5__enums_templateName__["a" /* default */].IR_SERVICE_DEACTIVATION)){packs=packs.filter(function(pack){return!(pack.price==="149"||pack.price==="99"||pack.price==="0");});}var deactivateIrpack=function deactivateIrpack(pack){var popup_message=null;if(template_list.includes(__WEBPACK_IMPORTED_MODULE_5__enums_templateName__["a" /* default */].IR_MULTIPLE_ZONE_PACKS)){popup_message='Do you want me to deactivate your IR pack @ Rs.'+pack.price;}else if(template_list.includes(__WEBPACK_IMPORTED_MODULE_5__enums_templateName__["a" /* default */].IR_SINGLE_ZONE_PACKS)){popup_message='While deactivating IR pack, IR service will also get deactivated. Do you want me to proceed?';}else if(template_list.includes(__WEBPACK_IMPORTED_MODULE_5__enums_templateName__["a" /* default */].IR_SERVICE_DEACTIVATION)){popup_message='IR service will also get deactivated. Do you want me to proceed?';}showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_components_confirmation_box_component__["a" /* default */],{title:'Deactivate IR Pack',messages:[popup_message],buttons:[{label:'No',onClick:function onClick(){showPopup(undefined);setBottomBarToInput();chatItem.scenarioResponse.templateNameList=[];// handleOptionsClick({option_params:{ ...chatItem,
//         option_selected:"No",
//         actionType: 'CHOICE_CLICKED'},
// userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,'No')
//     })
handleUserAction(new __WEBPACK_IMPORTED_MODULE_7__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,'No'));__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].disableDeactivateIrCardLink();}},{highlight:true,label:'Yes',onClick:function onClick(){showPopup(undefined);setBottomBarToInput();// handleOptionsClick({option_params:{ ...chatItem,
//     option_selected:pack.id,
//     pack:pack,
//     actionType: 'CHOICE_CLICKED'},
// userActionObject: new UserActionClass(UserActionType.CHOICE_CLICKED,pack.id,null,null,`I want to deactivate pack of Rs. ${pack.price}`)
// })
handleUserAction(new __WEBPACK_IMPORTED_MODULE_7__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8__enums_UserActionType__["a" /* default */].CHOICE_CLICKED,pack.id,null,null,'I want to deactivate pack of Rs. '+pack.price));__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].disableDeactivateIrCardLink();}}]}));};var showCountries=function showCountries(pack){showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pull-right cursor-pointer',onClick:function onClick(){showPopup();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:"/help/chat"+'/assets/images/outlined-cross.svg',width:'15'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-20 color-dark-grey'},'Countries for this pack are:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'country_list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:'width-full border-collapse'},__WEBPACK_IMPORTED_MODULE_4__constants_InternationRoamingPacksAndCountriesMapping__["a" /* CountriesInPack */][pack.id].map(function(country,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:'border-bottom-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'border-bottom-bar pt-10 pb-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-12 color-6-grey'},country)));})))));};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'plans_scroll_'+messageTime.timestamp,style:{alignItems:'center',display:'flex'},className:'monthly-plan monthly-plan-scroll '+( false?'pl-10':'monthly-plan-single pl-67')},!packs&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles relate pl-67 relate-0'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_6__constants_staticScripts__["a" /* SCRIPTS */].NO_SYSTEM_INFO_MESSAGE))),__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].getPlatformType()===__WEBPACK_IMPORTED_MODULE_3__enums_PlatformType__["a" /* default */].WEB&&packs&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'carousel_web_arrows'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow_button_left',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].startScrollingLeft('plans_scroll_'+messageTime.timestamp);}},'\u2039')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'arrow_button_right',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_1__services_util_service__["a" /* default */].startScrollingRight('plans_scroll_'+messageTime.timestamp);}},'\u203A'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'carousel_list'},packs&&packs.map(function(pack,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,className:'monthly_plan_item'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:' plan-details color-black'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-8 display-block color-grey pl-10  pt-15'},pack.packName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-20 display-block color-dark-grey  pl-10'},'Rs. ',pack.price),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'benifits'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,pack.finalDisplayText),__WEBPACK_IMPORTED_MODULE_4__constants_InternationRoamingPacksAndCountriesMapping__["a" /* CountriesInPack */][pack.id]&&__WEBPACK_IMPORTED_MODULE_4__constants_InternationRoamingPacksAndCountriesMapping__["a" /* CountriesInPack */][pack.id].length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'cursor-pointer color-link',onClick:function onClick(){showCountries(pack);}},'List of Countries'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',_defineProperty({disabled:message.fromHistory?true:false,style:{opacity:message.fromHistory?0.5:1},className:'dir-card-links color-link fs-12 activate cursor-pointer',onClick:function onClick(){deactivateIrpack(pack);}},'className','dir-card-links cursor-pointer billplan-card-links color-link fs-12 display-block  activate'),'DEACTIVATE')));})));};/* harmony default export */ __webpack_exports__["a"] = (DeactivateIrPack);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CountriesInPack; });
var CountriesInPack={'SCG2990611':['Australia','Singapore'],'SCG2990652':['Bangladesh','Sri Lanka'],'SCG2990612':['Malaysia','Thailand'],'SCG2990613':['Albania','Austria','Bahamas','Bahrain','Belgium','Brunei','Bulgaria','Canada','China','Croatia','Cyprus','Czech','Denmark','Egypt','Estonia','Faroe Islands','Finland','France','Germany','Georgia','Gibraltar','Greece'],'SCG2990653':['Guernsey','Hong Kong','Hungary','Iceland','Indonesia','Ireland','Isle of Mann','Israel','Italy','jersey','Korea','Kuwait','Laos','Latvia','Liechtenstein','Lithuania','Luxembourg','Macau','Macedonia','Malta','Mauritius','Mexico'],'SCG2990614':['Mongolia','Netherlands','New Zealand','Norway','Philippines','Poland','Portugal','Romania','Senegal','Serbia','Slovakia','Slovenia','Spain','Sudan','Sweden','Switzerland','Timor','Taiwan','Turkey','United Kingdom','USA','Vietnam'],'SCG2990615':['Armenia','Brazil','Iran','Iraq'],'SCG2990654':['Japan','Jordan','Nepal','Palestine'],'SCG2990616':['Qatar','Russia','Saudi Arabia','UAE'],'SCG2990617':['Afghanistan','Algeria','Anguilla','Antigua & Barbuda','Argentina','Azerbaijan','Barbados','Belarus','Bhutan','Botswana','British Virgin Islands','Burundi','Burkina Faso','Cambodia','Cameroon','Cape Verde','Cayman Islands','Centrafrique','Chile','Colombia','Congo','Congo Republic','Costa Rica',"Cote D'Ivoire,Dominica",'Dominican Republic','Ecuador'],'SCG2990655':['El Salvador','Fiji','Gabon','Ghana','Greenland','Grenada','Guatemala','Guinea','Guinea Bissau','Honduras','Jamaica','Kazakhstan','Kenya','Lesotho','Liberia','Madagascar','Malawi','Moldova','Montserrat','Morocco','Mozambique','Myanmar','Nauru','Nicaragua','Niger','Nigeria','Oman'],'SCG2990618':['Panama','Papua New Guinea','Paraguay','Peru','Puerto rico','Reunion Island','Rwanda','Samoa','Seychelles','Sierra Leone','South Africa','St Lucia','St. Kitts & Nevis','St. Vincent & the Grenadines','Swaziland','Tajikistan','Tanzania','Tchad/Chad','Tonga','Turks & caicos','Uganda','Ukraine','Uruguay','Uzbekistan','Vanuatu','Zambia']};

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_global_store_service__ = __webpack_require__(1);
var switchAccountMessageComponent=function switchAccountMessageComponent(_ref){var message=_ref.message,messageTime=_ref.messageTime,showNumbersToSwitchBot=_ref.showNumbersToSwitchBot,hide_logo=_ref.hide_logo,fromHistory=_ref.fromHistory;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("currentBotType")===__WEBPACK_IMPORTED_MODULE_2__enums_BotType__["a" /* default */].PAYMENTS_BANK?"arya new paymentsbank":"arya new",style:{visibility:hide_logo?'hidden':'visible'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'bubbles relate'},message&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Hey! It seems like you have a ',message,' related query.',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{disabled:fromHistory?true:false,className:'cursor-pointer link-color switch_msg_btn',onClick:function onClick(){// open the switch account menu to with switch tab open for user to switch account
showNumbersToSwitchBot();}},'Click here'),' to switch to a ',message,' number from your profile.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'time'},messageTime&&messageTime.time_in_format)))));};/* harmony default export */ __webpack_exports__["a"] = (switchAccountMessageComponent);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bottom_components_user_accounts_menu_component__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bottom_components_login_web_component__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_components_default_chat_bar_components_chatBarComponent__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bottom_components_alternate_number_input_component__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bottom_components_cancel_component__ = __webpack_require__(235);
var bottomComponent=function bottomComponent(_ref){var messageComp=_ref.messageComp;var onNumberSelected=messageComp.onNumberSelected,initiateScenarioAfterLogin=messageComp.initiateScenarioAfterLogin,setBottomBarComponentState=messageComp.setBottomBarComponentState,onSkipClick=messageComp.onSkipClick,addNewMessages=messageComp.addNewMessages,afterLoginAtALaterStage=messageComp.afterLoginAtALaterStage,handleCancelButtonClick=messageComp.handleCancelButtonClick;var initiate_after_login_in_multiple=messageComp.state.initiate_after_login_in_multiple;switch(messageComp.state.bottom_comp.type){case __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU:return Object(__WEBPACK_IMPORTED_MODULE_1__bottom_components_user_accounts_menu_component__["a" /* default */])({onNumberSelected:onNumberSelected,initiateScenarioAfterLogin:initiateScenarioAfterLogin,setBottomBarComponentState:setBottomBarComponentState,addNewMessages:addNewMessages,initiate_after_login_in_multiple:initiate_after_login_in_multiple});case __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.LOGIN_COMPONENT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__bottom_components_login_web_component__["a" /* default */],{onSkipClick:onSkipClick,resetLoginState:messageComp.state.bottom_comp.resetLoginState,afterLoginAtALaterStage:afterLoginAtALaterStage});case __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__bottom_components_default_chat_bar_components_chatBarComponent__["a" /* default */],{fieldType:messageComp.state.fieldType,disableUserSubmit:messageComp.state.disableOptionClicks,disableInputField:messageComp.state.disableInputField,handleUserAction:messageComp.handleUserAction,handleBottomBarCompState:messageComp.handleBottomBarCompState,scrollToBottom:messageComp.scrollToBottom,showPopup:messageComp.showPopup,showNumbersToSwitchBot:messageComp.state.showNumbersToSwitchBot,disableNumbersToSwitchBot:messageComp.disableNumbersToSwitchBot,responseAwaiting:messageComp.state.responseAwaiting,onSwitchNumber:messageComp.onSwitchNumber});case __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CANCEL_COMPONENT:return Object(__WEBPACK_IMPORTED_MODULE_6__bottom_components_cancel_component__["a" /* default */])({handleCancelButtonClick:handleCancelButtonClick});case __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.DFF_FORM_COMPONENT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__bottom_components_alternate_number_input_component__["a" /* default */],{props:messageComp.state.bottom_comp.dff_form_obj,handleUserAction:messageComp.handleUserAction,setBottomBarComponentState:setBottomBarComponentState,onSkipClick:onSkipClick});}};/* harmony default export */ __webpack_exports__["a"] = (bottomComponent);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_nuka_carousel__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_handle_user_action_service__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_util_service__ = __webpack_require__(3);
var userAccountsMenu=function userAccountsMenu(_ref){var onNumberSelected=_ref.onNumberSelected,initiateScenarioAfterLogin=_ref.initiateScenarioAfterLogin,setBottomBarComponentState=_ref.setBottomBarComponentState,addNewMessages=_ref.addNewMessages,_ref$initiate_after_l=_ref.initiate_after_login_in_multiple,initiate_after_login_in_multiple=_ref$initiate_after_l===undefined?false:_ref$initiate_after_l;var userProfile=__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].get('userProfile');var selectNumber=function selectNumber(account){__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].set("currentNumber",account.siNumber);__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].set("currentBotType",account.type);if(__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].get("loginViaOtp")||initiate_after_login_in_multiple){__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].set("loginViaOtp",false);addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_7__services_util_service__["a" /* default */].createUserMessageObject(''+account.siNumber),__WEBPACK_IMPORTED_MODULE_7__services_util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].number_selected_acknowledgement_msg)]});initiateScenarioAfterLogin();}else{onNumberSelected({user_response:account.siNumber,show_number:true});}};// let numbers_to_show = UtilService.getUserProfileNumbersWithAccountType()
var numbers_to_show=__WEBPACK_IMPORTED_MODULE_1__services_global_store_service__["a" /* default */].get("userAccounts");var renderNumbers=function renderNumbers(){var carousel_slides=[];var _loop=function _loop(i){carousel_slides.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'services-bar item '+(i===0?'active':''),style:{paddingTop:'15px',width:'auto'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'width-full',style:{float:"left"}},numbers_to_show.map(function(item,index){if(index>=6*i&&index<6*(i+1)){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'fs-14',onClick:function onClick(){selectNumber(item);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'display-block color-grey fs-11',title:item.customerName&&item.customerName},item.customerName&&item.customerName.toString().length>20?item.customerName.toString().substr(0,18)+'...':item.customerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.siNumber),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:' display-block color-grey fs-9',title:item.type&&item.type},__WEBPACK_IMPORTED_MODULE_3__enums_BotType__["a" /* default */].getNumberTypeToShow(item.type)));}}))));};for(var i=0;i<Math.ceil(numbers_to_show.length/6);i++){_loop(i);}return carousel_slides.map(function(item){return item;});};var calculateRows=function calculateRows(){if(numbers_to_show.length<=2){return 1;}else if(numbers_to_show.length<=4){return 2;}else if(numbers_to_show.length>4){return 3;}};var slide_height=80+(36+18)*calculateRows();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home user_accounts_menu'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_nuka_carousel__["a" /* default */],{initialSlideHeight:slide_height+'px',width:window.innerWidth,slideWidth:1.0},userProfile&&userProfile.products&&numbers_to_show&&numbers_to_show.length>0&&renderNumbers()));};/* harmony default export */ __webpack_exports__["a"] = (userAccountsMenu);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Carousel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exenv__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_move_Animate__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_move_Animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_move_Animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_ease__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__default_controls__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__all_transitions__ = __webpack_require__(223);
/* unused harmony reexport NextButton */
/* unused harmony reexport PreviousButton */
/* unused harmony reexport PagingDots */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }









var addEvent = function addEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }

  if (elem.addEventListener) {
    elem.addEventListener(type, eventHandle, false);
  } else if (elem.attachEvent) {
    elem.attachEvent("on".concat(type), eventHandle);
  } else {
    elem["on".concat(type)] = eventHandle;
  }
};

var removeEvent = function removeEvent(elem, type, eventHandle) {
  if (elem === null || typeof elem === 'undefined') {
    return;
  }

  if (elem.removeEventListener) {
    elem.removeEventListener(type, eventHandle, false);
  } else if (elem.detachEvent) {
    elem.detachEvent("on".concat(type), eventHandle);
  } else {
    elem["on".concat(type)] = null;
  }
};

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Carousel, _React$Component);

  function Carousel() {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _possibleConstructorReturn(this, (Carousel.__proto__ || Object.getPrototypeOf(Carousel)).apply(this, arguments));
    _this.displayName = 'Carousel';
    _this.clickSafe = true;
    _this.touchObject = {};
    _this.controlsMap = [{
      funcName: 'renderTopLeftControls',
      key: 'TopLeft'
    }, {
      funcName: 'renderTopCenterControls',
      key: 'TopCenter'
    }, {
      funcName: 'renderTopRightControls',
      key: 'TopRight'
    }, {
      funcName: 'renderCenterLeftControls',
      key: 'CenterLeft'
    }, {
      funcName: 'renderCenterCenterControls',
      key: 'CenterCenter'
    }, {
      funcName: 'renderCenterRightControls',
      key: 'CenterRight'
    }, {
      funcName: 'renderBottomLeftControls',
      key: 'BottomLeft'
    }, {
      funcName: 'renderBottomCenterControls',
      key: 'BottomCenter'
    }, {
      funcName: 'renderBottomRightControls',
      key: 'BottomRight'
    }];

    var _this$getPropsByTrans = _this.getPropsByTransitionMode(_this.props, ['slidesToScroll', 'slidesToShow', 'cellAlign']),
        slidesToScroll = _this$getPropsByTrans.slidesToScroll,
        slidesToShow = _this$getPropsByTrans.slidesToShow,
        cellAlign = _this$getPropsByTrans.cellAlign;

    _this.state = {
      currentSlide: _this.props.slideIndex,
      dragging: false,
      frameWidth: 0,
      left: 0,
      slideCount: 0,
      slidesToScroll: slidesToScroll,
      slidesToShow: slidesToShow,
      slideWidth: 0,
      top: 0,
      cellAlign: cellAlign,
      easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__["easeCircleOut"],
      isWrappingAround: false,
      wrapToIndex: null,
      resetWrapAroundPosition: false
    };
    _this.getTouchEvents = _this.getTouchEvents.bind(_assertThisInitialized(_this));
    _this.getMouseEvents = _this.getMouseEvents.bind(_assertThisInitialized(_this));
    _this.handleMouseOver = _this.handleMouseOver.bind(_assertThisInitialized(_this));
    _this.handleMouseOut = _this.handleMouseOut.bind(_assertThisInitialized(_this));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleSwipe = _this.handleSwipe.bind(_assertThisInitialized(_this));
    _this.swipeDirection = _this.swipeDirection.bind(_assertThisInitialized(_this));
    _this.autoplayIterator = _this.autoplayIterator.bind(_assertThisInitialized(_this));
    _this.startAutoplay = _this.startAutoplay.bind(_assertThisInitialized(_this));
    _this.stopAutoplay = _this.stopAutoplay.bind(_assertThisInitialized(_this));
    _this.resetAutoplay = _this.resetAutoplay.bind(_assertThisInitialized(_this));
    _this.goToSlide = _this.goToSlide.bind(_assertThisInitialized(_this));
    _this.nextSlide = _this.nextSlide.bind(_assertThisInitialized(_this));
    _this.previousSlide = _this.previousSlide.bind(_assertThisInitialized(_this));
    _this.getTargetLeft = _this.getTargetLeft.bind(_assertThisInitialized(_this));
    _this.onResize = _this.onResize.bind(_assertThisInitialized(_this));
    _this.onReadyStateChange = _this.onReadyStateChange.bind(_assertThisInitialized(_this));
    _this.onVisibilityChange = _this.onVisibilityChange.bind(_assertThisInitialized(_this));
    _this.setInitialDimensions = _this.setInitialDimensions.bind(_assertThisInitialized(_this));
    _this.setDimensions = _this.setDimensions.bind(_assertThisInitialized(_this));
    _this.setLeft = _this.setLeft.bind(_assertThisInitialized(_this));
    _this.getFrameStyles = _this.getFrameStyles.bind(_assertThisInitialized(_this));
    _this.getSliderStyles = _this.getSliderStyles.bind(_assertThisInitialized(_this));
    _this.getOffsetDeltas = _this.getOffsetDeltas.bind(_assertThisInitialized(_this));
    _this.getChildNodes = _this.getChildNodes.bind(_assertThisInitialized(_this));
    _this.getSlideHeight = _this.getSlideHeight.bind(_assertThisInitialized(_this));
    _this.findMaxHeightSlide = _this.findMaxHeightSlide.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.setInitialDimensions();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // see https://github.com/facebook/react/issues/3417#issuecomment-121649937
      this.mounted = true;
      this.setDimensions();
      this.bindEvents();

      if (this.props.autoplay) {
        this.startAutoplay();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var slideCount = this.getValidChildren(nextProps.children).length;
      var slideCountChanged = slideCount !== this.state.slideCount;
      this.setState({
        slideCount: slideCount,
        currentSlide: slideCountChanged ? nextProps.slideIndex : this.state.currentSlide
      });

      if (slideCount <= this.state.currentSlide) {
        this.goToSlide(Math.max(slideCount - 1, 0), nextProps);
      }

      var updateDimensions = slideCountChanged || function (curr, next, keys) {
        var shouldUpdate = false;

        for (var i = 0; i < keys.length; i++) {
          if (curr[keys[i]] !== next[keys[i]]) {
            shouldUpdate = true;
            break;
          }
        }

        return shouldUpdate;
      }(this.props, nextProps, ['cellSpacing', 'vertical', 'slideWidth', 'slideHeight', 'heightMode', 'slidesToScroll', 'slidesToShow', 'transitionMode', 'cellAlign']);

      if (updateDimensions) {
        this.setDimensions(nextProps);
      }

      if (this.props.slideIndex !== nextProps.slideIndex && nextProps.slideIndex !== this.state.currentSlide && !this.state.isWrappingAround) {
        this.goToSlide(nextProps.slideIndex, this.props);
      }

      if (this.props.autoplay !== nextProps.autoplay) {
        if (nextProps.autoplay) {
          this.startAutoplay();
        } else {
          this.stopAutoplay();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unbindEvents();
      this.stopAutoplay(); // see https://github.com/facebook/react/issues/3417#issuecomment-121649937

      this.mounted = false;
    }
  }, {
    key: "getPropsByTransitionMode",
    value: function getPropsByTransitionMode(props, keys) {
      var updatedDefaults = {};

      if (props.transitionMode === 'fade') {
        keys.forEach(function (key) {
          switch (key) {
            case 'slidesToShow':
              updatedDefaults[key] = Math.max(parseInt(props.slidesToShow), 1);
              break;

            case 'slidesToScroll':
              updatedDefaults[key] = Math.max(parseInt(props.slidesToShow), 1);
              break;

            case 'cellAlign':
              updatedDefaults[key] = 'left';
              break;

            default:
              updatedDefaults[key] = props[key];
              break;
          }
        });
      } else {
        keys.forEach(function (key) {
          updatedDefaults[key] = props[key];
        });
      }

      return updatedDefaults;
    }
  }, {
    key: "getTouchEvents",
    value: function getTouchEvents() {
      var _this2 = this;

      if (this.props.swiping === false) {
        return null;
      }

      return {
        onTouchStart: function onTouchStart(e) {
          _this2.touchObject = {
            startX: e.touches[0].pageX,
            startY: e.touches[0].pageY
          };

          _this2.handleMouseOver();
        },
        onTouchMove: function onTouchMove(e) {
          var direction = _this2.swipeDirection(_this2.touchObject.startX, e.touches[0].pageX, _this2.touchObject.startY, e.touches[0].pageY);

          if (direction !== 0) {
            e.preventDefault();
          }

          var length = _this2.props.vertical ? Math.round(Math.sqrt(Math.pow(e.touches[0].pageY - _this2.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.touches[0].pageX - _this2.touchObject.startX, 2)));
          _this2.touchObject = {
            startX: _this2.touchObject.startX,
            startY: _this2.touchObject.startY,
            endX: e.touches[0].pageX,
            endY: e.touches[0].pageY,
            length: length,
            direction: direction
          };

          _this2.setState({
            left: _this2.props.vertical ? 0 : _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction),
            top: _this2.props.vertical ? _this2.getTargetLeft(_this2.touchObject.length * _this2.touchObject.direction) : 0
          });
        },
        onTouchEnd: function onTouchEnd(e) {
          _this2.handleSwipe(e);

          _this2.handleMouseOut();
        },
        onTouchCancel: function onTouchCancel(e) {
          _this2.handleSwipe(e);
        }
      };
    }
  }, {
    key: "getMouseEvents",
    value: function getMouseEvents() {
      var _this3 = this;

      if (this.props.dragging === false) {
        return null;
      }

      return {
        onMouseOver: function onMouseOver() {
          return _this3.handleMouseOver();
        },
        onMouseOut: function onMouseOut() {
          return _this3.handleMouseOut();
        },
        onMouseDown: function onMouseDown(e) {
          if (e.preventDefault) {
            e.preventDefault();
          }

          _this3.touchObject = {
            startX: e.clientX,
            startY: e.clientY
          };

          _this3.setState({
            dragging: true
          });
        },
        onMouseMove: function onMouseMove(e) {
          if (!_this3.state.dragging) {
            return;
          }

          var direction = _this3.swipeDirection(_this3.touchObject.startX, e.clientX, _this3.touchObject.startY, e.clientY);

          if (direction !== 0) {
            e.preventDefault();
          }

          var length = _this3.props.vertical ? Math.round(Math.sqrt(Math.pow(e.clientY - _this3.touchObject.startY, 2))) : Math.round(Math.sqrt(Math.pow(e.clientX - _this3.touchObject.startX, 2)));
          _this3.touchObject = {
            startX: _this3.touchObject.startX,
            startY: _this3.touchObject.startY,
            endX: e.clientX,
            endY: e.clientY,
            length: length,
            direction: direction
          };

          _this3.setState({
            left: _this3.props.vertical ? 0 : _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction),
            top: _this3.props.vertical ? _this3.getTargetLeft(_this3.touchObject.length * _this3.touchObject.direction) : 0
          });
        },
        onMouseUp: function onMouseUp(e) {
          if (!_this3.state.dragging) {
            return;
          }

          _this3.handleSwipe(e);
        },
        onMouseLeave: function onMouseLeave(e) {
          if (!_this3.state.dragging) {
            return;
          }

          _this3.handleSwipe(e);
        }
      };
    }
  }, {
    key: "pauseAutoplay",
    value: function pauseAutoplay() {
      if (this.props.autoplay) {
        this.autoplayPaused = true;
        this.stopAutoplay();
      }
    }
  }, {
    key: "unpauseAutoplay",
    value: function unpauseAutoplay() {
      if (this.props.autoplay && this.autoplayPaused) {
        this.startAutoplay();
        this.autoplayPaused = null;
      }
    }
  }, {
    key: "handleMouseOver",
    value: function handleMouseOver() {
      this.pauseAutoplay();
    }
  }, {
    key: "handleMouseOut",
    value: function handleMouseOut() {
      this.unpauseAutoplay();
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (this.clickSafe === true) {
        event.preventDefault();
        event.stopPropagation();

        if (event.nativeEvent) {
          event.nativeEvent.stopPropagation();
        }
      }
    }
  }, {
    key: "handleSwipe",
    value: function handleSwipe() {
      if (typeof this.touchObject.length !== 'undefined' && this.touchObject.length > 44) {
        this.clickSafe = true;
      } else {
        this.clickSafe = false;
      }

      var slidesToShow = this.state.slidesToShow;

      if (this.props.slidesToScroll === 'auto') {
        slidesToShow = this.state.slidesToScroll;
      }

      if (this.touchObject.length > this.state.slideWidth / slidesToShow / 5) {
        if (this.touchObject.direction === 1) {
          if (this.state.currentSlide >= this.state.slideCount - slidesToShow && !this.props.wrapAround) {
            this.setState({
              easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__[this.props.edgeEasing]
            });
          } else {
            this.nextSlide();
          }
        } else if (this.touchObject.direction === -1) {
          if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
            this.setState({
              easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__[this.props.edgeEasing]
            });
          } else {
            this.previousSlide();
          }
        }
      } else {
        this.goToSlide(this.state.currentSlide);
      }

      this.touchObject = {};
      this.setState({
        dragging: false
      });
    }
  }, {
    key: "swipeDirection",
    value: function swipeDirection(x1, x2, y1, y2) {
      var xDist = x1 - x2;
      var yDist = y1 - y2;
      var r = Math.atan2(yDist, xDist);
      var swipeAngle = Math.round(r * 180 / Math.PI);

      if (swipeAngle < 0) {
        swipeAngle = 360 - Math.abs(swipeAngle);
      }

      if (swipeAngle <= 45 && swipeAngle >= 0) {
        return 1;
      }

      if (swipeAngle <= 360 && swipeAngle >= 315) {
        return 1;
      }

      if (swipeAngle >= 135 && swipeAngle <= 225) {
        return -1;
      }

      if (this.props.vertical === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) {
          return 1;
        } else {
          return -1;
        }
      }

      return 0;
    }
  }, {
    key: "autoplayIterator",
    value: function autoplayIterator() {
      if (this.props.wrapAround) {
        this.nextSlide();
        return;
      }

      if (this.state.currentSlide !== this.state.slideCount - this.state.slidesToShow) {
        this.nextSlide();
      } else {
        this.stopAutoplay();
      }
    }
  }, {
    key: "startAutoplay",
    value: function startAutoplay() {
      this.autoplayID = setInterval(this.autoplayIterator, this.props.autoplayInterval);
    }
  }, {
    key: "resetAutoplay",
    value: function resetAutoplay() {
      if (this.props.autoplay && !this.autoplayPaused) {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  }, {
    key: "stopAutoplay",
    value: function stopAutoplay() {
      if (this.autoplayID) {
        clearInterval(this.autoplayID);
      }
    } // Action Methods

  }, {
    key: "goToSlide",
    value: function goToSlide(index, props) {
      var _this4 = this;

      if (props === undefined) {
        props = this.props;
      }

      this.setState({
        easing: __WEBPACK_IMPORTED_MODULE_4_d3_ease__[props.easing]
      });

      if (index >= this.state.slideCount || index < 0) {
        if (!props.wrapAround) {
          return;
        }

        if (index >= this.state.slideCount) {
          props.beforeSlide(this.state.currentSlide, 0);
          this.setState(function (prevState) {
            return {
              left: props.vertical ? 0 : _this4.getTargetLeft(_this4.state.slideWidth, prevState.currentSlide),
              top: props.vertical ? _this4.getTargetLeft(_this4.state.slideWidth, prevState.currentSlide) : 0,
              currentSlide: 0,
              isWrappingAround: true,
              wrapToIndex: index
            };
          }, function () {
            return setTimeout(function () {
              _this4.setState({
                isWrappingAround: false,
                resetWrapAroundPosition: true
              }, function () {
                _this4.setState({
                  resetWrapAroundPosition: false
                });

                props.afterSlide(0);

                _this4.resetAutoplay();
              });
            }, props.speed);
          });
          return;
        } else {
          var endSlide = this.state.slideCount - this.state.slidesToScroll;
          props.beforeSlide(this.state.currentSlide, endSlide);
          this.setState(function (prevState) {
            return {
              left: props.vertical ? 0 : _this4.getTargetLeft(0, prevState.currentSlide),
              top: props.vertical ? _this4.getTargetLeft(0, prevState.currentSlide) : 0,
              currentSlide: endSlide,
              isWrappingAround: true,
              wrapToIndex: index
            };
          }, function () {
            return setTimeout(function () {
              _this4.setState({
                isWrappingAround: false,
                resetWrapAroundPosition: true
              }, function () {
                _this4.setState({
                  resetWrapAroundPosition: false
                });

                props.afterSlide(endSlide);

                _this4.resetAutoplay();
              });
            }, props.speed);
          });
          return;
        }
      }

      this.props.beforeSlide(this.state.currentSlide, index);
      this.setState({
        currentSlide: index
      }, function () {
        return setTimeout(function () {
          _this4.resetAutoplay();

          if (index !== _this4.state.currentSlide) {
            _this4.props.afterSlide(index);
          }
        }, props.speed);
      });
    }
  }, {
    key: "nextSlide",
    value: function nextSlide() {
      var childrenCount = this.state.slideCount;
      var slidesToShow = this.state.slidesToShow;

      if (this.props.slidesToScroll === 'auto') {
        slidesToShow = this.state.slidesToScroll;
      }

      if (this.state.currentSlide >= childrenCount - slidesToShow && !this.props.wrapAround && this.props.cellAlign === 'left') {
        return;
      }

      if (this.props.wrapAround) {
        this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
      } else {
        if (this.props.slideWidth !== 1) {
          this.goToSlide(this.state.currentSlide + this.state.slidesToScroll);
          return;
        }

        var offset = this.state.currentSlide + this.state.slidesToScroll;
        var nextSlideIndex = this.props.cellAlign !== 'left' ? offset : Math.min(offset, childrenCount - slidesToShow);
        this.goToSlide(nextSlideIndex);
      }
    }
  }, {
    key: "previousSlide",
    value: function previousSlide() {
      if (this.state.currentSlide <= 0 && !this.props.wrapAround) {
        return;
      }

      if (this.props.wrapAround) {
        this.goToSlide(this.state.currentSlide - this.state.slidesToScroll);
      } else {
        this.goToSlide(Math.max(0, this.state.currentSlide - this.state.slidesToScroll));
      }
    } // Animation

  }, {
    key: "getTargetLeft",
    value: function getTargetLeft(touchOffset, slide) {
      var offset;
      var target = slide || this.state.currentSlide;

      switch (this.state.cellAlign) {
        case 'left':
          {
            offset = 0;
            offset -= this.props.cellSpacing * target;
            break;
          }

        case 'center':
          {
            offset = (this.state.frameWidth - this.state.slideWidth) / 2;
            offset -= this.props.cellSpacing * target;
            break;
          }

        case 'right':
          {
            offset = this.state.frameWidth - this.state.slideWidth;
            offset -= this.props.cellSpacing * target;
            break;
          }
      }

      var left = this.state.slideWidth * target;
      var lastSlide = this.state.currentSlide > 0 && target + this.state.slidesToScroll >= this.state.slideCount;

      if (lastSlide && this.props.slideWidth !== 1 && !this.props.wrapAround && this.props.slidesToScroll === 'auto') {
        left = this.state.slideWidth * this.state.slideCount - this.state.frameWidth;
        offset = 0;
        offset -= this.props.cellSpacing * (this.state.slideCount - 1);
      }

      offset -= touchOffset || 0;
      return (left - offset) * -1;
    } // Bootstrapping

  }, {
    key: "bindEvents",
    value: function bindEvents() {
      if (__WEBPACK_IMPORTED_MODULE_2_exenv___default.a.canUseDOM) {
        addEvent(window, 'resize', this.onResize);
        addEvent(document, 'readystatechange', this.onReadyStateChange);
        addEvent(document, 'visibilitychange', this.onVisibilityChange);
      }
    }
  }, {
    key: "onResize",
    value: function onResize() {
      this.setDimensions(null, this.props.onResize);
    }
  }, {
    key: "onReadyStateChange",
    value: function onReadyStateChange() {
      this.setDimensions();
    }
  }, {
    key: "onVisibilityChange",
    value: function onVisibilityChange() {
      if (document.hidden) {
        this.pauseAutoplay();
      } else {
        this.unpauseAutoplay();
      }
    }
  }, {
    key: "unbindEvents",
    value: function unbindEvents() {
      if (__WEBPACK_IMPORTED_MODULE_2_exenv___default.a.canUseDOM) {
        removeEvent(window, 'resize', this.onResize);
        removeEvent(document, 'readystatechange', this.onReadyStateChange);
        removeEvent(document, 'visibilitychange', this.onVisibilityChange);
      }
    }
  }, {
    key: "setInitialDimensions",
    value: function setInitialDimensions() {
      var _this5 = this;

      var slideWidth = this.props.vertical ? this.props.initialSlideHeight || 0 : this.props.initialSlideWidth || 0;
      var slideHeight = this.props.vertical ? (this.props.initialSlideHeight || 0) * this.state.slidesToShow : this.props.initialSlideHeight || 0;
      var frameHeight = slideHeight + this.props.cellSpacing * (this.state.slidesToShow - 1);
      this.setState({
        slideHeight: slideHeight,
        frameWidth: this.props.vertical ? frameHeight : '100%',
        slideCount: this.getValidChildren(this.props.children).length,
        slideWidth: slideWidth
      }, function () {
        _this5.setLeft();
      });
    }
  }, {
    key: "findMaxHeightSlide",
    value: function findMaxHeightSlide(slides) {
      var maxHeight = 0;

      for (var i = 0; i < slides.length; i++) {
        if (slides[i].offsetHeight > maxHeight) {
          maxHeight = slides[i].offsetHeight;
        }
      }

      return maxHeight;
    }
  }, {
    key: "getSlideHeight",
    value: function getSlideHeight(props) {
      var childNodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var heightMode = props.heightMode,
          vertical = props.vertical;
      var firstSlide = childNodes[0];

      if (firstSlide && heightMode === 'first') {
        return vertical ? firstSlide.offsetHeight * this.state.slidesToShow : firstSlide.offsetHeight;
      }

      if (heightMode === 'max') {
        return this.findMaxHeightSlide(childNodes);
      }

      if (props.heightMode === 'current') {
        return childNodes[this.state.currentSlide].offsetHeight;
      }

      return 100;
    }
  }, {
    key: "setDimensions",
    value: function setDimensions(props) {
      var _this6 = this;

      var stateCb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      props = props || this.props;

      var _getPropsByTransition = this.getPropsByTransitionMode(props, ['slidesToShow', 'cellAlign']),
          slidesToShow = _getPropsByTransition.slidesToShow,
          cellAlign = _getPropsByTransition.cellAlign;

      var frame = this.frame;
      var childNodes = this.getChildNodes();
      var slideHeight = this.getSlideHeight(props, childNodes);
      var slideWidth;

      if (typeof props.slideWidth !== 'number') {
        slideWidth = parseInt(props.slideWidth);
      } else if (props.vertical) {
        slideWidth = slideHeight / slidesToShow * props.slideWidth;
      } else {
        slideWidth = frame.offsetWidth / slidesToShow * props.slideWidth;
      }

      if (!props.vertical) {
        slideWidth -= props.cellSpacing * ((100 - 100 / slidesToShow) / 100);
      }

      var frameHeight = slideHeight + props.cellSpacing * (slidesToShow - 1);
      var frameWidth = props.vertical ? frameHeight : frame.offsetWidth;

      var _getPropsByTransition2 = this.getPropsByTransitionMode(props, ['slidesToScroll']),
          slidesToScroll = _getPropsByTransition2.slidesToScroll;

      if (slidesToScroll === 'auto') {
        slidesToScroll = Math.floor(frameWidth / (slideWidth + props.cellSpacing));
      }

      this.setState({
        slideHeight: slideHeight,
        frameWidth: frameWidth,
        slideWidth: slideWidth,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        cellAlign: cellAlign,
        left: props.vertical ? 0 : this.getTargetLeft(),
        top: props.vertical ? this.getTargetLeft() : 0
      }, function () {
        stateCb();

        _this6.setLeft();
      });
    }
  }, {
    key: "getValidChildren",
    value: function getValidChildren(children) {
      // .toArray automatically removes invalid React children
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.toArray(children);
    }
  }, {
    key: "getChildNodes",
    value: function getChildNodes() {
      return this.frame.childNodes[0].childNodes;
    }
  }, {
    key: "setLeft",
    value: function setLeft() {
      var newLeft = this.props.vertical ? 0 : this.getTargetLeft();
      var newTop = this.props.vertical ? this.getTargetLeft() : 0;

      if (newLeft !== this.state.left || newTop !== this.state.top) {
        this.setState({
          left: newLeft,
          top: newTop
        });
      }
    } // Styles

  }, {
    key: "getFrameStyles",
    value: function getFrameStyles() {
      return {
        position: 'relative',
        display: 'block',
        overflow: this.props.frameOverflow,
        height: this.props.vertical ? this.state.frameWidth || 'initial' : 'auto',
        margin: this.props.framePadding,
        padding: 0,
        transform: 'translate3d(0, 0, 0)',
        WebkitTransform: 'translate3d(0, 0, 0)',
        msTransform: 'translate(0, 0)',
        boxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
      };
    }
  }, {
    key: "getSliderStyles",
    value: function getSliderStyles() {
      return {
        position: 'relative',
        display: 'block',
        width: this.props.width,
        height: 'auto',
        boxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        visibility: this.state.slideWidth ? 'inherit' : 'hidden'
      };
    }
  }, {
    key: "getStyleTagStyles",
    value: function getStyleTagStyles() {
      return '.slider-slide > img {width: 100%; display: block;}';
    }
  }, {
    key: "getDecoratorStyles",
    value: function getDecoratorStyles(position) {
      switch (position) {
        case 'TopLeft':
          {
            return {
              position: 'absolute',
              top: 0,
              left: 0
            };
          }

        case 'TopCenter':
          {
            return {
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              WebkitTransform: 'translateX(-50%)',
              msTransform: 'translateX(-50%)'
            };
          }

        case 'TopRight':
          {
            return {
              position: 'absolute',
              top: 0,
              right: 0
            };
          }

        case 'CenterLeft':
          {
            return {
              position: 'absolute',
              top: '50%',
              left: 0,
              transform: 'translateY(-50%)',
              WebkitTransform: 'translateY(-50%)',
              msTransform: 'translateY(-50%)'
            };
          }

        case 'CenterCenter':
          {
            return {
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%,-50%)',
              WebkitTransform: 'translate(-50%, -50%)',
              msTransform: 'translate(-50%, -50%)'
            };
          }

        case 'CenterRight':
          {
            return {
              position: 'absolute',
              top: '50%',
              right: 0,
              transform: 'translateY(-50%)',
              WebkitTransform: 'translateY(-50%)',
              msTransform: 'translateY(-50%)'
            };
          }

        case 'BottomLeft':
          {
            return {
              position: 'absolute',
              bottom: 0,
              left: 0
            };
          }

        case 'BottomCenter':
          {
            return {
              position: 'absolute',
              bottom: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              WebkitTransform: 'translateX(-50%)',
              msTransform: 'translateX(-50%)'
            };
          }

        case 'BottomRight':
          {
            return {
              position: 'absolute',
              bottom: 0,
              right: 0
            };
          }

        default:
          {
            return {
              position: 'absolute',
              top: 0,
              left: 0
            };
          }
      }
    }
  }, {
    key: "getOffsetDeltas",
    value: function getOffsetDeltas() {
      var offset = 0;

      if (this.state.isWrappingAround) {
        offset = this.getTargetLeft(null, this.state.wrapToIndex);
      } else {
        offset = this.getTargetLeft(this.touchObject.length * this.touchObject.direction);
      }

      return {
        tx: [this.props.vertical ? 0 : offset],
        ty: [this.props.vertical ? offset : 0]
      };
    }
  }, {
    key: "getTransitionProps",
    value: function getTransitionProps() {
      return {
        slideWidth: this.state.slideWidth,
        slideHeight: this.state.slideHeight,
        slideCount: this.state.slideCount,
        currentSlide: this.state.currentSlide,
        isWrappingAround: this.state.isWrappingAround,
        top: this.state.top,
        left: this.state.left,
        cellSpacing: this.props.cellSpacing,
        vertical: this.props.vertical,
        dragging: this.props.dragging,
        wrapAround: this.props.wrapAround,
        slidesToShow: this.state.slidesToShow
      };
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      var _this7 = this;

      return this.controlsMap.map(function (_ref) {
        var funcName = _ref.funcName,
            key = _ref.key;
        var func = _this7.props[funcName];
        return func && typeof func === 'function' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
          className: "slider-control-".concat(key.toLowerCase()),
          style: _this7.getDecoratorStyles(key),
          key: key
        }, func({
          currentSlide: _this7.state.currentSlide,
          slideCount: _this7.state.slideCount,
          frameWidth: _this7.state.frameWidth,
          slideWidth: _this7.state.slideWidth,
          slidesToScroll: _this7.state.slidesToScroll,
          cellSpacing: _this7.props.cellSpacing,
          slidesToShow: _this7.state.slidesToShow,
          wrapAround: _this7.props.wrapAround,
          nextSlide: function nextSlide() {
            return _this7.nextSlide();
          },
          previousSlide: function previousSlide() {
            return _this7.previousSlide();
          },
          goToSlide: function goToSlide(index) {
            return _this7.goToSlide(index);
          }
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var duration = this.state.dragging || this.state.resetWrapAroundPosition ? 0 : this.props.speed;
      var frameStyles = this.getFrameStyles();
      var touchEvents = this.getTouchEvents();
      var mouseEvents = this.getMouseEvents();
      var TransitionControl = __WEBPACK_IMPORTED_MODULE_6__all_transitions__["a" /* default */][this.props.transitionMode];
      var validChildren = this.getValidChildren(this.props.children);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: ['slider', this.props.className || ''].join(' '),
        style: _extends({}, this.getSliderStyles(), this.props.style)
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_move_Animate___default.a, {
        show: true,
        start: {
          tx: 0,
          ty: 0
        },
        update: _extends({}, this.getOffsetDeltas(), {
          timing: {
            duration: duration,
            ease: this.state.easing
          },
          events: {
            end: this.setLeft
          }
        }),
        children: function children(_ref2) {
          var tx = _ref2.tx,
              ty = _ref2.ty;
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
            className: "slider-frame",
            ref: function ref(frame) {
              return _this8.frame = frame;
            },
            style: frameStyles
          }, touchEvents, mouseEvents, {
            onClickCapture: _this8.handleClick
          }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TransitionControl, _extends({}, _this8.getTransitionProps(), {
            deltaX: tx,
            deltaY: ty
          }), validChildren));
        }
      }), this.renderControls(), this.props.autoGenerateStyleTag && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style", {
        type: "text/css",
        dangerouslySetInnerHTML: {
          __html: this.getStyleTagStyles()
        }
      }));
    }
  }]);

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


Carousel.propTypes = {
  afterSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autoplay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  autoplayInterval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  autoGenerateStyleTag: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  beforeSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  cellAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'center', 'right']),
  cellSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dragging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  easing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  edgeEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  frameOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  framePadding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  heightMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['first', 'current', 'max']),
  transitionMode: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['scroll', 'fade']),
  initialSlideHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  initialSlideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  onResize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderTopLeftControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderTopCenterControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderTopRightControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderCenterLeftControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderCenterCenterControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderCenterRightControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderBottomLeftControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderBottomCenterControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  renderBottomRightControls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  slideIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slidesToScroll: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto'])]),
  slidesToShow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  speed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  swiping: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  wrapAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
Carousel.defaultProps = {
  afterSlide: function afterSlide() {},
  autoplay: false,
  autoplayInterval: 3000,
  autoGenerateStyleTag: true,
  beforeSlide: function beforeSlide() {},
  cellAlign: 'left',
  cellSpacing: 0,
  dragging: true,
  easing: 'easeCircleOut',
  edgeEasing: 'easeElasticOut',
  framePadding: '0px',
  frameOverflow: 'hidden',
  heightMode: 'max',
  transitionMode: 'scroll',
  onResize: function onResize() {},
  slideIndex: 0,
  slidesToScroll: 1,
  slidesToShow: 1,
  style: {},
  renderCenterLeftControls: function renderCenterLeftControls(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__default_controls__["c" /* PreviousButton */], props);
  },
  renderCenterRightControls: function renderCenterRightControls(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__default_controls__["a" /* NextButton */], props);
  },
  renderBottomCenterControls: function renderBottomCenterControls(props) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__default_controls__["b" /* PagingDots */], props);
  },
  slideWidth: 1,
  speed: 500,
  swiping: true,
  vertical: false,
  width: '100%',
  wrapAround: false
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _Animate = __webpack_require__(187);

var _Animate2 = _interopRequireDefault(_Animate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Animate2.default; /* eslint-disable flowtype/require-valid-file-annotation */

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _d3Timer = __webpack_require__(46);

var _transition = __webpack_require__(190);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //  weak
/* eslint max-len: "off" */

var Animate = function (_Component) {
  _inherits(Animate, _Component);

  function Animate() {
    var _temp, _this, _ret;

    _classCallCheck(this, Animate);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = typeof _this.props.start === 'function' ? _this.props.start() : _this.props.start, _this.checkTransitionStatus = function () {
      if (!_this.TRANSITION_SCHEDULES) {
        _this.interval.stop();

        if (_this.props.show === false) {
          _this.renderNull = true;
          _this.setState(function (prevState) {
            return prevState;
          }); // force render as null
        }
      }
    }, _this.interval = null, _this.renderNull = true, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Animate.prototype.componentWillMount = function componentWillMount() {
    if (this.props.show === true) {
      this.renderNull = false;
    }
  };

  Animate.prototype.componentDidMount = function componentDidMount() {
    var _props = this.props,
        enter = _props.enter,
        show = _props.show;


    if (enter && show === true) {
      _transition.transition.call(this, typeof enter === 'function' ? enter() : enter);
    }
  };

  Animate.prototype.componentWillReceiveProps = function componentWillReceiveProps(next) {
    var _this2 = this;

    var show = next.show,
        start = next.start,
        enter = next.enter,
        update = next.update,
        leave = next.leave;


    if (this.props.show === false && this.renderNull === true && show === true) {
      this.renderNull = false;

      this.setState(function () {
        return typeof start === 'function' ? start() : start;
      }, function () {
        if (enter) {
          _transition.transition.call(_this2, typeof enter === 'function' ? enter() : enter);
        }
      });
    } else if (this.props.show === true && show === false) {
      if (leave) {
        _transition.transition.call(this, typeof leave === 'function' ? leave() : leave);
        this.interval = (0, _d3Timer.interval)(this.checkTransitionStatus);
      } else {
        this.renderNull = true;
        this.setState(function (prevState) {
          return prevState;
        }); // force render as null
      }
    } else if (show === true && update) {
      if (this.interval) {
        this.interval.stop();
      }

      _transition.transition.call(this, typeof update === 'function' ? update() : update);
    }
  };

  Animate.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.interval) {
      this.interval.stop();
    }

    _transition.stop.call(this);
  };

  Animate.prototype.render = function render() {
    if (this.renderNull === true) {
      return null;
    }

    var renderedChildren = this.props.children(this.state);
    return renderedChildren && _react2.default.Children.only(renderedChildren);
  };

  return Animate;
}(_react.Component);

Animate.defaultProps = {
  show: true
};
exports.default = Animate;

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(47);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */];
  delay = delay == null ? 0 : +delay;
  t.restart(function(elapsed) {
    t.stop();
    callback(elapsed + delay);
  }, delay, time);
  return t;
});


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__timer__ = __webpack_require__(47);


/* harmony default export */ __webpack_exports__["a"] = (function(callback, delay, time) {
  var t = new __WEBPACK_IMPORTED_MODULE_0__timer__["a" /* Timer */], total = delay;
  if (delay == null) return t.restart(callback, delay, time), t;
  delay = +delay, time = time == null ? Object(__WEBPACK_IMPORTED_MODULE_0__timer__["b" /* now */])() : +time;
  t.restart(function tick(elapsed) {
    elapsed += total;
    t.restart(tick, total += delay, time);
    callback(elapsed);
  }, delay, time);
  return t;
});


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _transition = __webpack_require__(191);

Object.defineProperty(exports, 'transition', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_transition).default;
  }
});

var _stop = __webpack_require__(210);

Object.defineProperty(exports, 'stop', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_stop).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.preset = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak

exports.newId = newId;
exports.default = transition;

var _d3Timer = __webpack_require__(46);

var _tween = __webpack_require__(192);

var _tween2 = _interopRequireDefault(_tween);

var _schedule = __webpack_require__(209);

var _schedule2 = _interopRequireDefault(_schedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function once(func) {
  var called = false;

  return function transitionEvent() {
    if (!called) {
      called = true;
      func.call(this);
    }
  };
}

var id = 0;

function newId() {
  return ++id;
}

// from https://github.com/d3/d3-ease/blob/master/src/linear.js
function linear(t) {
  return +t;
}

var preset = exports.preset = {
  time: null,
  delay: 0,
  duration: 250,
  ease: linear
};

function scheduleTransitions() {
  var _this = this;

  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var transitions = _extends({}, config);

  var events = transitions.events || {};
  delete transitions.events;

  // each event handler should be called only once
  Object.keys(events).forEach(function (d) {
    if (typeof events[d] !== 'function') {
      throw new Error('Event handlers must be a function');
    } else {
      events[d] = once(events[d]);
    }
  });

  var timing = transitions.timing || {};
  delete transitions.timing;

  Object.keys(transitions).forEach(function (stateKey) {
    var tweens = [];

    if (_typeof(transitions[stateKey]) === 'object' && Array.isArray(transitions[stateKey]) === false) {
      Object.keys(transitions[stateKey]).forEach(function (attr) {
        var val = transitions[stateKey][attr];

        if (Array.isArray(val)) {
          if (val.length === 1) {
            tweens.push(_tween2.default.call(_this, stateKey, attr, val[0]));
          } else {
            _this.setState(function (state) {
              var _extends2, _ref;

              return _ref = {}, _ref[stateKey] = _extends({}, state[stateKey], (_extends2 = {}, _extends2[attr] = val[0], _extends2)), _ref;
            });

            tweens.push(_tween2.default.call(_this, stateKey, attr, val[1]));
          }
        } else if (typeof val === 'function') {
          var getResonanceCustomTween = function getResonanceCustomTween() {
            var resonanceCustomTween = function resonanceCustomTween(t) {
              _this.setState(function (state) {
                var _extends3, _ref2;

                return _ref2 = {}, _ref2[stateKey] = _extends({}, state[stateKey], (_extends3 = {}, _extends3[attr] = val(t), _extends3)), _ref2;
              });
            };

            return resonanceCustomTween;
          };

          tweens.push(getResonanceCustomTween);
        } else {
          _this.setState(function (state) {
            var _extends4, _ref3;

            return _ref3 = {}, _ref3[stateKey] = _extends({}, state[stateKey], (_extends4 = {}, _extends4[attr] = val, _extends4)), _ref3;
          });
          // This assures any existing transitions are stopped
          tweens.push(_tween2.default.call(_this, stateKey, attr, val));
        }
      });
    } else {
      var val = transitions[stateKey];

      if (Array.isArray(val)) {
        if (val.length === 1) {
          tweens.push(_tween2.default.call(_this, null, stateKey, val[0]));
        } else {
          _this.setState(function () {
            var _ref4;

            return _ref4 = {}, _ref4[stateKey] = val[0], _ref4;
          });

          tweens.push(_tween2.default.call(_this, null, stateKey, val[1]));
        }
      } else if (typeof val === 'function') {
        var getResonanceCustomTween = function getResonanceCustomTween() {
          var resonanceCustomTween = function resonanceCustomTween(t) {
            _this.setState(function () {
              var _ref5;

              return _ref5 = {}, _ref5[stateKey] = val(t), _ref5;
            });
          };

          return resonanceCustomTween;
        };

        tweens.push(getResonanceCustomTween);
      } else {
        _this.setState(function () {
          var _ref6;

          return _ref6 = {}, _ref6[stateKey] = val, _ref6;
        });
        // This assures any existing transitions are stopped
        tweens.push(_tween2.default.call(_this, null, stateKey, val));
      }
    }

    var timingConfig = _extends({}, preset, timing, { time: (0, _d3Timer.now)() });
    (0, _schedule2.default)(_this, stateKey, newId(), timingConfig, tweens, events);
  });
}

function transition(config) {
  var _this2 = this;

  if (Array.isArray(config)) {
    config.forEach(function (c) {
      scheduleTransitions.call(_this2, c);
    });
  } else {
    scheduleTransitions.call(this, config);
  }
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak


exports.getInterpolator = getInterpolator;

exports.default = function (nameSpace, attr, value) {
  return getTween.call(this, nameSpace, attr, value);
};

var _d3Interpolate = __webpack_require__(193);

function getInterpolator(attr) {
  if (attr === 'transform') {
    return _d3Interpolate.interpolateTransformSvg;
  }

  return _d3Interpolate.interpolate;
}

function getTween(nameSpace, attr, value1) {
  return function tween() {
    var _this = this;

    var value0 = nameSpace ? this.state[nameSpace][attr] : this.state[attr];

    if (value0 === value1) {
      return null;
    }

    var i = getInterpolator(attr)(value0, value1);

    var stateTween = void 0;

    if (nameSpace === null) {
      stateTween = function stateTween(t) {
        _this.setState(function () {
          var _ref;

          return _ref = {}, _ref[attr] = i(t), _ref;
        });
      };
    } else {
      stateTween = function stateTween(t) {
        _this.setState(function (state) {
          var _extends2, _ref2;

          return _ref2 = {}, _ref2[nameSpace] = _extends({}, state[nameSpace], (_extends2 = {}, _extends2[attr] = i(t), _extends2)), _ref2;
        });
      };
    }

    return stateTween;
  };
}

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(48);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(79);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis__ = __webpack_require__(51);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed__ = __webpack_require__(77);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__(80);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDiscrete", function() { return __WEBPACK_IMPORTED_MODULE_5__discrete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHue", function() { return __WEBPACK_IMPORTED_MODULE_6__hue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_7__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__round__ = __webpack_require__(198);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_9__round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__string__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_10__string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transform_index__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoom__ = __webpack_require__(202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_12__zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rgb__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hsl__ = __webpack_require__(203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lab__ = __webpack_require__(204);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_15__lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hcl__ = __webpack_require__(205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cubehelix__ = __webpack_require__(206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__piecewise__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "piecewise", function() { return __WEBPACK_IMPORTED_MODULE_18__piecewise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__quantize__ = __webpack_require__(208);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_19__quantize__["a"]; });






















/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(75);




// https://beta.observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(75);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(23);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color__["c" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(200);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(201);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(23);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(23);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(23);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(23);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = piecewise;
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; //  weak
/* eslint no-use-before-define: "off" */
// Apapted from https://github.com/d3/d3-transition/blob/master/src/transition/schedule.js

exports.default = function (node, stateKey, id, timing, tweens) {
  var events = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

  var schedules = node.TRANSITION_SCHEDULES;
  if (!schedules) {
    node.TRANSITION_SCHEDULES = {}; // eslint-disable-line no-param-reassign
  } else if (id in schedules) {
    return;
  }

  var config = _extends({ stateKey: stateKey, events: events, tweens: tweens }, timing, { timer: null, state: CREATED });
  create(node, id, config);
};

var _d3Timer = __webpack_require__(46);

var CREATED = 0;
var SCHEDULED = 1;
var STARTING = 2;
var STARTED = 3;
var RUNNING = 4;
var ENDING = 5;
var ENDED = 6;

function create(node, id, config) {
  var schedules = node.TRANSITION_SCHEDULES;

  // Initialize the transition timer when the transition is created.
  // Note the actual delay is not known until the first callback!
  var transition = _extends({}, config);
  var n = transition.tweens.length;
  var tweens = new Array(n);

  schedules[id] = transition;
  transition.timer = (0, _d3Timer.timer)(schedule, 0, transition.time);

  function schedule(elapsed) {
    transition.state = SCHEDULED;
    transition.timer.restart(start, transition.delay, transition.time);

    // If the elapsed delay is less than our first sleep, start immediately.
    if (transition.delay <= elapsed) {
      start(elapsed - transition.delay);
    }
  }

  function start(elapsed) {
    // eslint-disable-line consistent-return
    // If the state is not SCHEDULED, then we previously errored on start.
    if (transition.state !== SCHEDULED) return stop();

    for (var sid in schedules) {
      // eslint-disable-line
      var s = schedules[sid];

      if (s.stateKey !== transition.stateKey) {
        continue; // eslint-disable-line no-continue
      }

      // While this element already has a starting transition during this frame,
      // defer starting an interrupting transition until that transition has a
      // chance to tick (and possibly end); see d3/d3-transition#54!
      if (s.state === STARTED) return (0, _d3Timer.timeout)(start);

      // 1. Interrupt the active transition, if any. dispatch the interrupt event.
      // 2. Cancel any pre-empted transitions. No interrupt event is dispatched
      // because the cancelled transitions never started. Note that this also
      // removes this transition from the pending list!

      if (s.state === RUNNING) {
        s.state = ENDED;
        s.timer.stop();
        if (s.events.interrupt && typeof s.events.interrupt === 'function') {
          s.events.interrupt.call(this);
        }
        delete schedules[sid];
      } else if (+sid < id) {
        s.state = ENDED;
        s.timer.stop();
        delete schedules[sid];
      }
    }

    // Defer the first tick to end of the current frame; see d3/d3#1576.
    // Note the transition may be canceled after start and before the first tick!
    // Note this must be scheduled before the start event; see d3/d3-transition#16!
    // Assuming this is successful, subsequent callbacks go straight to tick.
    (0, _d3Timer.timeout)(function () {
      if (transition.state === STARTED) {
        transition.state = RUNNING;
        transition.timer.restart(tick, transition.delay, transition.time);
        tick(elapsed);
      }
    });

    transition.state = STARTING;
    if (transition.events.start && typeof transition.events.start === 'function') {
      transition.events.start.call(node);
    }

    if (transition.state !== STARTING) {
      // interrupted
      return; // eslint-disable-line consistent-return
    }

    transition.state = STARTED;

    // Initialize the tween, deleting null tween.
    var j = -1;

    for (var i = 0; i < n; ++i) {
      var res = transition.tweens[i].call(node);

      if (res) {
        tweens[++j] = res;
      }
    }

    tweens.length = j + 1;
  }

  function tick(elapsed) {
    var t = 1;

    if (elapsed < transition.duration) {
      t = transition.ease.call(null, elapsed / transition.duration);
    } else {
      transition.timer.restart(stop);
      transition.state = ENDING;
    }

    var i = -1;

    while (++i < tweens.length) {
      tweens[i].call(null, t);
    }

    if (transition.state === ENDING) {
      if (transition.events.end && typeof transition.events.end === 'function') {
        transition.events.end.call(node);
      }
      stop();
    }
  }

  function stop() {
    transition.state = ENDED;
    transition.timer.stop();

    delete schedules[id];
    for (var i in schedules) {
      return;
    } // eslint-disable-line guard-for-in, no-restricted-syntax
    delete node.TRANSITION_SCHEDULES; // eslint-disable-line no-param-reassign
  }
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = stop;
//  weak

function stop() {
  var ts = this.TRANSITION_SCHEDULES;

  if (ts) {
    Object.keys(ts).forEach(function (s) {
      ts[s].timer.stop();
    });
  }
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeLinear", function() { return __WEBPACK_IMPORTED_MODULE_0__linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quad__ = __webpack_require__(213);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuad", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuadIn", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuadOut", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeQuadInOut", function() { return __WEBPACK_IMPORTED_MODULE_1__quad__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubic__ = __webpack_require__(214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubic", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubicIn", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubicOut", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCubicInOut", function() { return __WEBPACK_IMPORTED_MODULE_2__cubic__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__poly__ = __webpack_require__(215);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePoly", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePolyIn", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePolyOut", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easePolyInOut", function() { return __WEBPACK_IMPORTED_MODULE_3__poly__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sin__ = __webpack_require__(216);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSin", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSinIn", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSinOut", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeSinInOut", function() { return __WEBPACK_IMPORTED_MODULE_4__sin__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__exp__ = __webpack_require__(217);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExp", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExpIn", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExpOut", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeExpInOut", function() { return __WEBPACK_IMPORTED_MODULE_5__exp__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__circle__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircle", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircleIn", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircleOut", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeCircleInOut", function() { return __WEBPACK_IMPORTED_MODULE_6__circle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bounce__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounce", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounceIn", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounceOut", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBounceInOut", function() { return __WEBPACK_IMPORTED_MODULE_7__bounce__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__back__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBack", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBackIn", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBackOut", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeBackInOut", function() { return __WEBPACK_IMPORTED_MODULE_8__back__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elastic__ = __webpack_require__(221);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElastic", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElasticIn", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElasticOut", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "easeElasticInOut", function() { return __WEBPACK_IMPORTED_MODULE_9__elastic__["b"]; });





















/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
function linear(t) {
  return +t;
}


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quadIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = quadOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = quadInOut;
function quadIn(t) {
  return t * t;
}

function quadOut(t) {
  return t * (2 - t);
}

function quadInOut(t) {
  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
}


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubicIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = cubicOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = cubicInOut;
function cubicIn(t) {
  return t * t * t;
}

function cubicOut(t) {
  return --t * t * t + 1;
}

function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polyIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return polyOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return polyInOut; });
var exponent = 3;

var polyIn = (function custom(e) {
  e = +e;

  function polyIn(t) {
    return Math.pow(t, e);
  }

  polyIn.exponent = custom;

  return polyIn;
})(exponent);

var polyOut = (function custom(e) {
  e = +e;

  function polyOut(t) {
    return 1 - Math.pow(1 - t, e);
  }

  polyOut.exponent = custom;

  return polyOut;
})(exponent);

var polyInOut = (function custom(e) {
  e = +e;

  function polyInOut(t) {
    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
  }

  polyInOut.exponent = custom;

  return polyInOut;
})(exponent);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sinIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = sinOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = sinInOut;
var pi = Math.PI,
    halfPi = pi / 2;

function sinIn(t) {
  return 1 - Math.cos(t * halfPi);
}

function sinOut(t) {
  return Math.sin(t * halfPi);
}

function sinInOut(t) {
  return (1 - Math.cos(pi * t)) / 2;
}


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = expOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = expInOut;
function expIn(t) {
  return Math.pow(2, 10 * t - 10);
}

function expOut(t) {
  return 1 - Math.pow(2, -10 * t);
}

function expInOut(t) {
  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
}


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = circleIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = circleOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = circleInOut;
function circleIn(t) {
  return 1 - Math.sqrt(1 - t * t);
}

function circleOut(t) {
  return Math.sqrt(1 - --t * t);
}

function circleInOut(t) {
  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
}


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bounceIn;
/* harmony export (immutable) */ __webpack_exports__["c"] = bounceOut;
/* harmony export (immutable) */ __webpack_exports__["b"] = bounceInOut;
var b1 = 4 / 11,
    b2 = 6 / 11,
    b3 = 8 / 11,
    b4 = 3 / 4,
    b5 = 9 / 11,
    b6 = 10 / 11,
    b7 = 15 / 16,
    b8 = 21 / 22,
    b9 = 63 / 64,
    b0 = 1 / b1 / b1;

function bounceIn(t) {
  return 1 - bounceOut(1 - t);
}

function bounceOut(t) {
  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
}

function bounceInOut(t) {
  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
}


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return backIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return backOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return backInOut; });
var overshoot = 1.70158;

var backIn = (function custom(s) {
  s = +s;

  function backIn(t) {
    return t * t * ((s + 1) * t - s);
  }

  backIn.overshoot = custom;

  return backIn;
})(overshoot);

var backOut = (function custom(s) {
  s = +s;

  function backOut(t) {
    return --t * t * ((s + 1) * t + s) + 1;
  }

  backOut.overshoot = custom;

  return backOut;
})(overshoot);

var backInOut = (function custom(s) {
  s = +s;

  function backInOut(t) {
    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
  }

  backInOut.overshoot = custom;

  return backInOut;
})(overshoot);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return elasticIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return elasticOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return elasticInOut; });
var tau = 2 * Math.PI,
    amplitude = 1,
    period = 0.3;

var elasticIn = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticIn(t) {
    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
  }

  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
  elasticIn.period = function(p) { return custom(a, p); };

  return elasticIn;
})(amplitude, period);

var elasticOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticOut(t) {
    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
  }

  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticOut.period = function(p) { return custom(a, p); };

  return elasticOut;
})(amplitude, period);

var elasticInOut = (function custom(a, p) {
  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);

  function elasticInOut(t) {
    return ((t = t * 2 - 1) < 0
        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
  }

  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
  elasticInOut.period = function(p) { return custom(a, p); };

  return elasticInOut;
})(amplitude, period);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PreviousButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NextButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PagingDots; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }



var defaultButtonStyles = function defaultButtonStyles(disabled) {
  return {
    border: 0,
    background: 'rgba(0,0,0,0.4)',
    color: 'white',
    padding: 10,
    outline: 0,
    opacity: disabled ? 0.3 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer'
  };
};

var PreviousButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PreviousButton, _React$Component);

  function PreviousButton() {
    var _this;

    _classCallCheck(this, PreviousButton);

    _this = _possibleConstructorReturn(this, (PreviousButton.__proto__ || Object.getPrototypeOf(PreviousButton)).apply(this, arguments));
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(PreviousButton, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      this.props.previousSlide();
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.currentSlide === 0 && !this.props.wrapAround || this.props.slideCount === 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        style: defaultButtonStyles(disabled),
        disabled: disabled,
        onClick: this.handleClick
      }, "PREV");
    }
  }]);

  return PreviousButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
var NextButton =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(NextButton, _React$Component2);

  function NextButton() {
    var _this2;

    _classCallCheck(this, NextButton);

    _this2 = _possibleConstructorReturn(this, (NextButton.__proto__ || Object.getPrototypeOf(NextButton)).apply(this, arguments));
    _this2.handleClick = _this2.handleClick.bind(_assertThisInitialized(_this2));
    return _this2;
  }

  _createClass(NextButton, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault();
      this.props.nextSlide();
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props.currentSlide + this.props.slidesToScroll >= this.props.slideCount && !this.props.wrapAround;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        style: defaultButtonStyles(disabled),
        disabled: disabled,
        onClick: this.handleClick
      }, "NEXT");
    }
  }]);

  return NextButton;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
var PagingDots =
/*#__PURE__*/
function (_React$Component3) {
  _inherits(PagingDots, _React$Component3);

  function PagingDots() {
    _classCallCheck(this, PagingDots);

    return _possibleConstructorReturn(this, (PagingDots.__proto__ || Object.getPrototypeOf(PagingDots)).apply(this, arguments));
  }

  _createClass(PagingDots, [{
    key: "getIndexes",
    value: function getIndexes(count, inc) {
      var arr = [];

      for (var i = 0; i < count; i += inc) {
        arr.push(i);
      }

      return arr;
    }
  }, {
    key: "getListStyles",
    value: function getListStyles() {
      return {
        position: 'relative',
        margin: 0,
        top: -10,
        padding: 0
      };
    }
  }, {
    key: "getListItemStyles",
    value: function getListItemStyles() {
      return {
        listStyleType: 'none',
        display: 'inline-block'
      };
    }
  }, {
    key: "getButtonStyles",
    value: function getButtonStyles(active) {
      return {
        border: 0,
        background: 'transparent',
        color: 'black',
        cursor: 'pointer',
        padding: 10,
        outline: 0,
        fontSize: 24,
        opacity: active ? 1 : 0.5
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var indexes = this.getIndexes(this.props.slideCount, this.props.slidesToScroll);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        style: this.getListStyles()
      }, indexes.map(function (index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          style: _this3.getListItemStyles(),
          key: index
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
          style: _this3.getButtonStyles(_this3.props.currentSlide === index),
          onClick: _this3.props.goToSlide.bind(null, index)
        }, "\u2022"));
      }));
    }
  }]);

  return PagingDots;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transitions_scroll_transition__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transitions_fade_transition__ = __webpack_require__(225);


/* harmony default export */ __webpack_exports__["a"] = ({
  fade: __WEBPACK_IMPORTED_MODULE_1__transitions_fade_transition__["a" /* default */],
  scroll: __WEBPACK_IMPORTED_MODULE_0__transitions_scroll_transition__["a" /* default */]
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }




var ScrollTransition =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollTransition, _React$Component);

  function ScrollTransition(props) {
    var _this;

    _classCallCheck(this, ScrollTransition);

    _this = _possibleConstructorReturn(this, (ScrollTransition.__proto__ || Object.getPrototypeOf(ScrollTransition)).call(this, props));
    _this.getListStyles = _this.getListStyles.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ScrollTransition, [{
    key: "getSlideDirection",
    value: function getSlideDirection(start, end, isWrapping) {
      var direction = 0;
      if (start === end) return direction;

      if (isWrapping) {
        direction = start < end ? -1 : 1;
      } else {
        direction = start < end ? 1 : -1;
      }

      return direction;
    }
  }, {
    key: "getSlideTargetPosition",
    value: function getSlideTargetPosition(index, positionValue) {
      var targetPosition = (this.props.slideWidth + this.props.cellSpacing) * index;
      var startSlide = Math.min(Math.abs(Math.floor(positionValue / this.props.slideWidth)), this.props.slideCount - 1);

      if (this.props.wrapAround && index !== startSlide) {
        var direction = this.getSlideDirection(startSlide, this.props.currentSlide, this.props.isWrappingAround);
        var slidesBefore = Math.floor((this.props.slideCount - 1) / 2);
        var slidesAfter = this.props.slideCount - slidesBefore - 1;

        if (direction < 0) {
          var temp = slidesBefore;
          slidesBefore = slidesAfter;
          slidesAfter = temp;
        }

        var distanceFromStart = Math.abs(startSlide - index);

        if (index < startSlide) {
          if (distanceFromStart > slidesBefore) {
            targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount + index);
          }
        } else if (distanceFromStart > slidesAfter) {
          targetPosition = (this.props.slideWidth + this.props.cellSpacing) * (this.props.slideCount - index) * -1;
        }
      }

      return targetPosition;
    }
  }, {
    key: "formatChildren",
    value: function formatChildren(children) {
      var _this2 = this;

      var positionValue = this.props.vertical ? this.props.top : this.props.left;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: "slider-slide",
          style: _this2.getSlideStyles(index, positionValue),
          key: index
        }, child);
      });
    }
  }, {
    key: "getSlideStyles",
    value: function getSlideStyles(index, positionValue) {
      var targetPosition = this.getSlideTargetPosition(index, positionValue);
      return {
        position: 'absolute',
        left: this.props.vertical ? 0 : targetPosition,
        top: this.props.vertical ? targetPosition : 0,
        display: this.props.vertical ? 'block' : 'inline-block',
        listStyleType: 'none',
        verticalAlign: 'top',
        width: this.props.vertical ? '100%' : this.props.slideWidth,
        height: 'auto',
        minHeight: '100%',
        boxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        marginLeft: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
        marginRight: this.props.vertical ? 'auto' : this.props.cellSpacing / 2,
        marginTop: this.props.vertical ? this.props.cellSpacing / 2 : 'auto',
        marginBottom: this.props.vertical ? this.props.cellSpacing / 2 : 'auto'
      };
    }
  }, {
    key: "getListStyles",
    value: function getListStyles(styles) {
      var deltaX = styles.deltaX,
          deltaY = styles.deltaY;
      var listWidth = this.props.slideWidth * __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children);
      var spacingOffset = this.props.cellSpacing * __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.count(this.props.children);
      var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0)");
      return {
        transform: transform,
        WebkitTransform: transform,
        msTransform: "translate(".concat(deltaX, "px, ").concat(deltaY, "px)"),
        position: 'relative',
        display: 'block',
        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
        padding: 0,
        height: this.props.vertical ? listWidth + spacingOffset : this.props.slideHeight,
        width: this.props.vertical ? 'auto' : listWidth + spacingOffset,
        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
        boxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        touchAction: "pinch-zoom ".concat(this.props.vertical ? 'pan-x' : 'pan-y')
      };
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.formatChildren(this.props.children);
      var deltaX = this.props.deltaX;
      var deltaY = this.props.deltaY;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "slider-list",
        style: this.getListStyles({
          deltaX: deltaX,
          deltaY: deltaY
        })
      }, children);
    }
  }]);

  return ScrollTransition;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


ScrollTransition.propTypes = {
  deltaX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  deltaY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  isWrappingAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cellSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dragging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
ScrollTransition.defaultProps = {
  deltaX: 0,
  deltaY: 0,
  slideWidth: 0,
  slideHeight: 0,
  slideCount: 0,
  currentSlide: 0,
  isWrappingAround: false,
  top: 0,
  left: 0,
  cellSpacing: 0,
  vertical: false,
  dragging: false,
  wrapAround: false
};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FadeTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var FadeTransition =
/*#__PURE__*/
function (_React$Component) {
  _inherits(FadeTransition, _React$Component);

  function FadeTransition(props) {
    var _this;

    _classCallCheck(this, FadeTransition);

    _this = _possibleConstructorReturn(this, (FadeTransition.__proto__ || Object.getPrototypeOf(FadeTransition)).call(this, props));
    _this.fadeFromSlide = props.currentSlide;
    return _this;
  }

  _createClass(FadeTransition, [{
    key: "formatChildren",
    value: function formatChildren(children, opacity) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          className: "slider-slide",
          style: _this2.getSlideStyles(index, opacity),
          key: index
        }, child);
      });
    }
  }, {
    key: "getSlideOpacityAndLeftMap",
    value: function getSlideOpacityAndLeftMap(fadeFrom, fadeTo, fade) {
      // Figure out which position to fade to
      var fadeToPosition = fadeTo;

      if (fadeFrom > fade && fadeFrom === 0) {
        fadeToPosition = fadeFrom - this.props.slidesToShow;
      } else if (fadeFrom < fade && fadeFrom + this.props.slidesToShow > this.props.slideCount - 1) {
        fadeToPosition = fadeFrom + this.props.slidesToShow;
      } // Calculate opacity for active slides


      var opacity = {};

      if (fadeFrom === fadeTo) {
        opacity[fadeFrom] = 1;
      } else {
        var distance = fadeFrom - fadeToPosition;
        opacity[fadeFrom] = (fade - fadeToPosition) / distance;
        opacity[fadeTo] = (fadeFrom - fade) / distance;
      } // Calculate left for slides and merge in opacity


      var map = {};

      for (var i = 0; i < this.props.slidesToShow; i++) {
        map[fadeFrom + i] = {
          opacity: opacity[fadeFrom],
          left: this.props.slideWidth * i
        };
        map[fadeTo + i] = {
          opacity: opacity[fadeTo],
          left: this.props.slideWidth * i
        };
      }

      return map;
    }
  }, {
    key: "getSlideStyles",
    value: function getSlideStyles(index, data) {
      return {
        position: 'absolute',
        visibility: data[index] ? 'inherit' : 'hidden',
        left: data[index] ? data[index].left : 0,
        top: 0,
        opacity: data[index] ? data[index].opacity : 0,
        display: 'block',
        listStyleType: 'none',
        verticalAlign: 'top',
        width: this.props.slideWidth,
        height: 'auto',
        minHeight: '100%',
        boxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        marginLeft: this.props.cellSpacing / 2,
        marginRight: this.props.cellSpacing / 2,
        marginTop: 'auto',
        marginBottom: 'auto'
      };
    }
  }, {
    key: "getContainerStyles",
    value: function getContainerStyles() {
      var width = this.props.slideWidth * this.props.slidesToShow;
      return {
        display: 'block',
        margin: this.props.vertical ? "".concat(this.props.cellSpacing / 2 * -1, "px 0px") : "0px ".concat(this.props.cellSpacing / 2 * -1, "px"),
        padding: 0,
        height: this.props.slideHeight,
        width: width,
        cursor: this.props.dragging === true ? 'pointer' : 'inherit',
        boxSizing: 'border-box',
        MozBoxSizing: 'border-box',
        touchAction: 'none'
      };
    }
  }, {
    key: "render",
    value: function render() {
      var fade = -(this.props.deltaX || this.props.deltaY) / this.props.slideWidth;

      if (parseInt(fade) === fade) {
        this.fadeFromSlide = fade;
      }

      var opacityAndLeftMap = this.getSlideOpacityAndLeftMap(this.fadeFromSlide, this.props.currentSlide, fade);
      var children = this.formatChildren(this.props.children, opacityAndLeftMap);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "slider-list",
        style: this.getContainerStyles()
      }, children);
    }
  }]);

  return FadeTransition;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);


FadeTransition.propTypes = {
  deltaX: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  deltaY: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideHeight: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  slideCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  currentSlide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  isWrappingAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cellSpacing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  vertical: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  dragging: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  wrapAround: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  slidesToShow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
FadeTransition.defaultProps = {
  deltaX: 0,
  deltaY: 0,
  slideWidth: 0,
  slideHeight: 0,
  slideCount: 0,
  currentSlide: 0,
  isWrappingAround: false,
  top: 0,
  left: 0,
  cellSpacing: 0,
  vertical: false,
  dragging: false,
  wrapAround: false,
  slidesToShow: 1
};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_online_api_service__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_online_encdec_service__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_handle_user_login_service__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialState={button_text:'REQUEST OTP',input_fields:{mobile_number:{label:'MOBILE NUMBER',field_disabled:false,field_type:'text',value:'',digits:10,field_name:'mobile_number',field_placeholder:'Enter Your Mobile Number'},otp:{hidden:true,label:'OTP',value:'',field_disabled:false,field_type:'text',digits:4,field_name:'otp',field_placeholder:'Enter OTP'}},login_stage:'request_otp',button_disabled:false,response_msg:''};var LoginWeb=function(_Component){_inherits(LoginWeb,_Component);function LoginWeb(props){_classCallCheck(this,LoginWeb);var _this=_possibleConstructorReturn(this,(LoginWeb.__proto__||Object.getPrototypeOf(LoginWeb)).call(this,props));_this.onChange=function(e){var input_name=e.target.name;var input_value=e.target.value;if(_this.state.response_msg!==''&&_this.state.login_stage!=='verify_otp'){_this.setState({response_msg:''});}if(!isNaN(input_value)){_this[input_name]=input_value;var input_fields=Object.assign({},_this.state.input_fields);input_fields[input_name].value=input_value;if(input_fields[input_name].error_message&&input_fields[input_name].error_message!==''&&input_value.length===input_fields[input_name].digits){input_fields[input_name].error_message='';}_this.setState({input_fields:input_fields});}else{_this.setState({input_fields:_this.state.input_fields});}};_this.validateField=function(field){var value=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_this.state.input_fields[field.field_name].value;if(!isNaN(value)){var field_valid=false;if(!value||value.length!==field.digits){field['error_message']='Please enter a valid '+field.label.toLowerCase();field_valid=false;}else{field['error_message']='';field_valid=true;}var input_fields=_this.state.input_fields;input_fields[field.field_name]=field;_this.setState({input_fields:input_fields});return field_valid;}};_this.resendOtp=function(){if(!_this.state.button_disabled){__WEBPACK_IMPORTED_MODULE_2__services_online_api_service__["a" /* default */].generateOtp(_this.requestKey).then(function(result){result=JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services_online_encdec_service__["a" /* default */].decryptForOTP(result.data,result.headers["googlecookie"]));if(result&&result.result&&result.result.indexOf("SENT")!==-1){//---- success -----
var mobile_number=Object.assign({},_this.state.input_fields.mobile_number,{field_disabled:true});var otp=Object.assign({},_this.state.input_fields.otp,{hidden:false});_this.setState({input_fields:Object.assign({},_this.state.input_fields,{mobile_number:mobile_number,otp:otp}),button_text:'VERIFY OTP',response_msg:'Enter the OTP sent on your mobile number!',login_stage:'verify_otp'});}else if(result&&result.result&&result.result==="LIMIT_REACHED_DAY"){_this.setState({button_text:'REQUEST OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.limitReached});}else{_this.setState({button_text:'REQUEST OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.otpSendError});}},function(){_this.setState({button_text:'REQUEST OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.otpSendError});});}};_this.onSubmit=function(){if(_this.state.login_stage==="request_otp"){var number_valid=_this.validateField(_this.state.input_fields.mobile_number);if(number_valid){//check user api
_this.setState({button_text:'Sending OTP...'});__WEBPACK_IMPORTED_MODULE_2__services_online_api_service__["a" /* default */].checkUser(__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#mobile_number').val()).then(function(response){response=JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services_online_encdec_service__["a" /* default */].decryptForOTP(response.data,response.headers["googlecookie"]));_this.requestKey=response.requestkey;__WEBPACK_IMPORTED_MODULE_2__services_online_api_service__["a" /* default */].generateOtp(_this.requestKey).then(function(result){result=JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services_online_encdec_service__["a" /* default */].decryptForOTP(result.data,result.headers["googlecookie"]));if(result&&result.result&&result.result.indexOf("SENT")!==-1){//---- success -----
var mobile_number=Object.assign({},_this.state.input_fields.mobile_number,{field_disabled:true,hidden:true});var otp=Object.assign({},_this.state.input_fields.otp,{hidden:false});_this.setState({input_fields:Object.assign({},_this.state.input_fields,{mobile_number:mobile_number,otp:otp}),button_text:'VERIFY OTP',// response_msg: 'Enter the OTP sent on your mobile number!',
response_msg:'',login_stage:'verify_otp'});}else if(result&&result.result&&result.result==="LIMIT_REACHED_DAY"){_this.setState({button_text:'REQUEST OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.limitReached});}else{_this.setState({button_text:'REQUEST OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.otpSendError});}},function(){_this.setState({button_text:'REQUEST OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.otpSendError});});},function(){_this.setState({button_text:'REQUEST OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.otpSendError});});}}else if(_this.state.login_stage==="verify_otp"){var otp_valid=_this.validateField(_this.state.input_fields.otp,__WEBPACK_IMPORTED_MODULE_1_jquery___default()('#otp').val());if(otp_valid){_this.setState({button_text:'Verifying OTP...',response_msg:''});__WEBPACK_IMPORTED_MODULE_2__services_online_api_service__["a" /* default */].validateOtp(_this.requestKey,_this.otp).then(function(res){res=JSON.parse(__WEBPACK_IMPORTED_MODULE_3__services_online_encdec_service__["a" /* default */].decryptForOTP(res.data,res.headers["googlecookie"]));if(res&&res.result==="SUCCESS_AIRTEL"){//---- validation successfull ----
__WEBPACK_IMPORTED_MODULE_2__services_online_api_service__["a" /* default */].authLogin(_this.requestKey).then(function(response){var mobNo=_this.state.input_fields.mobile_number.value;var loginType=__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].TRACKING_EVENTS_CONSTANTS.loginType.OTP;__WEBPACK_IMPORTED_MODULE_8__services_handle_user_login_service__["a" /* default */].loginInWeb(mobNo,loginType).then(function(){window.parent.postMessage({message:"LOGGEDIN",value:mobNo},__WEBPACK_IMPORTED_MODULE_7__config_config__["a" /* default */].parentOrigin);_this.props.afterLoginAtALaterStage();}).catch(function(err){_this.setState({button_text:'VERIFY OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.validateError});});},function(err){_this.setState({button_text:'VERIFY OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.validateError});});}else if(res&&res.data&&res.data.result.indexOf("INCORRECT")!==-1){_this.otp="";_this.setState({button_text:'VERIFY OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.inCorrectOtp});}else{_this.setState({button_text:'VERIFY OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.validateError});}},function(err){_this.setState({button_text:'VERIFY OTP',response_msg:__WEBPACK_IMPORTED_MODULE_4__constants_globalConstants__["a" /* globalConstants */].error.validateError});});}}};_this.render_fields=function(){var fields=_this.state.input_fields;var fields_render=[];for(var i in fields){fields_render.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i,style:{display:fields[i].hidden?'none':'block'},className:'pull-left width-full'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'fs-11 color-light-grey fs-light pl-10 pt-5 pull-left border-bottom pb-5 width-full'},fields[i].label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{maxLength:''+fields[i].digits,disabled:fields[i].field_disabled,id:fields[i].field_name,name:fields[i].field_name,type:fields[i].field_type,className:"fs-light pull-left "+(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get('platformType')!==__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].WEB?'mobile-input':'width-full'),width:'260',placeholder:fields[i].field_placeholder,value:fields[i].value&&fields[i].value,onChange:function onChange(e){_this.onChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pl-10',style:{fontSize:'12px',color:'red',padding:'10px'}},fields[i].error_message)));}return fields_render.map(function(field){return field;});};_this.state=initialState;return _this;}_createClass(LoginWeb,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(newProps){// console.log('login state component will receive props',newProps);
if(newProps.resetLoginState){this.setState(Object.assign({},initialState));}}},{key:'componentDidMount',value:function componentDidMount(){document.getElementById("mobile_number").addEventListener("keyup",function(event){event.preventDefault();if(event.keyCode===13){document.getElementById("login_button_id").click();}});document.getElementById("otp").addEventListener("keyup",function(event){event.preventDefault();if(event.keyCode===13){document.getElementById("login_button_id").click();}});}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-bar-web',style:{position:'static'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'width-full pb-20 pull-left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'display-inline-block fs-20 fs-regular pl-10 pt-10 color-mid-grey'},'Please Login'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'text-right pr-20 fs-14 color-mid-grey  display-inline-block pt-15 pb-10 pull-right fs-regular',onClick:function onClick(){_this2.props.onSkipClick({});}},'Skip \u203A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,this.state.response_msg&&this.state.response_msg!==''&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{float:'left',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pl-10',style:{fontSize:'12px',color:'red',padding:'10px'}},this.state.response_msg)),this.state.login_stage=='verify_otp'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{marginLeft:'10px',marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-13 color-dark-grey fs-regular'},' We\u2019ve sent you an OTP on'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'fs-13 color-dark-grey fs-regular mt-5'},this.state.input_fields.mobile_number.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'fs-12',style:{color:'#e40000'},href:'#',onClick:function onClick(){_this2.resendOtp();}},'Resend OTP')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-left',style:{width:'50%'}},this.render_fields.bind(this)()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pull-right',style:{width:'50%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{id:'login_button_id',style:{outline:'none',width:'130px'},disabled:this.state.button_disabled,className:"login-button fs-light color-white fs-13 pull-left ml-20 pl-10 pr-10 pull-right mr-20 "+(__WEBPACK_IMPORTED_MODULE_5__services_global_store_service__["a" /* default */].get('platformType')!==__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].WEB?'login-button-mobile':''),onClick:function onClick(){_this2.onSubmit();}},this.state.button_text))));}}]);return LoginWeb;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LoginWeb);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom_http_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var OnlineApiService=function(){function OnlineApiService(){_classCallCheck(this,OnlineApiService);}_createClass(OnlineApiService,null,[{key:'checkUser',value:function checkUser(mobileNo){var url="https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/checkuser";var config={headers:{googleCookie:"airtel.com"}};var data={userid:mobileNo};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].ONLINE);}},{key:'generateOtp',value:function generateOtp(requestKey){var url="https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/generateotp";var config={headers:{googleCookie:"airtel.com"}};var data={requestkey:requestKey};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].ONLINE);}},{key:'validateOtp',value:function validateOtp(requestKey,Otp){var url="https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/validateuserwithotp";var config={headers:{googleCookie:"airtel.com"}};var data={requestkey:requestKey,otp:Otp};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].post(url,data,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].ONLINE);}},{key:'authLogin',value:function authLogin(requestKey){var url='https://www.airtel.in/as/app/wl-service/airtel-digital-profile/rest/customer/authapp/v1/authloginget?requestkey='+requestKey;var config={headers:{googleCookie:"airtel.com"}};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].ONLINE);}},{key:'isUserLoggedIn',value:function isUserLoggedIn(){var url="https://www.airtel.in/s/app/wl-service/airtel-digital-profile/rest/customer/profile/unauth/v1/get/login/info";var config={headers:{googleCookie:"google.com",adsHeader:"adsHeader",ignoreError:true,ignoreMobileApp:true}};return __WEBPACK_IMPORTED_MODULE_0__custom_http_service__["a" /* default */].get(url,config,__WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__["a" /* default */].DEFAULT);}}]);return OnlineApiService;}();/* harmony default export */ __webpack_exports__["a"] = (OnlineApiService);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chatBarOptionsComponent__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__chatBarInputField__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_UICalculations_service__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__objectClasses_user_action_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__enums_UserActionType__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__enums_TrackingPlatform__ = __webpack_require__(28);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatBar=function(_Component){_inherits(ChatBar,_Component);function ChatBar(props){_classCallCheck(this,ChatBar);var _this=_possibleConstructorReturn(this,(ChatBar.__proto__||Object.getPrototypeOf(ChatBar)).call(this,props));_this.renderSearchSuggestions=function(){__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();var list=[];var suggestions=[];if(_this.state.search_suggestions&&Object.keys(_this.state.search_suggestions).length>0){suggestions=Object.keys(_this.state.search_suggestions).map(function(item,index){return _this.getSnsObject(item,index);});}suggestions&&suggestions.map(function(snsobject,index){list.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index,onMouseDown:function onMouseDown(e){_this.handleUserInput(snsobject);}},_this.getHighlightedSnsHtml(snsobject.longKey)));});return list.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index},item);});};_this.getHighlightedSnsHtml=function(sns){var userInput=_this.state.input_search_value;var index=sns.toLowerCase().indexOf(userInput.toLowerCase());if(index!==-1){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,sns.substring(0,index),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,sns.substring(index,index+userInput.length)),sns.substring(index+userInput.length));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,sns);};_this.getSnsObject=function(key,snsIndex){if(_this.state.field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.PLACE){var item=_this.state.search_suggestions[key];return{shortKey:item.terms[item.terms.length-1].value.trim(),longKey:item.description};}else{var scenarioResponse=void 0;var scenario=void 0;var scenarioStrategy=void 0;if(_this.state.search_suggestions[key]&&_this.state.search_suggestions[key].scenario){scenario=_this.state.search_suggestions[key];if(_this.state.search_suggestions[key].scenario.scenarioStrategy){scenarioStrategy=_this.state.search_suggestions[key].scenario.scenarioStrategy;if(scenarioStrategy===__WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__["a" /* default */].FAQScenario){scenarioResponse=__WEBPACK_IMPORTED_MODULE_11__services_util_service__["a" /* default */].getCategoryFaqPlatformResponse(_this.state.search_suggestions[key]);}}}return{longKey:key,scenarioResponse:scenarioResponse,shortKey:key,scenario:scenario,scenarioStrategy:scenarioStrategy};}};_this.handleKeyBoardInApp=function(isFocussed){__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();if(isFocussed){__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#main").addClass("shift-up");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#bottom-bar-id").addClass("border-bottom-bar");}else{__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#main").removeClass("shift-up");__WEBPACK_IMPORTED_MODULE_3_jquery___default()("#bottom-bar-id").removeClass("border-bottom-bar");}};_this.setSearchSuggestions=function(search_suggestions_obj,input_search_value){__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();_this.setState({search_suggestions:search_suggestions_obj});};_this.setInputTextState=function(input){__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();if(_this.state.bottom_bar_options_visible){_this.setState({input_search_value:input,bottom_bar_options_visible:false});}else{_this.setState({input_search_value:input});}};_this.handleUserInput=function(snsobject){// console.log(snsobject)
var userActionType=snsobject?_this.state.field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.PLACE?__WEBPACK_IMPORTED_MODULE_10__enums_UserActionType__["a" /* default */].COUNTRY_SELECT:__WEBPACK_IMPORTED_MODULE_10__enums_UserActionType__["a" /* default */].SNS_CLICKED:__WEBPACK_IMPORTED_MODULE_10__enums_UserActionType__["a" /* default */].CHAT_TEXT_ENTER;var userInput=_this.state.input_search_value;__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#user_submit_button').removeClass('active');if(!_this.props.disableUserSubmit&&userInput!==''){_this.props.handleUserAction(new __WEBPACK_IMPORTED_MODULE_9__objectClasses_user_action_class__["a" /* default */](userActionType,_this.state.input_search_value,snsobject));//--- clear input field and suggestions
__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#user_input').val(null);_this.setState({search_suggestions:{},bottom_bar_options_visible:false,input_search_value:''});}};_this.clearInputFieldAndSuggestions=function(){__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#user_input').val(null);_this.setState({search_suggestions:{},input_search_value:''});};_this.closeOptions=function(){__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();_this.setState({bottom_bar_options_visible:false,showNumbersToSwitchBot:false});// this.props.disableNumbersToSwitchBot()
};_this.onCategoryOptionClick=function(option_obj){__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#user_input').val(null);__WEBPACK_IMPORTED_MODULE_3_jquery___default()('#user_submit_button').removeClass('active');_this.setState({search_suggestions:{},bottom_bar_options_visible:false,input_search_value:''});var userActionObject=_this.createUserActionObject(option_obj);_this.props.handleUserAction(userActionObject);// this.props.onCategoryOptionClick(option_obj)
};_this.createUserActionObject=function(optionObj){var platformTypeResponse=void 0;var scenarioStrategy=void 0;var scenarioObject=void 0;if(optionObj.scenario&&optionObj.scenario.scenarioStrategy&&optionObj.scenario.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__["a" /* default */].FAQScenario){if(optionObj[__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('platformType').toLowerCase()]!==null){platformTypeResponse=__WEBPACK_IMPORTED_MODULE_11__services_util_service__["a" /* default */].getCategoryFaqPlatformResponse(optionObj);scenarioStrategy=__WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__["a" /* default */].FAQScenario;}}else if(optionObj.scenario&&optionObj.scenario.scenarioStrategy&&optionObj.scenario.scenarioStrategy===__WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__["a" /* default */].DTScenario){scenarioObject=optionObj.scenario;scenarioStrategy=__WEBPACK_IMPORTED_MODULE_12__enums_scenario_type__["a" /* default */].DTScenario;}var catgegoryObject={scenarioTitle:optionObj.scenario_description_en,scenarioResponse:platformTypeResponse,scenarioStrategy:scenarioStrategy,scenario:scenarioObject};return new __WEBPACK_IMPORTED_MODULE_9__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_10__enums_UserActionType__["a" /* default */].CATEGORY_OPTION_CLICKED,null,null,catgegoryObject);};_this.toggleOptionsButtonClick=function(){if(_this.state.bottom_bar_options_visible){_this.closeOptions();}else{__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();_this.props.scrollToBottom();_this.setState({bottom_bar_options_visible:true});}};_this.state={bottom_bar_options_visible:false,field_type:props.fieldType,search_suggestions:{},input_search_value:'',showNumbersToSwitchBot:_this.props.showNumbersToSwitchBot};_this.inputBoxRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(ChatBar,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(new_props){if(this.state.field_type!==new_props.fieldType){this.setState({field_type:new_props.fieldType});}if(this.state.showNumbersToSwitchBot!==new_props.showNumbersToSwitchBot){if(new_props.showNumbersToSwitchBot){this.props.scrollToBottom();this.setState({bottom_bar_options_visible:true});}this.setState({showNumbersToSwitchBot:new_props.showNumbersToSwitchBot});}if(new_props.responseAwaiting){this.setState({bottom_bar_options_visible:false});this.clearInputFieldAndSuggestions();}}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var platformType=__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get("platformType");//only for old version
if(window.MyAirtelAppReact&&platformType===__WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__["a" /* default */].ANDROID){this.inputBoxRef.current.addEventListener("focus",function(e){_this2.handleKeyBoardInApp(true);if(_this2.state.bottom_bar_options_visible){_this2.closeOptions();}_this2.props.scrollToBottom();});this.inputBoxRef.current.addEventListener("blur",function(e){_this2.handleKeyBoardInApp(false);});}else{this.inputBoxRef.current.addEventListener("focus",function(e){if(_this2.state.bottom_bar_options_visible){_this2.closeOptions();}var platformType=__WEBPACK_IMPORTED_MODULE_11__services_util_service__["a" /* default */].getPlatformTypeForTracking();if(platformType===__WEBPACK_IMPORTED_MODULE_13__enums_TrackingPlatform__["a" /* default */].IOS_WEBVIEW){document.getElementById('messagesEnd').scrollIntoView({behavior:"instant",block:"end"});}else{_this2.props.scrollToBottom();}});}window.addEventListener("resize",function(e){_this2.props.scrollToBottom();});document.getElementById("user_input").addEventListener("keyup",function(event){event.preventDefault();if(event.keyCode===13&&_this2.state.field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT){_this2.handleUserInput();}});}},{key:'componentDidUpdate',value:function componentDidUpdate(){if(this.state.search_suggestions&&Object.keys(this.state.search_suggestions).length!==0&&this.state.input_search_value===''){this.setState({search_suggestions:{}});}if(document.getElementById('main')&&document.getElementById('main').scrollHeight>60){if(document.getElementById('options_bar_position_id')){if(!this.state.bottom_bar_options_visible){Object(__WEBPACK_IMPORTED_MODULE_8__services_UICalculations_service__["b" /* calculateOptionsPosition */])();}else{document.getElementById('options_bar_position_id').style.position='static';}}}}},{key:'render',value:function render(){var _this3=this;var _props=this.props,onSwitchNumber=_props.onSwitchNumber,showPopup=_props.showPopup;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'bottom-bar-id',className:'bottom-bar',style:{height:'auto',position:'static'}},this.state.search_suggestions&&Object.keys(this.state.search_suggestions).length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'suggestive-search show'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,!this.state.bottom_bar_options_visible&&this.renderSearchSuggestions())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'',id:'animid'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:this.state.bottom_bar_options_visible?'bottom-menu'+(__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__["a" /* default */].WEB?'-red':'')+' cross':'bottom-menu'+(__WEBPACK_IMPORTED_MODULE_4__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__["a" /* default */].WEB?'-red':''),onClick:function onClick(){_this3.toggleOptionsButtonClick();}}),Object(__WEBPACK_IMPORTED_MODULE_2__chatBarInputField__["a" /* default */])({setSearchSuggestions:this.setSearchSuggestions,field_type:this.state.field_type,handleUserInput:this.handleUserInput,disable_field:this.props.disableUserSubmit||this.props.disableInputField,setInputTextState:this.setInputTextState,inputBoxRef:this.inputBoxRef})),this.state.bottom_bar_options_visible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__chatBarOptionsComponent__["a" /* default */],{onCategoryOptionClick:this.onCategoryOptionClick,clearInputFieldAndSuggestions:this.clearInputFieldAndSuggestions,onSwitchNumber:onSwitchNumber,closeOptions:this.closeOptions,showNumbersToSwitchBot:this.state.showNumbersToSwitchBot,showPopup:showPopup})));}}]);return ChatBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatBar);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_components_confirmation_box_component__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_BotType__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_easy_swipe__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_easy_swipe___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_easy_swipe__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChatBarOptions=function(_Component){_inherits(ChatBarOptions,_Component);function ChatBarOptions(props){_classCallCheck(this,ChatBarOptions);var _this=_possibleConstructorReturn(this,(ChatBarOptions.__proto__||Object.getPrototypeOf(ChatBarOptions)).call(this,props));_this.insertAccountTypeInfo=function(accounts,type){accounts.forEach(function(element){element["type"]=type;});};_this.renderOptionsBar=function(){__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();var bot_type=__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentBotType');var options=_this.state.optionsCategories;var sorted_options=Object.keys(options).sort(function(a,b){return options[a][0].category_order-options[b][0].category_order;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,sorted_options.map(function(option_key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:option_key,id:option_key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void(0)",className:_this.state.active_option===option_key?"active"+(__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].WEB?'-red':''):""+(__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].WEB?'red':'blue'),onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();_this.setState({bar_inner_options_visible:true,active_option:option_key});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon"+(__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_6__enums_PlatformType__["a" /* default */].WEB?'-red':'')+" "+(option_key==='switch a/c'?'switch-ac':option_key.toLowerCase())}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:{textTransform:'uppercase'}},option_key)));}));};_this.getAccountType=function(account){var accountType=__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].getNumberTypeToShow(account.type);return accountType.charAt(0).toUpperCase()+accountType.slice(1);};_this.renderSelectedOptionsScenarios=function(){__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();var option=_this.state.active_option;var option_scenarios=_this.state.optionsCategories[option];if(option!=='switch a/c'){option_scenarios.sort(function(a,b){return a.scenario_order-b.scenario_order;});return option_scenarios.slice(0,__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentBotType')===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].PAYMENTS_BANK?5:4).map(function(option,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index,onClick:function onClick(){_this.props.onCategoryOptionClick(option);_this.props.closeOptions();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void(0)"},option.scenario_description_en));});}else if(option==='switch a/c'){return option_scenarios.map(function(item,index){if(item.siNumber!==__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentNumber')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:index,onClick:function onClick(){_this.props.showPopup(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_components_confirmation_box_component__["a" /* default */],{title:'Switch Account?',messages:['This will end your current chat session and will start a new one with the account you have selected.'],buttons:[{label:'CANCEL',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();_this.props.closeOptions();_this.props.showPopup(undefined);}},{highlight:true,label:'SWITCH',onClick:function onClick(){__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();_this.props.onSwitchNumber(item);_this.props.clearInputFieldAndSuggestions();_this.props.closeOptions();_this.props.showPopup(undefined);}}]})));}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"javascript:void(0)"},item.customerName,"-",item.siNumber," (",_this.getAccountType(item),")"));}});}};_this.onSwipeMove=function(position,event){_this.swipeGesture=__WEBPACK_IMPORTED_MODULE_7__services_util_service__["a" /* default */].returnSwipeGesture(position);};_this.onSwipeLeft=function(){if(_this.swipeGesture==='HORIZONTAL_SWIPE'){var active_option=_this.state.active_option;var active_index=_this.state.sorted_options.findIndex(function(option){return option===active_option;});if(active_index<_this.state.sorted_options.length-1){_this.setState({active_option:_this.state.sorted_options[active_index+1]});document.getElementById(""+_this.state.sorted_options[active_index+1])&&document.getElementById(""+_this.state.sorted_options[active_index+1]).scrollIntoView();}}};_this.onSwipeRight=function(){if(_this.swipeGesture==='HORIZONTAL_SWIPE'){var active_option=_this.state.active_option;var active_index=_this.state.sorted_options.findIndex(function(option){return option===active_option;});if(active_index>0){_this.setState({active_option:_this.state.sorted_options[active_index-1]});document.getElementById(""+_this.state.sorted_options[active_index-1])&&document.getElementById(""+_this.state.sorted_options[active_index-1]).scrollIntoView();}}};_this.state={bar_inner_options_visible:true,active_option:undefined,showNumbersToSwitchBot:_this.props.showNumbersToSwitchBot};return _this;}_createClass(ChatBarOptions,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_5__services_idle_timeout_service__["a" /* default */].updateIdleState();var bot_type=__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentBotType');var userProfile=__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('userProfile');var optionsCategories={};if(userProfile&&__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('isUserLoggedIn')){// let numbers_to_show = UtilService.getUserProfileNumbersWithAccountType()
var numbers_to_show=__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get("userAccounts");numbers_to_show.map(function(number,index){number['category_order']=0;});if(numbers_to_show.length>1){optionsCategories['switch a/c']=numbers_to_show;}}if(!__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('categoriesFetched')[__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */][__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentBotType')]]){__WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__["a" /* default */].getOptionsCategories().then(function(res){__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].set("categoriesFetched",Object.assign({},__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('categoriesFetched'),_defineProperty({},__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */][__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentBotType')],res)));var options=res;var sorted_options=Object.keys(options).sort(function(a,b){return options[a][0].category_order-options[b][0].category_order;});var active_option=sorted_options[0];if(sorted_options[0]==='switch a/c'&&!_this2.state.showNumbersToSwitchBot){active_option=sorted_options[1];}_this2.setState({optionsCategories:Object.assign({},res,optionsCategories),active_option:active_option});var options2=Object.assign({},res,optionsCategories);var sorted_options2=Object.keys(options2).sort(function(a,b){return options2[a][0].category_order-options2[b][0].category_order;});// console.log('sorted options', sorted_options2)
_this2.setState({sorted_options:sorted_options2});if(sorted_options2[0]==='switch a/c'&&_this2.state.showNumbersToSwitchBot){_this2.setState({active_option:sorted_options2[0]});}},function(err){// console.log(optionsCategories)
if(Object.keys(optionsCategories).length>0){_this2.setState({optionsCategories:optionsCategories,active_option:Object.keys(optionsCategories)[0]?Object.keys(optionsCategories)[0]:undefined});}else{_this2.props.closeOptions();}});}else{var options=Object.assign({},optionsCategories,__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('categoriesFetched')[__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */][__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get('currentBotType')]]);var sorted_options=Object.keys(options).sort(function(a,b){return options[a][0].category_order-options[b][0].category_order;});var active_option=sorted_options[0];if(sorted_options[0]==='switch a/c'&&!this.state.showNumbersToSwitchBot){active_option=sorted_options[1];}this.setState({optionsCategories:Object.assign({},options),active_option:active_option,sorted_options:sorted_options});}}},{key:"getSnapshotBeforeUpdate",value:function getSnapshotBeforeUpdate(prevProps,prevState){var _this3=this;var new_active_index=this.state.sorted_options&&this.state.sorted_options.findIndex(function(option){return option===_this3.state.active_option;});var prev_active_index=this.state.sorted_options&&this.state.sorted_options.findIndex(function(option){return option===prevState.active_option;});if(document.getElementById('optionsScenarioList')&&prevState.active_option!==this.state.active_option&&new_active_index&&prev_active_index){if(new_active_index>prev_active_index){document.getElementById('optionsScenarioList').classList.add('optionsAnimSwipeLeft');setTimeout(function(){document.getElementById('optionsScenarioList')&&document.getElementById('optionsScenarioList').classList.remove('optionsAnimSwipeLeft');},300);}else{document.getElementById('optionsScenarioList').classList.add('optionsAnimSwipeRight');setTimeout(function(){document.getElementById('optionsScenarioList')&&document.getElementById('optionsScenarioList').classList.remove('optionsAnimSwipeRight');},300);}}return true;}},{key:"componentDidUpdate",value:function componentDidUpdate(){}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bottom-menu-expand"+" "+(__WEBPACK_IMPORTED_MODULE_2__services_global_store_service__["a" /* default */].get("currentBotType")===__WEBPACK_IMPORTED_MODULE_4__enums_BotType__["a" /* default */].PAYMENTS_BANK?"paymentsbank":""),id:"chat-bar-options",style:{padding:'0 0'}},!this.state.optionsCategories&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"fs-regular fs-13 color-mid-grey pt-10 pb-10 ml-10"},"Fetching categories..."),this.state.optionsCategories&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"btm-link"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"links-scroll"},this.renderOptionsBar())),this.state.bar_inner_options_visible&&this.state.active_option&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_easy_swipe___default.a,{onSwipeRight:this.onSwipeRight,onSwipeLeft:this.onSwipeLeft,onSwipeMove:this.onSwipeMove},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"optionsScenarioList",className:"options "+(__WEBPACK_IMPORTED_MODULE_7__services_util_service__["a" /* default */].getOS()==="Windows"?"custom-scrollbar":""),style:{height:'195px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,this.state.optionsCategories&&this.renderSelectedOptionsScenarios()))));}}]);return ChatBarOptions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ChatBarOptions);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(231)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./react-swipe'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.reactSwipe);
    global.index = mod.exports;
  }
})(this, function (exports, _reactSwipe) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _reactSwipe2 = _interopRequireDefault(_reactSwipe);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.default = _reactSwipe2.default;
});

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, __webpack_require__(0), __webpack_require__(26)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes);
    global.reactSwipe = mod.exports;
  }
})(this, function (exports, _react, _propTypes) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.setHasSupportToCaptureOption = setHasSupportToCaptureOption;

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  function _objectWithoutProperties(obj, keys) {
    var target = {};

    for (var i in obj) {
      if (keys.indexOf(i) >= 0) continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
      target[i] = obj[i];
    }

    return target;
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  var supportsCaptureOption = false;
  function setHasSupportToCaptureOption(hasSupport) {
    supportsCaptureOption = hasSupport;
  }

  try {
    addEventListener("test", null, Object.defineProperty({}, 'capture', { get: function get() {
        setHasSupportToCaptureOption(true);
      } }));
  } catch (e) {}

  function getSafeEventHandlerOpts() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { capture: true };

    return supportsCaptureOption ? options : options.capture;
  }

  /**
   * [getPosition returns a position element that works for mouse or touch events]
   * @param  {[Event]} event [the received event]
   * @return {[Object]}      [x and y coords]
   */
  function getPosition(event) {
    if ('touches' in event) {
      var _event$touches$ = event.touches[0],
          pageX = _event$touches$.pageX,
          pageY = _event$touches$.pageY;

      return { x: pageX, y: pageY };
    }

    var screenX = event.screenX,
        screenY = event.screenY;

    return { x: screenX, y: screenY };
  }

  var ReactSwipe = function (_Component) {
    _inherits(ReactSwipe, _Component);

    function ReactSwipe() {
      var _ref;

      _classCallCheck(this, ReactSwipe);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ReactSwipe.__proto__ || Object.getPrototypeOf(ReactSwipe)).call.apply(_ref, [this].concat(args)));

      _this._handleSwipeStart = _this._handleSwipeStart.bind(_this);
      _this._handleSwipeMove = _this._handleSwipeMove.bind(_this);
      _this._handleSwipeEnd = _this._handleSwipeEnd.bind(_this);

      _this._onMouseDown = _this._onMouseDown.bind(_this);
      _this._onMouseMove = _this._onMouseMove.bind(_this);
      _this._onMouseUp = _this._onMouseUp.bind(_this);
      return _this;
    }

    _createClass(ReactSwipe, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.swiper) {
          this.swiper.addEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (this.swiper) {
          this.swiper.removeEventListener('touchmove', this._handleSwipeMove, getSafeEventHandlerOpts({
            capture: true,
            passive: false
          }));
        }
      }
    }, {
      key: '_onMouseDown',
      value: function _onMouseDown(event) {
        if (!this.props.allowMouseEvents) {
          return;
        }

        this.mouseDown = true;

        document.addEventListener('mouseup', this._onMouseUp);
        document.addEventListener('mousemove', this._onMouseMove);

        this._handleSwipeStart(event);
      }
    }, {
      key: '_onMouseMove',
      value: function _onMouseMove(event) {
        if (!this.mouseDown) {
          return;
        }

        this._handleSwipeMove(event);
      }
    }, {
      key: '_onMouseUp',
      value: function _onMouseUp(event) {
        this.mouseDown = false;

        document.removeEventListener('mouseup', this._onMouseUp);
        document.removeEventListener('mousemove', this._onMouseMove);

        this._handleSwipeEnd(event);
      }
    }, {
      key: '_handleSwipeStart',
      value: function _handleSwipeStart(event) {
        var _getPosition = getPosition(event),
            x = _getPosition.x,
            y = _getPosition.y;

        this.moveStart = { x: x, y: y };
        this.props.onSwipeStart(event);
      }
    }, {
      key: '_handleSwipeMove',
      value: function _handleSwipeMove(event) {
        if (!this.moveStart) {
          return;
        }

        var _getPosition2 = getPosition(event),
            x = _getPosition2.x,
            y = _getPosition2.y;

        var deltaX = x - this.moveStart.x;
        var deltaY = y - this.moveStart.y;
        this.moving = true;

        // handling the responsability of cancelling the scroll to
        // the component handling the event
        var shouldPreventDefault = this.props.onSwipeMove({
          x: deltaX,
          y: deltaY
        }, event);

        if (shouldPreventDefault) {
          event.preventDefault();
        }

        this.movePosition = { deltaX: deltaX, deltaY: deltaY };
      }
    }, {
      key: '_handleSwipeEnd',
      value: function _handleSwipeEnd(event) {
        this.props.onSwipeEnd(event);

        var tolerance = this.props.tolerance;


        if (this.moving && this.movePosition) {
          if (this.movePosition.deltaX < -tolerance) {
            this.props.onSwipeLeft(1, event);
          } else if (this.movePosition.deltaX > tolerance) {
            this.props.onSwipeRight(1, event);
          }
          if (this.movePosition.deltaY < -tolerance) {
            this.props.onSwipeUp(1, event);
          } else if (this.movePosition.deltaY > tolerance) {
            this.props.onSwipeDown(1, event);
          }
        }

        this.moveStart = null;
        this.moving = false;
        this.movePosition = null;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            tagName = _props.tagName,
            className = _props.className,
            style = _props.style,
            children = _props.children,
            allowMouseEvents = _props.allowMouseEvents,
            onSwipeUp = _props.onSwipeUp,
            onSwipeDown = _props.onSwipeDown,
            onSwipeLeft = _props.onSwipeLeft,
            onSwipeRight = _props.onSwipeRight,
            onSwipeStart = _props.onSwipeStart,
            onSwipeMove = _props.onSwipeMove,
            onSwipeEnd = _props.onSwipeEnd,
            props = _objectWithoutProperties(_props, ['tagName', 'className', 'style', 'children', 'allowMouseEvents', 'onSwipeUp', 'onSwipeDown', 'onSwipeLeft', 'onSwipeRight', 'onSwipeStart', 'onSwipeMove', 'onSwipeEnd']);

        return _react2.default.createElement(
          this.props.tagName,
          _extends({
            ref: function ref(node) {
              return _this2.swiper = node;
            },
            onMouseDown: this._onMouseDown,
            onTouchStart: this._handleSwipeStart,
            onTouchEnd: this._handleSwipeEnd,
            className: className,
            style: style
          }, props),
          children
        );
      }
    }]);

    return ReactSwipe;
  }(_react.Component);

  ReactSwipe.displayName = 'ReactSwipe';
  ReactSwipe.propTypes = {
    tagName: _propTypes2.default.string,
    className: _propTypes2.default.string,
    style: _propTypes2.default.object,
    children: _propTypes2.default.node,
    allowMouseEvents: _propTypes2.default.bool,
    onSwipeUp: _propTypes2.default.func,
    onSwipeDown: _propTypes2.default.func,
    onSwipeLeft: _propTypes2.default.func,
    onSwipeRight: _propTypes2.default.func,
    onSwipeStart: _propTypes2.default.func,
    onSwipeMove: _propTypes2.default.func,
    onSwipeEnd: _propTypes2.default.func,
    tolerance: _propTypes2.default.number.isRequired
  };
  ReactSwipe.defaultProps = {
    tagName: 'div',
    allowMouseEvents: false,
    onSwipeUp: function onSwipeUp() {},
    onSwipeDown: function onSwipeDown() {},
    onSwipeLeft: function onSwipeLeft() {},
    onSwipeRight: function onSwipeRight() {},
    onSwipeStart: function onSwipeStart() {},
    onSwipeMove: function onSwipeMove() {},
    onSwipeEnd: function onSwipeEnd() {},

    tolerance: 0
  };
  exports.default = ReactSwipe;
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_third_party_api_service__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__ = __webpack_require__(4);
var ChatBarInputField=function ChatBarInputField(props){var setSearchSuggestions=props.setSearchSuggestions,field_type=props.field_type,handleUserInput=props.handleUserInput,disable_field=props.disable_field,setInputTextState=props.setInputTextState,inputBoxRef=props.inputBoxRef;var recognition=void 0;var handleInputChange=function handleInputChange(e){__WEBPACK_IMPORTED_MODULE_6__services_idle_timeout_service__["a" /* default */].updateIdleState();var input_value=e?e.target.value:__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#user_input').val();;setInputTextState(input_value);if(input_value.length>0){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#user_submit_button').addClass('active');}else{__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#user_submit_button').removeClass('active');}var search_suggestions={};if(input_value.length>2){if(field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__["a" /* default */].getSmartSearches(input_value).then(function(response){if(response&&response.status&&response.status==="UNAUTHORIZED"){//HANDLING SESSION EXPIRATION
}else{search_suggestions=response;setSearchSuggestions(search_suggestions,input_value);}resolve();},function(error){// console.log(error);
reject();});});}else if(field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.PLACE){return new Promise(function(resolve,reject){__WEBPACK_IMPORTED_MODULE_1__services_chatbot_api_service__["a" /* default */].getCountrySmartSearches(input_value).then(function(res){if(res&&res.status&&res.status==="UNAUTHORIZED"){//HANDLING SESSION EXPIRATION
}else{res=res?JSON.parse(res):{};var _search_suggestions=[];res&&res.predictions&&res.predictions.map(function(item){_search_suggestions.push(item);});setSearchSuggestions(_search_suggestions,input_value);}resolve();},function(error){// console.log(error);
reject(error);});});}}else{setSearchSuggestions(search_suggestions,input_value);}};var SpeechRecognition=window.webkitSpeechRecognition;var SpeechGrammarList=window.webkitSpeechGrammarList;var SpeechRecognitionEvent=window.webkitSpeechRecognitionEvent;// console.log(window.webkitSpeechRecognition)
if(SpeechRecognition){recognition=new SpeechRecognition();}// var speechRecognitionList = new SpeechGrammarList();
var handleUserRecording=function handleUserRecording(){if(recognition){recognition.start();__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#mic_button_id').addClass('red');document.getElementById('mic_button_id').disabled=true;}// this.recognition =recognition
// console.log('Ready to listen.');
};if(recognition){recognition.onresult=function(event){var last=event.results.length-1;var transcript=event.results[last][0].transcript;// console.log(event.results)
// console.log('result ' + transcript);
if(transcript){__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#user_input').val(transcript);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#mic_button_id').removeClass('red');document.getElementById('mic_button_id').disabled=false;handleInputChange();}};recognition.onspeechend=function(){recognition.stop();console.log('speech end');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#mic_button_id').removeClass('red');document.getElementById('mic_button_id').disabled=false;};recognition.onnomatch=function(event){console.log('no match');__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#mic_button_id').removeClass('red');document.getElementById('mic_button_id').disabled=false;};recognition.onerror=function(event){console.log('error occurred',event);__WEBPACK_IMPORTED_MODULE_4_jquery___default()('#mic_button_id').removeClass('red');document.getElementById('mic_button_id').disabled=false;};}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'inherit'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{autoComplete:'off',id:'user_input',ref:inputBoxRef,disabled:disable_field,type:'text',width:'260',placeholder:'Type your '+(field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.PLACE?'place':'message')+' here...',onChange:function onChange(e){return handleInputChange(e);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',id:'user_submit_button',className:'chat-submit'+(__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get('platformType')===__WEBPACK_IMPORTED_MODULE_5__enums_PlatformType__["a" /* default */].WEB?'-red':'')+(field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.PLACE?" cursr-not-allowed":""),onMouseDown:function onMouseDown(){field_type===__WEBPACK_IMPORTED_MODULE_7__constants_globalConstants__["a" /* globalConstants */].INPUT_FIELD_TYPES.CHAT&&handleUserInput();}}));};/* harmony default export */ __webpack_exports__["a"] = (ChatBarInputField);

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__custom_http_service__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_EncodeDecodeType__ = __webpack_require__(30);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ThirdPartyApiService=function ThirdPartyApiService(){_classCallCheck(this,ThirdPartyApiService);};/* unused harmony default export */ var _unused_webpack_default_export = (ThirdPartyApiService);

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_action_types_ChatActionType__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_PlatformType__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__ = __webpack_require__(15);
var AlternateNumberInputComponent=function AlternateNumberInputComponent(_ref){var props=_ref.props,setBottomBarComponentState=_ref.setBottomBarComponentState,onSkipClick=_ref.onSkipClick,handleUserAction=_ref.handleUserAction;var handleOptionsClick=props.handleOptionsClick;var dffField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();setTimeout(function(){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alernateNumberErrorMessage").hide();var platformType=__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("platformType");if(window.MyAirtelAppReact&&platformType===__WEBPACK_IMPORTED_MODULE_4__enums_PlatformType__["a" /* default */].ANDROID){dffField.current.addEventListener("focus",function(e){handleKeyBoardInApp(true);});dffField.current.addEventListener("blur",function(e){handleKeyBoardInApp(false);});}},0);var handleKeyBoardInApp=function handleKeyBoardInApp(isFocussed){if(isFocussed){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#main").addClass("shift-up");}else{__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#main").removeClass("shift-up");}};var submitDff=function submitDff(){var regexp=/^\d{10}$/;if(!regexp.exec(__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alternateNumber").val())){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alernateNumberErrorMessage").show();return;}__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alernateNumberErrorMessage").hide();var dffData={};// for (let i = 0; i < props.DFFFieldToBeDisplayed.length; i += 1) {
//     let obj;
//     if (props.DFFFieldToBeDisplayed[i].name === "Customer Lat/Long") {
//         obj = {
//             order: props.DFFFieldToBeDisplayed[i].ordering,
//             value: props.additionalInfo.lat_long
//                 ? props.additionalInfo.lat_long
//                 : props.DFFFieldToBeDisplayed[i].defaultValue,
//             name: props.DFFFieldToBeDisplayed[i].name
//         };
//     } else if (
//         props.DFFFieldToBeDisplayed[i].name === "Problem Address & Landmark (M)" ||
//         props.DFFFieldToBeDisplayed[i].name === "Problem Address(M)"
//     ) {
//         obj = {
//             order: props.DFFFieldToBeDisplayed[i].ordering,
//             value: props.additionalInfo.leapText
//                 ? props.additionalInfo.leapText
//                 : props.DFFFieldToBeDisplayed[i].defaultValue,
//             name: props.DFFFieldToBeDisplayed[i].name
//         };
//     } else {
//         obj = {
//             order: props.DFFFieldToBeDisplayed[i].ordering,
//             value: $("#alternateNumber").val()
//                 ? $("#alternateNumber").val()
//                 : props.DFFFieldToBeDisplayed[i].defaultValue,
//             name: props.DFFFieldToBeDisplayed[i].name
//         };
//     }
//     dffData[props.DFFFieldToBeDisplayed[i].name] = obj;
//     const reqData = {
//         transactionId: props.chatItem.scenarioResponse.transactionId,
//         dffNameValuePairs: dffData,
//         scenarioName: props.chatItem.scenarioResponse.scenario.scenarioName,
//         notes: props.chatItem.scenarioResponse.notes,
//         authToken: props.chatItem.scenarioResponse.authToken,
//         crmCode: props.additionalInfo.crmCode
//     };
//     let additionalData = { reqData, ...props.additionalInfo }
//     handleUserAction(new UserActionClass(UserActionType.CREATE_SR, null, null, null, null, additionalData))
//     hideDffForm({});
// }
var obj=void 0;obj={order:props.DFFFieldToBeDisplayed[0].ordering,value:__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alternateNumber").val()?__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alternateNumber").val():props.DFFFieldToBeDisplayed[0].defaultValue,name:props.DFFFieldToBeDisplayed[0].name};dffData[props.DFFFieldToBeDisplayed[0].name]=obj;var reqData={transactionId:props.chatItem.scenarioResponse.transactionId,dffNameValuePairs:dffData,scenarioName:props.chatItem.scenarioResponse.scenario.scenarioName,notes:props.chatItem.scenarioResponse.notes,authToken:props.chatItem.scenarioResponse.authToken,crmCode:props.additionalInfo.crmCode};var additionalData=Object.assign({reqData:reqData},props.additionalInfo);handleUserAction(new __WEBPACK_IMPORTED_MODULE_6__objectClasses_user_action_class__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7__enums_UserActionType__["a" /* default */].CREATE_SR,null,null,null,null,additionalData));hideDffForm({});};var isValid=function isValid(event){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alernateNumberErrorMessage").hide();var regexp=/^\d{10}$/;if(event.which===13&&regexp.exec(event.currentTarget.value)){event.preventDefault();submitDff();return false;}if(event.which!==8&&event.which!==0&&event.which<48||event.which>57){event.preventDefault();return false;}if(event.currentTarget.value.length>9||event.which===13){event.preventDefault();return false;}if(regexp.exec(event.currentTarget.value+event.key)){__WEBPACK_IMPORTED_MODULE_1_jquery___default()("#alernateNumberErrorMessage").hide();return true;}else{return false;}};var hideDffForm=function hideDffForm(_ref2){var skip=_ref2.skip;if(skip){onSkipClick({pop_count:1});}setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_5__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.CHAT_INPUT_BAR});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'dffForm',className:'login-bar show',style:{zIndex:'11111',height:'auto',position:'static'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'text-right pr-20 fs-12 color-grey fs-light display-block pt-20 pb-10'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',onClick:function onClick(){return hideDffForm({skip:true});},className:'fs-12 color-grey fs-light'},'Skip \u203A')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{className:'fs-11 color-light-grey fs-light pl-10 pt-5 pull-left border-bottom pb-5 uppercase'},props&&props.DFFFieldToBeDisplayed&&props.DFFFieldToBeDisplayed.length>0&&props.DFFFieldToBeDisplayed[0].displayNameChatbot?props.DFFFieldToBeDisplayed[0].displayNameChatbot:props&&props.DFFFieldToBeDisplayed&&props.DFFFieldToBeDisplayed.length>0&&props.DFFFieldToBeDisplayed[0].name?props.DFFFieldToBeDisplayed[0].name:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',width:'260',ref:dffField,id:'alternateNumber',onKeyPress:isValid,placeholder:props&&props.DFFFieldToBeDisplayed&&props.DFFFieldToBeDisplayed.length>0&&props.DFFFieldToBeDisplayed[0].displayNameChatbot?props.DFFFieldToBeDisplayed[0].displayNameChatbot:props&&props.DFFFieldToBeDisplayed&&props.DFFFieldToBeDisplayed.length>0&&props.DFFFieldToBeDisplayed[0].name?props.DFFFieldToBeDisplayed[0].name:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'pl-10',style:{fontSize:'12px',color:'red',padding:'10px'},id:'alernateNumberErrorMessage'},'Please enter a valid mobile number'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'javascript:void(0)',className:'login-button fs-light color-white fs-13 pull-left',style:{marginTop:0},onMouseDown:function onMouseDown(){submitDff();}},'SUBMIT'));};/* harmony default export */ __webpack_exports__["a"] = (AlternateNumberInputComponent);

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var CancelComponent=function CancelComponent(_ref){var handleCancelButtonClick=_ref.handleCancelButtonClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cancel-bottom-bar',style:{textAlign:'center',padding:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){handleCancelButtonClick();},className:'cursor-pointer cancel_div'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'bottom-menu grey-cross'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'fs-10 color-grey text-center display-block'},'Cancel')));};/* harmony default export */ __webpack_exports__["a"] = (CancelComponent);

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return handleReadReturnFromDB; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_service__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global_store_service__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_globalConstants__ = __webpack_require__(4);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var handleReadReturnFromDB=function handleReadReturnFromDB(_ref){var data=_ref.data,message_comp=_ref.message_comp,status=_ref.status,readOnScroll=_ref.readOnScroll;var chatHistoryOldMessages=message_comp.state.chatHistoryMessages;var chatHistoryNewMessages=[];if(data&&data.length>0){var historyMessageDateObject=createHistoryMessageDateArray(data,chatHistoryOldMessages);chatHistoryNewMessages=historyMessageDateObject.chatHistoryNewMessages;chatHistoryOldMessages=historyMessageDateObject.chatHistoryOldMessages;message_comp.setState({chatHistoryMessages:[].concat(_toConsumableArray(chatHistoryNewMessages),_toConsumableArray(chatHistoryOldMessages))});}message_comp.setLoaderOff();if(!readOnScroll){var redirectCase=__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].checkIfRedirectCase();if(redirectCase){message_comp.setState({redirectCase:true});var new_messages=[];message_comp.showHistoryMessages();message_comp.scrollToBottom();if(redirectCase==="changePlanRedirectCase"){if(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("changePlanStatus")==="true"){new_messages.push(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].PLAN_CHANGE_SUCCESS));}else{new_messages.push(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].PLAN_CHANGE_FAIL));}}else if(redirectCase==="paymentTransactionRedirectCase"){if(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("transactionStatus")==="success"){var success_message=createPaymentSuccessMessage();new_messages.push(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(success_message));}else if(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("transactionStatus")==="failure"){new_messages.push(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].PAYMENT_FAIL));}else{new_messages.push(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].PAYMENT_PENDING));}}message_comp.addNewMessages({new_messages:new_messages});if(__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("n")){__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].set("currentNumber",__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("n"));}else{__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].set("currentNumber",__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].get("primaryNumber"));}}else{//normal first come case
if(__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].get('userProfileType')==='SINGLE'){//handle single account login
__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].set("currentNumber",__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].get("primaryNumber"));if(data&&data.length>0){message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].WELCOME_BACK)]});message_comp.onNumberSelected({user_response:__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].get("primaryNumber"),show_number:false});}else{message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].WELCOME)]});message_comp.onNumberSelected({user_response:__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].get("primaryNumber"),show_number:false});}}else if(__WEBPACK_IMPORTED_MODULE_2__global_store_service__["a" /* default */].get('userProfileType')==='MULTIPLE'){// handle multiple account login
if(data&&data.length>0){message_comp.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_3__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU});message_comp.setLoaderOff();message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].WELCOME_BACK),__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].SELECT_ACCOUNT)]});// WHEN AVATAR OF BOT WILL BE RELEASED                                       
// message_comp.addNewMessages({new_messages:[{component_type:'WELCOME_COMPONENT_MULTIPLE',message:SCRIPTS.WELCOME_BACK,messageTime:UtilService.getCurrentTime()}]})
}else{message_comp.setBottomBarComponentState({type:__WEBPACK_IMPORTED_MODULE_3__constants_globalConstants__["a" /* globalConstants */].BOTTOM_BAR_COMPONENTS.USER_ACCOUNTS_MENU});message_comp.setLoaderOff();message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].WELCOME),__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].SELECT_ACCOUNT)]});// WHEN AVATAR OF BOT WILL BE RELEASED
// message_comp.addNewMessages({new_messages:[{component_type:'WELCOME_COMPONENT_MULTIPLE',message:SCRIPTS.WELCOME,messageTime:UtilService.getCurrentTime()}]})
}}else{//handle no account case
message_comp.addNewMessages({new_messages:[__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].createChatBotMessageObject(__WEBPACK_IMPORTED_MODULE_1__constants_staticScripts__["a" /* SCRIPTS */].DEFAULT_ERROR)]});}}}};var createDateMessageComponentObject=function createDateMessageComponentObject(date){return{component_type:'HISTORY_DATE_COMPONENT',message:date};};var createPaymentSuccessMessage=function createPaymentSuccessMessage(){var number=__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("n");var transactionId=__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("transactionId");var transactionAmount=__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("amt");var transactionDate=__WEBPACK_IMPORTED_MODULE_0__util_service__["a" /* default */].getParamValue("transactionDate");var message="Yay ! Your transaction was successful. \n                "+(number||transactionAmount||transactionDate||transactionId?"Here are your payment details:<br>":"")+"\n                "+(number?"Mobile Number : "+number+" <br>":"")+"\n                "+(transactionAmount?"Amount Paid: Rs "+transactionAmount+"<br>":"")+"\n                "+(transactionId?"Transaction Id: "+transactionId+"<br>":"")+"\n                "+(transactionDate?"Transaction Date: "+transactionDate:"");return message;};var createHistoryMessageDateArray=function createHistoryMessageDateArray(data,oldHistoryMessages){// console.log(data)
var chatHistoryNewMessages=[];//filter the old history messages to remove history component messages to compare timestamp of messages
var filteredOldHistoryMessages=oldHistoryMessages&&oldHistoryMessages.length>0?oldHistoryMessages.filter(function(message){return message.component_type!=='HISTORY_DATE_COMPONENT';}):[];data.map(function(message_obj,index){try{var currentMessageDate=new Date(JSON.parse(message_obj.content).messageTime.timestamp);if(index>0||filteredOldHistoryMessages.length>0){var previousMessageDate=index>0?new Date(JSON.parse(data[index-1].content).messageTime.timestamp):new Date(filteredOldHistoryMessages[0].messageTime.timestamp);// console.log((getDateInFormat(previousMessageDate)),(getDateInFormat(currentMessageDate)))
if(areDatesSame(currentMessageDate,previousMessageDate)){// console.log('messages same date')
// if dates are same for the data message and first history message remove the history date component
if(index===0){oldHistoryMessages=oldHistoryMessages.filter(function(message,index){return!(message.component_type==="HISTORY_DATE_COMPONENT"&&index===0);});}else{}}else{// console.log('messages date not same')
// console.log(getDateInFormat(previousMessageDate))
chatHistoryNewMessages.push(createDateMessageComponentObject(getDateInFormat(previousMessageDate)));}}message_obj=JSON.parse(message_obj.content);message_obj['fromHistory']=true;chatHistoryNewMessages.push(message_obj);if(index===data.length-1){chatHistoryNewMessages.push(createDateMessageComponentObject(getDateInFormat(currentMessageDate)));}}catch(e){console.log('couldnt parse the message',data,e);}});return{chatHistoryNewMessages:chatHistoryNewMessages.reverse(),chatHistoryOldMessages:oldHistoryMessages};};var getDateInFormat=function getDateInFormat(date){var months=['Jan','Feb','March','April','May','June','July','August','Sept','Oct','Nov','Dec'];var day=date.getDate();var month=months[date.getMonth()];var year=date.getFullYear();var dateToday=new Date();var dayToday=dateToday.getDate();var monthToday=months[dateToday.getMonth()];var yearToday=dateToday.getFullYear();if(dayToday===day&&monthToday===month&&yearToday===year){return'TODAY';}else if(dayToday-1===day&&monthToday===month&&yearToday===year){return'YESTERDAY';}else{return day+" "+month+", "+year;}};var areDatesSame=function areDatesSame(currentDate,previousDate){if(currentDate.getDate()===previousDate.getDate()){if(currentDate.getMonth()===previousDate.getMonth()){if(currentDate.getFullYear()===previousDate.getFullYear()){return true;}else{return false;}}else{return false;}}else{return false;}};

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_action_types_HeaderActionType__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_config__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_global_store_service__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import '.././App.css';
var Header=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={isMinimized:false};return _this;}_createClass(Header,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(new_props){if(new_props.isMinimized!==this.state.isMinimized){this.setState({isMinimized:new_props.isMinimized});}}},{key:'render',value:function render(){var _this2=this;var handleHeaderClick=function handleHeaderClick(data){if(data.actionType===__WEBPACK_IMPORTED_MODULE_1__enums_action_types_HeaderActionType__["a" /* default */].MINIMIZE){if(!__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){window.parent.postMessage("MINIMIZE",__WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* default */].parentOrigin);}_this2.setState({isMinimized:true});}else if(data.actionType===__WEBPACK_IMPORTED_MODULE_1__enums_action_types_HeaderActionType__["a" /* default */].MAXIMIZE){if(!__WEBPACK_IMPORTED_MODULE_3__services_global_store_service__["a" /* default */].get("APP_CONTEXT")){window.parent.postMessage("MAXIMIZE",__WEBPACK_IMPORTED_MODULE_2__config_config__["a" /* default */].parentOrigin);}_this2.setState({isMinimized:false});}_this2.props.handleHeaderClick(data);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'top-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'color-white display-block fs-17'},'Airtel Support'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{float:"left"}},!this.state.isMinimized?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{marginLeft:"10px",marginRight:"10px",paddingBottom:"2px"},height:'20px',width:'20px',src:"/help/chat"+'/assets/images/minimize.svg',onClick:function onClick(){handleHeaderClick({actionType:__WEBPACK_IMPORTED_MODULE_1__enums_action_types_HeaderActionType__["a" /* default */].MINIMIZE});}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{marginLeft:"10px",marginRight:"10px"},height:'20px',width:'20px',src:"/help/chat"+'/assets/images/expand.png',onClick:function onClick(){handleHeaderClick({actionType:__WEBPACK_IMPORTED_MODULE_1__enums_action_types_HeaderActionType__["a" /* default */].MAXIMIZE});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{marginLeft:"10px"},height:'20px',width:'20px',src:"/help/chat"+'/assets/images/close.png',onClick:function onClick(){handleHeaderClick({actionType:__WEBPACK_IMPORTED_MODULE_1__enums_action_types_HeaderActionType__["a" /* default */].CLOSE});}})));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (immutable) */ __webpack_exports__["a"] = unregister;
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("/help/chat",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl="/help/chat"+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.c3b07e89.js